! function(t) {
    var e = {};
  
    function i(n) {
        if (e[n]) return e[n].exports;
        var s = e[n] = {
            i: n,
            l: !1,
            exports: {}
        };
        return t[n].call(s.exports, s, s.exports, i), s.l = !0, s.exports
    }
    i.m = t, i.c = e, i.d = function(t, e, n) {
        i.o(t, e) || Object.defineProperty(t, e, {
            enumerable: !0,
            get: n
        })
    }, i.r = function(t) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(t, "__esModule", {
            value: !0
        })
    }, i.t = function(t, e) {
        if (1 & e && (t = i(t)), 8 & e) return t;
        if (4 & e && "object" == typeof t && t && t.__esModule) return t;
        var n = Object.create(null);
        if (i.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: t
            }), 2 & e && "string" != typeof t)
            for (var s in t) i.d(n, s, function(e) {
                return t[e]
            }.bind(null, s));
        return n
    }, i.n = function(t) {
        var e = t && t.__esModule ? function() {
            return t.default
        } : function() {
            return t
        };
        return i.d(e, "a", e), e
    }, i.o = function(t, e) {
        return Object.prototype.hasOwnProperty.call(t, e)
    }, i.p = "", i(i.s = 62)
  }([function(t, e, i) {
    "use strict";
    var n = "undefined" == typeof document ? {
            body: {},
            addEventListener: function() {},
            removeEventListener: function() {},
            activeElement: {
                blur: function() {},
                nodeName: ""
            },
            querySelector: function() {
                return null
            },
            querySelectorAll: function() {
                return []
            },
            getElementById: function() {
                return null
            },
            createEvent: function() {
                return {
                    initEvent: function() {}
                }
            },
            createElement: function() {
                return {
                    children: [],
                    childNodes: [],
                    style: {},
                    setAttribute: function() {},
                    getElementsByTagName: function() {
                        return []
                    }
                }
            },
            location: {
                hash: ""
            }
        } : document,
        s = "undefined" == typeof window ? {
            document: n,
            navigator: {
                userAgent: ""
            },
            location: {},
            history: {},
            CustomEvent: function() {
                return this
            },
            addEventListener: function() {},
            removeEventListener: function() {},
            getComputedStyle: function() {
                return {
                    getPropertyValue: function() {
                        return ""
                    }
                }
            },
            Image: function() {},
            Date: function() {},
            screen: {},
            setTimeout: function() {},
            clearTimeout: function() {}
        } : window;
    class o {
        constructor(t) {
            const e = this;
            for (let i = 0; i < t.length; i += 1) e[i] = t[i];
            return e.length = t.length, this
        }
    }
  
    function r(t, e) {
        const i = [];
        let r = 0;
        if (t && !e && t instanceof o) return t;
        if (t)
            if ("string" == typeof t) {
                let s, o;
                const a = t.trim();
                if (a.indexOf("<") >= 0 && a.indexOf(">") >= 0) {
                    let t = "div";
                    for (0 === a.indexOf("<li") && (t = "ul"), 0 === a.indexOf("<tr") && (t = "tbody"), 0 !== a.indexOf("<td") && 0 !== a.indexOf("<th") || (t = "tr"), 0 === a.indexOf("<tbody") && (t = "table"), 0 === a.indexOf("<option") && (t = "select"), (o = n.createElement(t)).innerHTML = a, r = 0; r < o.childNodes.length; r += 1) i.push(o.childNodes[r])
                } else
                    for (s = e || "#" !== t[0] || t.match(/[ .<>:~]/) ? (e || n).querySelectorAll(t.trim()) : [n.getElementById(t.trim().split("#")[1])], r = 0; r < s.length; r += 1) s[r] && i.push(s[r])
            } else if (t.nodeType || t === s || t === n) i.push(t);
        else if (t.length > 0 && t[0].nodeType)
            for (r = 0; r < t.length; r += 1) i.push(t[r]);
        return new o(i)
    }
  
    function a(t) {
        const e = [];
        for (let i = 0; i < t.length; i += 1) - 1 === e.indexOf(t[i]) && e.push(t[i]);
        return e
    }
    r.fn = o.prototype, r.Class = o, r.Dom7 = o;
    "resize scroll".split(" ");
    const l = {
        addClass: function(t) {
            if (void 0 === t) return this;
            const e = t.split(" ");
            for (let t = 0; t < e.length; t += 1)
                for (let i = 0; i < this.length; i += 1) void 0 !== this[i] && void 0 !== this[i].classList && this[i].classList.add(e[t]);
            return this
        },
        removeClass: function(t) {
            const e = t.split(" ");
            for (let t = 0; t < e.length; t += 1)
                for (let i = 0; i < this.length; i += 1) void 0 !== this[i] && void 0 !== this[i].classList && this[i].classList.remove(e[t]);
            return this
        },
        hasClass: function(t) {
            return !!this[0] && this[0].classList.contains(t)
        },
        toggleClass: function(t) {
            const e = t.split(" ");
            for (let t = 0; t < e.length; t += 1)
                for (let i = 0; i < this.length; i += 1) void 0 !== this[i] && void 0 !== this[i].classList && this[i].classList.toggle(e[t]);
            return this
        },
        attr: function(t, e) {
            if (1 === arguments.length && "string" == typeof t) return this[0] ? this[0].getAttribute(t) : void 0;
            for (let i = 0; i < this.length; i += 1)
                if (2 === arguments.length) this[i].setAttribute(t, e);
                else
                    for (const e in t) this[i][e] = t[e], this[i].setAttribute(e, t[e]);
            return this
        },
        removeAttr: function(t) {
            for (let e = 0; e < this.length; e += 1) this[e].removeAttribute(t);
            return this
        },
        data: function(t, e) {
            let i;
            if (void 0 !== e) {
                for (let n = 0; n < this.length; n += 1)(i = this[n]).dom7ElementDataStorage || (i.dom7ElementDataStorage = {}), i.dom7ElementDataStorage[t] = e;
                return this
            }
            if (i = this[0]) {
                if (i.dom7ElementDataStorage && t in i.dom7ElementDataStorage) return i.dom7ElementDataStorage[t];
                const e = i.getAttribute(`data-${t}`);
                return e || void 0
            }
        },
        transform: function(t) {
            for (let e = 0; e < this.length; e += 1) {
                const i = this[e].style;
                i.webkitTransform = t, i.transform = t
            }
            return this
        },
        transition: function(t) {
            "string" != typeof t && (t = `${t}ms`);
            for (let e = 0; e < this.length; e += 1) {
                const i = this[e].style;
                i.webkitTransitionDuration = t, i.transitionDuration = t
            }
            return this
        },
        on: function(...t) {
            let [e, i, n, s] = t;
  
            function o(t) {
                const e = t.target;
                if (!e) return;
                const s = t.target.dom7EventData || [];
                if (s.indexOf(t) < 0 && s.unshift(t), r(e).is(i)) n.apply(e, s);
                else {
                    const t = r(e).parents();
                    for (let e = 0; e < t.length; e += 1) r(t[e]).is(i) && n.apply(t[e], s)
                }
            }
  
            function a(t) {
                const e = t && t.target && t.target.dom7EventData || [];
                e.indexOf(t) < 0 && e.unshift(t), n.apply(this, e)
            }
            "function" == typeof t[1] && ([e, n, s] = t, i = void 0), s || (s = !1);
            const l = e.split(" ");
            let h;
            for (let t = 0; t < this.length; t += 1) {
                const e = this[t];
                if (i)
                    for (h = 0; h < l.length; h += 1) {
                        const t = l[h];
                        e.dom7LiveListeners || (e.dom7LiveListeners = {}), e.dom7LiveListeners[t] || (e.dom7LiveListeners[t] = []), e.dom7LiveListeners[t].push({
                            listener: n,
                            proxyListener: o
                        }), e.addEventListener(t, o, s)
                    } else
                        for (h = 0; h < l.length; h += 1) {
                            const t = l[h];
                            e.dom7Listeners || (e.dom7Listeners = {}), e.dom7Listeners[t] || (e.dom7Listeners[t] = []), e.dom7Listeners[t].push({
                                listener: n,
                                proxyListener: a
                            }), e.addEventListener(t, a, s)
                        }
            }
            return this
        },
        off: function(...t) {
            let [e, i, n, s] = t;
            "function" == typeof t[1] && ([e, n, s] = t, i = void 0), s || (s = !1);
            const o = e.split(" ");
            for (let t = 0; t < o.length; t += 1) {
                const e = o[t];
                for (let t = 0; t < this.length; t += 1) {
                    const o = this[t];
                    let r;
                    if (!i && o.dom7Listeners ? r = o.dom7Listeners[e] : i && o.dom7LiveListeners && (r = o.dom7LiveListeners[e]), r && r.length)
                        for (let t = r.length - 1; t >= 0; t -= 1) {
                            const i = r[t];
                            n && i.listener === n ? (o.removeEventListener(e, i.proxyListener, s), r.splice(t, 1)) : n || (o.removeEventListener(e, i.proxyListener, s), r.splice(t, 1))
                        }
                }
            }
            return this
        },
        trigger: function(...t) {
            const e = t[0].split(" "),
                i = t[1];
            for (let o = 0; o < e.length; o += 1) {
                const r = e[o];
                for (let e = 0; e < this.length; e += 1) {
                    const o = this[e];
                    let a;
                    try {
                        a = new s.CustomEvent(r, {
                            detail: i,
                            bubbles: !0,
                            cancelable: !0
                        })
                    } catch (t) {
                        (a = n.createEvent("Event")).initEvent(r, !0, !0), a.detail = i
                    }
                    o.dom7EventData = t.filter((t, e) => e > 0), o.dispatchEvent(a), o.dom7EventData = [], delete o.dom7EventData
                }
            }
            return this
        },
        transitionEnd: function(t) {
            const e = ["webkitTransitionEnd", "transitionend"],
                i = this;
            let n;
  
            function s(o) {
                if (o.target === this)
                    for (t.call(this, o), n = 0; n < e.length; n += 1) i.off(e[n], s)
            }
            if (t)
                for (n = 0; n < e.length; n += 1) i.on(e[n], s);
            return this
        },
        outerWidth: function(t) {
            if (this.length > 0) {
                if (t) {
                    const t = this.styles();
                    return this[0].offsetWidth + parseFloat(t.getPropertyValue("margin-right")) + parseFloat(t.getPropertyValue("margin-left"))
                }
                return this[0].offsetWidth
            }
            return null
        },
        outerHeight: function(t) {
            if (this.length > 0) {
                if (t) {
                    const t = this.styles();
                    return this[0].offsetHeight + parseFloat(t.getPropertyValue("margin-top")) + parseFloat(t.getPropertyValue("margin-bottom"))
                }
                return this[0].offsetHeight
            }
            return null
        },
        offset: function() {
            if (this.length > 0) {
                const t = this[0],
                    e = t.getBoundingClientRect(),
                    i = n.body,
                    o = t.clientTop || i.clientTop || 0,
                    r = t.clientLeft || i.clientLeft || 0,
                    a = t === s ? s.scrollY : t.scrollTop,
                    l = t === s ? s.scrollX : t.scrollLeft;
                return {
                    top: e.top + a - o,
                    left: e.left + l - r
                }
            }
            return null
        },
        css: function(t, e) {
            let i;
            if (1 === arguments.length) {
                if ("string" != typeof t) {
                    for (i = 0; i < this.length; i += 1)
                        for (let e in t) this[i].style[e] = t[e];
                    return this
                }
                if (this[0]) return s.getComputedStyle(this[0], null).getPropertyValue(t)
            }
            if (2 === arguments.length && "string" == typeof t) {
                for (i = 0; i < this.length; i += 1) this[i].style[t] = e;
                return this
            }
            return this
        },
        each: function(t) {
            if (!t) return this;
            for (let e = 0; e < this.length; e += 1)
                if (!1 === t.call(this[e], e, this[e])) return this;
            return this
        },
        html: function(t) {
            if (void 0 === t) return this[0] ? this[0].innerHTML : void 0;
            for (let e = 0; e < this.length; e += 1) this[e].innerHTML = t;
            return this
        },
        text: function(t) {
            if (void 0 === t) return this[0] ? this[0].textContent.trim() : null;
            for (let e = 0; e < this.length; e += 1) this[e].textContent = t;
            return this
        },
        is: function(t) {
            const e = this[0];
            let i, a;
            if (!e || void 0 === t) return !1;
            if ("string" == typeof t) {
                if (e.matches) return e.matches(t);
                if (e.webkitMatchesSelector) return e.webkitMatchesSelector(t);
                if (e.msMatchesSelector) return e.msMatchesSelector(t);
                for (i = r(t), a = 0; a < i.length; a += 1)
                    if (i[a] === e) return !0;
                return !1
            }
            if (t === n) return e === n;
            if (t === s) return e === s;
            if (t.nodeType || t instanceof o) {
                for (i = t.nodeType ? [t] : t, a = 0; a < i.length; a += 1)
                    if (i[a] === e) return !0;
                return !1
            }
            return !1
        },
        index: function() {
            let t, e = this[0];
            if (e) {
                for (t = 0; null !== (e = e.previousSibling);) 1 === e.nodeType && (t += 1);
                return t
            }
        },
        eq: function(t) {
            if (void 0 === t) return this;
            const e = this.length;
            let i;
            return new o(t > e - 1 ? [] : t < 0 ? (i = e + t) < 0 ? [] : [this[i]] : [this[t]])
        },
        append: function(...t) {
            let e;
            for (let i = 0; i < t.length; i += 1) {
                e = t[i];
                for (let t = 0; t < this.length; t += 1)
                    if ("string" == typeof e) {
                        const i = n.createElement("div");
                        for (i.innerHTML = e; i.firstChild;) this[t].appendChild(i.firstChild)
                    } else if (e instanceof o)
                    for (let i = 0; i < e.length; i += 1) this[t].appendChild(e[i]);
                else this[t].appendChild(e)
            }
            return this
        },
        prepend: function(t) {
            let e, i;
            for (e = 0; e < this.length; e += 1)
                if ("string" == typeof t) {
                    const s = n.createElement("div");
                    for (s.innerHTML = t, i = s.childNodes.length - 1; i >= 0; i -= 1) this[e].insertBefore(s.childNodes[i], this[e].childNodes[0])
                } else if (t instanceof o)
                for (i = 0; i < t.length; i += 1) this[e].insertBefore(t[i], this[e].childNodes[0]);
            else this[e].insertBefore(t, this[e].childNodes[0]);
            return this
        },
        next: function(t) {
            return this.length > 0 ? t ? this[0].nextElementSibling && r(this[0].nextElementSibling).is(t) ? new o([this[0].nextElementSibling]) : new o([]) : this[0].nextElementSibling ? new o([this[0].nextElementSibling]) : new o([]) : new o([])
        },
        nextAll: function(t) {
            const e = [];
            let i = this[0];
            if (!i) return new o([]);
            for (; i.nextElementSibling;) {
                const n = i.nextElementSibling;
                t ? r(n).is(t) && e.push(n) : e.push(n), i = n
            }
            return new o(e)
        },
        prev: function(t) {
            if (this.length > 0) {
                const e = this[0];
                return t ? e.previousElementSibling && r(e.previousElementSibling).is(t) ? new o([e.previousElementSibling]) : new o([]) : e.previousElementSibling ? new o([e.previousElementSibling]) : new o([])
            }
            return new o([])
        },
        prevAll: function(t) {
            const e = [];
            let i = this[0];
            if (!i) return new o([]);
            for (; i.previousElementSibling;) {
                const n = i.previousElementSibling;
                t ? r(n).is(t) && e.push(n) : e.push(n), i = n
            }
            return new o(e)
        },
        parent: function(t) {
            const e = [];
            for (let i = 0; i < this.length; i += 1) null !== this[i].parentNode && (t ? r(this[i].parentNode).is(t) && e.push(this[i].parentNode) : e.push(this[i].parentNode));
            return r(a(e))
        },
        parents: function(t) {
            const e = [];
            for (let i = 0; i < this.length; i += 1) {
                let n = this[i].parentNode;
                for (; n;) t ? r(n).is(t) && e.push(n) : e.push(n), n = n.parentNode
            }
            return r(a(e))
        },
        closest: function(t) {
            let e = this;
            return void 0 === t ? new o([]) : (e.is(t) || (e = e.parents(t).eq(0)), e)
        },
        find: function(t) {
            const e = [];
            for (let i = 0; i < this.length; i += 1) {
                const n = this[i].querySelectorAll(t);
                for (let t = 0; t < n.length; t += 1) e.push(n[t])
            }
            return new o(e)
        },
        children: function(t) {
            const e = [];
            for (let i = 0; i < this.length; i += 1) {
                const n = this[i].childNodes;
                for (let i = 0; i < n.length; i += 1) t ? 1 === n[i].nodeType && r(n[i]).is(t) && e.push(n[i]) : 1 === n[i].nodeType && e.push(n[i])
            }
            return new o(a(e))
        },
        remove: function() {
            for (let t = 0; t < this.length; t += 1) this[t].parentNode && this[t].parentNode.removeChild(this[t]);
            return this
        },
        add: function(...t) {
            const e = this;
            let i, n;
            for (i = 0; i < t.length; i += 1) {
                const s = r(t[i]);
                for (n = 0; n < s.length; n += 1) e[e.length] = s[n], e.length += 1
            }
            return e
        },
        styles: function() {
            return this[0] ? s.getComputedStyle(this[0], null) : {}
        }
    };
    Object.keys(l).forEach(t => {
        r.fn[t] = l[t]
    });
    const h = {
            deleteProps(t) {
                const e = t;
                Object.keys(e).forEach(t => {
                    try {
                        e[t] = null
                    } catch (t) {}
                    try {
                        delete e[t]
                    } catch (t) {}
                })
            },
            nextTick: (t, e = 0) => setTimeout(t, e),
            now: () => Date.now(),
            getTranslate(t, e = "x") {
                let i, n, o;
                const r = s.getComputedStyle(t, null);
                return s.WebKitCSSMatrix ? ((n = r.transform || r.webkitTransform).split(",").length > 6 && (n = n.split(", ").map(t => t.replace(",", ".")).join(", ")), o = new s.WebKitCSSMatrix("none" === n ? "" : n)) : i = (o = r.MozTransform || r.OTransform || r.MsTransform || r.msTransform || r.transform || r.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,")).toString().split(","), "x" === e && (n = s.WebKitCSSMatrix ? o.m41 : 16 === i.length ? parseFloat(i[12]) : parseFloat(i[4])), "y" === e && (n = s.WebKitCSSMatrix ? o.m42 : 16 === i.length ? parseFloat(i[13]) : parseFloat(i[5])), n || 0
            },
            parseUrlQuery(t) {
                const e = {};
                let i, n, o, r, a = t || s.location.href;
                if ("string" == typeof a && a.length)
                    for (r = (n = (a = a.indexOf("?") > -1 ? a.replace(/\S*\?/, "") : "").split("&").filter(t => "" !== t)).length, i = 0; i < r; i += 1) o = n[i].replace(/#\S+/g, "").split("="), e[decodeURIComponent(o[0])] = void 0 === o[1] ? void 0 : decodeURIComponent(o[1]) || "";
                return e
            },
            isObject: t => "object" == typeof t && null !== t && t.constructor && t.constructor === Object,
            extend(...t) {
                const e = Object(t[0]);
                for (let i = 1; i < t.length; i += 1) {
                    const n = t[i];
                    if (void 0 !== n && null !== n) {
                        const t = Object.keys(Object(n));
                        for (let i = 0, s = t.length; i < s; i += 1) {
                            const s = t[i],
                                o = Object.getOwnPropertyDescriptor(n, s);
                            void 0 !== o && o.enumerable && (h.isObject(e[s]) && h.isObject(n[s]) ? h.extend(e[s], n[s]) : !h.isObject(e[s]) && h.isObject(n[s]) ? (e[s] = {}, h.extend(e[s], n[s])) : e[s] = n[s])
                        }
                    }
                }
                return e
            }
        },
        c = function() {
            const t = n.createElement("div");
            return {
                touch: s.Modernizr && !0 === s.Modernizr.touch || !!(s.navigator.maxTouchPoints > 0 || "ontouchstart" in s || s.DocumentTouch && n instanceof s.DocumentTouch),
                pointerEvents: !!(s.navigator.pointerEnabled || s.PointerEvent || "maxTouchPoints" in s.navigator),
                prefixedPointerEvents: !!s.navigator.msPointerEnabled,
                transition: function() {
                    const e = t.style;
                    return "transition" in e || "webkitTransition" in e || "MozTransition" in e
                }(),
                transforms3d: s.Modernizr && !0 === s.Modernizr.csstransforms3d || function() {
                    const e = t.style;
                    return "webkitPerspective" in e || "MozPerspective" in e || "OPerspective" in e || "MsPerspective" in e || "perspective" in e
                }(),
                flexbox: function() {
                    const e = t.style,
                        i = "alignItems webkitAlignItems webkitBoxAlign msFlexAlign mozBoxAlign webkitFlexDirection msFlexDirection mozBoxDirection mozBoxOrient webkitBoxDirection webkitBoxOrient".split(" ");
                    for (let t = 0; t < i.length; t += 1)
                        if (i[t] in e) return !0;
                    return !1
                }(),
                observer: "MutationObserver" in s || "WebkitMutationObserver" in s,
                passiveListener: function() {
                    let t = !1;
                    try {
                        const e = Object.defineProperty({}, "passive", {
                            get() {
                                t = !0
                            }
                        });
                        s.addEventListener("testPassiveListener", null, e)
                    } catch (t) {}
                    return t
                }(),
                gestures: "ongesturestart" in s
            }
        }();
    class d {
        constructor(t = {}) {
            const e = this;
            e.params = t, e.eventsListeners = {}, e.params && e.params.on && Object.keys(e.params.on).forEach(t => {
                e.on(t, e.params.on[t])
            })
        }
        on(t, e, i) {
            const n = this;
            if ("function" != typeof e) return n;
            const s = i ? "unshift" : "push";
            return t.split(" ").forEach(t => {
                n.eventsListeners[t] || (n.eventsListeners[t] = []), n.eventsListeners[t][s](e)
            }), n
        }
        once(t, e, i) {
            const n = this;
            if ("function" != typeof e) return n;
            return n.on(t, function i(...s) {
                e.apply(n, s), n.off(t, i)
            }, i)
        }
        off(t, e) {
            const i = this;
            return i.eventsListeners ? (t.split(" ").forEach(t => {
                void 0 === e ? i.eventsListeners[t] = [] : i.eventsListeners[t] && i.eventsListeners[t].length && i.eventsListeners[t].forEach((n, s) => {
                    n === e && i.eventsListeners[t].splice(s, 1)
                })
            }), i) : i
        }
        emit(...t) {
            const e = this;
            if (!e.eventsListeners) return e;
            let i, n, s;
            return "string" == typeof t[0] || Array.isArray(t[0]) ? (i = t[0], n = t.slice(1, t.length), s = e) : (i = t[0].events, n = t[0].data, s = t[0].context || e), (Array.isArray(i) ? i : i.split(" ")).forEach(t => {
                if (e.eventsListeners && e.eventsListeners[t]) {
                    const i = [];
                    e.eventsListeners[t].forEach(t => {
                        i.push(t)
                    }), i.forEach(t => {
                        t.apply(s, n)
                    })
                }
            }), e
        }
        useModulesParams(t) {
            const e = this;
            e.modules && Object.keys(e.modules).forEach(i => {
                const n = e.modules[i];
                n.params && h.extend(t, n.params)
            })
        }
        useModules(t = {}) {
            const e = this;
            e.modules && Object.keys(e.modules).forEach(i => {
                const n = e.modules[i],
                    s = t[i] || {};
                n.instance && Object.keys(n.instance).forEach(t => {
                    const i = n.instance[t];
                    e[t] = "function" == typeof i ? i.bind(e) : i
                }), n.on && e.on && Object.keys(n.on).forEach(t => {
                    e.on(t, n.on[t])
                }), n.create && n.create.bind(e)(s)
            })
        }
        static set components(t) {
            this.use && this.use(t)
        }
        static installModule(t, ...e) {
            const i = this;
            i.prototype.modules || (i.prototype.modules = {});
            const n = t.name || `${Object.keys(i.prototype.modules).length}_${h.now()}`;
            return i.prototype.modules[n] = t, t.proto && Object.keys(t.proto).forEach(e => {
                i.prototype[e] = t.proto[e]
            }), t.static && Object.keys(t.static).forEach(e => {
                i[e] = t.static[e]
            }), t.install && t.install.apply(i, e), i
        }
        static use(t, ...e) {
            const i = this;
            return Array.isArray(t) ? (t.forEach(t => i.installModule(t)), i) : i.installModule(t, ...e)
        }
    }
    var u = {
        updateSize: function() {
            const t = this;
            let e, i;
            const n = t.$el;
            e = void 0 !== t.params.width ? t.params.width : n[0].clientWidth, i = void 0 !== t.params.height ? t.params.height : n[0].clientHeight, 0 === e && t.isHorizontal() || 0 === i && t.isVertical() || (e = e - parseInt(n.css("padding-left"), 10) - parseInt(n.css("padding-right"), 10), i = i - parseInt(n.css("padding-top"), 10) - parseInt(n.css("padding-bottom"), 10), h.extend(t, {
                width: e,
                height: i,
                size: t.isHorizontal() ? e : i
            }))
        },
        updateSlides: function() {
            const t = this,
                e = t.params,
                {
                    $wrapperEl: i,
                    size: n,
                    rtlTranslate: o,
                    wrongRTL: r
                } = t,
                a = t.virtual && e.virtual.enabled,
                l = a ? t.virtual.slides.length : t.slides.length,
                d = i.children(`.${t.params.slideClass}`),
                u = a ? t.virtual.slides.length : d.length;
            let p = [];
            const f = [],
                m = [];
            let g = e.slidesOffsetBefore;
            "function" == typeof g && (g = e.slidesOffsetBefore.call(t));
            let v = e.slidesOffsetAfter;
            "function" == typeof v && (v = e.slidesOffsetAfter.call(t));
            const y = t.snapGrid.length,
                _ = t.snapGrid.length;
            let b, w, x = e.spaceBetween,
                T = -g,
                E = 0,
                C = 0;
            if (void 0 === n) return;
            "string" == typeof x && x.indexOf("%") >= 0 && (x = parseFloat(x.replace("%", "")) / 100 * n), t.virtualSize = -x, o ? d.css({
                marginLeft: "",
                marginTop: ""
            }) : d.css({
                marginRight: "",
                marginBottom: ""
            }), e.slidesPerColumn > 1 && (b = Math.floor(u / e.slidesPerColumn) === u / t.params.slidesPerColumn ? u : Math.ceil(u / e.slidesPerColumn) * e.slidesPerColumn, "auto" !== e.slidesPerView && "row" === e.slidesPerColumnFill && (b = Math.max(b, e.slidesPerView * e.slidesPerColumn)));
            const S = e.slidesPerColumn,
                D = b / S,
                I = Math.floor(u / e.slidesPerColumn);
            for (let i = 0; i < u; i += 1) {
                w = 0;
                const o = d.eq(i);
                if (e.slidesPerColumn > 1) {
                    let n, s, r;
                    "column" === e.slidesPerColumnFill ? (r = i - (s = Math.floor(i / S)) * S, (s > I || s === I && r === S - 1) && (r += 1) >= S && (r = 0, s += 1), n = s + r * b / S, o.css({
                        "-webkit-box-ordinal-group": n,
                        "-moz-box-ordinal-group": n,
                        "-ms-flex-order": n,
                        "-webkit-order": n,
                        order: n
                    })) : s = i - (r = Math.floor(i / D)) * D, o.css(`margin-${t.isHorizontal()?"top":"left"}`, 0 !== r && e.spaceBetween && `${e.spaceBetween}px`).attr("data-swiper-column", s).attr("data-swiper-row", r)
                }
                if ("none" !== o.css("display")) {
                    if ("auto" === e.slidesPerView) {
                        const i = s.getComputedStyle(o[0], null),
                            n = o[0].style.transform,
                            r = o[0].style.webkitTransform;
                        if (n && (o[0].style.transform = "none"), r && (o[0].style.webkitTransform = "none"), e.roundLengths) w = t.isHorizontal() ? o.outerWidth(!0) : o.outerHeight(!0);
                        else if (t.isHorizontal()) {
                            const t = parseFloat(i.getPropertyValue("width")),
                                e = parseFloat(i.getPropertyValue("padding-left")),
                                n = parseFloat(i.getPropertyValue("padding-right")),
                                s = parseFloat(i.getPropertyValue("margin-left")),
                                o = parseFloat(i.getPropertyValue("margin-right")),
                                r = i.getPropertyValue("box-sizing");
                            w = r && "border-box" === r ? t + s + o : t + e + n + s + o
                        } else {
                            const t = parseFloat(i.getPropertyValue("height")),
                                e = parseFloat(i.getPropertyValue("padding-top")),
                                n = parseFloat(i.getPropertyValue("padding-bottom")),
                                s = parseFloat(i.getPropertyValue("margin-top")),
                                o = parseFloat(i.getPropertyValue("margin-bottom")),
                                r = i.getPropertyValue("box-sizing");
                            w = r && "border-box" === r ? t + s + o : t + e + n + s + o
                        }
                        n && (o[0].style.transform = n), r && (o[0].style.webkitTransform = r), e.roundLengths && (w = Math.floor(w))
                    } else w = (n - (e.slidesPerView - 1) * x) / e.slidesPerView, e.roundLengths && (w = Math.floor(w)), d[i] && (t.isHorizontal() ? d[i].style.width = `${w}px` : d[i].style.height = `${w}px`);
                    d[i] && (d[i].swiperSlideSize = w), m.push(w), e.centeredSlides ? (T = T + w / 2 + E / 2 + x, 0 === E && 0 !== i && (T = T - n / 2 - x), 0 === i && (T = T - n / 2 - x), Math.abs(T) < .001 && (T = 0), e.roundLengths && (T = Math.floor(T)), C % e.slidesPerGroup == 0 && p.push(T), f.push(T)) : (e.roundLengths && (T = Math.floor(T)), C % e.slidesPerGroup == 0 && p.push(T), f.push(T), T = T + w + x), t.virtualSize += w + x, E = w, C += 1
                }
            }
            let M;
            if (t.virtualSize = Math.max(t.virtualSize, n) + v, o && r && ("slide" === e.effect || "coverflow" === e.effect) && i.css({
                    width: `${t.virtualSize+e.spaceBetween}px`
                }), c.flexbox && !e.setWrapperSize || (t.isHorizontal() ? i.css({
                    width: `${t.virtualSize+e.spaceBetween}px`
                }) : i.css({
                    height: `${t.virtualSize+e.spaceBetween}px`
                })), e.slidesPerColumn > 1 && (t.virtualSize = (w + e.spaceBetween) * b, t.virtualSize = Math.ceil(t.virtualSize / e.slidesPerColumn) - e.spaceBetween, t.isHorizontal() ? i.css({
                    width: `${t.virtualSize+e.spaceBetween}px`
                }) : i.css({
                    height: `${t.virtualSize+e.spaceBetween}px`
                }), e.centeredSlides)) {
                M = [];
                for (let i = 0; i < p.length; i += 1) {
                    let n = p[i];
                    e.roundLengths && (n = Math.floor(n)), p[i] < t.virtualSize + p[0] && M.push(n)
                }
                p = M
            }
            if (!e.centeredSlides) {
                M = [];
                for (let i = 0; i < p.length; i += 1) {
                    let s = p[i];
                    e.roundLengths && (s = Math.floor(s)), p[i] <= t.virtualSize - n && M.push(s)
                }
                p = M, Math.floor(t.virtualSize - n) - Math.floor(p[p.length - 1]) > 1 && p.push(t.virtualSize - n)
            }
            if (0 === p.length && (p = [0]), 0 !== e.spaceBetween && (t.isHorizontal() ? o ? d.css({
                    marginLeft: `${x}px`
                }) : d.css({
                    marginRight: `${x}px`
                }) : d.css({
                    marginBottom: `${x}px`
                })), e.centerInsufficientSlides) {
                let t = 0;
                if (m.forEach(i => {
                        t += i + (e.spaceBetween ? e.spaceBetween : 0)
                    }), (t -= e.spaceBetween) < n) {
                    const e = (n - t) / 2;
                    p.forEach((t, i) => {
                        p[i] = t - e
                    }), f.forEach((t, i) => {
                        f[i] = t + e
                    })
                }
            }
            h.extend(t, {
                slides: d,
                snapGrid: p,
                slidesGrid: f,
                slidesSizesGrid: m
            }), u !== l && t.emit("slidesLengthChange"), p.length !== y && (t.params.watchOverflow && t.checkOverflow(), t.emit("snapGridLengthChange")), f.length !== _ && t.emit("slidesGridLengthChange"), (e.watchSlidesProgress || e.watchSlidesVisibility) && t.updateSlidesOffset()
        },
        updateAutoHeight: function(t) {
            const e = this,
                i = [];
            let n, s = 0;
            if ("number" == typeof t ? e.setTransition(t) : !0 === t && e.setTransition(e.params.speed), "auto" !== e.params.slidesPerView && e.params.slidesPerView > 1)
                for (n = 0; n < Math.ceil(e.params.slidesPerView); n += 1) {
                    const t = e.activeIndex + n;
                    if (t > e.slides.length) break;
                    i.push(e.slides.eq(t)[0])
                } else i.push(e.slides.eq(e.activeIndex)[0]);
            for (n = 0; n < i.length; n += 1)
                if (void 0 !== i[n]) {
                    const t = i[n].offsetHeight;
                    s = t > s ? t : s
                } s && e.$wrapperEl.css("height", `${s}px`)
        },
        updateSlidesOffset: function() {
            const t = this,
                e = t.slides;
            for (let i = 0; i < e.length; i += 1) e[i].swiperSlideOffset = t.isHorizontal() ? e[i].offsetLeft : e[i].offsetTop
        },
        updateSlidesProgress: function(t = this && this.translate || 0) {
            const e = this,
                i = e.params,
                {
                    slides: n,
                    rtlTranslate: s
                } = e;
            if (0 === n.length) return;
            void 0 === n[0].swiperSlideOffset && e.updateSlidesOffset();
            let o = -t;
            s && (o = t), n.removeClass(i.slideVisibleClass), e.visibleSlidesIndexes = [], e.visibleSlides = [];
            for (let t = 0; t < n.length; t += 1) {
                const r = n[t],
                    a = (o + (i.centeredSlides ? e.minTranslate() : 0) - r.swiperSlideOffset) / (r.swiperSlideSize + i.spaceBetween);
                if (i.watchSlidesVisibility) {
                    const s = -(o - r.swiperSlideOffset),
                        a = s + e.slidesSizesGrid[t];
                    (s >= 0 && s < e.size || a > 0 && a <= e.size || s <= 0 && a >= e.size) && (e.visibleSlides.push(r), e.visibleSlidesIndexes.push(t), n.eq(t).addClass(i.slideVisibleClass))
                }
                r.progress = s ? -a : a
            }
            e.visibleSlides = r(e.visibleSlides)
        },
        updateProgress: function(t = this && this.translate || 0) {
            const e = this,
                i = e.params,
                n = e.maxTranslate() - e.minTranslate();
            let {
                progress: s,
                isBeginning: o,
                isEnd: r
            } = e;
            const a = o,
                l = r;
            0 === n ? (s = 0, o = !0, r = !0) : (o = (s = (t - e.minTranslate()) / n) <= 0, r = s >= 1), h.extend(e, {
                progress: s,
                isBeginning: o,
                isEnd: r
            }), (i.watchSlidesProgress || i.watchSlidesVisibility) && e.updateSlidesProgress(t), o && !a && e.emit("reachBeginning toEdge"), r && !l && e.emit("reachEnd toEdge"), (a && !o || l && !r) && e.emit("fromEdge"), e.emit("progress", s)
        },
        updateSlidesClasses: function() {
            const t = this,
                {
                    slides: e,
                    params: i,
                    $wrapperEl: n,
                    activeIndex: s,
                    realIndex: o
                } = t,
                r = t.virtual && i.virtual.enabled;
            let a;
            e.removeClass(`${i.slideActiveClass} ${i.slideNextClass} ${i.slidePrevClass} ${i.slideDuplicateActiveClass} ${i.slideDuplicateNextClass} ${i.slideDuplicatePrevClass}`), (a = r ? t.$wrapperEl.find(`.${i.slideClass}[data-swiper-slide-index="${s}"]`) : e.eq(s)).addClass(i.slideActiveClass), i.loop && (a.hasClass(i.slideDuplicateClass) ? n.children(`.${i.slideClass}:not(.${i.slideDuplicateClass})[data-swiper-slide-index="${o}"]`).addClass(i.slideDuplicateActiveClass) : n.children(`.${i.slideClass}.${i.slideDuplicateClass}[data-swiper-slide-index="${o}"]`).addClass(i.slideDuplicateActiveClass));
            let l = a.nextAll(`.${i.slideClass}`).eq(0).addClass(i.slideNextClass);
            i.loop && 0 === l.length && (l = e.eq(0)).addClass(i.slideNextClass);
            let h = a.prevAll(`.${i.slideClass}`).eq(0).addClass(i.slidePrevClass);
            i.loop && 0 === h.length && (h = e.eq(-1)).addClass(i.slidePrevClass), i.loop && (l.hasClass(i.slideDuplicateClass) ? n.children(`.${i.slideClass}:not(.${i.slideDuplicateClass})[data-swiper-slide-index="${l.attr("data-swiper-slide-index")}"]`).addClass(i.slideDuplicateNextClass) : n.children(`.${i.slideClass}.${i.slideDuplicateClass}[data-swiper-slide-index="${l.attr("data-swiper-slide-index")}"]`).addClass(i.slideDuplicateNextClass), h.hasClass(i.slideDuplicateClass) ? n.children(`.${i.slideClass}:not(.${i.slideDuplicateClass})[data-swiper-slide-index="${h.attr("data-swiper-slide-index")}"]`).addClass(i.slideDuplicatePrevClass) : n.children(`.${i.slideClass}.${i.slideDuplicateClass}[data-swiper-slide-index="${h.attr("data-swiper-slide-index")}"]`).addClass(i.slideDuplicatePrevClass))
        },
        updateActiveIndex: function(t) {
            const e = this,
                i = e.rtlTranslate ? e.translate : -e.translate,
                {
                    slidesGrid: n,
                    snapGrid: s,
                    params: o,
                    activeIndex: r,
                    realIndex: a,
                    snapIndex: l
                } = e;
            let c, d = t;
            if (void 0 === d) {
                for (let t = 0; t < n.length; t += 1) void 0 !== n[t + 1] ? i >= n[t] && i < n[t + 1] - (n[t + 1] - n[t]) / 2 ? d = t : i >= n[t] && i < n[t + 1] && (d = t + 1) : i >= n[t] && (d = t);
                o.normalizeSlideIndex && (d < 0 || void 0 === d) && (d = 0)
            }
            if ((c = s.indexOf(i) >= 0 ? s.indexOf(i) : Math.floor(d / o.slidesPerGroup)) >= s.length && (c = s.length - 1), d === r) return void(c !== l && (e.snapIndex = c, e.emit("snapIndexChange")));
            const u = parseInt(e.slides.eq(d).attr("data-swiper-slide-index") || d, 10);
            h.extend(e, {
                snapIndex: c,
                realIndex: u,
                previousIndex: r,
                activeIndex: d
            }), e.emit("activeIndexChange"), e.emit("snapIndexChange"), a !== u && e.emit("realIndexChange"), e.emit("slideChange")
        },
        updateClickedSlide: function(t) {
            const e = this,
                i = e.params,
                n = r(t.target).closest(`.${i.slideClass}`)[0];
            let s = !1;
            if (n)
                for (let t = 0; t < e.slides.length; t += 1) e.slides[t] === n && (s = !0);
            if (!n || !s) return e.clickedSlide = void 0, void(e.clickedIndex = void 0);
            e.clickedSlide = n, e.virtual && e.params.virtual.enabled ? e.clickedIndex = parseInt(r(n).attr("data-swiper-slide-index"), 10) : e.clickedIndex = r(n).index(), i.slideToClickedSlide && void 0 !== e.clickedIndex && e.clickedIndex !== e.activeIndex && e.slideToClickedSlide()
        }
    };
    var p = {
        getTranslate: function(t = (this.isHorizontal() ? "x" : "y")) {
            const {
                params: e,
                rtlTranslate: i,
                translate: n,
                $wrapperEl: s
            } = this;
            if (e.virtualTranslate) return i ? -n : n;
            let o = h.getTranslate(s[0], t);
            return i && (o = -o), o || 0
        },
        setTranslate: function(t, e) {
            const i = this,
                {
                    rtlTranslate: n,
                    params: s,
                    $wrapperEl: o,
                    progress: r
                } = i;
            let a, l = 0,
                h = 0;
            i.isHorizontal() ? l = n ? -t : t : h = t, s.roundLengths && (l = Math.floor(l), h = Math.floor(h)), s.virtualTranslate || (c.transforms3d ? o.transform(`translate3d(${l}px, ${h}px, 0px)`) : o.transform(`translate(${l}px, ${h}px)`)), i.previousTranslate = i.translate, i.translate = i.isHorizontal() ? l : h;
            const d = i.maxTranslate() - i.minTranslate();
            (a = 0 === d ? 0 : (t - i.minTranslate()) / d) !== r && i.updateProgress(t), i.emit("setTranslate", i.translate, e)
        },
        minTranslate: function() {
            return -this.snapGrid[0]
        },
        maxTranslate: function() {
            return -this.snapGrid[this.snapGrid.length - 1]
        }
    };
    var f = {
        setTransition: function(t, e) {
            this.$wrapperEl.transition(t), this.emit("setTransition", t, e)
        },
        transitionStart: function(t = !0, e) {
            const i = this,
                {
                    activeIndex: n,
                    params: s,
                    previousIndex: o
                } = i;
            s.autoHeight && i.updateAutoHeight();
            let r = e;
            if (r || (r = n > o ? "next" : n < o ? "prev" : "reset"), i.emit("transitionStart"), t && n !== o) {
                if ("reset" === r) return void i.emit("slideResetTransitionStart");
                i.emit("slideChangeTransitionStart"), "next" === r ? i.emit("slideNextTransitionStart") : i.emit("slidePrevTransitionStart")
            }
        },
        transitionEnd: function(t = !0, e) {
            const i = this,
                {
                    activeIndex: n,
                    previousIndex: s
                } = i;
            i.animating = !1, i.setTransition(0);
            let o = e;
            if (o || (o = n > s ? "next" : n < s ? "prev" : "reset"), i.emit("transitionEnd"), t && n !== s) {
                if ("reset" === o) return void i.emit("slideResetTransitionEnd");
                i.emit("slideChangeTransitionEnd"), "next" === o ? i.emit("slideNextTransitionEnd") : i.emit("slidePrevTransitionEnd")
            }
        }
    };
    var m = {
        slideTo: function(t = 0, e = this.params.speed, i = !0, n) {
            const s = this;
            let o = t;
            o < 0 && (o = 0);
            const {
                params: r,
                snapGrid: a,
                slidesGrid: l,
                previousIndex: h,
                activeIndex: d,
                rtlTranslate: u
            } = s;
            if (s.animating && r.preventInteractionOnTransition) return !1;
            let p = Math.floor(o / r.slidesPerGroup);
            p >= a.length && (p = a.length - 1), (d || r.initialSlide || 0) === (h || 0) && i && s.emit("beforeSlideChangeStart");
            const f = -a[p];
            if (s.updateProgress(f), r.normalizeSlideIndex)
                for (let t = 0; t < l.length; t += 1) - Math.floor(100 * f) >= Math.floor(100 * l[t]) && (o = t);
            if (s.initialized && o !== d) {
                if (!s.allowSlideNext && f < s.translate && f < s.minTranslate()) return !1;
                if (!s.allowSlidePrev && f > s.translate && f > s.maxTranslate() && (d || 0) !== o) return !1
            }
            let m;
            return m = o > d ? "next" : o < d ? "prev" : "reset", u && -f === s.translate || !u && f === s.translate ? (s.updateActiveIndex(o), r.autoHeight && s.updateAutoHeight(), s.updateSlidesClasses(), "slide" !== r.effect && s.setTranslate(f), "reset" !== m && (s.transitionStart(i, m), s.transitionEnd(i, m)), !1) : (0 !== e && c.transition ? (s.setTransition(e), s.setTranslate(f), s.updateActiveIndex(o), s.updateSlidesClasses(), s.emit("beforeTransitionStart", e, n), s.transitionStart(i, m), s.animating || (s.animating = !0, s.onSlideToWrapperTransitionEnd || (s.onSlideToWrapperTransitionEnd = function(t) {
                s && !s.destroyed && t.target === this && (s.$wrapperEl[0].removeEventListener("transitionend", s.onSlideToWrapperTransitionEnd), s.$wrapperEl[0].removeEventListener("webkitTransitionEnd", s.onSlideToWrapperTransitionEnd), s.onSlideToWrapperTransitionEnd = null, delete s.onSlideToWrapperTransitionEnd, s.transitionEnd(i, m))
            }), s.$wrapperEl[0].addEventListener("transitionend", s.onSlideToWrapperTransitionEnd), s.$wrapperEl[0].addEventListener("webkitTransitionEnd", s.onSlideToWrapperTransitionEnd))) : (s.setTransition(0), s.setTranslate(f), s.updateActiveIndex(o), s.updateSlidesClasses(), s.emit("beforeTransitionStart", e, n), s.transitionStart(i, m), s.transitionEnd(i, m)), !0)
        },
        slideToLoop: function(t = 0, e = this.params.speed, i = !0, n) {
            const s = this;
            let o = t;
            return s.params.loop && (o += s.loopedSlides), s.slideTo(o, e, i, n)
        },
        slideNext: function(t = this.params.speed, e = !0, i) {
            const n = this,
                {
                    params: s,
                    animating: o
                } = n;
            return s.loop ? !o && (n.loopFix(), n._clientLeft = n.$wrapperEl[0].clientLeft, n.slideTo(n.activeIndex + s.slidesPerGroup, t, e, i)) : n.slideTo(n.activeIndex + s.slidesPerGroup, t, e, i)
        },
        slidePrev: function(t = this.params.speed, e = !0, i) {
            const n = this,
                {
                    params: s,
                    animating: o,
                    snapGrid: r,
                    slidesGrid: a,
                    rtlTranslate: l
                } = n;
            if (s.loop) {
                if (o) return !1;
                n.loopFix(), n._clientLeft = n.$wrapperEl[0].clientLeft
            }
  
            function h(t) {
                return t < 0 ? -Math.floor(Math.abs(t)) : Math.floor(t)
            }
            const c = h(l ? n.translate : -n.translate),
                d = r.map(t => h(t)),
                u = (a.map(t => h(t)), r[d.indexOf(c)], r[d.indexOf(c) - 1]);
            let p;
            return void 0 !== u && (p = a.indexOf(u)) < 0 && (p = n.activeIndex - 1), n.slideTo(p, t, e, i)
        },
        slideReset: function(t = this.params.speed, e = !0, i) {
            return this.slideTo(this.activeIndex, t, e, i)
        },
        slideToClosest: function(t = this.params.speed, e = !0, i) {
            const n = this;
            let s = n.activeIndex;
            const o = Math.floor(s / n.params.slidesPerGroup);
            if (o < n.snapGrid.length - 1) {
                const t = n.rtlTranslate ? n.translate : -n.translate,
                    e = n.snapGrid[o];
                t - e > (n.snapGrid[o + 1] - e) / 2 && (s = n.params.slidesPerGroup)
            }
            return n.slideTo(s, t, e, i)
        },
        slideToClickedSlide: function() {
            const t = this,
                {
                    params: e,
                    $wrapperEl: i
                } = t,
                n = "auto" === e.slidesPerView ? t.slidesPerViewDynamic() : e.slidesPerView;
            let s, o = t.clickedIndex;
            if (e.loop) {
                if (t.animating) return;
                s = parseInt(r(t.clickedSlide).attr("data-swiper-slide-index"), 10), e.centeredSlides ? o < t.loopedSlides - n / 2 || o > t.slides.length - t.loopedSlides + n / 2 ? (t.loopFix(), o = i.children(`.${e.slideClass}[data-swiper-slide-index="${s}"]:not(.${e.slideDuplicateClass})`).eq(0).index(), h.nextTick(() => {
                    t.slideTo(o)
                })) : t.slideTo(o) : o > t.slides.length - n ? (t.loopFix(), o = i.children(`.${e.slideClass}[data-swiper-slide-index="${s}"]:not(.${e.slideDuplicateClass})`).eq(0).index(), h.nextTick(() => {
                    t.slideTo(o)
                })) : t.slideTo(o)
            } else t.slideTo(o)
        }
    };
    var g = {
        loopCreate: function() {
            const t = this,
                {
                    params: e,
                    $wrapperEl: i
                } = t;
            i.children(`.${e.slideClass}.${e.slideDuplicateClass}`).remove();
            let s = i.children(`.${e.slideClass}`);
            if (e.loopFillGroupWithBlank) {
                const t = e.slidesPerGroup - s.length % e.slidesPerGroup;
                if (t !== e.slidesPerGroup) {
                    for (let s = 0; s < t; s += 1) {
                        const t = r(n.createElement("div")).addClass(`${e.slideClass} ${e.slideBlankClass}`);
                        i.append(t)
                    }
                    s = i.children(`.${e.slideClass}`)
                }
            }
            "auto" !== e.slidesPerView || e.loopedSlides || (e.loopedSlides = s.length), t.loopedSlides = parseInt(e.loopedSlides || e.slidesPerView, 10), t.loopedSlides += e.loopAdditionalSlides, t.loopedSlides > s.length && (t.loopedSlides = s.length);
            const o = [],
                a = [];
            s.each((e, i) => {
                const n = r(i);
                e < t.loopedSlides && a.push(i), e < s.length && e >= s.length - t.loopedSlides && o.push(i), n.attr("data-swiper-slide-index", e)
            });
            for (let t = 0; t < a.length; t += 1) i.append(r(a[t].cloneNode(!0)).addClass(e.slideDuplicateClass));
            for (let t = o.length - 1; t >= 0; t -= 1) i.prepend(r(o[t].cloneNode(!0)).addClass(e.slideDuplicateClass))
        },
        loopFix: function() {
            const t = this,
                {
                    params: e,
                    activeIndex: i,
                    slides: n,
                    loopedSlides: s,
                    allowSlidePrev: o,
                    allowSlideNext: r,
                    snapGrid: a,
                    rtlTranslate: l
                } = t;
            let h;
            t.allowSlidePrev = !0, t.allowSlideNext = !0;
            const c = -a[i] - t.getTranslate();
            i < s ? (h = n.length - 3 * s + i, h += s, t.slideTo(h, 0, !1, !0) && 0 !== c && t.setTranslate((l ? -t.translate : t.translate) - c)) : ("auto" === e.slidesPerView && i >= 2 * s || i >= n.length - s) && (h = -n.length + i + s, h += s, t.slideTo(h, 0, !1, !0) && 0 !== c && t.setTranslate((l ? -t.translate : t.translate) - c));
            t.allowSlidePrev = o, t.allowSlideNext = r
        },
        loopDestroy: function() {
            const {
                $wrapperEl: t,
                params: e,
                slides: i
            } = this;
            t.children(`.${e.slideClass}.${e.slideDuplicateClass},.${e.slideClass}.${e.slideBlankClass}`).remove(), i.removeAttr("data-swiper-slide-index")
        }
    };
    var v = {
        setGrabCursor: function(t) {
            if (c.touch || !this.params.simulateTouch || this.params.watchOverflow && this.isLocked) return;
            const e = this.el;
            e.style.cursor = "move", e.style.cursor = t ? "-webkit-grabbing" : "-webkit-grab", e.style.cursor = t ? "-moz-grabbin" : "-moz-grab", e.style.cursor = t ? "grabbing" : "grab"
        },
        unsetGrabCursor: function() {
            c.touch || this.params.watchOverflow && this.isLocked || (this.el.style.cursor = "")
        }
    };
    var y = {
        appendSlide: function(t) {
            const e = this,
                {
                    $wrapperEl: i,
                    params: n
                } = e;
            if (n.loop && e.loopDestroy(), "object" == typeof t && "length" in t)
                for (let e = 0; e < t.length; e += 1) t[e] && i.append(t[e]);
            else i.append(t);
            n.loop && e.loopCreate(), n.observer && c.observer || e.update()
        },
        prependSlide: function(t) {
            const e = this,
                {
                    params: i,
                    $wrapperEl: n,
                    activeIndex: s
                } = e;
            i.loop && e.loopDestroy();
            let o = s + 1;
            if ("object" == typeof t && "length" in t) {
                for (let e = 0; e < t.length; e += 1) t[e] && n.prepend(t[e]);
                o = s + t.length
            } else n.prepend(t);
            i.loop && e.loopCreate(), i.observer && c.observer || e.update(), e.slideTo(o, 0, !1)
        },
        addSlide: function(t, e) {
            const i = this,
                {
                    $wrapperEl: n,
                    params: s,
                    activeIndex: o
                } = i;
            let r = o;
            s.loop && (r -= i.loopedSlides, i.loopDestroy(), i.slides = n.children(`.${s.slideClass}`));
            const a = i.slides.length;
            if (t <= 0) return void i.prependSlide(e);
            if (t >= a) return void i.appendSlide(e);
            let l = r > t ? r + 1 : r;
            const h = [];
            for (let e = a - 1; e >= t; e -= 1) {
                const t = i.slides.eq(e);
                t.remove(), h.unshift(t)
            }
            if ("object" == typeof e && "length" in e) {
                for (let t = 0; t < e.length; t += 1) e[t] && n.append(e[t]);
                l = r > t ? r + e.length : r
            } else n.append(e);
            for (let t = 0; t < h.length; t += 1) n.append(h[t]);
            s.loop && i.loopCreate(), s.observer && c.observer || i.update(), s.loop ? i.slideTo(l + i.loopedSlides, 0, !1) : i.slideTo(l, 0, !1)
        },
        removeSlide: function(t) {
            const e = this,
                {
                    params: i,
                    $wrapperEl: n,
                    activeIndex: s
                } = e;
            let o = s;
            i.loop && (o -= e.loopedSlides, e.loopDestroy(), e.slides = n.children(`.${i.slideClass}`));
            let r, a = o;
            if ("object" == typeof t && "length" in t) {
                for (let i = 0; i < t.length; i += 1) r = t[i], e.slides[r] && e.slides.eq(r).remove(), r < a && (a -= 1);
                a = Math.max(a, 0)
            } else r = t, e.slides[r] && e.slides.eq(r).remove(), r < a && (a -= 1), a = Math.max(a, 0);
            i.loop && e.loopCreate(), i.observer && c.observer || e.update(), i.loop ? e.slideTo(a + e.loopedSlides, 0, !1) : e.slideTo(a, 0, !1)
        },
        removeAllSlides: function() {
            const t = this,
                e = [];
            for (let i = 0; i < t.slides.length; i += 1) e.push(i);
            t.removeSlide(e)
        }
    };
    const _ = function() {
        const t = s.navigator.userAgent,
            e = {
                ios: !1,
                android: !1,
                androidChrome: !1,
                desktop: !1,
                windows: !1,
                iphone: !1,
                ipod: !1,
                ipad: !1,
                cordova: s.cordova || s.phonegap,
                phonegap: s.cordova || s.phonegap
            },
            i = t.match(/(Windows Phone);?[\s\/]+([\d.]+)?/),
            o = t.match(/(Android);?[\s\/]+([\d.]+)?/),
            r = t.match(/(iPad).*OS\s([\d_]+)/),
            a = t.match(/(iPod)(.*OS\s([\d_]+))?/),
            l = !r && t.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
        if (i && (e.os = "windows", e.osVersion = i[2], e.windows = !0), o && !i && (e.os = "android", e.osVersion = o[2], e.android = !0, e.androidChrome = t.toLowerCase().indexOf("chrome") >= 0), (r || l || a) && (e.os = "ios", e.ios = !0), l && !a && (e.osVersion = l[2].replace(/_/g, "."), e.iphone = !0), r && (e.osVersion = r[2].replace(/_/g, "."), e.ipad = !0), a && (e.osVersion = a[3] ? a[3].replace(/_/g, ".") : null, e.iphone = !0), e.ios && e.osVersion && t.indexOf("Version/") >= 0 && "10" === e.osVersion.split(".")[0] && (e.osVersion = t.toLowerCase().split("version/")[1].split(" ")[0]), e.desktop = !(e.os || e.android || e.webView), e.webView = (l || r || a) && t.match(/.*AppleWebKit(?!.*Safari)/i), e.os && "ios" === e.os) {
            const t = e.osVersion.split("."),
                i = n.querySelector('meta[name="viewport"]');
            e.minimalUi = !e.webView && (a || l) && (1 * t[0] == 7 ? 1 * t[1] >= 1 : 1 * t[0] > 7) && i && i.getAttribute("content").indexOf("minimal-ui") >= 0
        }
        return e.pixelRatio = s.devicePixelRatio || 1, e
    }();
  
    function b() {
        const t = this,
            {
                params: e,
                el: i
            } = t;
        if (i && 0 === i.offsetWidth) return;
        e.breakpoints && t.setBreakpoint();
        const {
            allowSlideNext: n,
            allowSlidePrev: s,
            snapGrid: o
        } = t;
        if (t.allowSlideNext = !0, t.allowSlidePrev = !0, t.updateSize(), t.updateSlides(), e.freeMode) {
            const i = Math.min(Math.max(t.translate, t.maxTranslate()), t.minTranslate());
            t.setTranslate(i), t.updateActiveIndex(), t.updateSlidesClasses(), e.autoHeight && t.updateAutoHeight()
        } else t.updateSlidesClasses(), ("auto" === e.slidesPerView || e.slidesPerView > 1) && t.isEnd && !t.params.centeredSlides ? t.slideTo(t.slides.length - 1, 0, !1, !0) : t.slideTo(t.activeIndex, 0, !1, !0);
        t.allowSlidePrev = s, t.allowSlideNext = n, t.params.watchOverflow && o !== t.snapGrid && t.checkOverflow()
    }
    var w = {
        attachEvents: function() {
            const t = this,
                {
                    params: e,
                    touchEvents: i,
                    el: o,
                    wrapperEl: a
                } = t;
            t.onTouchStart = function(t) {
                const e = this,
                    i = e.touchEventsData,
                    {
                        params: o,
                        touches: a
                    } = e;
                if (e.animating && o.preventInteractionOnTransition) return;
                let l = t;
                if (l.originalEvent && (l = l.originalEvent), i.isTouchEvent = "touchstart" === l.type, !i.isTouchEvent && "which" in l && 3 === l.which) return;
                if (!i.isTouchEvent && "button" in l && l.button > 0) return;
                if (i.isTouched && i.isMoved) return;
                if (o.noSwiping && r(l.target).closest(o.noSwipingSelector ? o.noSwipingSelector : `.${o.noSwipingClass}`)[0]) return void(e.allowClick = !0);
                if (o.swipeHandler && !r(l).closest(o.swipeHandler)[0]) return;
                a.currentX = "touchstart" === l.type ? l.targetTouches[0].pageX : l.pageX, a.currentY = "touchstart" === l.type ? l.targetTouches[0].pageY : l.pageY;
                const c = a.currentX,
                    d = a.currentY,
                    u = o.edgeSwipeDetection || o.iOSEdgeSwipeDetection,
                    p = o.edgeSwipeThreshold || o.iOSEdgeSwipeThreshold;
                if (!u || !(c <= p || c >= s.screen.width - p)) {
                    if (h.extend(i, {
                            isTouched: !0,
                            isMoved: !1,
                            allowTouchCallbacks: !0,
                            isScrolling: void 0,
                            startMoving: void 0
                        }), a.startX = c, a.startY = d, i.touchStartTime = h.now(), e.allowClick = !0, e.updateSize(), e.swipeDirection = void 0, o.threshold > 0 && (i.allowThresholdMove = !1), "touchstart" !== l.type) {
                        let t = !0;
                        r(l.target).is(i.formElements) && (t = !1), n.activeElement && r(n.activeElement).is(i.formElements) && n.activeElement !== l.target && n.activeElement.blur();
                        const s = t && e.allowTouchMove && o.touchStartPreventDefault;
                        (o.touchStartForcePreventDefault || s) && l.preventDefault()
                    }
                    e.emit("touchStart", l)
                }
            }.bind(t), t.onTouchMove = function(t) {
                const e = this,
                    i = e.touchEventsData,
                    {
                        params: s,
                        touches: o,
                        rtlTranslate: a
                    } = e;
                let l = t;
                if (l.originalEvent && (l = l.originalEvent), !i.isTouched) return void(i.startMoving && i.isScrolling && e.emit("touchMoveOpposite", l));
                if (i.isTouchEvent && "mousemove" === l.type) return;
                const c = "touchmove" === l.type ? l.targetTouches[0].pageX : l.pageX,
                    d = "touchmove" === l.type ? l.targetTouches[0].pageY : l.pageY;
                if (l.preventedByNestedSwiper) return o.startX = c, void(o.startY = d);
                if (!e.allowTouchMove) return e.allowClick = !1, void(i.isTouched && (h.extend(o, {
                    startX: c,
                    startY: d,
                    currentX: c,
                    currentY: d
                }), i.touchStartTime = h.now()));
                if (i.isTouchEvent && s.touchReleaseOnEdges && !s.loop)
                    if (e.isVertical()) {
                        if (d < o.startY && e.translate <= e.maxTranslate() || d > o.startY && e.translate >= e.minTranslate()) return i.isTouched = !1, void(i.isMoved = !1)
                    } else if (c < o.startX && e.translate <= e.maxTranslate() || c > o.startX && e.translate >= e.minTranslate()) return;
                if (i.isTouchEvent && n.activeElement && l.target === n.activeElement && r(l.target).is(i.formElements)) return i.isMoved = !0, void(e.allowClick = !1);
                if (i.allowTouchCallbacks && e.emit("touchMove", l), l.targetTouches && l.targetTouches.length > 1) return;
                o.currentX = c, o.currentY = d;
                const u = o.currentX - o.startX,
                    p = o.currentY - o.startY;
                if (e.params.threshold && Math.sqrt(u ** 2 + p ** 2) < e.params.threshold) return;
                if (void 0 === i.isScrolling) {
                    let t;
                    e.isHorizontal() && o.currentY === o.startY || e.isVertical() && o.currentX === o.startX ? i.isScrolling = !1 : u * u + p * p >= 25 && (t = 180 * Math.atan2(Math.abs(p), Math.abs(u)) / Math.PI, i.isScrolling = e.isHorizontal() ? t > s.touchAngle : 90 - t > s.touchAngle)
                }
                if (i.isScrolling && e.emit("touchMoveOpposite", l), void 0 === i.startMoving && (o.currentX === o.startX && o.currentY === o.startY || (i.startMoving = !0)), i.isScrolling) return void(i.isTouched = !1);
                if (!i.startMoving) return;
                e.allowClick = !1, l.preventDefault(), s.touchMoveStopPropagation && !s.nested && l.stopPropagation(), i.isMoved || (s.loop && e.loopFix(), i.startTranslate = e.getTranslate(), e.setTransition(0), e.animating && e.$wrapperEl.trigger("webkitTransitionEnd transitionend"), i.allowMomentumBounce = !1, !s.grabCursor || !0 !== e.allowSlideNext && !0 !== e.allowSlidePrev || e.setGrabCursor(!0), e.emit("sliderFirstMove", l)), e.emit("sliderMove", l), i.isMoved = !0;
                let f = e.isHorizontal() ? u : p;
                o.diff = f, f *= s.touchRatio, a && (f = -f), e.swipeDirection = f > 0 ? "prev" : "next", i.currentTranslate = f + i.startTranslate;
                let m = !0,
                    g = s.resistanceRatio;
                if (s.touchReleaseOnEdges && (g = 0), f > 0 && i.currentTranslate > e.minTranslate() ? (m = !1, s.resistance && (i.currentTranslate = e.minTranslate() - 1 + (-e.minTranslate() + i.startTranslate + f) ** g)) : f < 0 && i.currentTranslate < e.maxTranslate() && (m = !1, s.resistance && (i.currentTranslate = e.maxTranslate() + 1 - (e.maxTranslate() - i.startTranslate - f) ** g)), m && (l.preventedByNestedSwiper = !0), !e.allowSlideNext && "next" === e.swipeDirection && i.currentTranslate < i.startTranslate && (i.currentTranslate = i.startTranslate), !e.allowSlidePrev && "prev" === e.swipeDirection && i.currentTranslate > i.startTranslate && (i.currentTranslate = i.startTranslate), s.threshold > 0) {
                    if (!(Math.abs(f) > s.threshold || i.allowThresholdMove)) return void(i.currentTranslate = i.startTranslate);
                    if (!i.allowThresholdMove) return i.allowThresholdMove = !0, o.startX = o.currentX, o.startY = o.currentY, i.currentTranslate = i.startTranslate, void(o.diff = e.isHorizontal() ? o.currentX - o.startX : o.currentY - o.startY)
                }
                s.followFinger && ((s.freeMode || s.watchSlidesProgress || s.watchSlidesVisibility) && (e.updateActiveIndex(), e.updateSlidesClasses()), s.freeMode && (0 === i.velocities.length && i.velocities.push({
                    position: o[e.isHorizontal() ? "startX" : "startY"],
                    time: i.touchStartTime
                }), i.velocities.push({
                    position: o[e.isHorizontal() ? "currentX" : "currentY"],
                    time: h.now()
                })), e.updateProgress(i.currentTranslate), e.setTranslate(i.currentTranslate))
            }.bind(t), t.onTouchEnd = function(t) {
                const e = this,
                    i = e.touchEventsData,
                    {
                        params: n,
                        touches: s,
                        rtlTranslate: o,
                        $wrapperEl: r,
                        slidesGrid: a,
                        snapGrid: l
                    } = e;
                let c = t;
                if (c.originalEvent && (c = c.originalEvent), i.allowTouchCallbacks && e.emit("touchEnd", c), i.allowTouchCallbacks = !1, !i.isTouched) return i.isMoved && n.grabCursor && e.setGrabCursor(!1), i.isMoved = !1, void(i.startMoving = !1);
                n.grabCursor && i.isMoved && i.isTouched && (!0 === e.allowSlideNext || !0 === e.allowSlidePrev) && e.setGrabCursor(!1);
                const d = h.now(),
                    u = d - i.touchStartTime;
                if (e.allowClick && (e.updateClickedSlide(c), e.emit("tap", c), u < 300 && d - i.lastClickTime > 300 && (i.clickTimeout && clearTimeout(i.clickTimeout), i.clickTimeout = h.nextTick(() => {
                        e && !e.destroyed && e.emit("click", c)
                    }, 300)), u < 300 && d - i.lastClickTime < 300 && (i.clickTimeout && clearTimeout(i.clickTimeout), e.emit("doubleTap", c))), i.lastClickTime = h.now(), h.nextTick(() => {
                        e.destroyed || (e.allowClick = !0)
                    }), !i.isTouched || !i.isMoved || !e.swipeDirection || 0 === s.diff || i.currentTranslate === i.startTranslate) return i.isTouched = !1, i.isMoved = !1, void(i.startMoving = !1);
                let p;
                if (i.isTouched = !1, i.isMoved = !1, i.startMoving = !1, p = n.followFinger ? o ? e.translate : -e.translate : -i.currentTranslate, n.freeMode) {
                    if (p < -e.minTranslate()) return void e.slideTo(e.activeIndex);
                    if (p > -e.maxTranslate()) return void(e.slides.length < l.length ? e.slideTo(l.length - 1) : e.slideTo(e.slides.length - 1));
                    if (n.freeModeMomentum) {
                        if (i.velocities.length > 1) {
                            const t = i.velocities.pop(),
                                s = i.velocities.pop(),
                                o = t.position - s.position,
                                r = t.time - s.time;
                            e.velocity = o / r, e.velocity /= 2, Math.abs(e.velocity) < n.freeModeMinimumVelocity && (e.velocity = 0), (r > 150 || h.now() - t.time > 300) && (e.velocity = 0)
                        } else e.velocity = 0;
                        e.velocity *= n.freeModeMomentumVelocityRatio, i.velocities.length = 0;
                        let t = 1e3 * n.freeModeMomentumRatio;
                        const s = e.velocity * t;
                        let a = e.translate + s;
                        o && (a = -a);
                        let c, d = !1;
                        const u = 20 * Math.abs(e.velocity) * n.freeModeMomentumBounceRatio;
                        let p;
                        if (a < e.maxTranslate()) n.freeModeMomentumBounce ? (a + e.maxTranslate() < -u && (a = e.maxTranslate() - u), c = e.maxTranslate(), d = !0, i.allowMomentumBounce = !0) : a = e.maxTranslate(), n.loop && n.centeredSlides && (p = !0);
                        else if (a > e.minTranslate()) n.freeModeMomentumBounce ? (a - e.minTranslate() > u && (a = e.minTranslate() + u), c = e.minTranslate(), d = !0, i.allowMomentumBounce = !0) : a = e.minTranslate(), n.loop && n.centeredSlides && (p = !0);
                        else if (n.freeModeSticky) {
                            let t;
                            for (let e = 0; e < l.length; e += 1)
                                if (l[e] > -a) {
                                    t = e;
                                    break
                                } a = -(a = Math.abs(l[t] - a) < Math.abs(l[t - 1] - a) || "next" === e.swipeDirection ? l[t] : l[t - 1])
                        }
                        if (p && e.once("transitionEnd", () => {
                                e.loopFix()
                            }), 0 !== e.velocity) t = o ? Math.abs((-a - e.translate) / e.velocity) : Math.abs((a - e.translate) / e.velocity);
                        else if (n.freeModeSticky) return void e.slideToClosest();
                        n.freeModeMomentumBounce && d ? (e.updateProgress(c), e.setTransition(t), e.setTranslate(a), e.transitionStart(!0, e.swipeDirection), e.animating = !0, r.transitionEnd(() => {
                            e && !e.destroyed && i.allowMomentumBounce && (e.emit("momentumBounce"), e.setTransition(n.speed), e.setTranslate(c), r.transitionEnd(() => {
                                e && !e.destroyed && e.transitionEnd()
                            }))
                        })) : e.velocity ? (e.updateProgress(a), e.setTransition(t), e.setTranslate(a), e.transitionStart(!0, e.swipeDirection), e.animating || (e.animating = !0, r.transitionEnd(() => {
                            e && !e.destroyed && e.transitionEnd()
                        }))) : e.updateProgress(a), e.updateActiveIndex(), e.updateSlidesClasses()
                    } else if (n.freeModeSticky) return void e.slideToClosest();
                    return void((!n.freeModeMomentum || u >= n.longSwipesMs) && (e.updateProgress(), e.updateActiveIndex(), e.updateSlidesClasses()))
                }
                let f = 0,
                    m = e.slidesSizesGrid[0];
                for (let t = 0; t < a.length; t += n.slidesPerGroup) void 0 !== a[t + n.slidesPerGroup] ? p >= a[t] && p < a[t + n.slidesPerGroup] && (f = t, m = a[t + n.slidesPerGroup] - a[t]) : p >= a[t] && (f = t, m = a[a.length - 1] - a[a.length - 2]);
                const g = (p - a[f]) / m;
                if (u > n.longSwipesMs) {
                    if (!n.longSwipes) return void e.slideTo(e.activeIndex);
                    "next" === e.swipeDirection && (g >= n.longSwipesRatio ? e.slideTo(f + n.slidesPerGroup) : e.slideTo(f)), "prev" === e.swipeDirection && (g > 1 - n.longSwipesRatio ? e.slideTo(f + n.slidesPerGroup) : e.slideTo(f))
                } else {
                    if (!n.shortSwipes) return void e.slideTo(e.activeIndex);
                    "next" === e.swipeDirection && e.slideTo(f + n.slidesPerGroup), "prev" === e.swipeDirection && e.slideTo(f)
                }
            }.bind(t), t.onClick = function(t) {
                const e = this;
                e.allowClick || (e.params.preventClicks && t.preventDefault(), e.params.preventClicksPropagation && e.animating && (t.stopPropagation(), t.stopImmediatePropagation()))
            }.bind(t);
            const l = "container" === e.touchEventsTarget ? o : a,
                d = !!e.nested;
            if (c.touch || !c.pointerEvents && !c.prefixedPointerEvents) {
                if (c.touch) {
                    const n = !("touchstart" !== i.start || !c.passiveListener || !e.passiveListeners) && {
                        passive: !0,
                        capture: !1
                    };
                    l.addEventListener(i.start, t.onTouchStart, n), l.addEventListener(i.move, t.onTouchMove, c.passiveListener ? {
                        passive: !1,
                        capture: d
                    } : d), l.addEventListener(i.end, t.onTouchEnd, n)
                }(e.simulateTouch && !_.ios && !_.android || e.simulateTouch && !c.touch && _.ios) && (l.addEventListener("mousedown", t.onTouchStart, !1), n.addEventListener("mousemove", t.onTouchMove, d), n.addEventListener("mouseup", t.onTouchEnd, !1))
            } else l.addEventListener(i.start, t.onTouchStart, !1), n.addEventListener(i.move, t.onTouchMove, d), n.addEventListener(i.end, t.onTouchEnd, !1);
            (e.preventClicks || e.preventClicksPropagation) && l.addEventListener("click", t.onClick, !0), t.on(_.ios || _.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", b, !0)
        },
        detachEvents: function() {
            const t = this,
                {
                    params: e,
                    touchEvents: i,
                    el: s,
                    wrapperEl: o
                } = t,
                r = "container" === e.touchEventsTarget ? s : o,
                a = !!e.nested;
            if (c.touch || !c.pointerEvents && !c.prefixedPointerEvents) {
                if (c.touch) {
                    const n = !("onTouchStart" !== i.start || !c.passiveListener || !e.passiveListeners) && {
                        passive: !0,
                        capture: !1
                    };
                    r.removeEventListener(i.start, t.onTouchStart, n), r.removeEventListener(i.move, t.onTouchMove, a), r.removeEventListener(i.end, t.onTouchEnd, n)
                }(e.simulateTouch && !_.ios && !_.android || e.simulateTouch && !c.touch && _.ios) && (r.removeEventListener("mousedown", t.onTouchStart, !1), n.removeEventListener("mousemove", t.onTouchMove, a), n.removeEventListener("mouseup", t.onTouchEnd, !1))
            } else r.removeEventListener(i.start, t.onTouchStart, !1), n.removeEventListener(i.move, t.onTouchMove, a), n.removeEventListener(i.end, t.onTouchEnd, !1);
            (e.preventClicks || e.preventClicksPropagation) && r.removeEventListener("click", t.onClick, !0), t.off(_.ios || _.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", b)
        }
    };
    var x = {
        setBreakpoint: function() {
            const t = this,
                {
                    activeIndex: e,
                    initialized: i,
                    loopedSlides: n = 0,
                    params: s
                } = t,
                o = s.breakpoints;
            if (!o || o && 0 === Object.keys(o).length) return;
            const r = t.getBreakpoint(o);
            if (r && t.currentBreakpoint !== r) {
                const a = r in o ? o[r] : void 0;
                a && ["slidesPerView", "spaceBetween", "slidesPerGroup"].forEach(t => {
                    const e = a[t];
                    void 0 !== e && (a[t] = "slidesPerView" !== t || "AUTO" !== e && "auto" !== e ? "slidesPerView" === t ? parseFloat(e) : parseInt(e, 10) : "auto")
                });
                const l = a || t.originalParams,
                    c = s.loop && l.slidesPerView !== s.slidesPerView;
                h.extend(t.params, l), h.extend(t, {
                    allowTouchMove: t.params.allowTouchMove,
                    allowSlideNext: t.params.allowSlideNext,
                    allowSlidePrev: t.params.allowSlidePrev
                }), t.currentBreakpoint = r, c && i && (t.loopDestroy(), t.loopCreate(), t.updateSlides(), t.slideTo(e - n + t.loopedSlides, 0, !1)), t.emit("breakpoint", l)
            }
        },
        getBreakpoint: function(t) {
            const e = this;
            if (!t) return;
            let i = !1;
            const n = [];
            Object.keys(t).forEach(t => {
                n.push(t)
            }), n.sort((t, e) => parseInt(t, 10) - parseInt(e, 10));
            for (let t = 0; t < n.length; t += 1) {
                const o = n[t];
                e.params.breakpointsInverse ? o <= s.innerWidth && (i = o) : o >= s.innerWidth && !i && (i = o)
            }
            return i || "max"
        }
    };
    const T = function() {
        return {
            isIE: !!s.navigator.userAgent.match(/Trident/g) || !!s.navigator.userAgent.match(/MSIE/g),
            isEdge: !!s.navigator.userAgent.match(/Edge/g),
            isSafari: function() {
                const t = s.navigator.userAgent.toLowerCase();
                return t.indexOf("safari") >= 0 && t.indexOf("chrome") < 0 && t.indexOf("android") < 0
            }(),
            isUiWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(s.navigator.userAgent)
        }
    }();
    var E = {
        init: !0,
        direction: "horizontal",
        touchEventsTarget: "container",
        initialSlide: 0,
        speed: 300,
        preventInteractionOnTransition: !1,
        edgeSwipeDetection: !1,
        edgeSwipeThreshold: 20,
        freeMode: !1,
        freeModeMomentum: !0,
        freeModeMomentumRatio: 1,
        freeModeMomentumBounce: !0,
        freeModeMomentumBounceRatio: 1,
        freeModeMomentumVelocityRatio: 1,
        freeModeSticky: !1,
        freeModeMinimumVelocity: .02,
        autoHeight: !1,
        setWrapperSize: !1,
        virtualTranslate: !1,
        effect: "slide",
        breakpoints: void 0,
        breakpointsInverse: !1,
        spaceBetween: 0,
        slidesPerView: 1,
        slidesPerColumn: 1,
        slidesPerColumnFill: "column",
        slidesPerGroup: 1,
        centeredSlides: !1,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        normalizeSlideIndex: !0,
        centerInsufficientSlides: !1,
        watchOverflow: !1,
        roundLengths: !1,
        touchRatio: 1,
        touchAngle: 45,
        simulateTouch: !0,
        shortSwipes: !0,
        longSwipes: !0,
        longSwipesRatio: .5,
        longSwipesMs: 300,
        followFinger: !0,
        allowTouchMove: !0,
        threshold: 0,
        touchMoveStopPropagation: !0,
        touchStartPreventDefault: !0,
        touchStartForcePreventDefault: !1,
        touchReleaseOnEdges: !1,
        uniqueNavElements: !0,
        resistance: !0,
        resistanceRatio: .85,
        watchSlidesProgress: !1,
        watchSlidesVisibility: !1,
        grabCursor: !1,
        preventClicks: !0,
        preventClicksPropagation: !0,
        slideToClickedSlide: !1,
        preloadImages: !0,
        updateOnImagesReady: !0,
        loop: !1,
        loopAdditionalSlides: 0,
        loopedSlides: null,
        loopFillGroupWithBlank: !1,
        allowSlidePrev: !0,
        allowSlideNext: !0,
        swipeHandler: null,
        noSwiping: !0,
        noSwipingClass: "swiper-no-swiping",
        noSwipingSelector: null,
        passiveListeners: !0,
        containerModifierClass: "swiper-container-",
        slideClass: "swiper-slide",
        slideBlankClass: "swiper-slide-invisible-blank",
        slideActiveClass: "swiper-slide-active",
        slideDuplicateActiveClass: "swiper-slide-duplicate-active",
        slideVisibleClass: "swiper-slide-visible",
        slideDuplicateClass: "swiper-slide-duplicate",
        slideNextClass: "swiper-slide-next",
        slideDuplicateNextClass: "swiper-slide-duplicate-next",
        slidePrevClass: "swiper-slide-prev",
        slideDuplicatePrevClass: "swiper-slide-duplicate-prev",
        wrapperClass: "swiper-wrapper",
        runCallbacksOnInit: !0
    };
    const C = {
            update: u,
            translate: p,
            transition: f,
            slide: m,
            loop: g,
            grabCursor: v,
            manipulation: y,
            events: w,
            breakpoints: x,
            checkOverflow: {
                checkOverflow: function() {
                    const t = this,
                        e = t.isLocked;
                    t.isLocked = 1 === t.snapGrid.length, t.allowSlideNext = !t.isLocked, t.allowSlidePrev = !t.isLocked, e !== t.isLocked && t.emit(t.isLocked ? "lock" : "unlock"), e && e !== t.isLocked && (t.isEnd = !1, t.navigation.update())
                }
            },
            classes: {
                addClasses: function() {
                    const {
                        classNames: t,
                        params: e,
                        rtl: i,
                        $el: n
                    } = this, s = [];
                    s.push(e.direction), e.freeMode && s.push("free-mode"), c.flexbox || s.push("no-flexbox"), e.autoHeight && s.push("autoheight"), i && s.push("rtl"), e.slidesPerColumn > 1 && s.push("multirow"), _.android && s.push("android"), _.ios && s.push("ios"), (T.isIE || T.isEdge) && (c.pointerEvents || c.prefixedPointerEvents) && s.push(`wp8-${e.direction}`), s.forEach(i => {
                        t.push(e.containerModifierClass + i)
                    }), n.addClass(t.join(" "))
                },
                removeClasses: function() {
                    const {
                        $el: t,
                        classNames: e
                    } = this;
                    t.removeClass(e.join(" "))
                }
            },
            images: {
                loadImage: function(t, e, i, n, o, r) {
                    let a;
  
                    function l() {
                        r && r()
                    }
                    t.complete && o ? l() : e ? ((a = new s.Image).onload = l, a.onerror = l, n && (a.sizes = n), i && (a.srcset = i), e && (a.src = e)) : l()
                },
                preloadImages: function() {
                    const t = this;
  
                    function e() {
                        void 0 !== t && null !== t && t && !t.destroyed && (void 0 !== t.imagesLoaded && (t.imagesLoaded += 1), t.imagesLoaded === t.imagesToLoad.length && (t.params.updateOnImagesReady && t.update(), t.emit("imagesReady")))
                    }
                    t.imagesToLoad = t.$el.find("img");
                    for (let i = 0; i < t.imagesToLoad.length; i += 1) {
                        const n = t.imagesToLoad[i];
                        t.loadImage(n, n.currentSrc || n.getAttribute("src"), n.srcset || n.getAttribute("srcset"), n.sizes || n.getAttribute("sizes"), !0, e)
                    }
                }
            }
        },
        S = {};
    class D extends d {
        constructor(...t) {
            let e, i;
            1 === t.length && t[0].constructor && t[0].constructor === Object ? i = t[0] : [e, i] = t, i || (i = {}), i = h.extend({}, i), e && !i.el && (i.el = e), super(i), Object.keys(C).forEach(t => {
                Object.keys(C[t]).forEach(e => {
                    D.prototype[e] || (D.prototype[e] = C[t][e])
                })
            });
            const n = this;
            void 0 === n.modules && (n.modules = {}), Object.keys(n.modules).forEach(t => {
                const e = n.modules[t];
                if (e.params) {
                    const t = Object.keys(e.params)[0],
                        n = e.params[t];
                    if ("object" != typeof n || null === n) return;
                    if (!(t in i && "enabled" in n)) return;
                    !0 === i[t] && (i[t] = {
                        enabled: !0
                    }), "object" != typeof i[t] || "enabled" in i[t] || (i[t].enabled = !0), i[t] || (i[t] = {
                        enabled: !1
                    })
                }
            });
            const s = h.extend({}, E);
            n.useModulesParams(s), n.params = h.extend({}, s, S, i), n.originalParams = h.extend({}, n.params), n.passedParams = h.extend({}, i), n.$ = r;
            const o = r(n.params.el);
            if (!(e = o[0])) return;
            if (o.length > 1) {
                const t = [];
                return o.each((e, n) => {
                    const s = h.extend({}, i, {
                        el: n
                    });
                    t.push(new D(s))
                }), t
            }
            e.swiper = n, o.data("swiper", n);
            const a = o.children(`.${n.params.wrapperClass}`);
            return h.extend(n, {
                $el: o,
                el: e,
                $wrapperEl: a,
                wrapperEl: a[0],
                classNames: [],
                slides: r(),
                slidesGrid: [],
                snapGrid: [],
                slidesSizesGrid: [],
                isHorizontal: () => "horizontal" === n.params.direction,
                isVertical: () => "vertical" === n.params.direction,
                rtl: "rtl" === e.dir.toLowerCase() || "rtl" === o.css("direction"),
                rtlTranslate: "horizontal" === n.params.direction && ("rtl" === e.dir.toLowerCase() || "rtl" === o.css("direction")),
                wrongRTL: "-webkit-box" === a.css("display"),
                activeIndex: 0,
                realIndex: 0,
                isBeginning: !0,
                isEnd: !1,
                translate: 0,
                previousTranslate: 0,
                progress: 0,
                velocity: 0,
                animating: !1,
                allowSlideNext: n.params.allowSlideNext,
                allowSlidePrev: n.params.allowSlidePrev,
                touchEvents: function() {
                    const t = ["touchstart", "touchmove", "touchend"];
                    let e = ["mousedown", "mousemove", "mouseup"];
                    return c.pointerEvents ? e = ["pointerdown", "pointermove", "pointerup"] : c.prefixedPointerEvents && (e = ["MSPointerDown", "MSPointerMove", "MSPointerUp"]), n.touchEventsTouch = {
                        start: t[0],
                        move: t[1],
                        end: t[2]
                    }, n.touchEventsDesktop = {
                        start: e[0],
                        move: e[1],
                        end: e[2]
                    }, c.touch || !n.params.simulateTouch ? n.touchEventsTouch : n.touchEventsDesktop
                }(),
                touchEventsData: {
                    isTouched: void 0,
                    isMoved: void 0,
                    allowTouchCallbacks: void 0,
                    touchStartTime: void 0,
                    isScrolling: void 0,
                    currentTranslate: void 0,
                    startTranslate: void 0,
                    allowThresholdMove: void 0,
                    formElements: "input, select, option, textarea, button, video",
                    lastClickTime: h.now(),
                    clickTimeout: void 0,
                    velocities: [],
                    allowMomentumBounce: void 0,
                    isTouchEvent: void 0,
                    startMoving: void 0
                },
                allowClick: !0,
                allowTouchMove: n.params.allowTouchMove,
                touches: {
                    startX: 0,
                    startY: 0,
                    currentX: 0,
                    currentY: 0,
                    diff: 0
                },
                imagesToLoad: [],
                imagesLoaded: 0
            }), n.useModules(), n.params.init && n.init(), n
        }
        slidesPerViewDynamic() {
            const {
                params: t,
                slides: e,
                slidesGrid: i,
                size: n,
                activeIndex: s
            } = this;
            let o = 1;
            if (t.centeredSlides) {
                let t, i = e[s].swiperSlideSize;
                for (let r = s + 1; r < e.length; r += 1) e[r] && !t && (o += 1, (i += e[r].swiperSlideSize) > n && (t = !0));
                for (let r = s - 1; r >= 0; r -= 1) e[r] && !t && (o += 1, (i += e[r].swiperSlideSize) > n && (t = !0))
            } else
                for (let t = s + 1; t < e.length; t += 1) i[t] - i[s] < n && (o += 1);
            return o
        }
        update() {
            const t = this;
            if (!t || t.destroyed) return;
            const {
                snapGrid: e,
                params: i
            } = t;
  
            function n() {
                const e = t.rtlTranslate ? -1 * t.translate : t.translate,
                    i = Math.min(Math.max(e, t.maxTranslate()), t.minTranslate());
                t.setTranslate(i), t.updateActiveIndex(), t.updateSlidesClasses()
            }
            let s;
            i.breakpoints && t.setBreakpoint(), t.updateSize(), t.updateSlides(), t.updateProgress(), t.updateSlidesClasses(), t.params.freeMode ? (n(), t.params.autoHeight && t.updateAutoHeight()) : (s = ("auto" === t.params.slidesPerView || t.params.slidesPerView > 1) && t.isEnd && !t.params.centeredSlides ? t.slideTo(t.slides.length - 1, 0, !1, !0) : t.slideTo(t.activeIndex, 0, !1, !0)) || n(), i.watchOverflow && e !== t.snapGrid && t.checkOverflow(), t.emit("update")
        }
        init() {
            const t = this;
            t.initialized || (t.emit("beforeInit"), t.params.breakpoints && t.setBreakpoint(), t.addClasses(), t.params.loop && t.loopCreate(), t.updateSize(), t.updateSlides(), t.params.watchOverflow && t.checkOverflow(), t.params.grabCursor && t.setGrabCursor(), t.params.preloadImages && t.preloadImages(), t.params.loop ? t.slideTo(t.params.initialSlide + t.loopedSlides, 0, t.params.runCallbacksOnInit) : t.slideTo(t.params.initialSlide, 0, t.params.runCallbacksOnInit), t.attachEvents(), t.initialized = !0, t.emit("init"))
        }
        destroy(t = !0, e = !0) {
            const i = this,
                {
                    params: n,
                    $el: s,
                    $wrapperEl: o,
                    slides: r
                } = i;
            return void 0 === i.params || i.destroyed ? null : (i.emit("beforeDestroy"), i.initialized = !1, i.detachEvents(), n.loop && i.loopDestroy(), e && (i.removeClasses(), s.removeAttr("style"), o.removeAttr("style"), r && r.length && r.removeClass([n.slideVisibleClass, n.slideActiveClass, n.slideNextClass, n.slidePrevClass].join(" ")).removeAttr("style").removeAttr("data-swiper-slide-index").removeAttr("data-swiper-column").removeAttr("data-swiper-row")), i.emit("destroy"), Object.keys(i.eventsListeners).forEach(t => {
                i.off(t)
            }), !1 !== t && (i.$el[0].swiper = null, i.$el.data("swiper", null), h.deleteProps(i)), i.destroyed = !0, null)
        }
        static extendDefaults(t) {
            h.extend(S, t)
        }
        static get extendedDefaults() {
            return S
        }
        static get defaults() {
            return E
        }
        static get Class() {
            return d
        }
        static get $() {
            return r
        }
    }
    var I = {
            name: "device",
            proto: {
                device: _
            },
            static: {
                device: _
            }
        },
        M = {
            name: "support",
            proto: {
                support: c
            },
            static: {
                support: c
            }
        },
        O = {
            name: "browser",
            proto: {
                browser: T
            },
            static: {
                browser: T
            }
        },
        k = {
            name: "resize",
            create() {
                const t = this;
                h.extend(t, {
                    resize: {
                        resizeHandler() {
                            t && !t.destroyed && t.initialized && (t.emit("beforeResize"), t.emit("resize"))
                        },
                        orientationChangeHandler() {
                            t && !t.destroyed && t.initialized && t.emit("orientationchange")
                        }
                    }
                })
            },
            on: {
                init() {
                    s.addEventListener("resize", this.resize.resizeHandler), s.addEventListener("orientationchange", this.resize.orientationChangeHandler)
                },
                destroy() {
                    s.removeEventListener("resize", this.resize.resizeHandler), s.removeEventListener("orientationchange", this.resize.orientationChangeHandler)
                }
            }
        };
    const A = {
        func: s.MutationObserver || s.WebkitMutationObserver,
        attach(t, e = {}) {
            const i = this,
                n = new(0, A.func)(t => {
                    if (1 === t.length) return void i.emit("observerUpdate", t[0]);
                    const e = function() {
                        i.emit("observerUpdate", t[0])
                    };
                    s.requestAnimationFrame ? s.requestAnimationFrame(e) : s.setTimeout(e, 0)
                });
            n.observe(t, {
                attributes: void 0 === e.attributes || e.attributes,
                childList: void 0 === e.childList || e.childList,
                characterData: void 0 === e.characterData || e.characterData
            }), i.observer.observers.push(n)
        },
        init() {
            const t = this;
            if (c.observer && t.params.observer) {
                if (t.params.observeParents) {
                    const e = t.$el.parents();
                    for (let i = 0; i < e.length; i += 1) t.observer.attach(e[i])
                }
                t.observer.attach(t.$el[0], {
                    childList: t.params.observeSlideChildren
                }), t.observer.attach(t.$wrapperEl[0], {
                    attributes: !1
                })
            }
        },
        destroy() {
            this.observer.observers.forEach(t => {
                t.disconnect()
            }), this.observer.observers = []
        }
    };
    var P = {
        name: "observer",
        params: {
            observer: !1,
            observeParents: !1,
            observeSlideChildren: !1
        },
        create() {
            h.extend(this, {
                observer: {
                    init: A.init.bind(this),
                    attach: A.attach.bind(this),
                    destroy: A.destroy.bind(this),
                    observers: []
                }
            })
        },
        on: {
            init() {
                this.observer.init()
            },
            destroy() {
                this.observer.destroy()
            }
        }
    };
    const $ = {
        update(t) {
            const e = this,
                {
                    slidesPerView: i,
                    slidesPerGroup: n,
                    centeredSlides: s
                } = e.params,
                {
                    addSlidesBefore: o,
                    addSlidesAfter: r
                } = e.params.virtual,
                {
                    from: a,
                    to: l,
                    slides: c,
                    slidesGrid: d,
                    renderSlide: u,
                    offset: p
                } = e.virtual;
            e.updateActiveIndex();
            const f = e.activeIndex || 0;
            let m, g, v;
            m = e.rtlTranslate ? "right" : e.isHorizontal() ? "left" : "top", s ? (g = Math.floor(i / 2) + n + o, v = Math.floor(i / 2) + n + r) : (g = i + (n - 1) + o, v = n + r);
            const y = Math.max((f || 0) - v, 0),
                _ = Math.min((f || 0) + g, c.length - 1),
                b = (e.slidesGrid[y] || 0) - (e.slidesGrid[0] || 0);
  
            function w() {
                e.updateSlides(), e.updateProgress(), e.updateSlidesClasses(), e.lazy && e.params.lazy.enabled && e.lazy.load()
            }
            if (h.extend(e.virtual, {
                    from: y,
                    to: _,
                    offset: b,
                    slidesGrid: e.slidesGrid
                }), a === y && l === _ && !t) return e.slidesGrid !== d && b !== p && e.slides.css(m, `${b}px`), void e.updateProgress();
            if (e.params.virtual.renderExternal) return e.params.virtual.renderExternal.call(e, {
                offset: b,
                from: y,
                to: _,
                slides: function() {
                    const t = [];
                    for (let e = y; e <= _; e += 1) t.push(c[e]);
                    return t
                }()
            }), void w();
            const x = [],
                T = [];
            if (t) e.$wrapperEl.find(`.${e.params.slideClass}`).remove();
            else
                for (let t = a; t <= l; t += 1)(t < y || t > _) && e.$wrapperEl.find(`.${e.params.slideClass}[data-swiper-slide-index="${t}"]`).remove();
            for (let e = 0; e < c.length; e += 1) e >= y && e <= _ && (void 0 === l || t ? T.push(e) : (e > l && T.push(e), e < a && x.push(e)));
            T.forEach(t => {
                e.$wrapperEl.append(u(c[t], t))
            }), x.sort((t, e) => e - t).forEach(t => {
                e.$wrapperEl.prepend(u(c[t], t))
            }), e.$wrapperEl.children(".swiper-slide").css(m, `${b}px`), w()
        },
        renderSlide(t, e) {
            const i = this,
                n = i.params.virtual;
            if (n.cache && i.virtual.cache[e]) return i.virtual.cache[e];
            const s = n.renderSlide ? r(n.renderSlide.call(i, t, e)) : r(`<div class="${i.params.slideClass}" data-swiper-slide-index="${e}">${t}</div>`);
            return s.attr("data-swiper-slide-index") || s.attr("data-swiper-slide-index", e), n.cache && (i.virtual.cache[e] = s), s
        },
        appendSlide(t) {
            this.virtual.slides.push(t), this.virtual.update(!0)
        },
        prependSlide(t) {
            const e = this;
            if (e.virtual.slides.unshift(t), e.params.virtual.cache) {
                const t = e.virtual.cache,
                    i = {};
                Object.keys(t).forEach(e => {
                    i[e + 1] = t[e]
                }), e.virtual.cache = i
            }
            e.virtual.update(!0), e.slideNext(0)
        }
    };
    var L = {
        name: "virtual",
        params: {
            virtual: {
                enabled: !1,
                slides: [],
                cache: !0,
                renderSlide: null,
                renderExternal: null,
                addSlidesBefore: 0,
                addSlidesAfter: 0
            }
        },
        create() {
            h.extend(this, {
                virtual: {
                    update: $.update.bind(this),
                    appendSlide: $.appendSlide.bind(this),
                    prependSlide: $.prependSlide.bind(this),
                    renderSlide: $.renderSlide.bind(this),
                    slides: this.params.virtual.slides,
                    cache: {}
                }
            })
        },
        on: {
            beforeInit() {
                const t = this;
                if (!t.params.virtual.enabled) return;
                t.classNames.push(`${t.params.containerModifierClass}virtual`);
                const e = {
                    watchSlidesProgress: !0
                };
                h.extend(t.params, e), h.extend(t.originalParams, e), t.params.initialSlide || t.virtual.update()
            },
            setTranslate() {
                this.params.virtual.enabled && this.virtual.update()
            }
        }
    };
    const N = {
        handle(t) {
            const e = this,
                {
                    rtlTranslate: i
                } = e;
            let o = t;
            o.originalEvent && (o = o.originalEvent);
            const r = o.keyCode || o.charCode;
            if (!e.allowSlideNext && (e.isHorizontal() && 39 === r || e.isVertical() && 40 === r)) return !1;
            if (!e.allowSlidePrev && (e.isHorizontal() && 37 === r || e.isVertical() && 38 === r)) return !1;
            if (!(o.shiftKey || o.altKey || o.ctrlKey || o.metaKey || n.activeElement && n.activeElement.nodeName && ("input" === n.activeElement.nodeName.toLowerCase() || "textarea" === n.activeElement.nodeName.toLowerCase()))) {
                if (e.params.keyboard.onlyInViewport && (37 === r || 39 === r || 38 === r || 40 === r)) {
                    let t = !1;
                    if (e.$el.parents(`.${e.params.slideClass}`).length > 0 && 0 === e.$el.parents(`.${e.params.slideActiveClass}`).length) return;
                    const n = s.innerWidth,
                        o = s.innerHeight,
                        r = e.$el.offset();
                    i && (r.left -= e.$el[0].scrollLeft);
                    const a = [
                        [r.left, r.top],
                        [r.left + e.width, r.top],
                        [r.left, r.top + e.height],
                        [r.left + e.width, r.top + e.height]
                    ];
                    for (let e = 0; e < a.length; e += 1) {
                        const i = a[e];
                        i[0] >= 0 && i[0] <= n && i[1] >= 0 && i[1] <= o && (t = !0)
                    }
                    if (!t) return
                }
                e.isHorizontal() ? (37 !== r && 39 !== r || (o.preventDefault ? o.preventDefault() : o.returnValue = !1), (39 === r && !i || 37 === r && i) && e.slideNext(), (37 === r && !i || 39 === r && i) && e.slidePrev()) : (38 !== r && 40 !== r || (o.preventDefault ? o.preventDefault() : o.returnValue = !1), 40 === r && e.slideNext(), 38 === r && e.slidePrev()), e.emit("keyPress", r)
            }
        },
        enable() {
            this.keyboard.enabled || (r(n).on("keydown", this.keyboard.handle), this.keyboard.enabled = !0)
        },
        disable() {
            this.keyboard.enabled && (r(n).off("keydown", this.keyboard.handle), this.keyboard.enabled = !1)
        }
    };
    var z = {
        name: "keyboard",
        params: {
            keyboard: {
                enabled: !1,
                onlyInViewport: !0
            }
        },
        create() {
            h.extend(this, {
                keyboard: {
                    enabled: !1,
                    enable: N.enable.bind(this),
                    disable: N.disable.bind(this),
                    handle: N.handle.bind(this)
                }
            })
        },
        on: {
            init() {
                const t = this;
                t.params.keyboard.enabled && t.keyboard.enable()
            },
            destroy() {
                const t = this;
                t.keyboard.enabled && t.keyboard.disable()
            }
        }
    };
    const F = {
        lastScrollTime: h.now(),
        event: s.navigator.userAgent.indexOf("firefox") > -1 ? "DOMMouseScroll" : function() {
            let t = "onwheel" in n;
            if (!t) {
                const e = n.createElement("div");
                e.setAttribute("onwheel", "return;"), t = "function" == typeof e.onwheel
            }
            return !t && n.implementation && n.implementation.hasFeature && !0 !== n.implementation.hasFeature("", "") && (t = n.implementation.hasFeature("Events.wheel", "3.0")), t
        }() ? "wheel" : "mousewheel",
        normalize(t) {
            let e = 0,
                i = 0,
                n = 0,
                s = 0;
            return "detail" in t && (i = t.detail), "wheelDelta" in t && (i = -t.wheelDelta / 120), "wheelDeltaY" in t && (i = -t.wheelDeltaY / 120), "wheelDeltaX" in t && (e = -t.wheelDeltaX / 120), "axis" in t && t.axis === t.HORIZONTAL_AXIS && (e = i, i = 0), n = 10 * e, s = 10 * i, "deltaY" in t && (s = t.deltaY), "deltaX" in t && (n = t.deltaX), (n || s) && t.deltaMode && (1 === t.deltaMode ? (n *= 40, s *= 40) : (n *= 800, s *= 800)), n && !e && (e = n < 1 ? -1 : 1), s && !i && (i = s < 1 ? -1 : 1), {
                spinX: e,
                spinY: i,
                pixelX: n,
                pixelY: s
            }
        },
        handleMouseEnter() {
            this.mouseEntered = !0
        },
        handleMouseLeave() {
            this.mouseEntered = !1
        },
        handle(t) {
            let e = t;
            const i = this,
                n = i.params.mousewheel;
            if (!i.mouseEntered && !n.releaseOnEdges) return !0;
            e.originalEvent && (e = e.originalEvent);
            let o = 0;
            const r = i.rtlTranslate ? -1 : 1,
                a = F.normalize(e);
            if (n.forceToAxis)
                if (i.isHorizontal()) {
                    if (!(Math.abs(a.pixelX) > Math.abs(a.pixelY))) return !0;
                    o = a.pixelX * r
                } else {
                    if (!(Math.abs(a.pixelY) > Math.abs(a.pixelX))) return !0;
                    o = a.pixelY
                }
            else o = Math.abs(a.pixelX) > Math.abs(a.pixelY) ? -a.pixelX * r : -a.pixelY;
            if (0 === o) return !0;
            if (n.invert && (o = -o), i.params.freeMode) {
                i.params.loop && i.loopFix();
                let t = i.getTranslate() + o * n.sensitivity;
                const s = i.isBeginning,
                    r = i.isEnd;
                if (t >= i.minTranslate() && (t = i.minTranslate()), t <= i.maxTranslate() && (t = i.maxTranslate()), i.setTransition(0), i.setTranslate(t), i.updateProgress(), i.updateActiveIndex(), i.updateSlidesClasses(), (!s && i.isBeginning || !r && i.isEnd) && i.updateSlidesClasses(), i.params.freeModeSticky && (clearTimeout(i.mousewheel.timeout), i.mousewheel.timeout = h.nextTick(() => {
                        i.slideToClosest()
                    }, 300)), i.emit("scroll", e), i.params.autoplay && i.params.autoplayDisableOnInteraction && i.autoplay.stop(), t === i.minTranslate() || t === i.maxTranslate()) return !0
            } else {
                if (h.now() - i.mousewheel.lastScrollTime > 60)
                    if (o < 0)
                        if (i.isEnd && !i.params.loop || i.animating) {
                            if (n.releaseOnEdges) return !0
                        } else i.slideNext(), i.emit("scroll", e);
                else if (i.isBeginning && !i.params.loop || i.animating) {
                    if (n.releaseOnEdges) return !0
                } else i.slidePrev(), i.emit("scroll", e);
                i.mousewheel.lastScrollTime = (new s.Date).getTime()
            }
            return e.preventDefault ? e.preventDefault() : e.returnValue = !1, !1
        },
        enable() {
            const t = this;
            if (!F.event) return !1;
            if (t.mousewheel.enabled) return !1;
            let e = t.$el;
            return "container" !== t.params.mousewheel.eventsTarged && (e = r(t.params.mousewheel.eventsTarged)), e.on("mouseenter", t.mousewheel.handleMouseEnter), e.on("mouseleave", t.mousewheel.handleMouseLeave), e.on(F.event, t.mousewheel.handle), t.mousewheel.enabled = !0, !0
        },
        disable() {
            const t = this;
            if (!F.event) return !1;
            if (!t.mousewheel.enabled) return !1;
            let e = t.$el;
            return "container" !== t.params.mousewheel.eventsTarged && (e = r(t.params.mousewheel.eventsTarged)), e.off(F.event, t.mousewheel.handle), t.mousewheel.enabled = !1, !0
        }
    };
    const H = {
        update() {
            const t = this,
                e = t.params.navigation;
            if (t.params.loop) return;
            const {
                $nextEl: i,
                $prevEl: n
            } = t.navigation;
            n && n.length > 0 && (t.isBeginning ? n.addClass(e.disabledClass) : n.removeClass(e.disabledClass), n[t.params.watchOverflow && t.isLocked ? "addClass" : "removeClass"](e.lockClass)), i && i.length > 0 && (t.isEnd ? i.addClass(e.disabledClass) : i.removeClass(e.disabledClass), i[t.params.watchOverflow && t.isLocked ? "addClass" : "removeClass"](e.lockClass))
        },
        onPrevClick(t) {
            t.preventDefault(), this.isBeginning && !this.params.loop || this.slidePrev()
        },
        onNextClick(t) {
            t.preventDefault(), this.isEnd && !this.params.loop || this.slideNext()
        },
        init() {
            const t = this,
                e = t.params.navigation;
            if (!e.nextEl && !e.prevEl) return;
            let i, n;
            e.nextEl && (i = r(e.nextEl), t.params.uniqueNavElements && "string" == typeof e.nextEl && i.length > 1 && 1 === t.$el.find(e.nextEl).length && (i = t.$el.find(e.nextEl))), e.prevEl && (n = r(e.prevEl), t.params.uniqueNavElements && "string" == typeof e.prevEl && n.length > 1 && 1 === t.$el.find(e.prevEl).length && (n = t.$el.find(e.prevEl))), i && i.length > 0 && i.on("click", t.navigation.onNextClick), n && n.length > 0 && n.on("click", t.navigation.onPrevClick), h.extend(t.navigation, {
                $nextEl: i,
                nextEl: i && i[0],
                $prevEl: n,
                prevEl: n && n[0]
            })
        },
        destroy() {
            const t = this,
                {
                    $nextEl: e,
                    $prevEl: i
                } = t.navigation;
            e && e.length && (e.off("click", t.navigation.onNextClick), e.removeClass(t.params.navigation.disabledClass)), i && i.length && (i.off("click", t.navigation.onPrevClick), i.removeClass(t.params.navigation.disabledClass))
        }
    };
    const R = {
        update() {
            const t = this,
                e = t.rtl,
                i = t.params.pagination;
            if (!i.el || !t.pagination.el || !t.pagination.$el || 0 === t.pagination.$el.length) return;
            const n = t.virtual && t.params.virtual.enabled ? t.virtual.slides.length : t.slides.length,
                s = t.pagination.$el;
            let o;
            const a = t.params.loop ? Math.ceil((n - 2 * t.loopedSlides) / t.params.slidesPerGroup) : t.snapGrid.length;
            if (t.params.loop ? ((o = Math.ceil((t.activeIndex - t.loopedSlides) / t.params.slidesPerGroup)) > n - 1 - 2 * t.loopedSlides && (o -= n - 2 * t.loopedSlides), o > a - 1 && (o -= a), o < 0 && "bullets" !== t.params.paginationType && (o = a + o)) : o = void 0 !== t.snapIndex ? t.snapIndex : t.activeIndex || 0, "bullets" === i.type && t.pagination.bullets && t.pagination.bullets.length > 0) {
                const n = t.pagination.bullets;
                let a, l, h;
                if (i.dynamicBullets && (t.pagination.bulletSize = n.eq(0)[t.isHorizontal() ? "outerWidth" : "outerHeight"](!0), s.css(t.isHorizontal() ? "width" : "height", `${t.pagination.bulletSize*(i.dynamicMainBullets+4)}px`), i.dynamicMainBullets > 1 && void 0 !== t.previousIndex && (t.pagination.dynamicBulletIndex += o - t.previousIndex, t.pagination.dynamicBulletIndex > i.dynamicMainBullets - 1 ? t.pagination.dynamicBulletIndex = i.dynamicMainBullets - 1 : t.pagination.dynamicBulletIndex < 0 && (t.pagination.dynamicBulletIndex = 0)), a = o - t.pagination.dynamicBulletIndex, h = ((l = a + (Math.min(n.length, i.dynamicMainBullets) - 1)) + a) / 2), n.removeClass(`${i.bulletActiveClass} ${i.bulletActiveClass}-next ${i.bulletActiveClass}-next-next ${i.bulletActiveClass}-prev ${i.bulletActiveClass}-prev-prev ${i.bulletActiveClass}-main`), s.length > 1) n.each((t, e) => {
                    const n = r(e),
                        s = n.index();
                    s === o && n.addClass(i.bulletActiveClass), i.dynamicBullets && (s >= a && s <= l && n.addClass(`${i.bulletActiveClass}-main`), s === a && n.prev().addClass(`${i.bulletActiveClass}-prev`).prev().addClass(`${i.bulletActiveClass}-prev-prev`), s === l && n.next().addClass(`${i.bulletActiveClass}-next`).next().addClass(`${i.bulletActiveClass}-next-next`))
                });
                else {
                    if (n.eq(o).addClass(i.bulletActiveClass), i.dynamicBullets) {
                        const t = n.eq(a),
                            e = n.eq(l);
                        for (let t = a; t <= l; t += 1) n.eq(t).addClass(`${i.bulletActiveClass}-main`);
                        t.prev().addClass(`${i.bulletActiveClass}-prev`).prev().addClass(`${i.bulletActiveClass}-prev-prev`), e.next().addClass(`${i.bulletActiveClass}-next`).next().addClass(`${i.bulletActiveClass}-next-next`)
                    }
                }
                if (i.dynamicBullets) {
                    const s = Math.min(n.length, i.dynamicMainBullets + 4),
                        o = (t.pagination.bulletSize * s - t.pagination.bulletSize) / 2 - h * t.pagination.bulletSize,
                        r = e ? "right" : "left";
                    n.css(t.isHorizontal() ? r : "top", `${o}px`)
                }
            }
            if ("fraction" === i.type && (s.find(`.${i.currentClass}`).text(i.formatFractionCurrent(o + 1)), s.find(`.${i.totalClass}`).text(i.formatFractionTotal(a))), "progressbar" === i.type) {
                let e;
                e = i.progressbarOpposite ? t.isHorizontal() ? "vertical" : "horizontal" : t.isHorizontal() ? "horizontal" : "vertical";
                const n = (o + 1) / a;
                let r = 1,
                    l = 1;
                "horizontal" === e ? r = n : l = n, s.find(`.${i.progressbarFillClass}`).transform(`translate3d(0,0,0) scaleX(${r}) scaleY(${l})`).transition(t.params.speed)
            }
            "custom" === i.type && i.renderCustom ? (s.html(i.renderCustom(t, o + 1, a)), t.emit("paginationRender", t, s[0])) : t.emit("paginationUpdate", t, s[0]), s[t.params.watchOverflow && t.isLocked ? "addClass" : "removeClass"](i.lockClass)
        },
        render() {
            const t = this,
                e = t.params.pagination;
            if (!e.el || !t.pagination.el || !t.pagination.$el || 0 === t.pagination.$el.length) return;
            const i = t.virtual && t.params.virtual.enabled ? t.virtual.slides.length : t.slides.length,
                n = t.pagination.$el;
            let s = "";
            if ("bullets" === e.type) {
                const o = t.params.loop ? Math.ceil((i - 2 * t.loopedSlides) / t.params.slidesPerGroup) : t.snapGrid.length;
                for (let i = 0; i < o; i += 1) e.renderBullet ? s += e.renderBullet.call(t, i, e.bulletClass) : s += `<${e.bulletElement} class="${e.bulletClass}"></${e.bulletElement}>`;
                n.html(s), t.pagination.bullets = n.find(`.${e.bulletClass}`)
            }
            "fraction" === e.type && (s = e.renderFraction ? e.renderFraction.call(t, e.currentClass, e.totalClass) : `<span class="${e.currentClass}"></span>` + " / " + `<span class="${e.totalClass}"></span>`, n.html(s)), "progressbar" === e.type && (s = e.renderProgressbar ? e.renderProgressbar.call(t, e.progressbarFillClass) : `<span class="${e.progressbarFillClass}"></span>`, n.html(s)), "custom" !== e.type && t.emit("paginationRender", t.pagination.$el[0])
        },
        init() {
            const t = this,
                e = t.params.pagination;
            if (!e.el) return;
            let i = r(e.el);
            0 !== i.length && (t.params.uniqueNavElements && "string" == typeof e.el && i.length > 1 && 1 === t.$el.find(e.el).length && (i = t.$el.find(e.el)), "bullets" === e.type && e.clickable && i.addClass(e.clickableClass), i.addClass(e.modifierClass + e.type), "bullets" === e.type && e.dynamicBullets && (i.addClass(`${e.modifierClass}${e.type}-dynamic`), t.pagination.dynamicBulletIndex = 0, e.dynamicMainBullets < 1 && (e.dynamicMainBullets = 1)), "progressbar" === e.type && e.progressbarOpposite && i.addClass(e.progressbarOppositeClass), e.clickable && i.on("click", `.${e.bulletClass}`, function(e) {
                e.preventDefault();
                let i = r(this).index() * t.params.slidesPerGroup;
                t.params.loop && (i += t.loopedSlides), t.slideTo(i)
            }), h.extend(t.pagination, {
                $el: i,
                el: i[0]
            }))
        },
        destroy() {
            const t = this.params.pagination;
            if (!t.el || !this.pagination.el || !this.pagination.$el || 0 === this.pagination.$el.length) return;
            const e = this.pagination.$el;
            e.removeClass(t.hiddenClass), e.removeClass(t.modifierClass + t.type), this.pagination.bullets && this.pagination.bullets.removeClass(t.bulletActiveClass), t.clickable && e.off("click", `.${t.bulletClass}`)
        }
    };
    const j = {
        setTranslate() {
            const t = this;
            if (!t.params.scrollbar.el || !t.scrollbar.el) return;
            const {
                scrollbar: e,
                rtlTranslate: i,
                progress: n
            } = t, {
                dragSize: s,
                trackSize: o,
                $dragEl: r,
                $el: a
            } = e, l = t.params.scrollbar;
            let h = s,
                d = (o - s) * n;
            i ? (d = -d) > 0 ? (h = s - d, d = 0) : -d + s > o && (h = o + d) : d < 0 ? (h = s + d, d = 0) : d + s > o && (h = o - d), t.isHorizontal() ? (c.transforms3d ? r.transform(`translate3d(${d}px, 0, 0)`) : r.transform(`translateX(${d}px)`), r[0].style.width = `${h}px`) : (c.transforms3d ? r.transform(`translate3d(0px, ${d}px, 0)`) : r.transform(`translateY(${d}px)`), r[0].style.height = `${h}px`), l.hide && (clearTimeout(t.scrollbar.timeout), a[0].style.opacity = 1, t.scrollbar.timeout = setTimeout(() => {
                a[0].style.opacity = 0, a.transition(400)
            }, 1e3))
        },
        setTransition(t) {
            this.params.scrollbar.el && this.scrollbar.el && this.scrollbar.$dragEl.transition(t)
        },
        updateSize() {
            const t = this;
            if (!t.params.scrollbar.el || !t.scrollbar.el) return;
            const {
                scrollbar: e
            } = t, {
                $dragEl: i,
                $el: n
            } = e;
            i[0].style.width = "", i[0].style.height = "";
            const s = t.isHorizontal() ? n[0].offsetWidth : n[0].offsetHeight,
                o = t.size / t.virtualSize,
                r = o * (s / t.size);
            let a;
            a = "auto" === t.params.scrollbar.dragSize ? s * o : parseInt(t.params.scrollbar.dragSize, 10), t.isHorizontal() ? i[0].style.width = `${a}px` : i[0].style.height = `${a}px`, n[0].style.display = o >= 1 ? "none" : "", t.params.scrollbarHide && (n[0].style.opacity = 0), h.extend(e, {
                trackSize: s,
                divider: o,
                moveDivider: r,
                dragSize: a
            }), e.$el[t.params.watchOverflow && t.isLocked ? "addClass" : "removeClass"](t.params.scrollbar.lockClass)
        },
        setDragPosition(t) {
            const {
                scrollbar: e,
                rtlTranslate: i
            } = this, {
                $el: n,
                dragSize: s,
                trackSize: o
            } = e;
            let r, a;
            a = ((r = this.isHorizontal() ? "touchstart" === t.type || "touchmove" === t.type ? t.targetTouches[0].pageX : t.pageX || t.clientX : "touchstart" === t.type || "touchmove" === t.type ? t.targetTouches[0].pageY : t.pageY || t.clientY) - n.offset()[this.isHorizontal() ? "left" : "top"] - s / 2) / (o - s), a = Math.max(Math.min(a, 1), 0), i && (a = 1 - a);
            const l = this.minTranslate() + (this.maxTranslate() - this.minTranslate()) * a;
            this.updateProgress(l), this.setTranslate(l), this.updateActiveIndex(), this.updateSlidesClasses()
        },
        onDragStart(t) {
            const e = this.params.scrollbar,
                {
                    scrollbar: i,
                    $wrapperEl: n
                } = this,
                {
                    $el: s,
                    $dragEl: o
                } = i;
            this.scrollbar.isTouched = !0, t.preventDefault(), t.stopPropagation(), n.transition(100), o.transition(100), i.setDragPosition(t), clearTimeout(this.scrollbar.dragTimeout), s.transition(0), e.hide && s.css("opacity", 1), this.emit("scrollbarDragStart", t)
        },
        onDragMove(t) {
            const {
                scrollbar: e,
                $wrapperEl: i
            } = this, {
                $el: n,
                $dragEl: s
            } = e;
            this.scrollbar.isTouched && (t.preventDefault ? t.preventDefault() : t.returnValue = !1, e.setDragPosition(t), i.transition(0), n.transition(0), s.transition(0), this.emit("scrollbarDragMove", t))
        },
        onDragEnd(t) {
            const e = this,
                i = e.params.scrollbar,
                {
                    scrollbar: n
                } = e,
                {
                    $el: s
                } = n;
            e.scrollbar.isTouched && (e.scrollbar.isTouched = !1, i.hide && (clearTimeout(e.scrollbar.dragTimeout), e.scrollbar.dragTimeout = h.nextTick(() => {
                s.css("opacity", 0), s.transition(400)
            }, 1e3)), e.emit("scrollbarDragEnd", t), i.snapOnRelease && e.slideToClosest())
        },
        enableDraggable() {
            const t = this;
            if (!t.params.scrollbar.el) return;
            const {
                scrollbar: e,
                touchEventsTouch: i,
                touchEventsDesktop: s,
                params: o
            } = t, r = e.$el[0], a = !(!c.passiveListener || !o.passiveListeners) && {
                passive: !1,
                capture: !1
            }, l = !(!c.passiveListener || !o.passiveListeners) && {
                passive: !0,
                capture: !1
            };
            if (r) {
                c.touch && r ? (r.addEventListener(i.start, t.scrollbar.onDragStart, a), r.addEventListener(i.move, t.scrollbar.onDragMove, a), r.addEventListener(i.end, t.scrollbar.onDragEnd, l)) : (r.addEventListener(s.start, t.scrollbar.onDragStart, a), n.addEventListener(s.move, t.scrollbar.onDragMove, a), n.addEventListener(s.end, t.scrollbar.onDragEnd, l))
            }
        },
        disableDraggable() {
            const t = this;
            if (!t.params.scrollbar.el) return;
            const {
                scrollbar: e,
                touchEventsTouch: i,
                touchEventsDesktop: s,
                params: o
            } = t, r = e.$el[0], a = !(!c.passiveListener || !o.passiveListeners) && {
                passive: !1,
                capture: !1
            }, l = !(!c.passiveListener || !o.passiveListeners) && {
                passive: !0,
                capture: !1
            };
            c.touch ? (r.removeEventListener(i.start, t.scrollbar.onDragStart, a), r.removeEventListener(i.move, t.scrollbar.onDragMove, a), r.removeEventListener(i.end, t.scrollbar.onDragEnd, l)) : (r.removeEventListener(s.start, t.scrollbar.onDragStart, a), n.removeEventListener(s.move, t.scrollbar.onDragMove, a), n.removeEventListener(s.end, t.scrollbar.onDragEnd, l))
        },
        init() {
            const t = this;
            if (!t.params.scrollbar.el) return;
            const {
                scrollbar: e,
                $el: i
            } = t, n = t.params.scrollbar;
            let s = r(n.el);
            t.params.uniqueNavElements && "string" == typeof n.el && s.length > 1 && 1 === i.find(n.el).length && (s = i.find(n.el));
            let o = s.find(`.${t.params.scrollbar.dragClass}`);
            0 === o.length && (o = r(`<div class="${t.params.scrollbar.dragClass}"></div>`), s.append(o)), h.extend(e, {
                $el: s,
                el: s[0],
                $dragEl: o,
                dragEl: o[0]
            }), n.draggable && e.enableDraggable()
        },
        destroy() {
            this.scrollbar.disableDraggable()
        }
    };
    const W = {
        setTransform(t, e) {
            const {
                rtl: i
            } = this, n = r(t), s = i ? -1 : 1, o = n.attr("data-swiper-parallax") || "0";
            let a = n.attr("data-swiper-parallax-x"),
                l = n.attr("data-swiper-parallax-y");
            const h = n.attr("data-swiper-parallax-scale"),
                c = n.attr("data-swiper-parallax-opacity");
            if (a || l ? (a = a || "0", l = l || "0") : this.isHorizontal() ? (a = o, l = "0") : (l = o, a = "0"), a = a.indexOf("%") >= 0 ? `${parseInt(a,10)*e*s}%` : `${a*e*s}px`, l = l.indexOf("%") >= 0 ? `${parseInt(l,10)*e}%` : `${l*e}px`, void 0 !== c && null !== c) {
                const t = c - (c - 1) * (1 - Math.abs(e));
                n[0].style.opacity = t
            }
            if (void 0 === h || null === h) n.transform(`translate3d(${a}, ${l}, 0px)`);
            else {
                const t = h - (h - 1) * (1 - Math.abs(e));
                n.transform(`translate3d(${a}, ${l}, 0px) scale(${t})`)
            }
        },
        setTranslate() {
            const t = this,
                {
                    $el: e,
                    slides: i,
                    progress: n,
                    snapGrid: s
                } = t;
            e.children("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]").each((e, i) => {
                t.parallax.setTransform(i, n)
            }), i.each((e, i) => {
                let o = i.progress;
                t.params.slidesPerGroup > 1 && "auto" !== t.params.slidesPerView && (o += Math.ceil(e / 2) - n * (s.length - 1)), o = Math.min(Math.max(o, -1), 1), r(i).find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]").each((e, i) => {
                    t.parallax.setTransform(i, o)
                })
            })
        },
        setTransition(t = this.params.speed) {
            const {
                $el: e
            } = this;
            e.find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]").each((e, i) => {
                const n = r(i);
                let s = parseInt(n.attr("data-swiper-parallax-duration"), 10) || t;
                0 === t && (s = 0), n.transition(s)
            })
        }
    };
    const B = {
        getDistanceBetweenTouches(t) {
            if (t.targetTouches.length < 2) return 1;
            const e = t.targetTouches[0].pageX,
                i = t.targetTouches[0].pageY,
                n = t.targetTouches[1].pageX,
                s = t.targetTouches[1].pageY;
            return Math.sqrt((n - e) ** 2 + (s - i) ** 2)
        },
        onGestureStart(t) {
            const e = this,
                i = e.params.zoom,
                n = e.zoom,
                {
                    gesture: s
                } = n;
            if (n.fakeGestureTouched = !1, n.fakeGestureMoved = !1, !c.gestures) {
                if ("touchstart" !== t.type || "touchstart" === t.type && t.targetTouches.length < 2) return;
                n.fakeGestureTouched = !0, s.scaleStart = B.getDistanceBetweenTouches(t)
            }
            s.$slideEl && s.$slideEl.length || (s.$slideEl = r(t.target).closest(".swiper-slide"), 0 === s.$slideEl.length && (s.$slideEl = e.slides.eq(e.activeIndex)), s.$imageEl = s.$slideEl.find("img, svg, canvas"), s.$imageWrapEl = s.$imageEl.parent(`.${i.containerClass}`), s.maxRatio = s.$imageWrapEl.attr("data-swiper-zoom") || i.maxRatio, 0 !== s.$imageWrapEl.length) ? (s.$imageEl.transition(0), e.zoom.isScaling = !0) : s.$imageEl = void 0
        },
        onGestureChange(t) {
            const e = this.params.zoom,
                i = this.zoom,
                {
                    gesture: n
                } = i;
            if (!c.gestures) {
                if ("touchmove" !== t.type || "touchmove" === t.type && t.targetTouches.length < 2) return;
                i.fakeGestureMoved = !0, n.scaleMove = B.getDistanceBetweenTouches(t)
            }
            n.$imageEl && 0 !== n.$imageEl.length && (c.gestures ? i.scale = t.scale * i.currentScale : i.scale = n.scaleMove / n.scaleStart * i.currentScale, i.scale > n.maxRatio && (i.scale = n.maxRatio - 1 + (i.scale - n.maxRatio + 1) ** .5), i.scale < e.minRatio && (i.scale = e.minRatio + 1 - (e.minRatio - i.scale + 1) ** .5), n.$imageEl.transform(`translate3d(0,0,0) scale(${i.scale})`))
        },
        onGestureEnd(t) {
            const e = this.params.zoom,
                i = this.zoom,
                {
                    gesture: n
                } = i;
            if (!c.gestures) {
                if (!i.fakeGestureTouched || !i.fakeGestureMoved) return;
                if ("touchend" !== t.type || "touchend" === t.type && t.changedTouches.length < 2 && !_.android) return;
                i.fakeGestureTouched = !1, i.fakeGestureMoved = !1
            }
            n.$imageEl && 0 !== n.$imageEl.length && (i.scale = Math.max(Math.min(i.scale, n.maxRatio), e.minRatio), n.$imageEl.transition(this.params.speed).transform(`translate3d(0,0,0) scale(${i.scale})`), i.currentScale = i.scale, i.isScaling = !1, 1 === i.scale && (n.$slideEl = void 0))
        },
        onTouchStart(t) {
            const e = this.zoom,
                {
                    gesture: i,
                    image: n
                } = e;
            i.$imageEl && 0 !== i.$imageEl.length && (n.isTouched || (_.android && t.preventDefault(), n.isTouched = !0, n.touchesStart.x = "touchstart" === t.type ? t.targetTouches[0].pageX : t.pageX, n.touchesStart.y = "touchstart" === t.type ? t.targetTouches[0].pageY : t.pageY))
        },
        onTouchMove(t) {
            const e = this,
                i = e.zoom,
                {
                    gesture: n,
                    image: s,
                    velocity: o
                } = i;
            if (!n.$imageEl || 0 === n.$imageEl.length) return;
            if (e.allowClick = !1, !s.isTouched || !n.$slideEl) return;
            s.isMoved || (s.width = n.$imageEl[0].offsetWidth, s.height = n.$imageEl[0].offsetHeight, s.startX = h.getTranslate(n.$imageWrapEl[0], "x") || 0, s.startY = h.getTranslate(n.$imageWrapEl[0], "y") || 0, n.slideWidth = n.$slideEl[0].offsetWidth, n.slideHeight = n.$slideEl[0].offsetHeight, n.$imageWrapEl.transition(0), e.rtl && (s.startX = -s.startX, s.startY = -s.startY));
            const r = s.width * i.scale,
                a = s.height * i.scale;
            if (!(r < n.slideWidth && a < n.slideHeight)) {
                if (s.minX = Math.min(n.slideWidth / 2 - r / 2, 0), s.maxX = -s.minX, s.minY = Math.min(n.slideHeight / 2 - a / 2, 0), s.maxY = -s.minY, s.touchesCurrent.x = "touchmove" === t.type ? t.targetTouches[0].pageX : t.pageX, s.touchesCurrent.y = "touchmove" === t.type ? t.targetTouches[0].pageY : t.pageY, !s.isMoved && !i.isScaling) {
                    if (e.isHorizontal() && (Math.floor(s.minX) === Math.floor(s.startX) && s.touchesCurrent.x < s.touchesStart.x || Math.floor(s.maxX) === Math.floor(s.startX) && s.touchesCurrent.x > s.touchesStart.x)) return void(s.isTouched = !1);
                    if (!e.isHorizontal() && (Math.floor(s.minY) === Math.floor(s.startY) && s.touchesCurrent.y < s.touchesStart.y || Math.floor(s.maxY) === Math.floor(s.startY) && s.touchesCurrent.y > s.touchesStart.y)) return void(s.isTouched = !1)
                }
                t.preventDefault(), t.stopPropagation(), s.isMoved = !0, s.currentX = s.touchesCurrent.x - s.touchesStart.x + s.startX, s.currentY = s.touchesCurrent.y - s.touchesStart.y + s.startY, s.currentX < s.minX && (s.currentX = s.minX + 1 - (s.minX - s.currentX + 1) ** .8), s.currentX > s.maxX && (s.currentX = s.maxX - 1 + (s.currentX - s.maxX + 1) ** .8), s.currentY < s.minY && (s.currentY = s.minY + 1 - (s.minY - s.currentY + 1) ** .8), s.currentY > s.maxY && (s.currentY = s.maxY - 1 + (s.currentY - s.maxY + 1) ** .8), o.prevPositionX || (o.prevPositionX = s.touchesCurrent.x), o.prevPositionY || (o.prevPositionY = s.touchesCurrent.y), o.prevTime || (o.prevTime = Date.now()), o.x = (s.touchesCurrent.x - o.prevPositionX) / (Date.now() - o.prevTime) / 2, o.y = (s.touchesCurrent.y - o.prevPositionY) / (Date.now() - o.prevTime) / 2, Math.abs(s.touchesCurrent.x - o.prevPositionX) < 2 && (o.x = 0), Math.abs(s.touchesCurrent.y - o.prevPositionY) < 2 && (o.y = 0), o.prevPositionX = s.touchesCurrent.x, o.prevPositionY = s.touchesCurrent.y, o.prevTime = Date.now(), n.$imageWrapEl.transform(`translate3d(${s.currentX}px, ${s.currentY}px,0)`)
            }
        },
        onTouchEnd() {
            const t = this.zoom,
                {
                    gesture: e,
                    image: i,
                    velocity: n
                } = t;
            if (!e.$imageEl || 0 === e.$imageEl.length) return;
            if (!i.isTouched || !i.isMoved) return i.isTouched = !1, void(i.isMoved = !1);
            i.isTouched = !1, i.isMoved = !1;
            let s = 300,
                o = 300;
            const r = n.x * s,
                a = i.currentX + r,
                l = n.y * o,
                h = i.currentY + l;
            0 !== n.x && (s = Math.abs((a - i.currentX) / n.x)), 0 !== n.y && (o = Math.abs((h - i.currentY) / n.y));
            const c = Math.max(s, o);
            i.currentX = a, i.currentY = h;
            const d = i.width * t.scale,
                u = i.height * t.scale;
            i.minX = Math.min(e.slideWidth / 2 - d / 2, 0), i.maxX = -i.minX, i.minY = Math.min(e.slideHeight / 2 - u / 2, 0), i.maxY = -i.minY, i.currentX = Math.max(Math.min(i.currentX, i.maxX), i.minX), i.currentY = Math.max(Math.min(i.currentY, i.maxY), i.minY), e.$imageWrapEl.transition(c).transform(`translate3d(${i.currentX}px, ${i.currentY}px,0)`)
        },
        onTransitionEnd() {
            const t = this.zoom,
                {
                    gesture: e
                } = t;
            e.$slideEl && this.previousIndex !== this.activeIndex && (e.$imageEl.transform("translate3d(0,0,0) scale(1)"), e.$imageWrapEl.transform("translate3d(0,0,0)"), t.scale = 1, t.currentScale = 1, e.$slideEl = void 0, e.$imageEl = void 0, e.$imageWrapEl = void 0)
        },
        toggle(t) {
            const e = this.zoom;
            e.scale && 1 !== e.scale ? e.out() : e.in(t)
        },
        in (t) {
            const e = this,
                i = e.zoom,
                n = e.params.zoom,
                {
                    gesture: s,
                    image: o
                } = i;
            if (s.$slideEl || (s.$slideEl = e.clickedSlide ? r(e.clickedSlide) : e.slides.eq(e.activeIndex), s.$imageEl = s.$slideEl.find("img, svg, canvas"), s.$imageWrapEl = s.$imageEl.parent(`.${n.containerClass}`)), !s.$imageEl || 0 === s.$imageEl.length) return;
            let a, l, h, c, d, u, p, f, m, g, v, y, _, b, w, x, T, E;
            s.$slideEl.addClass(`${n.zoomedSlideClass}`), void 0 === o.touchesStart.x && t ? (a = "touchend" === t.type ? t.changedTouches[0].pageX : t.pageX, l = "touchend" === t.type ? t.changedTouches[0].pageY : t.pageY) : (a = o.touchesStart.x, l = o.touchesStart.y), i.scale = s.$imageWrapEl.attr("data-swiper-zoom") || n.maxRatio, i.currentScale = s.$imageWrapEl.attr("data-swiper-zoom") || n.maxRatio, t ? (T = s.$slideEl[0].offsetWidth, E = s.$slideEl[0].offsetHeight, d = (h = s.$slideEl.offset().left) + T / 2 - a, u = (c = s.$slideEl.offset().top) + E / 2 - l, m = s.$imageEl[0].offsetWidth, g = s.$imageEl[0].offsetHeight, v = m * i.scale, y = g * i.scale, w = -(_ = Math.min(T / 2 - v / 2, 0)), x = -(b = Math.min(E / 2 - y / 2, 0)), p = d * i.scale, f = u * i.scale, p < _ && (p = _), p > w && (p = w), f < b && (f = b), f > x && (f = x)) : (p = 0, f = 0), s.$imageWrapEl.transition(300).transform(`translate3d(${p}px, ${f}px,0)`), s.$imageEl.transition(300).transform(`translate3d(0,0,0) scale(${i.scale})`)
        },
        out() {
            const t = this,
                e = t.zoom,
                i = t.params.zoom,
                {
                    gesture: n
                } = e;
            n.$slideEl || (n.$slideEl = t.clickedSlide ? r(t.clickedSlide) : t.slides.eq(t.activeIndex), n.$imageEl = n.$slideEl.find("img, svg, canvas"), n.$imageWrapEl = n.$imageEl.parent(`.${i.containerClass}`)), n.$imageEl && 0 !== n.$imageEl.length && (e.scale = 1, e.currentScale = 1, n.$imageWrapEl.transition(300).transform("translate3d(0,0,0)"), n.$imageEl.transition(300).transform("translate3d(0,0,0) scale(1)"), n.$slideEl.removeClass(`${i.zoomedSlideClass}`), n.$slideEl = void 0)
        },
        enable() {
            const t = this,
                e = t.zoom;
            if (e.enabled) return;
            e.enabled = !0;
            const i = !("touchstart" !== t.touchEvents.start || !c.passiveListener || !t.params.passiveListeners) && {
                passive: !0,
                capture: !1
            };
            c.gestures ? (t.$wrapperEl.on("gesturestart", ".swiper-slide", e.onGestureStart, i), t.$wrapperEl.on("gesturechange", ".swiper-slide", e.onGestureChange, i), t.$wrapperEl.on("gestureend", ".swiper-slide", e.onGestureEnd, i)) : "touchstart" === t.touchEvents.start && (t.$wrapperEl.on(t.touchEvents.start, ".swiper-slide", e.onGestureStart, i), t.$wrapperEl.on(t.touchEvents.move, ".swiper-slide", e.onGestureChange, i), t.$wrapperEl.on(t.touchEvents.end, ".swiper-slide", e.onGestureEnd, i)), t.$wrapperEl.on(t.touchEvents.move, `.${t.params.zoom.containerClass}`, e.onTouchMove)
        },
        disable() {
            const t = this,
                e = t.zoom;
            if (!e.enabled) return;
            t.zoom.enabled = !1;
            const i = !("touchstart" !== t.touchEvents.start || !c.passiveListener || !t.params.passiveListeners) && {
                passive: !0,
                capture: !1
            };
            c.gestures ? (t.$wrapperEl.off("gesturestart", ".swiper-slide", e.onGestureStart, i), t.$wrapperEl.off("gesturechange", ".swiper-slide", e.onGestureChange, i), t.$wrapperEl.off("gestureend", ".swiper-slide", e.onGestureEnd, i)) : "touchstart" === t.touchEvents.start && (t.$wrapperEl.off(t.touchEvents.start, ".swiper-slide", e.onGestureStart, i), t.$wrapperEl.off(t.touchEvents.move, ".swiper-slide", e.onGestureChange, i), t.$wrapperEl.off(t.touchEvents.end, ".swiper-slide", e.onGestureEnd, i)), t.$wrapperEl.off(t.touchEvents.move, `.${t.params.zoom.containerClass}`, e.onTouchMove)
        }
    };
    const V = {
        loadInSlide(t, e = !0) {
            const i = this,
                n = i.params.lazy;
            if (void 0 === t) return;
            if (0 === i.slides.length) return;
            const s = i.virtual && i.params.virtual.enabled ? i.$wrapperEl.children(`.${i.params.slideClass}[data-swiper-slide-index="${t}"]`) : i.slides.eq(t);
            let o = s.find(`.${n.elementClass}:not(.${n.loadedClass}):not(.${n.loadingClass})`);
            !s.hasClass(n.elementClass) || s.hasClass(n.loadedClass) || s.hasClass(n.loadingClass) || (o = o.add(s[0])), 0 !== o.length && o.each((t, o) => {
                const a = r(o);
                a.addClass(n.loadingClass);
                const l = a.attr("data-background"),
                    h = a.attr("data-src"),
                    c = a.attr("data-srcset"),
                    d = a.attr("data-sizes");
                i.loadImage(a[0], h || l, c, d, !1, () => {
                    if (void 0 !== i && null !== i && i && (!i || i.params) && !i.destroyed) {
                        if (l ? (a.css("background-image", `url("${l}")`), a.removeAttr("data-background")) : (c && (a.attr("srcset", c), a.removeAttr("data-srcset")), d && (a.attr("sizes", d), a.removeAttr("data-sizes")), h && (a.attr("src", h), a.removeAttr("data-src"))), a.addClass(n.loadedClass).removeClass(n.loadingClass), s.find(`.${n.preloaderClass}`).remove(), i.params.loop && e) {
                            const t = s.attr("data-swiper-slide-index");
                            if (s.hasClass(i.params.slideDuplicateClass)) {
                                const e = i.$wrapperEl.children(`[data-swiper-slide-index="${t}"]:not(.${i.params.slideDuplicateClass})`);
                                i.lazy.loadInSlide(e.index(), !1)
                            } else {
                                const e = i.$wrapperEl.children(`.${i.params.slideDuplicateClass}[data-swiper-slide-index="${t}"]`);
                                i.lazy.loadInSlide(e.index(), !1)
                            }
                        }
                        i.emit("lazyImageReady", s[0], a[0])
                    }
                }), i.emit("lazyImageLoad", s[0], a[0])
            })
        },
        load() {
            const t = this,
                {
                    $wrapperEl: e,
                    params: i,
                    slides: n,
                    activeIndex: s
                } = t,
                o = t.virtual && i.virtual.enabled,
                a = i.lazy;
            let l = i.slidesPerView;
  
            function h(t) {
                if (o) {
                    if (e.children(`.${i.slideClass}[data-swiper-slide-index="${t}"]`).length) return !0
                } else if (n[t]) return !0;
                return !1
            }
  
            function c(t) {
                return o ? r(t).attr("data-swiper-slide-index") : r(t).index()
            }
            if ("auto" === l && (l = 0), t.lazy.initialImageLoaded || (t.lazy.initialImageLoaded = !0), t.params.watchSlidesVisibility) e.children(`.${i.slideVisibleClass}`).each((e, i) => {
                const n = o ? r(i).attr("data-swiper-slide-index") : r(i).index();
                t.lazy.loadInSlide(n)
            });
            else if (l > 1)
                for (let e = s; e < s + l; e += 1) h(e) && t.lazy.loadInSlide(e);
            else t.lazy.loadInSlide(s);
            if (a.loadPrevNext)
                if (l > 1 || a.loadPrevNextAmount && a.loadPrevNextAmount > 1) {
                    const e = a.loadPrevNextAmount,
                        i = l,
                        o = Math.min(s + i + Math.max(e, i), n.length),
                        r = Math.max(s - Math.max(i, e), 0);
                    for (let e = s + l; e < o; e += 1) h(e) && t.lazy.loadInSlide(e);
                    for (let e = r; e < s; e += 1) h(e) && t.lazy.loadInSlide(e)
                } else {
                    const n = e.children(`.${i.slideNextClass}`);
                    n.length > 0 && t.lazy.loadInSlide(c(n));
                    const s = e.children(`.${i.slidePrevClass}`);
                    s.length > 0 && t.lazy.loadInSlide(c(s))
                }
        }
    };
    const q = {
        LinearSpline: function(t, e) {
            const i = function() {
                let t, e, i;
                return (n, s) => {
                    for (e = -1, t = n.length; t - e > 1;) n[i = t + e >> 1] <= s ? e = i : t = i;
                    return t
                }
            }();
            let n, s;
            return this.x = t, this.y = e, this.lastIndex = t.length - 1, this.interpolate = function(t) {
                return t ? (s = i(this.x, t), n = s - 1, (t - this.x[n]) * (this.y[s] - this.y[n]) / (this.x[s] - this.x[n]) + this.y[n]) : 0
            }, this
        },
        getInterpolateFunction(t) {
            const e = this;
            e.controller.spline || (e.controller.spline = e.params.loop ? new q.LinearSpline(e.slidesGrid, t.slidesGrid) : new q.LinearSpline(e.snapGrid, t.snapGrid))
        },
        setTranslate(t, e) {
            const i = this,
                n = i.controller.control;
            let s, o;
  
            function r(t) {
                const e = i.rtlTranslate ? -i.translate : i.translate;
                "slide" === i.params.controller.by && (i.controller.getInterpolateFunction(t), o = -i.controller.spline.interpolate(-e)), o && "container" !== i.params.controller.by || (s = (t.maxTranslate() - t.minTranslate()) / (i.maxTranslate() - i.minTranslate()), o = (e - i.minTranslate()) * s + t.minTranslate()), i.params.controller.inverse && (o = t.maxTranslate() - o), t.updateProgress(o), t.setTranslate(o, i), t.updateActiveIndex(), t.updateSlidesClasses()
            }
            if (Array.isArray(n))
                for (let t = 0; t < n.length; t += 1) n[t] !== e && n[t] instanceof D && r(n[t]);
            else n instanceof D && e !== n && r(n)
        },
        setTransition(t, e) {
            const i = this,
                n = i.controller.control;
            let s;
  
            function o(e) {
                e.setTransition(t, i), 0 !== t && (e.transitionStart(), e.params.autoHeight && h.nextTick(() => {
                    e.updateAutoHeight()
                }), e.$wrapperEl.transitionEnd(() => {
                    n && (e.params.loop && "slide" === i.params.controller.by && e.loopFix(), e.transitionEnd())
                }))
            }
            if (Array.isArray(n))
                for (s = 0; s < n.length; s += 1) n[s] !== e && n[s] instanceof D && o(n[s]);
            else n instanceof D && e !== n && o(n)
        }
    };
    const G = {
        makeElFocusable: t => (t.attr("tabIndex", "0"), t),
        addElRole: (t, e) => (t.attr("role", e), t),
        addElLabel: (t, e) => (t.attr("aria-label", e), t),
        disableEl: t => (t.attr("aria-disabled", !0), t),
        enableEl: t => (t.attr("aria-disabled", !1), t),
        onEnterKey(t) {
            const e = this,
                i = e.params.a11y;
            if (13 !== t.keyCode) return;
            const n = r(t.target);
            e.navigation && e.navigation.$nextEl && n.is(e.navigation.$nextEl) && (e.isEnd && !e.params.loop || e.slideNext(), e.isEnd ? e.a11y.notify(i.lastSlideMessage) : e.a11y.notify(i.nextSlideMessage)), e.navigation && e.navigation.$prevEl && n.is(e.navigation.$prevEl) && (e.isBeginning && !e.params.loop || e.slidePrev(), e.isBeginning ? e.a11y.notify(i.firstSlideMessage) : e.a11y.notify(i.prevSlideMessage)), e.pagination && n.is(`.${e.params.pagination.bulletClass}`) && n[0].click()
        },
        notify(t) {
            const e = this.a11y.liveRegion;
            0 !== e.length && (e.html(""), e.html(t))
        },
        updateNavigation() {
            const t = this;
            if (t.params.loop) return;
            const {
                $nextEl: e,
                $prevEl: i
            } = t.navigation;
            i && i.length > 0 && (t.isBeginning ? t.a11y.disableEl(i) : t.a11y.enableEl(i)), e && e.length > 0 && (t.isEnd ? t.a11y.disableEl(e) : t.a11y.enableEl(e))
        },
        updatePagination() {
            const t = this,
                e = t.params.a11y;
            t.pagination && t.params.pagination.clickable && t.pagination.bullets && t.pagination.bullets.length && t.pagination.bullets.each((i, n) => {
                const s = r(n);
                t.a11y.makeElFocusable(s), t.a11y.addElRole(s, "button"), t.a11y.addElLabel(s, e.paginationBulletMessage.replace(/{{index}}/, s.index() + 1))
            })
        },
        init() {
            const t = this;
            t.$el.append(t.a11y.liveRegion);
            const e = t.params.a11y;
            let i, n;
            t.navigation && t.navigation.$nextEl && (i = t.navigation.$nextEl), t.navigation && t.navigation.$prevEl && (n = t.navigation.$prevEl), i && (t.a11y.makeElFocusable(i), t.a11y.addElRole(i, "button"), t.a11y.addElLabel(i, e.nextSlideMessage), i.on("keydown", t.a11y.onEnterKey)), n && (t.a11y.makeElFocusable(n), t.a11y.addElRole(n, "button"), t.a11y.addElLabel(n, e.prevSlideMessage), n.on("keydown", t.a11y.onEnterKey)), t.pagination && t.params.pagination.clickable && t.pagination.bullets && t.pagination.bullets.length && t.pagination.$el.on("keydown", `.${t.params.pagination.bulletClass}`, t.a11y.onEnterKey)
        },
        destroy() {
            const t = this;
            let e, i;
            t.a11y.liveRegion && t.a11y.liveRegion.length > 0 && t.a11y.liveRegion.remove(), t.navigation && t.navigation.$nextEl && (e = t.navigation.$nextEl), t.navigation && t.navigation.$prevEl && (i = t.navigation.$prevEl), e && e.off("keydown", t.a11y.onEnterKey), i && i.off("keydown", t.a11y.onEnterKey), t.pagination && t.params.pagination.clickable && t.pagination.bullets && t.pagination.bullets.length && t.pagination.$el.off("keydown", `.${t.params.pagination.bulletClass}`, t.a11y.onEnterKey)
        }
    };
    const U = {
        init() {
            const t = this;
            if (!t.params.history) return;
            if (!s.history || !s.history.pushState) return t.params.history.enabled = !1, void(t.params.hashNavigation.enabled = !0);
            const e = t.history;
            e.initialized = !0, e.paths = U.getPathValues(), (e.paths.key || e.paths.value) && (e.scrollToSlide(0, e.paths.value, t.params.runCallbacksOnInit), t.params.history.replaceState || s.addEventListener("popstate", t.history.setHistoryPopState))
        },
        destroy() {
            const t = this;
            t.params.history.replaceState || s.removeEventListener("popstate", t.history.setHistoryPopState)
        },
        setHistoryPopState() {
            this.history.paths = U.getPathValues(), this.history.scrollToSlide(this.params.speed, this.history.paths.value, !1)
        },
        getPathValues() {
            const t = s.location.pathname.slice(1).split("/").filter(t => "" !== t),
                e = t.length;
            return {
                key: t[e - 2],
                value: t[e - 1]
            }
        },
        setHistory(t, e) {
            if (!this.history.initialized || !this.params.history.enabled) return;
            const i = this.slides.eq(e);
            let n = U.slugify(i.attr("data-history"));
            s.location.pathname.includes(t) || (n = `${t}/${n}`);
            const o = s.history.state;
            o && o.value === n || (this.params.history.replaceState ? s.history.replaceState({
                value: n
            }, null, n) : s.history.pushState({
                value: n
            }, null, n))
        },
        slugify: t => t.toString().toLowerCase().replace(/\s+/g, "-").replace(/[^\w-]+/g, "").replace(/--+/g, "-").replace(/^-+/, "").replace(/-+$/, ""),
        scrollToSlide(t, e, i) {
            const n = this;
            if (e)
                for (let s = 0, o = n.slides.length; s < o; s += 1) {
                    const o = n.slides.eq(s);
                    if (U.slugify(o.attr("data-history")) === e && !o.hasClass(n.params.slideDuplicateClass)) {
                        const e = o.index();
                        n.slideTo(e, t, i)
                    }
                } else n.slideTo(0, t, i)
        }
    };
    const Y = {
        onHashCange() {
            const t = this,
                e = n.location.hash.replace("#", "");
            if (e !== t.slides.eq(t.activeIndex).attr("data-hash")) {
                const i = t.$wrapperEl.children(`.${t.params.slideClass}[data-hash="${e}"]`).index();
                if (void 0 === i) return;
                t.slideTo(i)
            }
        },
        setHash() {
            const t = this;
            if (t.hashNavigation.initialized && t.params.hashNavigation.enabled)
                if (t.params.hashNavigation.replaceState && s.history && s.history.replaceState) s.history.replaceState(null, null, `#${t.slides.eq(t.activeIndex).attr("data-hash")}` || "");
                else {
                    const e = t.slides.eq(t.activeIndex),
                        i = e.attr("data-hash") || e.attr("data-history");
                    n.location.hash = i || ""
                }
        },
        init() {
            const t = this;
            if (!t.params.hashNavigation.enabled || t.params.history && t.params.history.enabled) return;
            t.hashNavigation.initialized = !0;
            const e = n.location.hash.replace("#", "");
            if (e) {
                const i = 0;
                for (let n = 0, s = t.slides.length; n < s; n += 1) {
                    const s = t.slides.eq(n);
                    if ((s.attr("data-hash") || s.attr("data-history")) === e && !s.hasClass(t.params.slideDuplicateClass)) {
                        const e = s.index();
                        t.slideTo(e, i, t.params.runCallbacksOnInit, !0)
                    }
                }
            }
            t.params.hashNavigation.watchState && r(s).on("hashchange", t.hashNavigation.onHashCange)
        },
        destroy() {
            const t = this;
            t.params.hashNavigation.watchState && r(s).off("hashchange", t.hashNavigation.onHashCange)
        }
    };
    const X = {
        run() {
            const t = this,
                e = t.slides.eq(t.activeIndex);
            let i = t.params.autoplay.delay;
            e.attr("data-swiper-autoplay") && (i = e.attr("data-swiper-autoplay") || t.params.autoplay.delay), t.autoplay.timeout = h.nextTick(() => {
                t.params.autoplay.reverseDirection ? t.params.loop ? (t.loopFix(), t.slidePrev(t.params.speed, !0, !0), t.emit("autoplay")) : t.isBeginning ? t.params.autoplay.stopOnLastSlide ? t.autoplay.stop() : (t.slideTo(t.slides.length - 1, t.params.speed, !0, !0), t.emit("autoplay")) : (t.slidePrev(t.params.speed, !0, !0), t.emit("autoplay")) : t.params.loop ? (t.loopFix(), t.slideNext(t.params.speed, !0, !0), t.emit("autoplay")) : t.isEnd ? t.params.autoplay.stopOnLastSlide ? t.autoplay.stop() : (t.slideTo(0, t.params.speed, !0, !0), t.emit("autoplay")) : (t.slideNext(t.params.speed, !0, !0), t.emit("autoplay"))
            }, i)
        },
        start() {
            return void 0 === this.autoplay.timeout && (!this.autoplay.running && (this.autoplay.running = !0, this.emit("autoplayStart"), this.autoplay.run(), !0))
        },
        stop() {
            const t = this;
            return !!t.autoplay.running && (void 0 !== t.autoplay.timeout && (t.autoplay.timeout && (clearTimeout(t.autoplay.timeout), t.autoplay.timeout = void 0), t.autoplay.running = !1, t.emit("autoplayStop"), !0))
        },
        pause(t) {
            const e = this;
            e.autoplay.running && (e.autoplay.paused || (e.autoplay.timeout && clearTimeout(e.autoplay.timeout), e.autoplay.paused = !0, 0 !== t && e.params.autoplay.waitForTransition ? (e.$wrapperEl[0].addEventListener("transitionend", e.autoplay.onTransitionEnd), e.$wrapperEl[0].addEventListener("webkitTransitionEnd", e.autoplay.onTransitionEnd)) : (e.autoplay.paused = !1, e.autoplay.run())))
        }
    };
    const K = {
        setTranslate() {
            const t = this,
                {
                    slides: e
                } = t;
            for (let i = 0; i < e.length; i += 1) {
                const e = t.slides.eq(i);
                let n = -e[0].swiperSlideOffset;
                t.params.virtualTranslate || (n -= t.translate);
                let s = 0;
                t.isHorizontal() || (s = n, n = 0);
                const o = t.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(e[0].progress), 0) : 1 + Math.min(Math.max(e[0].progress, -1), 0);
                e.css({
                    opacity: o
                }).transform(`translate3d(${n}px, ${s}px, 0px)`)
            }
        },
        setTransition(t) {
            const e = this,
                {
                    slides: i,
                    $wrapperEl: n
                } = e;
            if (i.transition(t), e.params.virtualTranslate && 0 !== t) {
                let t = !1;
                i.transitionEnd(() => {
                    if (t) return;
                    if (!e || e.destroyed) return;
                    t = !0, e.animating = !1;
                    const i = ["webkitTransitionEnd", "transitionend"];
                    for (let t = 0; t < i.length; t += 1) n.trigger(i[t])
                })
            }
        }
    };
    const Q = {
        setTranslate() {
            const {
                $el: t,
                $wrapperEl: e,
                slides: i,
                width: n,
                height: s,
                rtlTranslate: o,
                size: a
            } = this, l = this.params.cubeEffect, h = this.isHorizontal(), c = this.virtual && this.params.virtual.enabled;
            let d, u = 0;
            l.shadow && (h ? (0 === (d = e.find(".swiper-cube-shadow")).length && (d = r('<div class="swiper-cube-shadow"></div>'), e.append(d)), d.css({
                height: `${n}px`
            })) : 0 === (d = t.find(".swiper-cube-shadow")).length && (d = r('<div class="swiper-cube-shadow"></div>'), t.append(d)));
            for (let t = 0; t < i.length; t += 1) {
                const e = i.eq(t);
                let n = t;
                c && (n = parseInt(e.attr("data-swiper-slide-index"), 10));
                let s = 90 * n,
                    d = Math.floor(s / 360);
                o && (s = -s, d = Math.floor(-s / 360));
                const p = Math.max(Math.min(e[0].progress, 1), -1);
                let f = 0,
                    m = 0,
                    g = 0;
                n % 4 == 0 ? (f = 4 * -d * a, g = 0) : (n - 1) % 4 == 0 ? (f = 0, g = 4 * -d * a) : (n - 2) % 4 == 0 ? (f = a + 4 * d * a, g = a) : (n - 3) % 4 == 0 && (f = -a, g = 3 * a + 4 * a * d), o && (f = -f), h || (m = f, f = 0);
                const v = `rotateX(${h?0:-s}deg) rotateY(${h?s:0}deg) translate3d(${f}px, ${m}px, ${g}px)`;
                if (p <= 1 && p > -1 && (u = 90 * n + 90 * p, o && (u = 90 * -n - 90 * p)), e.transform(v), l.slideShadows) {
                    let t = h ? e.find(".swiper-slide-shadow-left") : e.find(".swiper-slide-shadow-top"),
                        i = h ? e.find(".swiper-slide-shadow-right") : e.find(".swiper-slide-shadow-bottom");
                    0 === t.length && (t = r(`<div class="swiper-slide-shadow-${h?"left":"top"}"></div>`), e.append(t)), 0 === i.length && (i = r(`<div class="swiper-slide-shadow-${h?"right":"bottom"}"></div>`), e.append(i)), t.length && (t[0].style.opacity = Math.max(-p, 0)), i.length && (i[0].style.opacity = Math.max(p, 0))
                }
            }
            if (e.css({
                    "-webkit-transform-origin": `50% 50% -${a/2}px`,
                    "-moz-transform-origin": `50% 50% -${a/2}px`,
                    "-ms-transform-origin": `50% 50% -${a/2}px`,
                    "transform-origin": `50% 50% -${a/2}px`
                }), l.shadow)
                if (h) d.transform(`translate3d(0px, ${n/2+l.shadowOffset}px, ${-n/2}px) rotateX(90deg) rotateZ(0deg) scale(${l.shadowScale})`);
                else {
                    const t = Math.abs(u) - 90 * Math.floor(Math.abs(u) / 90),
                        e = 1.5 - (Math.sin(2 * t * Math.PI / 360) / 2 + Math.cos(2 * t * Math.PI / 360) / 2),
                        i = l.shadowScale,
                        n = l.shadowScale / e,
                        o = l.shadowOffset;
                    d.transform(`scale3d(${i}, 1, ${n}) translate3d(0px, ${s/2+o}px, ${-s/2/n}px) rotateX(-90deg)`)
                } const p = T.isSafari || T.isUiWebView ? -a / 2 : 0;
            e.transform(`translate3d(0px,0,${p}px) rotateX(${this.isHorizontal()?0:u}deg) rotateY(${this.isHorizontal()?-u:0}deg)`)
        },
        setTransition(t) {
            const {
                $el: e,
                slides: i
            } = this;
            i.transition(t).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(t), this.params.cubeEffect.shadow && !this.isHorizontal() && e.find(".swiper-cube-shadow").transition(t)
        }
    };
    const Z = {
        setTranslate() {
            const t = this,
                {
                    slides: e,
                    rtlTranslate: i
                } = t;
            for (let n = 0; n < e.length; n += 1) {
                const s = e.eq(n);
                let o = s[0].progress;
                t.params.flipEffect.limitRotation && (o = Math.max(Math.min(s[0].progress, 1), -1));
                let a = -180 * o,
                    l = 0,
                    h = -s[0].swiperSlideOffset,
                    c = 0;
                if (t.isHorizontal() ? i && (a = -a) : (c = h, h = 0, l = -a, a = 0), s[0].style.zIndex = -Math.abs(Math.round(o)) + e.length, t.params.flipEffect.slideShadows) {
                    let e = t.isHorizontal() ? s.find(".swiper-slide-shadow-left") : s.find(".swiper-slide-shadow-top"),
                        i = t.isHorizontal() ? s.find(".swiper-slide-shadow-right") : s.find(".swiper-slide-shadow-bottom");
                    0 === e.length && (e = r(`<div class="swiper-slide-shadow-${t.isHorizontal()?"left":"top"}"></div>`), s.append(e)), 0 === i.length && (i = r(`<div class="swiper-slide-shadow-${t.isHorizontal()?"right":"bottom"}"></div>`), s.append(i)), e.length && (e[0].style.opacity = Math.max(-o, 0)), i.length && (i[0].style.opacity = Math.max(o, 0))
                }
                s.transform(`translate3d(${h}px, ${c}px, 0px) rotateX(${l}deg) rotateY(${a}deg)`)
            }
        },
        setTransition(t) {
            const e = this,
                {
                    slides: i,
                    activeIndex: n,
                    $wrapperEl: s
                } = e;
            if (i.transition(t).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(t), e.params.virtualTranslate && 0 !== t) {
                let t = !1;
                i.eq(n).transitionEnd(function() {
                    if (t) return;
                    if (!e || e.destroyed) return;
                    t = !0, e.animating = !1;
                    const i = ["webkitTransitionEnd", "transitionend"];
                    for (let t = 0; t < i.length; t += 1) s.trigger(i[t])
                })
            }
        }
    };
    const J = {
        setTranslate() {
            const {
                width: t,
                height: e,
                slides: i,
                $wrapperEl: n,
                slidesSizesGrid: s
            } = this, o = this.params.coverflowEffect, a = this.isHorizontal(), l = this.translate, h = a ? t / 2 - l : e / 2 - l, d = a ? o.rotate : -o.rotate, u = o.depth;
            for (let t = 0, e = i.length; t < e; t += 1) {
                const e = i.eq(t),
                    n = s[t],
                    l = (h - e[0].swiperSlideOffset - n / 2) / n * o.modifier;
                let c = a ? d * l : 0,
                    p = a ? 0 : d * l,
                    f = -u * Math.abs(l),
                    m = a ? 0 : o.stretch * l,
                    g = a ? o.stretch * l : 0;
                Math.abs(g) < .001 && (g = 0), Math.abs(m) < .001 && (m = 0), Math.abs(f) < .001 && (f = 0), Math.abs(c) < .001 && (c = 0), Math.abs(p) < .001 && (p = 0);
                const v = `translate3d(${g}px,${m}px,${f}px)  rotateX(${p}deg) rotateY(${c}deg)`;
                if (e.transform(v), e[0].style.zIndex = 1 - Math.abs(Math.round(l)), o.slideShadows) {
                    let t = a ? e.find(".swiper-slide-shadow-left") : e.find(".swiper-slide-shadow-top"),
                        i = a ? e.find(".swiper-slide-shadow-right") : e.find(".swiper-slide-shadow-bottom");
                    0 === t.length && (t = r(`<div class="swiper-slide-shadow-${a?"left":"top"}"></div>`), e.append(t)), 0 === i.length && (i = r(`<div class="swiper-slide-shadow-${a?"right":"bottom"}"></div>`), e.append(i)), t.length && (t[0].style.opacity = l > 0 ? l : 0), i.length && (i[0].style.opacity = -l > 0 ? -l : 0)
                }
            }
            if (c.pointerEvents || c.prefixedPointerEvents) {
                n[0].style.perspectiveOrigin = `${h}px 50%`
            }
        },
        setTransition(t) {
            this.slides.transition(t).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(t)
        }
    };
    const tt = {
        init() {
            const t = this,
                {
                    thumbs: e
                } = t.params,
                i = t.constructor;
            e.swiper instanceof i ? (t.thumbs.swiper = e.swiper, h.extend(t.thumbs.swiper.originalParams, {
                watchSlidesProgress: !0,
                slideToClickedSlide: !1
            }), h.extend(t.thumbs.swiper.params, {
                watchSlidesProgress: !0,
                slideToClickedSlide: !1
            })) : h.isObject(e.swiper) && (t.thumbs.swiper = new i(h.extend({}, e.swiper, {
                watchSlidesVisibility: !0,
                watchSlidesProgress: !0,
                slideToClickedSlide: !1
            })), t.thumbs.swiperCreated = !0), t.thumbs.swiper.$el.addClass(t.params.thumbs.thumbsContainerClass), t.thumbs.swiper.on("tap", t.thumbs.onThumbClick)
        },
        onThumbClick() {
            const t = this,
                e = t.thumbs.swiper;
            if (!e) return;
            const i = e.clickedIndex,
                n = e.clickedSlide;
            if (n && r(n).hasClass(t.params.thumbs.slideThumbActiveClass)) return;
            if (void 0 === i || null === i) return;
            let s;
            if (s = e.params.loop ? parseInt(r(e.clickedSlide).attr("data-swiper-slide-index"), 10) : i, t.params.loop) {
                let e = t.activeIndex;
                t.slides.eq(e).hasClass(t.params.slideDuplicateClass) && (t.loopFix(), t._clientLeft = t.$wrapperEl[0].clientLeft, e = t.activeIndex);
                const i = t.slides.eq(e).prevAll(`[data-swiper-slide-index="${s}"]`).eq(0).index(),
                    n = t.slides.eq(e).nextAll(`[data-swiper-slide-index="${s}"]`).eq(0).index();
                s = void 0 === i ? n : void 0 === n ? i : n - e < e - i ? n : i
            }
            t.slideTo(s)
        },
        update(t) {
            const e = this,
                i = e.thumbs.swiper;
            if (!i) return;
            const n = "auto" === i.params.slidesPerView ? i.slidesPerViewDynamic() : i.params.slidesPerView;
            if (e.realIndex !== i.realIndex) {
                let s, o = i.activeIndex;
                if (i.params.loop) {
                    i.slides.eq(o).hasClass(i.params.slideDuplicateClass) && (i.loopFix(), i._clientLeft = i.$wrapperEl[0].clientLeft, o = i.activeIndex);
                    const t = i.slides.eq(o).prevAll(`[data-swiper-slide-index="${e.realIndex}"]`).eq(0).index(),
                        n = i.slides.eq(o).nextAll(`[data-swiper-slide-index="${e.realIndex}"]`).eq(0).index();
                    s = void 0 === t ? n : void 0 === n ? t : n - o == o - t ? o : n - o < o - t ? n : t
                } else s = e.realIndex;
                i.visibleSlidesIndexes.indexOf(s) < 0 && (i.params.centeredSlides ? s = s > o ? s - Math.floor(n / 2) + 1 : s + Math.floor(n / 2) - 1 : s > o && (s = s - n + 1), i.slideTo(s, t ? 0 : void 0))
            }
            let s = 1;
            const o = e.params.thumbs.slideThumbActiveClass;
            if (e.params.slidesPerView > 1 && !e.params.centeredSlides && (s = e.params.slidesPerView), i.slides.removeClass(o), i.params.loop)
                for (let t = 0; t < s; t += 1) i.$wrapperEl.children(`[data-swiper-slide-index="${e.realIndex+t}"]`).addClass(o);
            else
                for (let t = 0; t < s; t += 1) i.slides.eq(e.realIndex + t).addClass(o)
        }
    };
    const et = [I, M, O, k, P, L, z, {
        name: "mousewheel",
        params: {
            mousewheel: {
                enabled: !1,
                releaseOnEdges: !1,
                invert: !1,
                forceToAxis: !1,
                sensitivity: 1,
                eventsTarged: "container"
            }
        },
        create() {
            h.extend(this, {
                mousewheel: {
                    enabled: !1,
                    enable: F.enable.bind(this),
                    disable: F.disable.bind(this),
                    handle: F.handle.bind(this),
                    handleMouseEnter: F.handleMouseEnter.bind(this),
                    handleMouseLeave: F.handleMouseLeave.bind(this),
                    lastScrollTime: h.now()
                }
            })
        },
        on: {
            init() {
                this.params.mousewheel.enabled && this.mousewheel.enable()
            },
            destroy() {
                this.mousewheel.enabled && this.mousewheel.disable()
            }
        }
    }, {
        name: "navigation",
        params: {
            navigation: {
                nextEl: null,
                prevEl: null,
                hideOnClick: !1,
                disabledClass: "swiper-button-disabled",
                hiddenClass: "swiper-button-hidden",
                lockClass: "swiper-button-lock"
            }
        },
        create() {
            h.extend(this, {
                navigation: {
                    init: H.init.bind(this),
                    update: H.update.bind(this),
                    destroy: H.destroy.bind(this),
                    onNextClick: H.onNextClick.bind(this),
                    onPrevClick: H.onPrevClick.bind(this)
                }
            })
        },
        on: {
            init() {
                this.navigation.init(), this.navigation.update()
            },
            toEdge() {
                this.navigation.update()
            },
            fromEdge() {
                this.navigation.update()
            },
            destroy() {
                this.navigation.destroy()
            },
            click(t) {
                const e = this,
                    {
                        $nextEl: i,
                        $prevEl: n
                    } = e.navigation;
                !e.params.navigation.hideOnClick || r(t.target).is(n) || r(t.target).is(i) || (i && i.toggleClass(e.params.navigation.hiddenClass), n && n.toggleClass(e.params.navigation.hiddenClass))
            }
        }
    }, {
        name: "pagination",
        params: {
            pagination: {
                el: null,
                bulletElement: "span",
                clickable: !1,
                hideOnClick: !1,
                renderBullet: null,
                renderProgressbar: null,
                renderFraction: null,
                renderCustom: null,
                progressbarOpposite: !1,
                type: "bullets",
                dynamicBullets: !1,
                dynamicMainBullets: 1,
                formatFractionCurrent: t => t,
                formatFractionTotal: t => t,
                bulletClass: "swiper-pagination-bullet",
                bulletActiveClass: "swiper-pagination-bullet-active",
                modifierClass: "swiper-pagination-",
                currentClass: "swiper-pagination-current",
                totalClass: "swiper-pagination-total",
                hiddenClass: "swiper-pagination-hidden",
                progressbarFillClass: "swiper-pagination-progressbar-fill",
                progressbarOppositeClass: "swiper-pagination-progressbar-opposite",
                clickableClass: "swiper-pagination-clickable",
                lockClass: "swiper-pagination-lock"
            }
        },
        create() {
            h.extend(this, {
                pagination: {
                    init: R.init.bind(this),
                    render: R.render.bind(this),
                    update: R.update.bind(this),
                    destroy: R.destroy.bind(this),
                    dynamicBulletIndex: 0
                }
            })
        },
        on: {
            init() {
                this.pagination.init(), this.pagination.render(), this.pagination.update()
            },
            activeIndexChange() {
                const t = this;
                t.params.loop ? t.pagination.update() : void 0 === t.snapIndex && t.pagination.update()
            },
            snapIndexChange() {
                const t = this;
                t.params.loop || t.pagination.update()
            },
            slidesLengthChange() {
                const t = this;
                t.params.loop && (t.pagination.render(), t.pagination.update())
            },
            snapGridLengthChange() {
                const t = this;
                t.params.loop || (t.pagination.render(), t.pagination.update())
            },
            destroy() {
                this.pagination.destroy()
            },
            click(t) {
                const e = this;
                e.params.pagination.el && e.params.pagination.hideOnClick && e.pagination.$el.length > 0 && !r(t.target).hasClass(e.params.pagination.bulletClass) && e.pagination.$el.toggleClass(e.params.pagination.hiddenClass)
            }
        }
    }, {
        name: "scrollbar",
        params: {
            scrollbar: {
                el: null,
                dragSize: "auto",
                hide: !1,
                draggable: !1,
                snapOnRelease: !0,
                lockClass: "swiper-scrollbar-lock",
                dragClass: "swiper-scrollbar-drag"
            }
        },
        create() {
            h.extend(this, {
                scrollbar: {
                    init: j.init.bind(this),
                    destroy: j.destroy.bind(this),
                    updateSize: j.updateSize.bind(this),
                    setTranslate: j.setTranslate.bind(this),
                    setTransition: j.setTransition.bind(this),
                    enableDraggable: j.enableDraggable.bind(this),
                    disableDraggable: j.disableDraggable.bind(this),
                    setDragPosition: j.setDragPosition.bind(this),
                    onDragStart: j.onDragStart.bind(this),
                    onDragMove: j.onDragMove.bind(this),
                    onDragEnd: j.onDragEnd.bind(this),
                    isTouched: !1,
                    timeout: null,
                    dragTimeout: null
                }
            })
        },
        on: {
            init() {
                this.scrollbar.init(), this.scrollbar.updateSize(), this.scrollbar.setTranslate()
            },
            update() {
                this.scrollbar.updateSize()
            },
            resize() {
                this.scrollbar.updateSize()
            },
            observerUpdate() {
                this.scrollbar.updateSize()
            },
            setTranslate() {
                this.scrollbar.setTranslate()
            },
            setTransition(t) {
                this.scrollbar.setTransition(t)
            },
            destroy() {
                this.scrollbar.destroy()
            }
        }
    }, {
        name: "parallax",
        params: {
            parallax: {
                enabled: !1
            }
        },
        create() {
            h.extend(this, {
                parallax: {
                    setTransform: W.setTransform.bind(this),
                    setTranslate: W.setTranslate.bind(this),
                    setTransition: W.setTransition.bind(this)
                }
            })
        },
        on: {
            beforeInit() {
                this.params.parallax.enabled && (this.params.watchSlidesProgress = !0, this.originalParams.watchSlidesProgress = !0)
            },
            init() {
                this.params.parallax && this.parallax.setTranslate()
            },
            setTranslate() {
                this.params.parallax && this.parallax.setTranslate()
            },
            setTransition(t) {
                this.params.parallax && this.parallax.setTransition(t)
            }
        }
    }, {
        name: "zoom",
        params: {
            zoom: {
                enabled: !1,
                maxRatio: 3,
                minRatio: 1,
                toggle: !0,
                containerClass: "swiper-zoom-container",
                zoomedSlideClass: "swiper-slide-zoomed"
            }
        },
        create() {
            const t = this,
                e = {
                    enabled: !1,
                    scale: 1,
                    currentScale: 1,
                    isScaling: !1,
                    gesture: {
                        $slideEl: void 0,
                        slideWidth: void 0,
                        slideHeight: void 0,
                        $imageEl: void 0,
                        $imageWrapEl: void 0,
                        maxRatio: 3
                    },
                    image: {
                        isTouched: void 0,
                        isMoved: void 0,
                        currentX: void 0,
                        currentY: void 0,
                        minX: void 0,
                        minY: void 0,
                        maxX: void 0,
                        maxY: void 0,
                        width: void 0,
                        height: void 0,
                        startX: void 0,
                        startY: void 0,
                        touchesStart: {},
                        touchesCurrent: {}
                    },
                    velocity: {
                        x: void 0,
                        y: void 0,
                        prevPositionX: void 0,
                        prevPositionY: void 0,
                        prevTime: void 0
                    }
                };
            "onGestureStart onGestureChange onGestureEnd onTouchStart onTouchMove onTouchEnd onTransitionEnd toggle enable disable in out".split(" ").forEach(i => {
                e[i] = B[i].bind(t)
            }), h.extend(t, {
                zoom: e
            });
            let i = 1;
            Object.defineProperty(t.zoom, "scale", {
                get: () => i,
                set(e) {
                    if (i !== e) {
                        const i = t.zoom.gesture.$imageEl ? t.zoom.gesture.$imageEl[0] : void 0,
                            n = t.zoom.gesture.$slideEl ? t.zoom.gesture.$slideEl[0] : void 0;
                        t.emit("zoomChange", e, i, n)
                    }
                    i = e
                }
            })
        },
        on: {
            init() {
                const t = this;
                t.params.zoom.enabled && t.zoom.enable()
            },
            destroy() {
                this.zoom.disable()
            },
            touchStart(t) {
                this.zoom.enabled && this.zoom.onTouchStart(t)
            },
            touchEnd(t) {
                this.zoom.enabled && this.zoom.onTouchEnd(t)
            },
            doubleTap(t) {
                const e = this;
                e.params.zoom.enabled && e.zoom.enabled && e.params.zoom.toggle && e.zoom.toggle(t)
            },
            transitionEnd() {
                const t = this;
                t.zoom.enabled && t.params.zoom.enabled && t.zoom.onTransitionEnd()
            }
        }
    }, {
        name: "lazy",
        params: {
            lazy: {
                enabled: !1,
                loadPrevNext: !1,
                loadPrevNextAmount: 1,
                loadOnTransitionStart: !1,
                elementClass: "swiper-lazy",
                loadingClass: "swiper-lazy-loading",
                loadedClass: "swiper-lazy-loaded",
                preloaderClass: "swiper-lazy-preloader"
            }
        },
        create() {
            h.extend(this, {
                lazy: {
                    initialImageLoaded: !1,
                    load: V.load.bind(this),
                    loadInSlide: V.loadInSlide.bind(this)
                }
            })
        },
        on: {
            beforeInit() {
                const t = this;
                t.params.lazy.enabled && t.params.preloadImages && (t.params.preloadImages = !1)
            },
            init() {
                const t = this;
                t.params.lazy.enabled && !t.params.loop && 0 === t.params.initialSlide && t.lazy.load()
            },
            scroll() {
                const t = this;
                t.params.freeMode && !t.params.freeModeSticky && t.lazy.load()
            },
            resize() {
                const t = this;
                t.params.lazy.enabled && t.lazy.load()
            },
            scrollbarDragMove() {
                const t = this;
                t.params.lazy.enabled && t.lazy.load()
            },
            transitionStart() {
                const t = this;
                t.params.lazy.enabled && (t.params.lazy.loadOnTransitionStart || !t.params.lazy.loadOnTransitionStart && !t.lazy.initialImageLoaded) && t.lazy.load()
            },
            transitionEnd() {
                const t = this;
                t.params.lazy.enabled && !t.params.lazy.loadOnTransitionStart && t.lazy.load()
            }
        }
    }, {
        name: "controller",
        params: {
            controller: {
                control: void 0,
                inverse: !1,
                by: "slide"
            }
        },
        create() {
            h.extend(this, {
                controller: {
                    control: this.params.controller.control,
                    getInterpolateFunction: q.getInterpolateFunction.bind(this),
                    setTranslate: q.setTranslate.bind(this),
                    setTransition: q.setTransition.bind(this)
                }
            })
        },
        on: {
            update() {
                const t = this;
                t.controller.control && t.controller.spline && (t.controller.spline = void 0, delete t.controller.spline)
            },
            resize() {
                const t = this;
                t.controller.control && t.controller.spline && (t.controller.spline = void 0, delete t.controller.spline)
            },
            observerUpdate() {
                const t = this;
                t.controller.control && t.controller.spline && (t.controller.spline = void 0, delete t.controller.spline)
            },
            setTranslate(t, e) {
                this.controller.control && this.controller.setTranslate(t, e)
            },
            setTransition(t, e) {
                this.controller.control && this.controller.setTransition(t, e)
            }
        }
    }, {
        name: "a11y",
        params: {
            a11y: {
                enabled: !0,
                notificationClass: "swiper-notification",
                prevSlideMessage: "Previous slide",
                nextSlideMessage: "Next slide",
                firstSlideMessage: "This is the first slide",
                lastSlideMessage: "This is the last slide",
                paginationBulletMessage: "Go to slide {{index}}"
            }
        },
        create() {
            const t = this;
            h.extend(t, {
                a11y: {
                    liveRegion: r(`<span class="${t.params.a11y.notificationClass}" aria-live="assertive" aria-atomic="true"></span>`)
                }
            }), Object.keys(G).forEach(e => {
                t.a11y[e] = G[e].bind(t)
            })
        },
        on: {
            init() {
                this.params.a11y.enabled && (this.a11y.init(), this.a11y.updateNavigation())
            },
            toEdge() {
                this.params.a11y.enabled && this.a11y.updateNavigation()
            },
            fromEdge() {
                this.params.a11y.enabled && this.a11y.updateNavigation()
            },
            paginationUpdate() {
                this.params.a11y.enabled && this.a11y.updatePagination()
            },
            destroy() {
                this.params.a11y.enabled && this.a11y.destroy()
            }
        }
    }, {
        name: "history",
        params: {
            history: {
                enabled: !1,
                replaceState: !1,
                key: "slides"
            }
        },
        create() {
            h.extend(this, {
                history: {
                    init: U.init.bind(this),
                    setHistory: U.setHistory.bind(this),
                    setHistoryPopState: U.setHistoryPopState.bind(this),
                    scrollToSlide: U.scrollToSlide.bind(this),
                    destroy: U.destroy.bind(this)
                }
            })
        },
        on: {
            init() {
                const t = this;
                t.params.history.enabled && t.history.init()
            },
            destroy() {
                const t = this;
                t.params.history.enabled && t.history.destroy()
            },
            transitionEnd() {
                const t = this;
                t.history.initialized && t.history.setHistory(t.params.history.key, t.activeIndex)
            }
        }
    }, {
        name: "hash-navigation",
        params: {
            hashNavigation: {
                enabled: !1,
                replaceState: !1,
                watchState: !1
            }
        },
        create() {
            h.extend(this, {
                hashNavigation: {
                    initialized: !1,
                    init: Y.init.bind(this),
                    destroy: Y.destroy.bind(this),
                    setHash: Y.setHash.bind(this),
                    onHashCange: Y.onHashCange.bind(this)
                }
            })
        },
        on: {
            init() {
                const t = this;
                t.params.hashNavigation.enabled && t.hashNavigation.init()
            },
            destroy() {
                const t = this;
                t.params.hashNavigation.enabled && t.hashNavigation.destroy()
            },
            transitionEnd() {
                const t = this;
                t.hashNavigation.initialized && t.hashNavigation.setHash()
            }
        }
    }, {
        name: "autoplay",
        params: {
            autoplay: {
                enabled: !1,
                delay: 3e3,
                waitForTransition: !0,
                disableOnInteraction: !0,
                stopOnLastSlide: !1,
                reverseDirection: !1
            }
        },
        create() {
            const t = this;
            h.extend(t, {
                autoplay: {
                    running: !1,
                    paused: !1,
                    run: X.run.bind(t),
                    start: X.start.bind(t),
                    stop: X.stop.bind(t),
                    pause: X.pause.bind(t),
                    onTransitionEnd(e) {
                        t && !t.destroyed && t.$wrapperEl && e.target === this && (t.$wrapperEl[0].removeEventListener("transitionend", t.autoplay.onTransitionEnd), t.$wrapperEl[0].removeEventListener("webkitTransitionEnd", t.autoplay.onTransitionEnd), t.autoplay.paused = !1, t.autoplay.running ? t.autoplay.run() : t.autoplay.stop())
                    }
                }
            })
        },
        on: {
            init() {
                const t = this;
                t.params.autoplay.enabled && t.autoplay.start()
            },
            beforeTransitionStart(t, e) {
                const i = this;
                i.autoplay.running && (e || !i.params.autoplay.disableOnInteraction ? i.autoplay.pause(t) : i.autoplay.stop())
            },
            sliderFirstMove() {
                const t = this;
                t.autoplay.running && (t.params.autoplay.disableOnInteraction ? t.autoplay.stop() : t.autoplay.pause())
            },
            destroy() {
                const t = this;
                t.autoplay.running && t.autoplay.stop()
            }
        }
    }, {
        name: "effect-fade",
        params: {
            fadeEffect: {
                crossFade: !1
            }
        },
        create() {
            h.extend(this, {
                fadeEffect: {
                    setTranslate: K.setTranslate.bind(this),
                    setTransition: K.setTransition.bind(this)
                }
            })
        },
        on: {
            beforeInit() {
                if ("fade" !== this.params.effect) return;
                this.classNames.push(`${this.params.containerModifierClass}fade`);
                const t = {
                    slidesPerView: 1,
                    slidesPerColumn: 1,
                    slidesPerGroup: 1,
                    watchSlidesProgress: !0,
                    spaceBetween: 0,
                    virtualTranslate: !0
                };
                h.extend(this.params, t), h.extend(this.originalParams, t)
            },
            setTranslate() {
                "fade" === this.params.effect && this.fadeEffect.setTranslate()
            },
            setTransition(t) {
                "fade" === this.params.effect && this.fadeEffect.setTransition(t)
            }
        }
    }, {
        name: "effect-cube",
        params: {
            cubeEffect: {
                slideShadows: !0,
                shadow: !0,
                shadowOffset: 20,
                shadowScale: .94
            }
        },
        create() {
            h.extend(this, {
                cubeEffect: {
                    setTranslate: Q.setTranslate.bind(this),
                    setTransition: Q.setTransition.bind(this)
                }
            })
        },
        on: {
            beforeInit() {
                if ("cube" !== this.params.effect) return;
                this.classNames.push(`${this.params.containerModifierClass}cube`), this.classNames.push(`${this.params.containerModifierClass}3d`);
                const t = {
                    slidesPerView: 1,
                    slidesPerColumn: 1,
                    slidesPerGroup: 1,
                    watchSlidesProgress: !0,
                    resistanceRatio: 0,
                    spaceBetween: 0,
                    centeredSlides: !1,
                    virtualTranslate: !0
                };
                h.extend(this.params, t), h.extend(this.originalParams, t)
            },
            setTranslate() {
                "cube" === this.params.effect && this.cubeEffect.setTranslate()
            },
            setTransition(t) {
                "cube" === this.params.effect && this.cubeEffect.setTransition(t)
            }
        }
    }, {
        name: "effect-flip",
        params: {
            flipEffect: {
                slideShadows: !0,
                limitRotation: !0
            }
        },
        create() {
            h.extend(this, {
                flipEffect: {
                    setTranslate: Z.setTranslate.bind(this),
                    setTransition: Z.setTransition.bind(this)
                }
            })
        },
        on: {
            beforeInit() {
                if ("flip" !== this.params.effect) return;
                this.classNames.push(`${this.params.containerModifierClass}flip`), this.classNames.push(`${this.params.containerModifierClass}3d`);
                const t = {
                    slidesPerView: 1,
                    slidesPerColumn: 1,
                    slidesPerGroup: 1,
                    watchSlidesProgress: !0,
                    spaceBetween: 0,
                    virtualTranslate: !0
                };
                h.extend(this.params, t), h.extend(this.originalParams, t)
            },
            setTranslate() {
                "flip" === this.params.effect && this.flipEffect.setTranslate()
            },
            setTransition(t) {
                "flip" === this.params.effect && this.flipEffect.setTransition(t)
            }
        }
    }, {
        name: "effect-coverflow",
        params: {
            coverflowEffect: {
                rotate: 50,
                stretch: 0,
                depth: 100,
                modifier: 1,
                slideShadows: !0
            }
        },
        create() {
            h.extend(this, {
                coverflowEffect: {
                    setTranslate: J.setTranslate.bind(this),
                    setTransition: J.setTransition.bind(this)
                }
            })
        },
        on: {
            beforeInit() {
                "coverflow" === this.params.effect && (this.classNames.push(`${this.params.containerModifierClass}coverflow`), this.classNames.push(`${this.params.containerModifierClass}3d`), this.params.watchSlidesProgress = !0, this.originalParams.watchSlidesProgress = !0)
            },
            setTranslate() {
                "coverflow" === this.params.effect && this.coverflowEffect.setTranslate()
            },
            setTransition(t) {
                "coverflow" === this.params.effect && this.coverflowEffect.setTransition(t)
            }
        }
    }, {
        name: "thumbs",
        params: {
            thumbs: {
                swiper: null,
                slideThumbActiveClass: "swiper-slide-thumb-active",
                thumbsContainerClass: "swiper-container-thumbs"
            }
        },
        create() {
            h.extend(this, {
                thumbs: {
                    swiper: null,
                    init: tt.init.bind(this),
                    update: tt.update.bind(this),
                    onThumbClick: tt.onThumbClick.bind(this)
                }
            })
        },
        on: {
            beforeInit() {
                const {
                    thumbs: t
                } = this.params;
                t && t.swiper && (this.thumbs.init(), this.thumbs.update(!0))
            },
            slideChange() {
                this.thumbs.swiper && this.thumbs.update()
            },
            update() {
                this.thumbs.swiper && this.thumbs.update()
            },
            resize() {
                this.thumbs.swiper && this.thumbs.update()
            },
            observerUpdate() {
                this.thumbs.swiper && this.thumbs.update()
            },
            setTransition(t) {
                const e = this.thumbs.swiper;
                e && e.setTransition(t)
            },
            beforeDestroy() {
                const t = this.thumbs.swiper;
                t && this.thumbs.swiperCreated && t && t.destroy()
            }
        }
    }];
    void 0 === D.use && (D.use = D.Class.use, D.installModule = D.Class.installModule), D.use(et);
    e.a = D
  }, function(t, e, i) {
    var n = i(30)("wks"),
        s = i(14),
        o = i(4).Symbol,
        r = "function" == typeof o;
    (t.exports = function(t) {
        return n[t] || (n[t] = r && o[t] || (r ? o : s)("Symbol." + t))
    }).store = n
  }, function(t, e, i) {
    var n = i(4),
        s = i(15),
        o = i(9),
        r = i(10),
        a = i(31),
        l = function(t, e, i) {
            var h, c, d, u, p = t & l.F,
                f = t & l.G,
                m = t & l.S,
                g = t & l.P,
                v = t & l.B,
                y = f ? n : m ? n[e] || (n[e] = {}) : (n[e] || {}).prototype,
                _ = f ? s : s[e] || (s[e] = {}),
                b = _.prototype || (_.prototype = {});
            for (h in f && (i = e), i) d = ((c = !p && y && void 0 !== y[h]) ? y : i)[h], u = v && c ? a(d, n) : g && "function" == typeof d ? a(Function.call, d) : d, y && r(y, h, d, t & l.U), _[h] != d && o(_, h, u), g && b[h] != d && (b[h] = d)
        };
    n.core = s, l.F = 1, l.G = 2, l.S = 4, l.P = 8, l.B = 16, l.W = 32, l.U = 64, l.R = 128, t.exports = l
  }, function(t, e, i) {
    var n;
    /*!
     * jQuery JavaScript Library v3.3.1
     * https://jquery.com/
     *
     * Includes Sizzle.js
     * https://sizzlejs.com/
     *
     * Copyright JS Foundation and other contributors
     * Released under the MIT license
     * https://jquery.org/license
     *
     * Date: 2018-01-20T17:24Z
     */
    /*!
     * jQuery JavaScript Library v3.3.1
     * https://jquery.com/
     *
     * Includes Sizzle.js
     * https://sizzlejs.com/
     *
     * Copyright JS Foundation and other contributors
     * Released under the MIT license
     * https://jquery.org/license
     *
     * Date: 2018-01-20T17:24Z
     */
    ! function(e, i) {
        "use strict";
        "object" == typeof t && "object" == typeof t.exports ? t.exports = e.document ? i(e, !0) : function(t) {
            if (!t.document) throw new Error("jQuery requires a window with a document");
            return i(t)
        } : i(e)
    }("undefined" != typeof window ? window : this, function(i, s) {
        "use strict";
        var o = [],
            r = i.document,
            a = Object.getPrototypeOf,
            l = o.slice,
            h = o.concat,
            c = o.push,
            d = o.indexOf,
            u = {},
            p = u.toString,
            f = u.hasOwnProperty,
            m = f.toString,
            g = m.call(Object),
            v = {},
            y = function(t) {
                return "function" == typeof t && "number" != typeof t.nodeType
            },
            _ = function(t) {
                return null != t && t === t.window
            },
            b = {
                type: !0,
                src: !0,
                noModule: !0
            };
  
        function w(t, e, i) {
            var n, s = (e = e || r).createElement("script");
            if (s.text = t, i)
                for (n in b) i[n] && (s[n] = i[n]);
            e.head.appendChild(s).parentNode.removeChild(s)
        }
  
        function x(t) {
            return null == t ? t + "" : "object" == typeof t || "function" == typeof t ? u[p.call(t)] || "object" : typeof t
        }
        var T = function(t, e) {
                return new T.fn.init(t, e)
            },
            E = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
  
        function C(t) {
            var e = !!t && "length" in t && t.length,
                i = x(t);
            return !y(t) && !_(t) && ("array" === i || 0 === e || "number" == typeof e && e > 0 && e - 1 in t)
        }
        T.fn = T.prototype = {
            jquery: "3.3.1",
            constructor: T,
            length: 0,
            toArray: function() {
                return l.call(this)
            },
            get: function(t) {
                return null == t ? l.call(this) : t < 0 ? this[t + this.length] : this[t]
            },
            pushStack: function(t) {
                var e = T.merge(this.constructor(), t);
                return e.prevObject = this, e
            },
            each: function(t) {
                return T.each(this, t)
            },
            map: function(t) {
                return this.pushStack(T.map(this, function(e, i) {
                    return t.call(e, i, e)
                }))
            },
            slice: function() {
                return this.pushStack(l.apply(this, arguments))
            },
            first: function() {
                return this.eq(0)
            },
            last: function() {
                return this.eq(-1)
            },
            eq: function(t) {
                var e = this.length,
                    i = +t + (t < 0 ? e : 0);
                return this.pushStack(i >= 0 && i < e ? [this[i]] : [])
            },
            end: function() {
                return this.prevObject || this.constructor()
            },
            push: c,
            sort: o.sort,
            splice: o.splice
        }, T.extend = T.fn.extend = function() {
            var t, e, i, n, s, o, r = arguments[0] || {},
                a = 1,
                l = arguments.length,
                h = !1;
            for ("boolean" == typeof r && (h = r, r = arguments[a] || {}, a++), "object" == typeof r || y(r) || (r = {}), a === l && (r = this, a--); a < l; a++)
                if (null != (t = arguments[a]))
                    for (e in t) i = r[e], r !== (n = t[e]) && (h && n && (T.isPlainObject(n) || (s = Array.isArray(n))) ? (s ? (s = !1, o = i && Array.isArray(i) ? i : []) : o = i && T.isPlainObject(i) ? i : {}, r[e] = T.extend(h, o, n)) : void 0 !== n && (r[e] = n));
            return r
        }, T.extend({
            expando: "jQuery" + ("3.3.1" + Math.random()).replace(/\D/g, ""),
            isReady: !0,
            error: function(t) {
                throw new Error(t)
            },
            noop: function() {},
            isPlainObject: function(t) {
                var e, i;
                return !(!t || "[object Object]" !== p.call(t)) && (!(e = a(t)) || "function" == typeof(i = f.call(e, "constructor") && e.constructor) && m.call(i) === g)
            },
            isEmptyObject: function(t) {
                var e;
                for (e in t) return !1;
                return !0
            },
            globalEval: function(t) {
                w(t)
            },
            each: function(t, e) {
                var i, n = 0;
                if (C(t))
                    for (i = t.length; n < i && !1 !== e.call(t[n], n, t[n]); n++);
                else
                    for (n in t)
                        if (!1 === e.call(t[n], n, t[n])) break;
                return t
            },
            trim: function(t) {
                return null == t ? "" : (t + "").replace(E, "")
            },
            makeArray: function(t, e) {
                var i = e || [];
                return null != t && (C(Object(t)) ? T.merge(i, "string" == typeof t ? [t] : t) : c.call(i, t)), i
            },
            inArray: function(t, e, i) {
                return null == e ? -1 : d.call(e, t, i)
            },
            merge: function(t, e) {
                for (var i = +e.length, n = 0, s = t.length; n < i; n++) t[s++] = e[n];
                return t.length = s, t
            },
            grep: function(t, e, i) {
                for (var n = [], s = 0, o = t.length, r = !i; s < o; s++) !e(t[s], s) !== r && n.push(t[s]);
                return n
            },
            map: function(t, e, i) {
                var n, s, o = 0,
                    r = [];
                if (C(t))
                    for (n = t.length; o < n; o++) null != (s = e(t[o], o, i)) && r.push(s);
                else
                    for (o in t) null != (s = e(t[o], o, i)) && r.push(s);
                return h.apply([], r)
            },
            guid: 1,
            support: v
        }), "function" == typeof Symbol && (T.fn[Symbol.iterator] = o[Symbol.iterator]), T.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(t, e) {
            u["[object " + e + "]"] = e.toLowerCase()
        });
        var S =
            /*!
             * Sizzle CSS Selector Engine v2.3.3
             * https://sizzlejs.com/
             *
             * Copyright jQuery Foundation and other contributors
             * Released under the MIT license
             * http://jquery.org/license
             *
             * Date: 2016-08-08
             */
            function(t) {
                var e, i, n, s, o, r, a, l, h, c, d, u, p, f, m, g, v, y, _, b = "sizzle" + 1 * new Date,
                    w = t.document,
                    x = 0,
                    T = 0,
                    E = rt(),
                    C = rt(),
                    S = rt(),
                    D = function(t, e) {
                        return t === e && (d = !0), 0
                    },
                    I = {}.hasOwnProperty,
                    M = [],
                    O = M.pop,
                    k = M.push,
                    A = M.push,
                    P = M.slice,
                    $ = function(t, e) {
                        for (var i = 0, n = t.length; i < n; i++)
                            if (t[i] === e) return i;
                        return -1
                    },
                    L = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
                    N = "[\\x20\\t\\r\\n\\f]",
                    z = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",
                    F = "\\[" + N + "*(" + z + ")(?:" + N + "*([*^$|!~]?=)" + N + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + z + "))|)" + N + "*\\]",
                    H = ":(" + z + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + F + ")*)|.*)\\)|)",
                    R = new RegExp(N + "+", "g"),
                    j = new RegExp("^" + N + "+|((?:^|[^\\\\])(?:\\\\.)*)" + N + "+$", "g"),
                    W = new RegExp("^" + N + "*," + N + "*"),
                    B = new RegExp("^" + N + "*([>+~]|" + N + ")" + N + "*"),
                    V = new RegExp("=" + N + "*([^\\]'\"]*?)" + N + "*\\]", "g"),
                    q = new RegExp(H),
                    G = new RegExp("^" + z + "$"),
                    U = {
                        ID: new RegExp("^#(" + z + ")"),
                        CLASS: new RegExp("^\\.(" + z + ")"),
                        TAG: new RegExp("^(" + z + "|[*])"),
                        ATTR: new RegExp("^" + F),
                        PSEUDO: new RegExp("^" + H),
                        CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + N + "*(even|odd|(([+-]|)(\\d*)n|)" + N + "*(?:([+-]|)" + N + "*(\\d+)|))" + N + "*\\)|)", "i"),
                        bool: new RegExp("^(?:" + L + ")$", "i"),
                        needsContext: new RegExp("^" + N + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + N + "*((?:-\\d)?\\d*)" + N + "*\\)|)(?=[^-]|$)", "i")
                    },
                    Y = /^(?:input|select|textarea|button)$/i,
                    X = /^h\d$/i,
                    K = /^[^{]+\{\s*\[native \w/,
                    Q = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
                    Z = /[+~]/,
                    J = new RegExp("\\\\([\\da-f]{1,6}" + N + "?|(" + N + ")|.)", "ig"),
                    tt = function(t, e, i) {
                        var n = "0x" + e - 65536;
                        return n != n || i ? e : n < 0 ? String.fromCharCode(n + 65536) : String.fromCharCode(n >> 10 | 55296, 1023 & n | 56320)
                    },
                    et = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
                    it = function(t, e) {
                        return e ? "\0" === t ? "�" : t.slice(0, -1) + "\\" + t.charCodeAt(t.length - 1).toString(16) + " " : "\\" + t
                    },
                    nt = function() {
                        u()
                    },
                    st = yt(function(t) {
                        return !0 === t.disabled && ("form" in t || "label" in t)
                    }, {
                        dir: "parentNode",
                        next: "legend"
                    });
                try {
                    A.apply(M = P.call(w.childNodes), w.childNodes), M[w.childNodes.length].nodeType
                } catch (t) {
                    A = {
                        apply: M.length ? function(t, e) {
                            k.apply(t, P.call(e))
                        } : function(t, e) {
                            for (var i = t.length, n = 0; t[i++] = e[n++];);
                            t.length = i - 1
                        }
                    }
                }
  
                function ot(t, e, n, s) {
                    var o, a, h, c, d, f, v, y = e && e.ownerDocument,
                        x = e ? e.nodeType : 9;
                    if (n = n || [], "string" != typeof t || !t || 1 !== x && 9 !== x && 11 !== x) return n;
                    if (!s && ((e ? e.ownerDocument || e : w) !== p && u(e), e = e || p, m)) {
                        if (11 !== x && (d = Q.exec(t)))
                            if (o = d[1]) {
                                if (9 === x) {
                                    if (!(h = e.getElementById(o))) return n;
                                    if (h.id === o) return n.push(h), n
                                } else if (y && (h = y.getElementById(o)) && _(e, h) && h.id === o) return n.push(h), n
                            } else {
                                if (d[2]) return A.apply(n, e.getElementsByTagName(t)), n;
                                if ((o = d[3]) && i.getElementsByClassName && e.getElementsByClassName) return A.apply(n, e.getElementsByClassName(o)), n
                            } if (i.qsa && !S[t + " "] && (!g || !g.test(t))) {
                            if (1 !== x) y = e, v = t;
                            else if ("object" !== e.nodeName.toLowerCase()) {
                                for ((c = e.getAttribute("id")) ? c = c.replace(et, it) : e.setAttribute("id", c = b), a = (f = r(t)).length; a--;) f[a] = "#" + c + " " + vt(f[a]);
                                v = f.join(","), y = Z.test(t) && mt(e.parentNode) || e
                            }
                            if (v) try {
                                return A.apply(n, y.querySelectorAll(v)), n
                            } catch (t) {} finally {
                                c === b && e.removeAttribute("id")
                            }
                        }
                    }
                    return l(t.replace(j, "$1"), e, n, s)
                }
  
                function rt() {
                    var t = [];
                    return function e(i, s) {
                        return t.push(i + " ") > n.cacheLength && delete e[t.shift()], e[i + " "] = s
                    }
                }
  
                function at(t) {
                    return t[b] = !0, t
                }
  
                function lt(t) {
                    var e = p.createElement("fieldset");
                    try {
                        return !!t(e)
                    } catch (t) {
                        return !1
                    } finally {
                        e.parentNode && e.parentNode.removeChild(e), e = null
                    }
                }
  
                function ht(t, e) {
                    for (var i = t.split("|"), s = i.length; s--;) n.attrHandle[i[s]] = e
                }
  
                function ct(t, e) {
                    var i = e && t,
                        n = i && 1 === t.nodeType && 1 === e.nodeType && t.sourceIndex - e.sourceIndex;
                    if (n) return n;
                    if (i)
                        for (; i = i.nextSibling;)
                            if (i === e) return -1;
                    return t ? 1 : -1
                }
  
                function dt(t) {
                    return function(e) {
                        return "input" === e.nodeName.toLowerCase() && e.type === t
                    }
                }
  
                function ut(t) {
                    return function(e) {
                        var i = e.nodeName.toLowerCase();
                        return ("input" === i || "button" === i) && e.type === t
                    }
                }
  
                function pt(t) {
                    return function(e) {
                        return "form" in e ? e.parentNode && !1 === e.disabled ? "label" in e ? "label" in e.parentNode ? e.parentNode.disabled === t : e.disabled === t : e.isDisabled === t || e.isDisabled !== !t && st(e) === t : e.disabled === t : "label" in e && e.disabled === t
                    }
                }
  
                function ft(t) {
                    return at(function(e) {
                        return e = +e, at(function(i, n) {
                            for (var s, o = t([], i.length, e), r = o.length; r--;) i[s = o[r]] && (i[s] = !(n[s] = i[s]))
                        })
                    })
                }
  
                function mt(t) {
                    return t && void 0 !== t.getElementsByTagName && t
                }
                for (e in i = ot.support = {}, o = ot.isXML = function(t) {
                        var e = t && (t.ownerDocument || t).documentElement;
                        return !!e && "HTML" !== e.nodeName
                    }, u = ot.setDocument = function(t) {
                        var e, s, r = t ? t.ownerDocument || t : w;
                        return r !== p && 9 === r.nodeType && r.documentElement ? (f = (p = r).documentElement, m = !o(p), w !== p && (s = p.defaultView) && s.top !== s && (s.addEventListener ? s.addEventListener("unload", nt, !1) : s.attachEvent && s.attachEvent("onunload", nt)), i.attributes = lt(function(t) {
                            return t.className = "i", !t.getAttribute("className")
                        }), i.getElementsByTagName = lt(function(t) {
                            return t.appendChild(p.createComment("")), !t.getElementsByTagName("*").length
                        }), i.getElementsByClassName = K.test(p.getElementsByClassName), i.getById = lt(function(t) {
                            return f.appendChild(t).id = b, !p.getElementsByName || !p.getElementsByName(b).length
                        }), i.getById ? (n.filter.ID = function(t) {
                            var e = t.replace(J, tt);
                            return function(t) {
                                return t.getAttribute("id") === e
                            }
                        }, n.find.ID = function(t, e) {
                            if (void 0 !== e.getElementById && m) {
                                var i = e.getElementById(t);
                                return i ? [i] : []
                            }
                        }) : (n.filter.ID = function(t) {
                            var e = t.replace(J, tt);
                            return function(t) {
                                var i = void 0 !== t.getAttributeNode && t.getAttributeNode("id");
                                return i && i.value === e
                            }
                        }, n.find.ID = function(t, e) {
                            if (void 0 !== e.getElementById && m) {
                                var i, n, s, o = e.getElementById(t);
                                if (o) {
                                    if ((i = o.getAttributeNode("id")) && i.value === t) return [o];
                                    for (s = e.getElementsByName(t), n = 0; o = s[n++];)
                                        if ((i = o.getAttributeNode("id")) && i.value === t) return [o]
                                }
                                return []
                            }
                        }), n.find.TAG = i.getElementsByTagName ? function(t, e) {
                            return void 0 !== e.getElementsByTagName ? e.getElementsByTagName(t) : i.qsa ? e.querySelectorAll(t) : void 0
                        } : function(t, e) {
                            var i, n = [],
                                s = 0,
                                o = e.getElementsByTagName(t);
                            if ("*" === t) {
                                for (; i = o[s++];) 1 === i.nodeType && n.push(i);
                                return n
                            }
                            return o
                        }, n.find.CLASS = i.getElementsByClassName && function(t, e) {
                            if (void 0 !== e.getElementsByClassName && m) return e.getElementsByClassName(t)
                        }, v = [], g = [], (i.qsa = K.test(p.querySelectorAll)) && (lt(function(t) {
                            f.appendChild(t).innerHTML = "<a id='" + b + "'></a><select id='" + b + "-\r\\' msallowcapture=''><option selected=''></option></select>", t.querySelectorAll("[msallowcapture^='']").length && g.push("[*^$]=" + N + "*(?:''|\"\")"), t.querySelectorAll("[selected]").length || g.push("\\[" + N + "*(?:value|" + L + ")"), t.querySelectorAll("[id~=" + b + "-]").length || g.push("~="), t.querySelectorAll(":checked").length || g.push(":checked"), t.querySelectorAll("a#" + b + "+*").length || g.push(".#.+[+~]")
                        }), lt(function(t) {
                            t.innerHTML = "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                            var e = p.createElement("input");
                            e.setAttribute("type", "hidden"), t.appendChild(e).setAttribute("name", "D"), t.querySelectorAll("[name=d]").length && g.push("name" + N + "*[*^$|!~]?="), 2 !== t.querySelectorAll(":enabled").length && g.push(":enabled", ":disabled"), f.appendChild(t).disabled = !0, 2 !== t.querySelectorAll(":disabled").length && g.push(":enabled", ":disabled"), t.querySelectorAll("*,:x"), g.push(",.*:")
                        })), (i.matchesSelector = K.test(y = f.matches || f.webkitMatchesSelector || f.mozMatchesSelector || f.oMatchesSelector || f.msMatchesSelector)) && lt(function(t) {
                            i.disconnectedMatch = y.call(t, "*"), y.call(t, "[s!='']:x"), v.push("!=", H)
                        }), g = g.length && new RegExp(g.join("|")), v = v.length && new RegExp(v.join("|")), e = K.test(f.compareDocumentPosition), _ = e || K.test(f.contains) ? function(t, e) {
                            var i = 9 === t.nodeType ? t.documentElement : t,
                                n = e && e.parentNode;
                            return t === n || !(!n || 1 !== n.nodeType || !(i.contains ? i.contains(n) : t.compareDocumentPosition && 16 & t.compareDocumentPosition(n)))
                        } : function(t, e) {
                            if (e)
                                for (; e = e.parentNode;)
                                    if (e === t) return !0;
                            return !1
                        }, D = e ? function(t, e) {
                            if (t === e) return d = !0, 0;
                            var n = !t.compareDocumentPosition - !e.compareDocumentPosition;
                            return n || (1 & (n = (t.ownerDocument || t) === (e.ownerDocument || e) ? t.compareDocumentPosition(e) : 1) || !i.sortDetached && e.compareDocumentPosition(t) === n ? t === p || t.ownerDocument === w && _(w, t) ? -1 : e === p || e.ownerDocument === w && _(w, e) ? 1 : c ? $(c, t) - $(c, e) : 0 : 4 & n ? -1 : 1)
                        } : function(t, e) {
                            if (t === e) return d = !0, 0;
                            var i, n = 0,
                                s = t.parentNode,
                                o = e.parentNode,
                                r = [t],
                                a = [e];
                            if (!s || !o) return t === p ? -1 : e === p ? 1 : s ? -1 : o ? 1 : c ? $(c, t) - $(c, e) : 0;
                            if (s === o) return ct(t, e);
                            for (i = t; i = i.parentNode;) r.unshift(i);
                            for (i = e; i = i.parentNode;) a.unshift(i);
                            for (; r[n] === a[n];) n++;
                            return n ? ct(r[n], a[n]) : r[n] === w ? -1 : a[n] === w ? 1 : 0
                        }, p) : p
                    }, ot.matches = function(t, e) {
                        return ot(t, null, null, e)
                    }, ot.matchesSelector = function(t, e) {
                        if ((t.ownerDocument || t) !== p && u(t), e = e.replace(V, "='$1']"), i.matchesSelector && m && !S[e + " "] && (!v || !v.test(e)) && (!g || !g.test(e))) try {
                            var n = y.call(t, e);
                            if (n || i.disconnectedMatch || t.document && 11 !== t.document.nodeType) return n
                        } catch (t) {}
                        return ot(e, p, null, [t]).length > 0
                    }, ot.contains = function(t, e) {
                        return (t.ownerDocument || t) !== p && u(t), _(t, e)
                    }, ot.attr = function(t, e) {
                        (t.ownerDocument || t) !== p && u(t);
                        var s = n.attrHandle[e.toLowerCase()],
                            o = s && I.call(n.attrHandle, e.toLowerCase()) ? s(t, e, !m) : void 0;
                        return void 0 !== o ? o : i.attributes || !m ? t.getAttribute(e) : (o = t.getAttributeNode(e)) && o.specified ? o.value : null
                    }, ot.escape = function(t) {
                        return (t + "").replace(et, it)
                    }, ot.error = function(t) {
                        throw new Error("Syntax error, unrecognized expression: " + t)
                    }, ot.uniqueSort = function(t) {
                        var e, n = [],
                            s = 0,
                            o = 0;
                        if (d = !i.detectDuplicates, c = !i.sortStable && t.slice(0), t.sort(D), d) {
                            for (; e = t[o++];) e === t[o] && (s = n.push(o));
                            for (; s--;) t.splice(n[s], 1)
                        }
                        return c = null, t
                    }, s = ot.getText = function(t) {
                        var e, i = "",
                            n = 0,
                            o = t.nodeType;
                        if (o) {
                            if (1 === o || 9 === o || 11 === o) {
                                if ("string" == typeof t.textContent) return t.textContent;
                                for (t = t.firstChild; t; t = t.nextSibling) i += s(t)
                            } else if (3 === o || 4 === o) return t.nodeValue
                        } else
                            for (; e = t[n++];) i += s(e);
                        return i
                    }, (n = ot.selectors = {
                        cacheLength: 50,
                        createPseudo: at,
                        match: U,
                        attrHandle: {},
                        find: {},
                        relative: {
                            ">": {
                                dir: "parentNode",
                                first: !0
                            },
                            " ": {
                                dir: "parentNode"
                            },
                            "+": {
                                dir: "previousSibling",
                                first: !0
                            },
                            "~": {
                                dir: "previousSibling"
                            }
                        },
                        preFilter: {
                            ATTR: function(t) {
                                return t[1] = t[1].replace(J, tt), t[3] = (t[3] || t[4] || t[5] || "").replace(J, tt), "~=" === t[2] && (t[3] = " " + t[3] + " "), t.slice(0, 4)
                            },
                            CHILD: function(t) {
                                return t[1] = t[1].toLowerCase(), "nth" === t[1].slice(0, 3) ? (t[3] || ot.error(t[0]), t[4] = +(t[4] ? t[5] + (t[6] || 1) : 2 * ("even" === t[3] || "odd" === t[3])), t[5] = +(t[7] + t[8] || "odd" === t[3])) : t[3] && ot.error(t[0]), t
                            },
                            PSEUDO: function(t) {
                                var e, i = !t[6] && t[2];
                                return U.CHILD.test(t[0]) ? null : (t[3] ? t[2] = t[4] || t[5] || "" : i && q.test(i) && (e = r(i, !0)) && (e = i.indexOf(")", i.length - e) - i.length) && (t[0] = t[0].slice(0, e), t[2] = i.slice(0, e)), t.slice(0, 3))
                            }
                        },
                        filter: {
                            TAG: function(t) {
                                var e = t.replace(J, tt).toLowerCase();
                                return "*" === t ? function() {
                                    return !0
                                } : function(t) {
                                    return t.nodeName && t.nodeName.toLowerCase() === e
                                }
                            },
                            CLASS: function(t) {
                                var e = E[t + " "];
                                return e || (e = new RegExp("(^|" + N + ")" + t + "(" + N + "|$)")) && E(t, function(t) {
                                    return e.test("string" == typeof t.className && t.className || void 0 !== t.getAttribute && t.getAttribute("class") || "")
                                })
                            },
                            ATTR: function(t, e, i) {
                                return function(n) {
                                    var s = ot.attr(n, t);
                                    return null == s ? "!=" === e : !e || (s += "", "=" === e ? s === i : "!=" === e ? s !== i : "^=" === e ? i && 0 === s.indexOf(i) : "*=" === e ? i && s.indexOf(i) > -1 : "$=" === e ? i && s.slice(-i.length) === i : "~=" === e ? (" " + s.replace(R, " ") + " ").indexOf(i) > -1 : "|=" === e && (s === i || s.slice(0, i.length + 1) === i + "-"))
                                }
                            },
                            CHILD: function(t, e, i, n, s) {
                                var o = "nth" !== t.slice(0, 3),
                                    r = "last" !== t.slice(-4),
                                    a = "of-type" === e;
                                return 1 === n && 0 === s ? function(t) {
                                    return !!t.parentNode
                                } : function(e, i, l) {
                                    var h, c, d, u, p, f, m = o !== r ? "nextSibling" : "previousSibling",
                                        g = e.parentNode,
                                        v = a && e.nodeName.toLowerCase(),
                                        y = !l && !a,
                                        _ = !1;
                                    if (g) {
                                        if (o) {
                                            for (; m;) {
                                                for (u = e; u = u[m];)
                                                    if (a ? u.nodeName.toLowerCase() === v : 1 === u.nodeType) return !1;
                                                f = m = "only" === t && !f && "nextSibling"
                                            }
                                            return !0
                                        }
                                        if (f = [r ? g.firstChild : g.lastChild], r && y) {
                                            for (_ = (p = (h = (c = (d = (u = g)[b] || (u[b] = {}))[u.uniqueID] || (d[u.uniqueID] = {}))[t] || [])[0] === x && h[1]) && h[2], u = p && g.childNodes[p]; u = ++p && u && u[m] || (_ = p = 0) || f.pop();)
                                                if (1 === u.nodeType && ++_ && u === e) {
                                                    c[t] = [x, p, _];
                                                    break
                                                }
                                        } else if (y && (_ = p = (h = (c = (d = (u = e)[b] || (u[b] = {}))[u.uniqueID] || (d[u.uniqueID] = {}))[t] || [])[0] === x && h[1]), !1 === _)
                                            for (;
                                                (u = ++p && u && u[m] || (_ = p = 0) || f.pop()) && ((a ? u.nodeName.toLowerCase() !== v : 1 !== u.nodeType) || !++_ || (y && ((c = (d = u[b] || (u[b] = {}))[u.uniqueID] || (d[u.uniqueID] = {}))[t] = [x, _]), u !== e)););
                                        return (_ -= s) === n || _ % n == 0 && _ / n >= 0
                                    }
                                }
                            },
                            PSEUDO: function(t, e) {
                                var i, s = n.pseudos[t] || n.setFilters[t.toLowerCase()] || ot.error("unsupported pseudo: " + t);
                                return s[b] ? s(e) : s.length > 1 ? (i = [t, t, "", e], n.setFilters.hasOwnProperty(t.toLowerCase()) ? at(function(t, i) {
                                    for (var n, o = s(t, e), r = o.length; r--;) t[n = $(t, o[r])] = !(i[n] = o[r])
                                }) : function(t) {
                                    return s(t, 0, i)
                                }) : s
                            }
                        },
                        pseudos: {
                            not: at(function(t) {
                                var e = [],
                                    i = [],
                                    n = a(t.replace(j, "$1"));
                                return n[b] ? at(function(t, e, i, s) {
                                    for (var o, r = n(t, null, s, []), a = t.length; a--;)(o = r[a]) && (t[a] = !(e[a] = o))
                                }) : function(t, s, o) {
                                    return e[0] = t, n(e, null, o, i), e[0] = null, !i.pop()
                                }
                            }),
                            has: at(function(t) {
                                return function(e) {
                                    return ot(t, e).length > 0
                                }
                            }),
                            contains: at(function(t) {
                                return t = t.replace(J, tt),
                                    function(e) {
                                        return (e.textContent || e.innerText || s(e)).indexOf(t) > -1
                                    }
                            }),
                            lang: at(function(t) {
                                return G.test(t || "") || ot.error("unsupported lang: " + t), t = t.replace(J, tt).toLowerCase(),
                                    function(e) {
                                        var i;
                                        do {
                                            if (i = m ? e.lang : e.getAttribute("xml:lang") || e.getAttribute("lang")) return (i = i.toLowerCase()) === t || 0 === i.indexOf(t + "-")
                                        } while ((e = e.parentNode) && 1 === e.nodeType);
                                        return !1
                                    }
                            }),
                            target: function(e) {
                                var i = t.location && t.location.hash;
                                return i && i.slice(1) === e.id
                            },
                            root: function(t) {
                                return t === f
                            },
                            focus: function(t) {
                                return t === p.activeElement && (!p.hasFocus || p.hasFocus()) && !!(t.type || t.href || ~t.tabIndex)
                            },
                            enabled: pt(!1),
                            disabled: pt(!0),
                            checked: function(t) {
                                var e = t.nodeName.toLowerCase();
                                return "input" === e && !!t.checked || "option" === e && !!t.selected
                            },
                            selected: function(t) {
                                return t.parentNode && t.parentNode.selectedIndex, !0 === t.selected
                            },
                            empty: function(t) {
                                for (t = t.firstChild; t; t = t.nextSibling)
                                    if (t.nodeType < 6) return !1;
                                return !0
                            },
                            parent: function(t) {
                                return !n.pseudos.empty(t)
                            },
                            header: function(t) {
                                return X.test(t.nodeName)
                            },
                            input: function(t) {
                                return Y.test(t.nodeName)
                            },
                            button: function(t) {
                                var e = t.nodeName.toLowerCase();
                                return "input" === e && "button" === t.type || "button" === e
                            },
                            text: function(t) {
                                var e;
                                return "input" === t.nodeName.toLowerCase() && "text" === t.type && (null == (e = t.getAttribute("type")) || "text" === e.toLowerCase())
                            },
                            first: ft(function() {
                                return [0]
                            }),
                            last: ft(function(t, e) {
                                return [e - 1]
                            }),
                            eq: ft(function(t, e, i) {
                                return [i < 0 ? i + e : i]
                            }),
                            even: ft(function(t, e) {
                                for (var i = 0; i < e; i += 2) t.push(i);
                                return t
                            }),
                            odd: ft(function(t, e) {
                                for (var i = 1; i < e; i += 2) t.push(i);
                                return t
                            }),
                            lt: ft(function(t, e, i) {
                                for (var n = i < 0 ? i + e : i; --n >= 0;) t.push(n);
                                return t
                            }),
                            gt: ft(function(t, e, i) {
                                for (var n = i < 0 ? i + e : i; ++n < e;) t.push(n);
                                return t
                            })
                        }
                    }).pseudos.nth = n.pseudos.eq, {
                        radio: !0,
                        checkbox: !0,
                        file: !0,
                        password: !0,
                        image: !0
                    }) n.pseudos[e] = dt(e);
                for (e in {
                        submit: !0,
                        reset: !0
                    }) n.pseudos[e] = ut(e);
  
                function gt() {}
  
                function vt(t) {
                    for (var e = 0, i = t.length, n = ""; e < i; e++) n += t[e].value;
                    return n
                }
  
                function yt(t, e, i) {
                    var n = e.dir,
                        s = e.next,
                        o = s || n,
                        r = i && "parentNode" === o,
                        a = T++;
                    return e.first ? function(e, i, s) {
                        for (; e = e[n];)
                            if (1 === e.nodeType || r) return t(e, i, s);
                        return !1
                    } : function(e, i, l) {
                        var h, c, d, u = [x, a];
                        if (l) {
                            for (; e = e[n];)
                                if ((1 === e.nodeType || r) && t(e, i, l)) return !0
                        } else
                            for (; e = e[n];)
                                if (1 === e.nodeType || r)
                                    if (c = (d = e[b] || (e[b] = {}))[e.uniqueID] || (d[e.uniqueID] = {}), s && s === e.nodeName.toLowerCase()) e = e[n] || e;
                                    else {
                                        if ((h = c[o]) && h[0] === x && h[1] === a) return u[2] = h[2];
                                        if (c[o] = u, u[2] = t(e, i, l)) return !0
                                    } return !1
                    }
                }
  
                function _t(t) {
                    return t.length > 1 ? function(e, i, n) {
                        for (var s = t.length; s--;)
                            if (!t[s](e, i, n)) return !1;
                        return !0
                    } : t[0]
                }
  
                function bt(t, e, i, n, s) {
                    for (var o, r = [], a = 0, l = t.length, h = null != e; a < l; a++)(o = t[a]) && (i && !i(o, n, s) || (r.push(o), h && e.push(a)));
                    return r
                }
  
                function wt(t, e, i, n, s, o) {
                    return n && !n[b] && (n = wt(n)), s && !s[b] && (s = wt(s, o)), at(function(o, r, a, l) {
                        var h, c, d, u = [],
                            p = [],
                            f = r.length,
                            m = o || function(t, e, i) {
                                for (var n = 0, s = e.length; n < s; n++) ot(t, e[n], i);
                                return i
                            }(e || "*", a.nodeType ? [a] : a, []),
                            g = !t || !o && e ? m : bt(m, u, t, a, l),
                            v = i ? s || (o ? t : f || n) ? [] : r : g;
                        if (i && i(g, v, a, l), n)
                            for (h = bt(v, p), n(h, [], a, l), c = h.length; c--;)(d = h[c]) && (v[p[c]] = !(g[p[c]] = d));
                        if (o) {
                            if (s || t) {
                                if (s) {
                                    for (h = [], c = v.length; c--;)(d = v[c]) && h.push(g[c] = d);
                                    s(null, v = [], h, l)
                                }
                                for (c = v.length; c--;)(d = v[c]) && (h = s ? $(o, d) : u[c]) > -1 && (o[h] = !(r[h] = d))
                            }
                        } else v = bt(v === r ? v.splice(f, v.length) : v), s ? s(null, r, v, l) : A.apply(r, v)
                    })
                }
  
                function xt(t) {
                    for (var e, i, s, o = t.length, r = n.relative[t[0].type], a = r || n.relative[" "], l = r ? 1 : 0, c = yt(function(t) {
                            return t === e
                        }, a, !0), d = yt(function(t) {
                            return $(e, t) > -1
                        }, a, !0), u = [function(t, i, n) {
                            var s = !r && (n || i !== h) || ((e = i).nodeType ? c(t, i, n) : d(t, i, n));
                            return e = null, s
                        }]; l < o; l++)
                        if (i = n.relative[t[l].type]) u = [yt(_t(u), i)];
                        else {
                            if ((i = n.filter[t[l].type].apply(null, t[l].matches))[b]) {
                                for (s = ++l; s < o && !n.relative[t[s].type]; s++);
                                return wt(l > 1 && _t(u), l > 1 && vt(t.slice(0, l - 1).concat({
                                    value: " " === t[l - 2].type ? "*" : ""
                                })).replace(j, "$1"), i, l < s && xt(t.slice(l, s)), s < o && xt(t = t.slice(s)), s < o && vt(t))
                            }
                            u.push(i)
                        } return _t(u)
                }
                return gt.prototype = n.filters = n.pseudos, n.setFilters = new gt, r = ot.tokenize = function(t, e) {
                    var i, s, o, r, a, l, h, c = C[t + " "];
                    if (c) return e ? 0 : c.slice(0);
                    for (a = t, l = [], h = n.preFilter; a;) {
                        for (r in i && !(s = W.exec(a)) || (s && (a = a.slice(s[0].length) || a), l.push(o = [])), i = !1, (s = B.exec(a)) && (i = s.shift(), o.push({
                                value: i,
                                type: s[0].replace(j, " ")
                            }), a = a.slice(i.length)), n.filter) !(s = U[r].exec(a)) || h[r] && !(s = h[r](s)) || (i = s.shift(), o.push({
                            value: i,
                            type: r,
                            matches: s
                        }), a = a.slice(i.length));
                        if (!i) break
                    }
                    return e ? a.length : a ? ot.error(t) : C(t, l).slice(0)
                }, a = ot.compile = function(t, e) {
                    var i, s = [],
                        o = [],
                        a = S[t + " "];
                    if (!a) {
                        for (e || (e = r(t)), i = e.length; i--;)(a = xt(e[i]))[b] ? s.push(a) : o.push(a);
                        (a = S(t, function(t, e) {
                            var i = e.length > 0,
                                s = t.length > 0,
                                o = function(o, r, a, l, c) {
                                    var d, f, g, v = 0,
                                        y = "0",
                                        _ = o && [],
                                        b = [],
                                        w = h,
                                        T = o || s && n.find.TAG("*", c),
                                        E = x += null == w ? 1 : Math.random() || .1,
                                        C = T.length;
                                    for (c && (h = r === p || r || c); y !== C && null != (d = T[y]); y++) {
                                        if (s && d) {
                                            for (f = 0, r || d.ownerDocument === p || (u(d), a = !m); g = t[f++];)
                                                if (g(d, r || p, a)) {
                                                    l.push(d);
                                                    break
                                                } c && (x = E)
                                        }
                                        i && ((d = !g && d) && v--, o && _.push(d))
                                    }
                                    if (v += y, i && y !== v) {
                                        for (f = 0; g = e[f++];) g(_, b, r, a);
                                        if (o) {
                                            if (v > 0)
                                                for (; y--;) _[y] || b[y] || (b[y] = O.call(l));
                                            b = bt(b)
                                        }
                                        A.apply(l, b), c && !o && b.length > 0 && v + e.length > 1 && ot.uniqueSort(l)
                                    }
                                    return c && (x = E, h = w), _
                                };
                            return i ? at(o) : o
                        }(o, s))).selector = t
                    }
                    return a
                }, l = ot.select = function(t, e, i, s) {
                    var o, l, h, c, d, u = "function" == typeof t && t,
                        p = !s && r(t = u.selector || t);
                    if (i = i || [], 1 === p.length) {
                        if ((l = p[0] = p[0].slice(0)).length > 2 && "ID" === (h = l[0]).type && 9 === e.nodeType && m && n.relative[l[1].type]) {
                            if (!(e = (n.find.ID(h.matches[0].replace(J, tt), e) || [])[0])) return i;
                            u && (e = e.parentNode), t = t.slice(l.shift().value.length)
                        }
                        for (o = U.needsContext.test(t) ? 0 : l.length; o-- && (h = l[o], !n.relative[c = h.type]);)
                            if ((d = n.find[c]) && (s = d(h.matches[0].replace(J, tt), Z.test(l[0].type) && mt(e.parentNode) || e))) {
                                if (l.splice(o, 1), !(t = s.length && vt(l))) return A.apply(i, s), i;
                                break
                            }
                    }
                    return (u || a(t, p))(s, e, !m, i, !e || Z.test(t) && mt(e.parentNode) || e), i
                }, i.sortStable = b.split("").sort(D).join("") === b, i.detectDuplicates = !!d, u(), i.sortDetached = lt(function(t) {
                    return 1 & t.compareDocumentPosition(p.createElement("fieldset"))
                }), lt(function(t) {
                    return t.innerHTML = "<a href='#'></a>", "#" === t.firstChild.getAttribute("href")
                }) || ht("type|href|height|width", function(t, e, i) {
                    if (!i) return t.getAttribute(e, "type" === e.toLowerCase() ? 1 : 2)
                }), i.attributes && lt(function(t) {
                    return t.innerHTML = "<input/>", t.firstChild.setAttribute("value", ""), "" === t.firstChild.getAttribute("value")
                }) || ht("value", function(t, e, i) {
                    if (!i && "input" === t.nodeName.toLowerCase()) return t.defaultValue
                }), lt(function(t) {
                    return null == t.getAttribute("disabled")
                }) || ht(L, function(t, e, i) {
                    var n;
                    if (!i) return !0 === t[e] ? e.toLowerCase() : (n = t.getAttributeNode(e)) && n.specified ? n.value : null
                }), ot
            }(i);
        T.find = S, T.expr = S.selectors, T.expr[":"] = T.expr.pseudos, T.uniqueSort = T.unique = S.uniqueSort, T.text = S.getText, T.isXMLDoc = S.isXML, T.contains = S.contains, T.escapeSelector = S.escape;
        var D = function(t, e, i) {
                for (var n = [], s = void 0 !== i;
                    (t = t[e]) && 9 !== t.nodeType;)
                    if (1 === t.nodeType) {
                        if (s && T(t).is(i)) break;
                        n.push(t)
                    } return n
            },
            I = function(t, e) {
                for (var i = []; t; t = t.nextSibling) 1 === t.nodeType && t !== e && i.push(t);
                return i
            },
            M = T.expr.match.needsContext;
  
        function O(t, e) {
            return t.nodeName && t.nodeName.toLowerCase() === e.toLowerCase()
        }
        var k = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
  
        function A(t, e, i) {
            return y(e) ? T.grep(t, function(t, n) {
                return !!e.call(t, n, t) !== i
            }) : e.nodeType ? T.grep(t, function(t) {
                return t === e !== i
            }) : "string" != typeof e ? T.grep(t, function(t) {
                return d.call(e, t) > -1 !== i
            }) : T.filter(e, t, i)
        }
        T.filter = function(t, e, i) {
            var n = e[0];
            return i && (t = ":not(" + t + ")"), 1 === e.length && 1 === n.nodeType ? T.find.matchesSelector(n, t) ? [n] : [] : T.find.matches(t, T.grep(e, function(t) {
                return 1 === t.nodeType
            }))
        }, T.fn.extend({
            find: function(t) {
                var e, i, n = this.length,
                    s = this;
                if ("string" != typeof t) return this.pushStack(T(t).filter(function() {
                    for (e = 0; e < n; e++)
                        if (T.contains(s[e], this)) return !0
                }));
                for (i = this.pushStack([]), e = 0; e < n; e++) T.find(t, s[e], i);
                return n > 1 ? T.uniqueSort(i) : i
            },
            filter: function(t) {
                return this.pushStack(A(this, t || [], !1))
            },
            not: function(t) {
                return this.pushStack(A(this, t || [], !0))
            },
            is: function(t) {
                return !!A(this, "string" == typeof t && M.test(t) ? T(t) : t || [], !1).length
            }
        });
        var P, $ = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
        (T.fn.init = function(t, e, i) {
            var n, s;
            if (!t) return this;
            if (i = i || P, "string" == typeof t) {
                if (!(n = "<" === t[0] && ">" === t[t.length - 1] && t.length >= 3 ? [null, t, null] : $.exec(t)) || !n[1] && e) return !e || e.jquery ? (e || i).find(t) : this.constructor(e).find(t);
                if (n[1]) {
                    if (e = e instanceof T ? e[0] : e, T.merge(this, T.parseHTML(n[1], e && e.nodeType ? e.ownerDocument || e : r, !0)), k.test(n[1]) && T.isPlainObject(e))
                        for (n in e) y(this[n]) ? this[n](e[n]) : this.attr(n, e[n]);
                    return this
                }
                return (s = r.getElementById(n[2])) && (this[0] = s, this.length = 1), this
            }
            return t.nodeType ? (this[0] = t, this.length = 1, this) : y(t) ? void 0 !== i.ready ? i.ready(t) : t(T) : T.makeArray(t, this)
        }).prototype = T.fn, P = T(r);
        var L = /^(?:parents|prev(?:Until|All))/,
            N = {
                children: !0,
                contents: !0,
                next: !0,
                prev: !0
            };
  
        function z(t, e) {
            for (;
                (t = t[e]) && 1 !== t.nodeType;);
            return t
        }
        T.fn.extend({
            has: function(t) {
                var e = T(t, this),
                    i = e.length;
                return this.filter(function() {
                    for (var t = 0; t < i; t++)
                        if (T.contains(this, e[t])) return !0
                })
            },
            closest: function(t, e) {
                var i, n = 0,
                    s = this.length,
                    o = [],
                    r = "string" != typeof t && T(t);
                if (!M.test(t))
                    for (; n < s; n++)
                        for (i = this[n]; i && i !== e; i = i.parentNode)
                            if (i.nodeType < 11 && (r ? r.index(i) > -1 : 1 === i.nodeType && T.find.matchesSelector(i, t))) {
                                o.push(i);
                                break
                            } return this.pushStack(o.length > 1 ? T.uniqueSort(o) : o)
            },
            index: function(t) {
                return t ? "string" == typeof t ? d.call(T(t), this[0]) : d.call(this, t.jquery ? t[0] : t) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1
            },
            add: function(t, e) {
                return this.pushStack(T.uniqueSort(T.merge(this.get(), T(t, e))))
            },
            addBack: function(t) {
                return this.add(null == t ? this.prevObject : this.prevObject.filter(t))
            }
        }), T.each({
            parent: function(t) {
                var e = t.parentNode;
                return e && 11 !== e.nodeType ? e : null
            },
            parents: function(t) {
                return D(t, "parentNode")
            },
            parentsUntil: function(t, e, i) {
                return D(t, "parentNode", i)
            },
            next: function(t) {
                return z(t, "nextSibling")
            },
            prev: function(t) {
                return z(t, "previousSibling")
            },
            nextAll: function(t) {
                return D(t, "nextSibling")
            },
            prevAll: function(t) {
                return D(t, "previousSibling")
            },
            nextUntil: function(t, e, i) {
                return D(t, "nextSibling", i)
            },
            prevUntil: function(t, e, i) {
                return D(t, "previousSibling", i)
            },
            siblings: function(t) {
                return I((t.parentNode || {}).firstChild, t)
            },
            children: function(t) {
                return I(t.firstChild)
            },
            contents: function(t) {
                return O(t, "iframe") ? t.contentDocument : (O(t, "template") && (t = t.content || t), T.merge([], t.childNodes))
            }
        }, function(t, e) {
            T.fn[t] = function(i, n) {
                var s = T.map(this, e, i);
                return "Until" !== t.slice(-5) && (n = i), n && "string" == typeof n && (s = T.filter(n, s)), this.length > 1 && (N[t] || T.uniqueSort(s), L.test(t) && s.reverse()), this.pushStack(s)
            }
        });
        var F = /[^\x20\t\r\n\f]+/g;
  
        function H(t) {
            return t
        }
  
        function R(t) {
            throw t
        }
  
        function j(t, e, i, n) {
            var s;
            try {
                t && y(s = t.promise) ? s.call(t).done(e).fail(i) : t && y(s = t.then) ? s.call(t, e, i) : e.apply(void 0, [t].slice(n))
            } catch (t) {
                i.apply(void 0, [t])
            }
        }
        T.Callbacks = function(t) {
            t = "string" == typeof t ? function(t) {
                var e = {};
                return T.each(t.match(F) || [], function(t, i) {
                    e[i] = !0
                }), e
            }(t) : T.extend({}, t);
            var e, i, n, s, o = [],
                r = [],
                a = -1,
                l = function() {
                    for (s = s || t.once, n = e = !0; r.length; a = -1)
                        for (i = r.shift(); ++a < o.length;) !1 === o[a].apply(i[0], i[1]) && t.stopOnFalse && (a = o.length, i = !1);
                    t.memory || (i = !1), e = !1, s && (o = i ? [] : "")
                },
                h = {
                    add: function() {
                        return o && (i && !e && (a = o.length - 1, r.push(i)), function e(i) {
                            T.each(i, function(i, n) {
                                y(n) ? t.unique && h.has(n) || o.push(n) : n && n.length && "string" !== x(n) && e(n)
                            })
                        }(arguments), i && !e && l()), this
                    },
                    remove: function() {
                        return T.each(arguments, function(t, e) {
                            for (var i;
                                (i = T.inArray(e, o, i)) > -1;) o.splice(i, 1), i <= a && a--
                        }), this
                    },
                    has: function(t) {
                        return t ? T.inArray(t, o) > -1 : o.length > 0
                    },
                    empty: function() {
                        return o && (o = []), this
                    },
                    disable: function() {
                        return s = r = [], o = i = "", this
                    },
                    disabled: function() {
                        return !o
                    },
                    lock: function() {
                        return s = r = [], i || e || (o = i = ""), this
                    },
                    locked: function() {
                        return !!s
                    },
                    fireWith: function(t, i) {
                        return s || (i = [t, (i = i || []).slice ? i.slice() : i], r.push(i), e || l()), this
                    },
                    fire: function() {
                        return h.fireWith(this, arguments), this
                    },
                    fired: function() {
                        return !!n
                    }
                };
            return h
        }, T.extend({
            Deferred: function(t) {
                var e = [
                        ["notify", "progress", T.Callbacks("memory"), T.Callbacks("memory"), 2],
                        ["resolve", "done", T.Callbacks("once memory"), T.Callbacks("once memory"), 0, "resolved"],
                        ["reject", "fail", T.Callbacks("once memory"), T.Callbacks("once memory"), 1, "rejected"]
                    ],
                    n = "pending",
                    s = {
                        state: function() {
                            return n
                        },
                        always: function() {
                            return o.done(arguments).fail(arguments), this
                        },
                        catch: function(t) {
                            return s.then(null, t)
                        },
                        pipe: function() {
                            var t = arguments;
                            return T.Deferred(function(i) {
                                T.each(e, function(e, n) {
                                    var s = y(t[n[4]]) && t[n[4]];
                                    o[n[1]](function() {
                                        var t = s && s.apply(this, arguments);
                                        t && y(t.promise) ? t.promise().progress(i.notify).done(i.resolve).fail(i.reject) : i[n[0] + "With"](this, s ? [t] : arguments)
                                    })
                                }), t = null
                            }).promise()
                        },
                        then: function(t, n, s) {
                            var o = 0;
  
                            function r(t, e, n, s) {
                                return function() {
                                    var a = this,
                                        l = arguments,
                                        h = function() {
                                            var i, h;
                                            if (!(t < o)) {
                                                if ((i = n.apply(a, l)) === e.promise()) throw new TypeError("Thenable self-resolution");
                                                h = i && ("object" == typeof i || "function" == typeof i) && i.then, y(h) ? s ? h.call(i, r(o, e, H, s), r(o, e, R, s)) : (o++, h.call(i, r(o, e, H, s), r(o, e, R, s), r(o, e, H, e.notifyWith))) : (n !== H && (a = void 0, l = [i]), (s || e.resolveWith)(a, l))
                                            }
                                        },
                                        c = s ? h : function() {
                                            try {
                                                h()
                                            } catch (i) {
                                                T.Deferred.exceptionHook && T.Deferred.exceptionHook(i, c.stackTrace), t + 1 >= o && (n !== R && (a = void 0, l = [i]), e.rejectWith(a, l))
                                            }
                                        };
                                    t ? c() : (T.Deferred.getStackHook && (c.stackTrace = T.Deferred.getStackHook()), i.setTimeout(c))
                                }
                            }
                            return T.Deferred(function(i) {
                                e[0][3].add(r(0, i, y(s) ? s : H, i.notifyWith)), e[1][3].add(r(0, i, y(t) ? t : H)), e[2][3].add(r(0, i, y(n) ? n : R))
                            }).promise()
                        },
                        promise: function(t) {
                            return null != t ? T.extend(t, s) : s
                        }
                    },
                    o = {};
                return T.each(e, function(t, i) {
                    var r = i[2],
                        a = i[5];
                    s[i[1]] = r.add, a && r.add(function() {
                        n = a
                    }, e[3 - t][2].disable, e[3 - t][3].disable, e[0][2].lock, e[0][3].lock), r.add(i[3].fire), o[i[0]] = function() {
                        return o[i[0] + "With"](this === o ? void 0 : this, arguments), this
                    }, o[i[0] + "With"] = r.fireWith
                }), s.promise(o), t && t.call(o, o), o
            },
            when: function(t) {
                var e = arguments.length,
                    i = e,
                    n = Array(i),
                    s = l.call(arguments),
                    o = T.Deferred(),
                    r = function(t) {
                        return function(i) {
                            n[t] = this, s[t] = arguments.length > 1 ? l.call(arguments) : i, --e || o.resolveWith(n, s)
                        }
                    };
                if (e <= 1 && (j(t, o.done(r(i)).resolve, o.reject, !e), "pending" === o.state() || y(s[i] && s[i].then))) return o.then();
                for (; i--;) j(s[i], r(i), o.reject);
                return o.promise()
            }
        });
        var W = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
        T.Deferred.exceptionHook = function(t, e) {
            i.console && i.console.warn && t && W.test(t.name) && i.console.warn("jQuery.Deferred exception: " + t.message, t.stack, e)
        }, T.readyException = function(t) {
            i.setTimeout(function() {
                throw t
            })
        };
        var B = T.Deferred();
  
        function V() {
            r.removeEventListener("DOMContentLoaded", V), i.removeEventListener("load", V), T.ready()
        }
        T.fn.ready = function(t) {
            return B.then(t).catch(function(t) {
                T.readyException(t)
            }), this
        }, T.extend({
            isReady: !1,
            readyWait: 1,
            ready: function(t) {
                (!0 === t ? --T.readyWait : T.isReady) || (T.isReady = !0, !0 !== t && --T.readyWait > 0 || B.resolveWith(r, [T]))
            }
        }), T.ready.then = B.then, "complete" === r.readyState || "loading" !== r.readyState && !r.documentElement.doScroll ? i.setTimeout(T.ready) : (r.addEventListener("DOMContentLoaded", V), i.addEventListener("load", V));
        var q = function(t, e, i, n, s, o, r) {
                var a = 0,
                    l = t.length,
                    h = null == i;
                if ("object" === x(i))
                    for (a in s = !0, i) q(t, e, a, i[a], !0, o, r);
                else if (void 0 !== n && (s = !0, y(n) || (r = !0), h && (r ? (e.call(t, n), e = null) : (h = e, e = function(t, e, i) {
                        return h.call(T(t), i)
                    })), e))
                    for (; a < l; a++) e(t[a], i, r ? n : n.call(t[a], a, e(t[a], i)));
                return s ? t : h ? e.call(t) : l ? e(t[0], i) : o
            },
            G = /^-ms-/,
            U = /-([a-z])/g;
  
        function Y(t, e) {
            return e.toUpperCase()
        }
  
        function X(t) {
            return t.replace(G, "ms-").replace(U, Y)
        }
        var K = function(t) {
            return 1 === t.nodeType || 9 === t.nodeType || !+t.nodeType
        };
  
        function Q() {
            this.expando = T.expando + Q.uid++
        }
        Q.uid = 1, Q.prototype = {
            cache: function(t) {
                var e = t[this.expando];
                return e || (e = {}, K(t) && (t.nodeType ? t[this.expando] = e : Object.defineProperty(t, this.expando, {
                    value: e,
                    configurable: !0
                }))), e
            },
            set: function(t, e, i) {
                var n, s = this.cache(t);
                if ("string" == typeof e) s[X(e)] = i;
                else
                    for (n in e) s[X(n)] = e[n];
                return s
            },
            get: function(t, e) {
                return void 0 === e ? this.cache(t) : t[this.expando] && t[this.expando][X(e)]
            },
            access: function(t, e, i) {
                return void 0 === e || e && "string" == typeof e && void 0 === i ? this.get(t, e) : (this.set(t, e, i), void 0 !== i ? i : e)
            },
            remove: function(t, e) {
                var i, n = t[this.expando];
                if (void 0 !== n) {
                    if (void 0 !== e) {
                        i = (e = Array.isArray(e) ? e.map(X) : (e = X(e)) in n ? [e] : e.match(F) || []).length;
                        for (; i--;) delete n[e[i]]
                    }(void 0 === e || T.isEmptyObject(n)) && (t.nodeType ? t[this.expando] = void 0 : delete t[this.expando])
                }
            },
            hasData: function(t) {
                var e = t[this.expando];
                return void 0 !== e && !T.isEmptyObject(e)
            }
        };
        var Z = new Q,
            J = new Q,
            tt = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
            et = /[A-Z]/g;
  
        function it(t, e, i) {
            var n;
            if (void 0 === i && 1 === t.nodeType)
                if (n = "data-" + e.replace(et, "-$&").toLowerCase(), "string" == typeof(i = t.getAttribute(n))) {
                    try {
                        i = function(t) {
                            return "true" === t || "false" !== t && ("null" === t ? null : t === +t + "" ? +t : tt.test(t) ? JSON.parse(t) : t)
                        }(i)
                    } catch (t) {}
                    J.set(t, e, i)
                } else i = void 0;
            return i
        }
        T.extend({
            hasData: function(t) {
                return J.hasData(t) || Z.hasData(t)
            },
            data: function(t, e, i) {
                return J.access(t, e, i)
            },
            removeData: function(t, e) {
                J.remove(t, e)
            },
            _data: function(t, e, i) {
                return Z.access(t, e, i)
            },
            _removeData: function(t, e) {
                Z.remove(t, e)
            }
        }), T.fn.extend({
            data: function(t, e) {
                var i, n, s, o = this[0],
                    r = o && o.attributes;
                if (void 0 === t) {
                    if (this.length && (s = J.get(o), 1 === o.nodeType && !Z.get(o, "hasDataAttrs"))) {
                        for (i = r.length; i--;) r[i] && 0 === (n = r[i].name).indexOf("data-") && (n = X(n.slice(5)), it(o, n, s[n]));
                        Z.set(o, "hasDataAttrs", !0)
                    }
                    return s
                }
                return "object" == typeof t ? this.each(function() {
                    J.set(this, t)
                }) : q(this, function(e) {
                    var i;
                    if (o && void 0 === e) return void 0 !== (i = J.get(o, t)) ? i : void 0 !== (i = it(o, t)) ? i : void 0;
                    this.each(function() {
                        J.set(this, t, e)
                    })
                }, null, e, arguments.length > 1, null, !0)
            },
            removeData: function(t) {
                return this.each(function() {
                    J.remove(this, t)
                })
            }
        }), T.extend({
            queue: function(t, e, i) {
                var n;
                if (t) return e = (e || "fx") + "queue", n = Z.get(t, e), i && (!n || Array.isArray(i) ? n = Z.access(t, e, T.makeArray(i)) : n.push(i)), n || []
            },
            dequeue: function(t, e) {
                e = e || "fx";
                var i = T.queue(t, e),
                    n = i.length,
                    s = i.shift(),
                    o = T._queueHooks(t, e);
                "inprogress" === s && (s = i.shift(), n--), s && ("fx" === e && i.unshift("inprogress"), delete o.stop, s.call(t, function() {
                    T.dequeue(t, e)
                }, o)), !n && o && o.empty.fire()
            },
            _queueHooks: function(t, e) {
                var i = e + "queueHooks";
                return Z.get(t, i) || Z.access(t, i, {
                    empty: T.Callbacks("once memory").add(function() {
                        Z.remove(t, [e + "queue", i])
                    })
                })
            }
        }), T.fn.extend({
            queue: function(t, e) {
                var i = 2;
                return "string" != typeof t && (e = t, t = "fx", i--), arguments.length < i ? T.queue(this[0], t) : void 0 === e ? this : this.each(function() {
                    var i = T.queue(this, t, e);
                    T._queueHooks(this, t), "fx" === t && "inprogress" !== i[0] && T.dequeue(this, t)
                })
            },
            dequeue: function(t) {
                return this.each(function() {
                    T.dequeue(this, t)
                })
            },
            clearQueue: function(t) {
                return this.queue(t || "fx", [])
            },
            promise: function(t, e) {
                var i, n = 1,
                    s = T.Deferred(),
                    o = this,
                    r = this.length,
                    a = function() {
                        --n || s.resolveWith(o, [o])
                    };
                for ("string" != typeof t && (e = t, t = void 0), t = t || "fx"; r--;)(i = Z.get(o[r], t + "queueHooks")) && i.empty && (n++, i.empty.add(a));
                return a(), s.promise(e)
            }
        });
        var nt = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
            st = new RegExp("^(?:([+-])=|)(" + nt + ")([a-z%]*)$", "i"),
            ot = ["Top", "Right", "Bottom", "Left"],
            rt = function(t, e) {
                return "none" === (t = e || t).style.display || "" === t.style.display && T.contains(t.ownerDocument, t) && "none" === T.css(t, "display")
            },
            at = function(t, e, i, n) {
                var s, o, r = {};
                for (o in e) r[o] = t.style[o], t.style[o] = e[o];
                for (o in s = i.apply(t, n || []), e) t.style[o] = r[o];
                return s
            };
  
        function lt(t, e, i, n) {
            var s, o, r = 20,
                a = n ? function() {
                    return n.cur()
                } : function() {
                    return T.css(t, e, "")
                },
                l = a(),
                h = i && i[3] || (T.cssNumber[e] ? "" : "px"),
                c = (T.cssNumber[e] || "px" !== h && +l) && st.exec(T.css(t, e));
            if (c && c[3] !== h) {
                for (l /= 2, h = h || c[3], c = +l || 1; r--;) T.style(t, e, c + h), (1 - o) * (1 - (o = a() / l || .5)) <= 0 && (r = 0), c /= o;
                c *= 2, T.style(t, e, c + h), i = i || []
            }
            return i && (c = +c || +l || 0, s = i[1] ? c + (i[1] + 1) * i[2] : +i[2], n && (n.unit = h, n.start = c, n.end = s)), s
        }
        var ht = {};
  
        function ct(t) {
            var e, i = t.ownerDocument,
                n = t.nodeName,
                s = ht[n];
            return s || (e = i.body.appendChild(i.createElement(n)), s = T.css(e, "display"), e.parentNode.removeChild(e), "none" === s && (s = "block"), ht[n] = s, s)
        }
  
        function dt(t, e) {
            for (var i, n, s = [], o = 0, r = t.length; o < r; o++)(n = t[o]).style && (i = n.style.display, e ? ("none" === i && (s[o] = Z.get(n, "display") || null, s[o] || (n.style.display = "")), "" === n.style.display && rt(n) && (s[o] = ct(n))) : "none" !== i && (s[o] = "none", Z.set(n, "display", i)));
            for (o = 0; o < r; o++) null != s[o] && (t[o].style.display = s[o]);
            return t
        }
        T.fn.extend({
            show: function() {
                return dt(this, !0)
            },
            hide: function() {
                return dt(this)
            },
            toggle: function(t) {
                return "boolean" == typeof t ? t ? this.show() : this.hide() : this.each(function() {
                    rt(this) ? T(this).show() : T(this).hide()
                })
            }
        });
        var ut = /^(?:checkbox|radio)$/i,
            pt = /<([a-z][^\/\0>\x20\t\r\n\f]+)/i,
            ft = /^$|^module$|\/(?:java|ecma)script/i,
            mt = {
                option: [1, "<select multiple='multiple'>", "</select>"],
                thead: [1, "<table>", "</table>"],
                col: [2, "<table><colgroup>", "</colgroup></table>"],
                tr: [2, "<table><tbody>", "</tbody></table>"],
                td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
                _default: [0, "", ""]
            };
  
        function gt(t, e) {
            var i;
            return i = void 0 !== t.getElementsByTagName ? t.getElementsByTagName(e || "*") : void 0 !== t.querySelectorAll ? t.querySelectorAll(e || "*") : [], void 0 === e || e && O(t, e) ? T.merge([t], i) : i
        }
  
        function vt(t, e) {
            for (var i = 0, n = t.length; i < n; i++) Z.set(t[i], "globalEval", !e || Z.get(e[i], "globalEval"))
        }
        mt.optgroup = mt.option, mt.tbody = mt.tfoot = mt.colgroup = mt.caption = mt.thead, mt.th = mt.td;
        var yt = /<|&#?\w+;/;
  
        function _t(t, e, i, n, s) {
            for (var o, r, a, l, h, c, d = e.createDocumentFragment(), u = [], p = 0, f = t.length; p < f; p++)
                if ((o = t[p]) || 0 === o)
                    if ("object" === x(o)) T.merge(u, o.nodeType ? [o] : o);
                    else if (yt.test(o)) {
                for (r = r || d.appendChild(e.createElement("div")), a = (pt.exec(o) || ["", ""])[1].toLowerCase(), l = mt[a] || mt._default, r.innerHTML = l[1] + T.htmlPrefilter(o) + l[2], c = l[0]; c--;) r = r.lastChild;
                T.merge(u, r.childNodes), (r = d.firstChild).textContent = ""
            } else u.push(e.createTextNode(o));
            for (d.textContent = "", p = 0; o = u[p++];)
                if (n && T.inArray(o, n) > -1) s && s.push(o);
                else if (h = T.contains(o.ownerDocument, o), r = gt(d.appendChild(o), "script"), h && vt(r), i)
                for (c = 0; o = r[c++];) ft.test(o.type || "") && i.push(o);
            return d
        }! function() {
            var t = r.createDocumentFragment().appendChild(r.createElement("div")),
                e = r.createElement("input");
            e.setAttribute("type", "radio"), e.setAttribute("checked", "checked"), e.setAttribute("name", "t"), t.appendChild(e), v.checkClone = t.cloneNode(!0).cloneNode(!0).lastChild.checked, t.innerHTML = "<textarea>x</textarea>", v.noCloneChecked = !!t.cloneNode(!0).lastChild.defaultValue
        }();
        var bt = r.documentElement,
            wt = /^key/,
            xt = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
            Tt = /^([^.]*)(?:\.(.+)|)/;
  
        function Et() {
            return !0
        }
  
        function Ct() {
            return !1
        }
  
        function St() {
            try {
                return r.activeElement
            } catch (t) {}
        }
  
        function Dt(t, e, i, n, s, o) {
            var r, a;
            if ("object" == typeof e) {
                for (a in "string" != typeof i && (n = n || i, i = void 0), e) Dt(t, a, i, n, e[a], o);
                return t
            }
            if (null == n && null == s ? (s = i, n = i = void 0) : null == s && ("string" == typeof i ? (s = n, n = void 0) : (s = n, n = i, i = void 0)), !1 === s) s = Ct;
            else if (!s) return t;
            return 1 === o && (r = s, (s = function(t) {
                return T().off(t), r.apply(this, arguments)
            }).guid = r.guid || (r.guid = T.guid++)), t.each(function() {
                T.event.add(this, e, s, n, i)
            })
        }
        T.event = {
            global: {},
            add: function(t, e, i, n, s) {
                var o, r, a, l, h, c, d, u, p, f, m, g = Z.get(t);
                if (g)
                    for (i.handler && (i = (o = i).handler, s = o.selector), s && T.find.matchesSelector(bt, s), i.guid || (i.guid = T.guid++), (l = g.events) || (l = g.events = {}), (r = g.handle) || (r = g.handle = function(e) {
                            return void 0 !== T && T.event.triggered !== e.type ? T.event.dispatch.apply(t, arguments) : void 0
                        }), h = (e = (e || "").match(F) || [""]).length; h--;) p = m = (a = Tt.exec(e[h]) || [])[1], f = (a[2] || "").split(".").sort(), p && (d = T.event.special[p] || {}, p = (s ? d.delegateType : d.bindType) || p, d = T.event.special[p] || {}, c = T.extend({
                        type: p,
                        origType: m,
                        data: n,
                        handler: i,
                        guid: i.guid,
                        selector: s,
                        needsContext: s && T.expr.match.needsContext.test(s),
                        namespace: f.join(".")
                    }, o), (u = l[p]) || ((u = l[p] = []).delegateCount = 0, d.setup && !1 !== d.setup.call(t, n, f, r) || t.addEventListener && t.addEventListener(p, r)), d.add && (d.add.call(t, c), c.handler.guid || (c.handler.guid = i.guid)), s ? u.splice(u.delegateCount++, 0, c) : u.push(c), T.event.global[p] = !0)
            },
            remove: function(t, e, i, n, s) {
                var o, r, a, l, h, c, d, u, p, f, m, g = Z.hasData(t) && Z.get(t);
                if (g && (l = g.events)) {
                    for (h = (e = (e || "").match(F) || [""]).length; h--;)
                        if (p = m = (a = Tt.exec(e[h]) || [])[1], f = (a[2] || "").split(".").sort(), p) {
                            for (d = T.event.special[p] || {}, u = l[p = (n ? d.delegateType : d.bindType) || p] || [], a = a[2] && new RegExp("(^|\\.)" + f.join("\\.(?:.*\\.|)") + "(\\.|$)"), r = o = u.length; o--;) c = u[o], !s && m !== c.origType || i && i.guid !== c.guid || a && !a.test(c.namespace) || n && n !== c.selector && ("**" !== n || !c.selector) || (u.splice(o, 1), c.selector && u.delegateCount--, d.remove && d.remove.call(t, c));
                            r && !u.length && (d.teardown && !1 !== d.teardown.call(t, f, g.handle) || T.removeEvent(t, p, g.handle), delete l[p])
                        } else
                            for (p in l) T.event.remove(t, p + e[h], i, n, !0);
                    T.isEmptyObject(l) && Z.remove(t, "handle events")
                }
            },
            dispatch: function(t) {
                var e, i, n, s, o, r, a = T.event.fix(t),
                    l = new Array(arguments.length),
                    h = (Z.get(this, "events") || {})[a.type] || [],
                    c = T.event.special[a.type] || {};
                for (l[0] = a, e = 1; e < arguments.length; e++) l[e] = arguments[e];
                if (a.delegateTarget = this, !c.preDispatch || !1 !== c.preDispatch.call(this, a)) {
                    for (r = T.event.handlers.call(this, a, h), e = 0;
                        (s = r[e++]) && !a.isPropagationStopped();)
                        for (a.currentTarget = s.elem, i = 0;
                            (o = s.handlers[i++]) && !a.isImmediatePropagationStopped();) a.rnamespace && !a.rnamespace.test(o.namespace) || (a.handleObj = o, a.data = o.data, void 0 !== (n = ((T.event.special[o.origType] || {}).handle || o.handler).apply(s.elem, l)) && !1 === (a.result = n) && (a.preventDefault(), a.stopPropagation()));
                    return c.postDispatch && c.postDispatch.call(this, a), a.result
                }
            },
            handlers: function(t, e) {
                var i, n, s, o, r, a = [],
                    l = e.delegateCount,
                    h = t.target;
                if (l && h.nodeType && !("click" === t.type && t.button >= 1))
                    for (; h !== this; h = h.parentNode || this)
                        if (1 === h.nodeType && ("click" !== t.type || !0 !== h.disabled)) {
                            for (o = [], r = {}, i = 0; i < l; i++) void 0 === r[s = (n = e[i]).selector + " "] && (r[s] = n.needsContext ? T(s, this).index(h) > -1 : T.find(s, this, null, [h]).length), r[s] && o.push(n);
                            o.length && a.push({
                                elem: h,
                                handlers: o
                            })
                        } return h = this, l < e.length && a.push({
                    elem: h,
                    handlers: e.slice(l)
                }), a
            },
            addProp: function(t, e) {
                Object.defineProperty(T.Event.prototype, t, {
                    enumerable: !0,
                    configurable: !0,
                    get: y(e) ? function() {
                        if (this.originalEvent) return e(this.originalEvent)
                    } : function() {
                        if (this.originalEvent) return this.originalEvent[t]
                    },
                    set: function(e) {
                        Object.defineProperty(this, t, {
                            enumerable: !0,
                            configurable: !0,
                            writable: !0,
                            value: e
                        })
                    }
                })
            },
            fix: function(t) {
                return t[T.expando] ? t : new T.Event(t)
            },
            special: {
                load: {
                    noBubble: !0
                },
                focus: {
                    trigger: function() {
                        if (this !== St() && this.focus) return this.focus(), !1
                    },
                    delegateType: "focusin"
                },
                blur: {
                    trigger: function() {
                        if (this === St() && this.blur) return this.blur(), !1
                    },
                    delegateType: "focusout"
                },
                click: {
                    trigger: function() {
                        if ("checkbox" === this.type && this.click && O(this, "input")) return this.click(), !1
                    },
                    _default: function(t) {
                        return O(t.target, "a")
                    }
                },
                beforeunload: {
                    postDispatch: function(t) {
                        void 0 !== t.result && t.originalEvent && (t.originalEvent.returnValue = t.result)
                    }
                }
            }
        }, T.removeEvent = function(t, e, i) {
            t.removeEventListener && t.removeEventListener(e, i)
        }, T.Event = function(t, e) {
            if (!(this instanceof T.Event)) return new T.Event(t, e);
            t && t.type ? (this.originalEvent = t, this.type = t.type, this.isDefaultPrevented = t.defaultPrevented || void 0 === t.defaultPrevented && !1 === t.returnValue ? Et : Ct, this.target = t.target && 3 === t.target.nodeType ? t.target.parentNode : t.target, this.currentTarget = t.currentTarget, this.relatedTarget = t.relatedTarget) : this.type = t, e && T.extend(this, e), this.timeStamp = t && t.timeStamp || Date.now(), this[T.expando] = !0
        }, T.Event.prototype = {
            constructor: T.Event,
            isDefaultPrevented: Ct,
            isPropagationStopped: Ct,
            isImmediatePropagationStopped: Ct,
            isSimulated: !1,
            preventDefault: function() {
                var t = this.originalEvent;
                this.isDefaultPrevented = Et, t && !this.isSimulated && t.preventDefault()
            },
            stopPropagation: function() {
                var t = this.originalEvent;
                this.isPropagationStopped = Et, t && !this.isSimulated && t.stopPropagation()
            },
            stopImmediatePropagation: function() {
                var t = this.originalEvent;
                this.isImmediatePropagationStopped = Et, t && !this.isSimulated && t.stopImmediatePropagation(), this.stopPropagation()
            }
        }, T.each({
            altKey: !0,
            bubbles: !0,
            cancelable: !0,
            changedTouches: !0,
            ctrlKey: !0,
            detail: !0,
            eventPhase: !0,
            metaKey: !0,
            pageX: !0,
            pageY: !0,
            shiftKey: !0,
            view: !0,
            char: !0,
            charCode: !0,
            key: !0,
            keyCode: !0,
            button: !0,
            buttons: !0,
            clientX: !0,
            clientY: !0,
            offsetX: !0,
            offsetY: !0,
            pointerId: !0,
            pointerType: !0,
            screenX: !0,
            screenY: !0,
            targetTouches: !0,
            toElement: !0,
            touches: !0,
            which: function(t) {
                var e = t.button;
                return null == t.which && wt.test(t.type) ? null != t.charCode ? t.charCode : t.keyCode : !t.which && void 0 !== e && xt.test(t.type) ? 1 & e ? 1 : 2 & e ? 3 : 4 & e ? 2 : 0 : t.which
            }
        }, T.event.addProp), T.each({
            mouseenter: "mouseover",
            mouseleave: "mouseout",
            pointerenter: "pointerover",
            pointerleave: "pointerout"
        }, function(t, e) {
            T.event.special[t] = {
                delegateType: e,
                bindType: e,
                handle: function(t) {
                    var i, n = t.relatedTarget,
                        s = t.handleObj;
                    return n && (n === this || T.contains(this, n)) || (t.type = s.origType, i = s.handler.apply(this, arguments), t.type = e), i
                }
            }
        }), T.fn.extend({
            on: function(t, e, i, n) {
                return Dt(this, t, e, i, n)
            },
            one: function(t, e, i, n) {
                return Dt(this, t, e, i, n, 1)
            },
            off: function(t, e, i) {
                var n, s;
                if (t && t.preventDefault && t.handleObj) return n = t.handleObj, T(t.delegateTarget).off(n.namespace ? n.origType + "." + n.namespace : n.origType, n.selector, n.handler), this;
                if ("object" == typeof t) {
                    for (s in t) this.off(s, e, t[s]);
                    return this
                }
                return !1 !== e && "function" != typeof e || (i = e, e = void 0), !1 === i && (i = Ct), this.each(function() {
                    T.event.remove(this, t, i, e)
                })
            }
        });
        var It = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,
            Mt = /<script|<style|<link/i,
            Ot = /checked\s*(?:[^=]|=\s*.checked.)/i,
            kt = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
  
        function At(t, e) {
            return O(t, "table") && O(11 !== e.nodeType ? e : e.firstChild, "tr") && T(t).children("tbody")[0] || t
        }
  
        function Pt(t) {
            return t.type = (null !== t.getAttribute("type")) + "/" + t.type, t
        }
  
        function $t(t) {
            return "true/" === (t.type || "").slice(0, 5) ? t.type = t.type.slice(5) : t.removeAttribute("type"), t
        }
  
        function Lt(t, e) {
            var i, n, s, o, r, a, l, h;
            if (1 === e.nodeType) {
                if (Z.hasData(t) && (o = Z.access(t), r = Z.set(e, o), h = o.events))
                    for (s in delete r.handle, r.events = {}, h)
                        for (i = 0, n = h[s].length; i < n; i++) T.event.add(e, s, h[s][i]);
                J.hasData(t) && (a = J.access(t), l = T.extend({}, a), J.set(e, l))
            }
        }
  
        function Nt(t, e) {
            var i = e.nodeName.toLowerCase();
            "input" === i && ut.test(t.type) ? e.checked = t.checked : "input" !== i && "textarea" !== i || (e.defaultValue = t.defaultValue)
        }
  
        function zt(t, e, i, n) {
            e = h.apply([], e);
            var s, o, r, a, l, c, d = 0,
                u = t.length,
                p = u - 1,
                f = e[0],
                m = y(f);
            if (m || u > 1 && "string" == typeof f && !v.checkClone && Ot.test(f)) return t.each(function(s) {
                var o = t.eq(s);
                m && (e[0] = f.call(this, s, o.html())), zt(o, e, i, n)
            });
            if (u && (o = (s = _t(e, t[0].ownerDocument, !1, t, n)).firstChild, 1 === s.childNodes.length && (s = o), o || n)) {
                for (a = (r = T.map(gt(s, "script"), Pt)).length; d < u; d++) l = s, d !== p && (l = T.clone(l, !0, !0), a && T.merge(r, gt(l, "script"))), i.call(t[d], l, d);
                if (a)
                    for (c = r[r.length - 1].ownerDocument, T.map(r, $t), d = 0; d < a; d++) l = r[d], ft.test(l.type || "") && !Z.access(l, "globalEval") && T.contains(c, l) && (l.src && "module" !== (l.type || "").toLowerCase() ? T._evalUrl && T._evalUrl(l.src) : w(l.textContent.replace(kt, ""), c, l))
            }
            return t
        }
  
        function Ft(t, e, i) {
            for (var n, s = e ? T.filter(e, t) : t, o = 0; null != (n = s[o]); o++) i || 1 !== n.nodeType || T.cleanData(gt(n)), n.parentNode && (i && T.contains(n.ownerDocument, n) && vt(gt(n, "script")), n.parentNode.removeChild(n));
            return t
        }
        T.extend({
            htmlPrefilter: function(t) {
                return t.replace(It, "<$1></$2>")
            },
            clone: function(t, e, i) {
                var n, s, o, r, a = t.cloneNode(!0),
                    l = T.contains(t.ownerDocument, t);
                if (!(v.noCloneChecked || 1 !== t.nodeType && 11 !== t.nodeType || T.isXMLDoc(t)))
                    for (r = gt(a), n = 0, s = (o = gt(t)).length; n < s; n++) Nt(o[n], r[n]);
                if (e)
                    if (i)
                        for (o = o || gt(t), r = r || gt(a), n = 0, s = o.length; n < s; n++) Lt(o[n], r[n]);
                    else Lt(t, a);
                return (r = gt(a, "script")).length > 0 && vt(r, !l && gt(t, "script")), a
            },
            cleanData: function(t) {
                for (var e, i, n, s = T.event.special, o = 0; void 0 !== (i = t[o]); o++)
                    if (K(i)) {
                        if (e = i[Z.expando]) {
                            if (e.events)
                                for (n in e.events) s[n] ? T.event.remove(i, n) : T.removeEvent(i, n, e.handle);
                            i[Z.expando] = void 0
                        }
                        i[J.expando] && (i[J.expando] = void 0)
                    }
            }
        }), T.fn.extend({
            detach: function(t) {
                return Ft(this, t, !0)
            },
            remove: function(t) {
                return Ft(this, t)
            },
            text: function(t) {
                return q(this, function(t) {
                    return void 0 === t ? T.text(this) : this.empty().each(function() {
                        1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || (this.textContent = t)
                    })
                }, null, t, arguments.length)
            },
            append: function() {
                return zt(this, arguments, function(t) {
                    1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || At(this, t).appendChild(t)
                })
            },
            prepend: function() {
                return zt(this, arguments, function(t) {
                    if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                        var e = At(this, t);
                        e.insertBefore(t, e.firstChild)
                    }
                })
            },
            before: function() {
                return zt(this, arguments, function(t) {
                    this.parentNode && this.parentNode.insertBefore(t, this)
                })
            },
            after: function() {
                return zt(this, arguments, function(t) {
                    this.parentNode && this.parentNode.insertBefore(t, this.nextSibling)
                })
            },
            empty: function() {
                for (var t, e = 0; null != (t = this[e]); e++) 1 === t.nodeType && (T.cleanData(gt(t, !1)), t.textContent = "");
                return this
            },
            clone: function(t, e) {
                return t = null != t && t, e = null == e ? t : e, this.map(function() {
                    return T.clone(this, t, e)
                })
            },
            html: function(t) {
                return q(this, function(t) {
                    var e = this[0] || {},
                        i = 0,
                        n = this.length;
                    if (void 0 === t && 1 === e.nodeType) return e.innerHTML;
                    if ("string" == typeof t && !Mt.test(t) && !mt[(pt.exec(t) || ["", ""])[1].toLowerCase()]) {
                        t = T.htmlPrefilter(t);
                        try {
                            for (; i < n; i++) 1 === (e = this[i] || {}).nodeType && (T.cleanData(gt(e, !1)), e.innerHTML = t);
                            e = 0
                        } catch (t) {}
                    }
                    e && this.empty().append(t)
                }, null, t, arguments.length)
            },
            replaceWith: function() {
                var t = [];
                return zt(this, arguments, function(e) {
                    var i = this.parentNode;
                    T.inArray(this, t) < 0 && (T.cleanData(gt(this)), i && i.replaceChild(e, this))
                }, t)
            }
        }), T.each({
            appendTo: "append",
            prependTo: "prepend",
            insertBefore: "before",
            insertAfter: "after",
            replaceAll: "replaceWith"
        }, function(t, e) {
            T.fn[t] = function(t) {
                for (var i, n = [], s = T(t), o = s.length - 1, r = 0; r <= o; r++) i = r === o ? this : this.clone(!0), T(s[r])[e](i), c.apply(n, i.get());
                return this.pushStack(n)
            }
        });
        var Ht = new RegExp("^(" + nt + ")(?!px)[a-z%]+$", "i"),
            Rt = function(t) {
                var e = t.ownerDocument.defaultView;
                return e && e.opener || (e = i), e.getComputedStyle(t)
            },
            jt = new RegExp(ot.join("|"), "i");
  
        function Wt(t, e, i) {
            var n, s, o, r, a = t.style;
            return (i = i || Rt(t)) && ("" !== (r = i.getPropertyValue(e) || i[e]) || T.contains(t.ownerDocument, t) || (r = T.style(t, e)), !v.pixelBoxStyles() && Ht.test(r) && jt.test(e) && (n = a.width, s = a.minWidth, o = a.maxWidth, a.minWidth = a.maxWidth = a.width = r, r = i.width, a.width = n, a.minWidth = s, a.maxWidth = o)), void 0 !== r ? r + "" : r
        }
  
        function Bt(t, e) {
            return {
                get: function() {
                    if (!t()) return (this.get = e).apply(this, arguments);
                    delete this.get
                }
            }
        }! function() {
            function t() {
                if (c) {
                    h.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0", c.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%", bt.appendChild(h).appendChild(c);
                    var t = i.getComputedStyle(c);
                    n = "1%" !== t.top, l = 12 === e(t.marginLeft), c.style.right = "60%", a = 36 === e(t.right), s = 36 === e(t.width), c.style.position = "absolute", o = 36 === c.offsetWidth || "absolute", bt.removeChild(h), c = null
                }
            }
  
            function e(t) {
                return Math.round(parseFloat(t))
            }
            var n, s, o, a, l, h = r.createElement("div"),
                c = r.createElement("div");
            c.style && (c.style.backgroundClip = "content-box", c.cloneNode(!0).style.backgroundClip = "", v.clearCloneStyle = "content-box" === c.style.backgroundClip, T.extend(v, {
                boxSizingReliable: function() {
                    return t(), s
                },
                pixelBoxStyles: function() {
                    return t(), a
                },
                pixelPosition: function() {
                    return t(), n
                },
                reliableMarginLeft: function() {
                    return t(), l
                },
                scrollboxSize: function() {
                    return t(), o
                }
            }))
        }();
        var Vt = /^(none|table(?!-c[ea]).+)/,
            qt = /^--/,
            Gt = {
                position: "absolute",
                visibility: "hidden",
                display: "block"
            },
            Ut = {
                letterSpacing: "0",
                fontWeight: "400"
            },
            Yt = ["Webkit", "Moz", "ms"],
            Xt = r.createElement("div").style;
  
        function Kt(t) {
            var e = T.cssProps[t];
            return e || (e = T.cssProps[t] = function(t) {
                if (t in Xt) return t;
                for (var e = t[0].toUpperCase() + t.slice(1), i = Yt.length; i--;)
                    if ((t = Yt[i] + e) in Xt) return t
            }(t) || t), e
        }
  
        function Qt(t, e, i) {
            var n = st.exec(e);
            return n ? Math.max(0, n[2] - (i || 0)) + (n[3] || "px") : e
        }
  
        function Zt(t, e, i, n, s, o) {
            var r = "width" === e ? 1 : 0,
                a = 0,
                l = 0;
            if (i === (n ? "border" : "content")) return 0;
            for (; r < 4; r += 2) "margin" === i && (l += T.css(t, i + ot[r], !0, s)), n ? ("content" === i && (l -= T.css(t, "padding" + ot[r], !0, s)), "margin" !== i && (l -= T.css(t, "border" + ot[r] + "Width", !0, s))) : (l += T.css(t, "padding" + ot[r], !0, s), "padding" !== i ? l += T.css(t, "border" + ot[r] + "Width", !0, s) : a += T.css(t, "border" + ot[r] + "Width", !0, s));
            return !n && o >= 0 && (l += Math.max(0, Math.ceil(t["offset" + e[0].toUpperCase() + e.slice(1)] - o - l - a - .5))), l
        }
  
        function Jt(t, e, i) {
            var n = Rt(t),
                s = Wt(t, e, n),
                o = "border-box" === T.css(t, "boxSizing", !1, n),
                r = o;
            if (Ht.test(s)) {
                if (!i) return s;
                s = "auto"
            }
            return r = r && (v.boxSizingReliable() || s === t.style[e]), ("auto" === s || !parseFloat(s) && "inline" === T.css(t, "display", !1, n)) && (s = t["offset" + e[0].toUpperCase() + e.slice(1)], r = !0), (s = parseFloat(s) || 0) + Zt(t, e, i || (o ? "border" : "content"), r, n, s) + "px"
        }
  
        function te(t, e, i, n, s) {
            return new te.prototype.init(t, e, i, n, s)
        }
        T.extend({
            cssHooks: {
                opacity: {
                    get: function(t, e) {
                        if (e) {
                            var i = Wt(t, "opacity");
                            return "" === i ? "1" : i
                        }
                    }
                }
            },
            cssNumber: {
                animationIterationCount: !0,
                columnCount: !0,
                fillOpacity: !0,
                flexGrow: !0,
                flexShrink: !0,
                fontWeight: !0,
                lineHeight: !0,
                opacity: !0,
                order: !0,
                orphans: !0,
                widows: !0,
                zIndex: !0,
                zoom: !0
            },
            cssProps: {},
            style: function(t, e, i, n) {
                if (t && 3 !== t.nodeType && 8 !== t.nodeType && t.style) {
                    var s, o, r, a = X(e),
                        l = qt.test(e),
                        h = t.style;
                    if (l || (e = Kt(a)), r = T.cssHooks[e] || T.cssHooks[a], void 0 === i) return r && "get" in r && void 0 !== (s = r.get(t, !1, n)) ? s : h[e];
                    "string" === (o = typeof i) && (s = st.exec(i)) && s[1] && (i = lt(t, e, s), o = "number"), null != i && i == i && ("number" === o && (i += s && s[3] || (T.cssNumber[a] ? "" : "px")), v.clearCloneStyle || "" !== i || 0 !== e.indexOf("background") || (h[e] = "inherit"), r && "set" in r && void 0 === (i = r.set(t, i, n)) || (l ? h.setProperty(e, i) : h[e] = i))
                }
            },
            css: function(t, e, i, n) {
                var s, o, r, a = X(e);
                return qt.test(e) || (e = Kt(a)), (r = T.cssHooks[e] || T.cssHooks[a]) && "get" in r && (s = r.get(t, !0, i)), void 0 === s && (s = Wt(t, e, n)), "normal" === s && e in Ut && (s = Ut[e]), "" === i || i ? (o = parseFloat(s), !0 === i || isFinite(o) ? o || 0 : s) : s
            }
        }), T.each(["height", "width"], function(t, e) {
            T.cssHooks[e] = {
                get: function(t, i, n) {
                    if (i) return !Vt.test(T.css(t, "display")) || t.getClientRects().length && t.getBoundingClientRect().width ? Jt(t, e, n) : at(t, Gt, function() {
                        return Jt(t, e, n)
                    })
                },
                set: function(t, i, n) {
                    var s, o = Rt(t),
                        r = "border-box" === T.css(t, "boxSizing", !1, o),
                        a = n && Zt(t, e, n, r, o);
                    return r && v.scrollboxSize() === o.position && (a -= Math.ceil(t["offset" + e[0].toUpperCase() + e.slice(1)] - parseFloat(o[e]) - Zt(t, e, "border", !1, o) - .5)), a && (s = st.exec(i)) && "px" !== (s[3] || "px") && (t.style[e] = i, i = T.css(t, e)), Qt(0, i, a)
                }
            }
        }), T.cssHooks.marginLeft = Bt(v.reliableMarginLeft, function(t, e) {
            if (e) return (parseFloat(Wt(t, "marginLeft")) || t.getBoundingClientRect().left - at(t, {
                marginLeft: 0
            }, function() {
                return t.getBoundingClientRect().left
            })) + "px"
        }), T.each({
            margin: "",
            padding: "",
            border: "Width"
        }, function(t, e) {
            T.cssHooks[t + e] = {
                expand: function(i) {
                    for (var n = 0, s = {}, o = "string" == typeof i ? i.split(" ") : [i]; n < 4; n++) s[t + ot[n] + e] = o[n] || o[n - 2] || o[0];
                    return s
                }
            }, "margin" !== t && (T.cssHooks[t + e].set = Qt)
        }), T.fn.extend({
            css: function(t, e) {
                return q(this, function(t, e, i) {
                    var n, s, o = {},
                        r = 0;
                    if (Array.isArray(e)) {
                        for (n = Rt(t), s = e.length; r < s; r++) o[e[r]] = T.css(t, e[r], !1, n);
                        return o
                    }
                    return void 0 !== i ? T.style(t, e, i) : T.css(t, e)
                }, t, e, arguments.length > 1)
            }
        }), T.Tween = te, te.prototype = {
            constructor: te,
            init: function(t, e, i, n, s, o) {
                this.elem = t, this.prop = i, this.easing = s || T.easing._default, this.options = e, this.start = this.now = this.cur(), this.end = n, this.unit = o || (T.cssNumber[i] ? "" : "px")
            },
            cur: function() {
                var t = te.propHooks[this.prop];
                return t && t.get ? t.get(this) : te.propHooks._default.get(this)
            },
            run: function(t) {
                var e, i = te.propHooks[this.prop];
                return this.options.duration ? this.pos = e = T.easing[this.easing](t, this.options.duration * t, 0, 1, this.options.duration) : this.pos = e = t, this.now = (this.end - this.start) * e + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), i && i.set ? i.set(this) : te.propHooks._default.set(this), this
            }
        }, te.prototype.init.prototype = te.prototype, te.propHooks = {
            _default: {
                get: function(t) {
                    var e;
                    return 1 !== t.elem.nodeType || null != t.elem[t.prop] && null == t.elem.style[t.prop] ? t.elem[t.prop] : (e = T.css(t.elem, t.prop, "")) && "auto" !== e ? e : 0
                },
                set: function(t) {
                    T.fx.step[t.prop] ? T.fx.step[t.prop](t) : 1 !== t.elem.nodeType || null == t.elem.style[T.cssProps[t.prop]] && !T.cssHooks[t.prop] ? t.elem[t.prop] = t.now : T.style(t.elem, t.prop, t.now + t.unit)
                }
            }
        }, te.propHooks.scrollTop = te.propHooks.scrollLeft = {
            set: function(t) {
                t.elem.nodeType && t.elem.parentNode && (t.elem[t.prop] = t.now)
            }
        }, T.easing = {
            linear: function(t) {
                return t
            },
            swing: function(t) {
                return .5 - Math.cos(t * Math.PI) / 2
            },
            _default: "swing"
        }, T.fx = te.prototype.init, T.fx.step = {};
        var ee, ie, ne = /^(?:toggle|show|hide)$/,
            se = /queueHooks$/;
  
        function oe() {
            ie && (!1 === r.hidden && i.requestAnimationFrame ? i.requestAnimationFrame(oe) : i.setTimeout(oe, T.fx.interval), T.fx.tick())
        }
  
        function re() {
            return i.setTimeout(function() {
                ee = void 0
            }), ee = Date.now()
        }
  
        function ae(t, e) {
            var i, n = 0,
                s = {
                    height: t
                };
            for (e = e ? 1 : 0; n < 4; n += 2 - e) s["margin" + (i = ot[n])] = s["padding" + i] = t;
            return e && (s.opacity = s.width = t), s
        }
  
        function le(t, e, i) {
            for (var n, s = (he.tweeners[e] || []).concat(he.tweeners["*"]), o = 0, r = s.length; o < r; o++)
                if (n = s[o].call(i, e, t)) return n
        }
  
        function he(t, e, i) {
            var n, s, o = 0,
                r = he.prefilters.length,
                a = T.Deferred().always(function() {
                    delete l.elem
                }),
                l = function() {
                    if (s) return !1;
                    for (var e = ee || re(), i = Math.max(0, h.startTime + h.duration - e), n = 1 - (i / h.duration || 0), o = 0, r = h.tweens.length; o < r; o++) h.tweens[o].run(n);
                    return a.notifyWith(t, [h, n, i]), n < 1 && r ? i : (r || a.notifyWith(t, [h, 1, 0]), a.resolveWith(t, [h]), !1)
                },
                h = a.promise({
                    elem: t,
                    props: T.extend({}, e),
                    opts: T.extend(!0, {
                        specialEasing: {},
                        easing: T.easing._default
                    }, i),
                    originalProperties: e,
                    originalOptions: i,
                    startTime: ee || re(),
                    duration: i.duration,
                    tweens: [],
                    createTween: function(e, i) {
                        var n = T.Tween(t, h.opts, e, i, h.opts.specialEasing[e] || h.opts.easing);
                        return h.tweens.push(n), n
                    },
                    stop: function(e) {
                        var i = 0,
                            n = e ? h.tweens.length : 0;
                        if (s) return this;
                        for (s = !0; i < n; i++) h.tweens[i].run(1);
                        return e ? (a.notifyWith(t, [h, 1, 0]), a.resolveWith(t, [h, e])) : a.rejectWith(t, [h, e]), this
                    }
                }),
                c = h.props;
            for (! function(t, e) {
                    var i, n, s, o, r;
                    for (i in t)
                        if (s = e[n = X(i)], o = t[i], Array.isArray(o) && (s = o[1], o = t[i] = o[0]), i !== n && (t[n] = o, delete t[i]), (r = T.cssHooks[n]) && "expand" in r)
                            for (i in o = r.expand(o), delete t[n], o) i in t || (t[i] = o[i], e[i] = s);
                        else e[n] = s
                }(c, h.opts.specialEasing); o < r; o++)
                if (n = he.prefilters[o].call(h, t, c, h.opts)) return y(n.stop) && (T._queueHooks(h.elem, h.opts.queue).stop = n.stop.bind(n)), n;
            return T.map(c, le, h), y(h.opts.start) && h.opts.start.call(t, h), h.progress(h.opts.progress).done(h.opts.done, h.opts.complete).fail(h.opts.fail).always(h.opts.always), T.fx.timer(T.extend(l, {
                elem: t,
                anim: h,
                queue: h.opts.queue
            })), h
        }
        T.Animation = T.extend(he, {
                tweeners: {
                    "*": [function(t, e) {
                        var i = this.createTween(t, e);
                        return lt(i.elem, t, st.exec(e), i), i
                    }]
                },
                tweener: function(t, e) {
                    y(t) ? (e = t, t = ["*"]) : t = t.match(F);
                    for (var i, n = 0, s = t.length; n < s; n++) i = t[n], he.tweeners[i] = he.tweeners[i] || [], he.tweeners[i].unshift(e)
                },
                prefilters: [function(t, e, i) {
                    var n, s, o, r, a, l, h, c, d = "width" in e || "height" in e,
                        u = this,
                        p = {},
                        f = t.style,
                        m = t.nodeType && rt(t),
                        g = Z.get(t, "fxshow");
                    for (n in i.queue || (null == (r = T._queueHooks(t, "fx")).unqueued && (r.unqueued = 0, a = r.empty.fire, r.empty.fire = function() {
                            r.unqueued || a()
                        }), r.unqueued++, u.always(function() {
                            u.always(function() {
                                r.unqueued--, T.queue(t, "fx").length || r.empty.fire()
                            })
                        })), e)
                        if (s = e[n], ne.test(s)) {
                            if (delete e[n], o = o || "toggle" === s, s === (m ? "hide" : "show")) {
                                if ("show" !== s || !g || void 0 === g[n]) continue;
                                m = !0
                            }
                            p[n] = g && g[n] || T.style(t, n)
                        } if ((l = !T.isEmptyObject(e)) || !T.isEmptyObject(p))
                        for (n in d && 1 === t.nodeType && (i.overflow = [f.overflow, f.overflowX, f.overflowY], null == (h = g && g.display) && (h = Z.get(t, "display")), "none" === (c = T.css(t, "display")) && (h ? c = h : (dt([t], !0), h = t.style.display || h, c = T.css(t, "display"), dt([t]))), ("inline" === c || "inline-block" === c && null != h) && "none" === T.css(t, "float") && (l || (u.done(function() {
                                f.display = h
                            }), null == h && (c = f.display, h = "none" === c ? "" : c)), f.display = "inline-block")), i.overflow && (f.overflow = "hidden", u.always(function() {
                                f.overflow = i.overflow[0], f.overflowX = i.overflow[1], f.overflowY = i.overflow[2]
                            })), l = !1, p) l || (g ? "hidden" in g && (m = g.hidden) : g = Z.access(t, "fxshow", {
                            display: h
                        }), o && (g.hidden = !m), m && dt([t], !0), u.done(function() {
                            for (n in m || dt([t]), Z.remove(t, "fxshow"), p) T.style(t, n, p[n])
                        })), l = le(m ? g[n] : 0, n, u), n in g || (g[n] = l.start, m && (l.end = l.start, l.start = 0))
                }],
                prefilter: function(t, e) {
                    e ? he.prefilters.unshift(t) : he.prefilters.push(t)
                }
            }), T.speed = function(t, e, i) {
                var n = t && "object" == typeof t ? T.extend({}, t) : {
                    complete: i || !i && e || y(t) && t,
                    duration: t,
                    easing: i && e || e && !y(e) && e
                };
                return T.fx.off ? n.duration = 0 : "number" != typeof n.duration && (n.duration in T.fx.speeds ? n.duration = T.fx.speeds[n.duration] : n.duration = T.fx.speeds._default), null != n.queue && !0 !== n.queue || (n.queue = "fx"), n.old = n.complete, n.complete = function() {
                    y(n.old) && n.old.call(this), n.queue && T.dequeue(this, n.queue)
                }, n
            }, T.fn.extend({
                fadeTo: function(t, e, i, n) {
                    return this.filter(rt).css("opacity", 0).show().end().animate({
                        opacity: e
                    }, t, i, n)
                },
                animate: function(t, e, i, n) {
                    var s = T.isEmptyObject(t),
                        o = T.speed(e, i, n),
                        r = function() {
                            var e = he(this, T.extend({}, t), o);
                            (s || Z.get(this, "finish")) && e.stop(!0)
                        };
                    return r.finish = r, s || !1 === o.queue ? this.each(r) : this.queue(o.queue, r)
                },
                stop: function(t, e, i) {
                    var n = function(t) {
                        var e = t.stop;
                        delete t.stop, e(i)
                    };
                    return "string" != typeof t && (i = e, e = t, t = void 0), e && !1 !== t && this.queue(t || "fx", []), this.each(function() {
                        var e = !0,
                            s = null != t && t + "queueHooks",
                            o = T.timers,
                            r = Z.get(this);
                        if (s) r[s] && r[s].stop && n(r[s]);
                        else
                            for (s in r) r[s] && r[s].stop && se.test(s) && n(r[s]);
                        for (s = o.length; s--;) o[s].elem !== this || null != t && o[s].queue !== t || (o[s].anim.stop(i), e = !1, o.splice(s, 1));
                        !e && i || T.dequeue(this, t)
                    })
                },
                finish: function(t) {
                    return !1 !== t && (t = t || "fx"), this.each(function() {
                        var e, i = Z.get(this),
                            n = i[t + "queue"],
                            s = i[t + "queueHooks"],
                            o = T.timers,
                            r = n ? n.length : 0;
                        for (i.finish = !0, T.queue(this, t, []), s && s.stop && s.stop.call(this, !0), e = o.length; e--;) o[e].elem === this && o[e].queue === t && (o[e].anim.stop(!0), o.splice(e, 1));
                        for (e = 0; e < r; e++) n[e] && n[e].finish && n[e].finish.call(this);
                        delete i.finish
                    })
                }
            }), T.each(["toggle", "show", "hide"], function(t, e) {
                var i = T.fn[e];
                T.fn[e] = function(t, n, s) {
                    return null == t || "boolean" == typeof t ? i.apply(this, arguments) : this.animate(ae(e, !0), t, n, s)
                }
            }), T.each({
                slideDown: ae("show"),
                slideUp: ae("hide"),
                slideToggle: ae("toggle"),
                fadeIn: {
                    opacity: "show"
                },
                fadeOut: {
                    opacity: "hide"
                },
                fadeToggle: {
                    opacity: "toggle"
                }
            }, function(t, e) {
                T.fn[t] = function(t, i, n) {
                    return this.animate(e, t, i, n)
                }
            }), T.timers = [], T.fx.tick = function() {
                var t, e = 0,
                    i = T.timers;
                for (ee = Date.now(); e < i.length; e++)(t = i[e])() || i[e] !== t || i.splice(e--, 1);
                i.length || T.fx.stop(), ee = void 0
            }, T.fx.timer = function(t) {
                T.timers.push(t), T.fx.start()
            }, T.fx.interval = 13, T.fx.start = function() {
                ie || (ie = !0, oe())
            }, T.fx.stop = function() {
                ie = null
            }, T.fx.speeds = {
                slow: 600,
                fast: 200,
                _default: 400
            }, T.fn.delay = function(t, e) {
                return t = T.fx && T.fx.speeds[t] || t, e = e || "fx", this.queue(e, function(e, n) {
                    var s = i.setTimeout(e, t);
                    n.stop = function() {
                        i.clearTimeout(s)
                    }
                })
            },
            function() {
                var t = r.createElement("input"),
                    e = r.createElement("select").appendChild(r.createElement("option"));
                t.type = "checkbox", v.checkOn = "" !== t.value, v.optSelected = e.selected, (t = r.createElement("input")).value = "t", t.type = "radio", v.radioValue = "t" === t.value
            }();
        var ce, de = T.expr.attrHandle;
        T.fn.extend({
            attr: function(t, e) {
                return q(this, T.attr, t, e, arguments.length > 1)
            },
            removeAttr: function(t) {
                return this.each(function() {
                    T.removeAttr(this, t)
                })
            }
        }), T.extend({
            attr: function(t, e, i) {
                var n, s, o = t.nodeType;
                if (3 !== o && 8 !== o && 2 !== o) return void 0 === t.getAttribute ? T.prop(t, e, i) : (1 === o && T.isXMLDoc(t) || (s = T.attrHooks[e.toLowerCase()] || (T.expr.match.bool.test(e) ? ce : void 0)), void 0 !== i ? null === i ? void T.removeAttr(t, e) : s && "set" in s && void 0 !== (n = s.set(t, i, e)) ? n : (t.setAttribute(e, i + ""), i) : s && "get" in s && null !== (n = s.get(t, e)) ? n : null == (n = T.find.attr(t, e)) ? void 0 : n)
            },
            attrHooks: {
                type: {
                    set: function(t, e) {
                        if (!v.radioValue && "radio" === e && O(t, "input")) {
                            var i = t.value;
                            return t.setAttribute("type", e), i && (t.value = i), e
                        }
                    }
                }
            },
            removeAttr: function(t, e) {
                var i, n = 0,
                    s = e && e.match(F);
                if (s && 1 === t.nodeType)
                    for (; i = s[n++];) t.removeAttribute(i)
            }
        }), ce = {
            set: function(t, e, i) {
                return !1 === e ? T.removeAttr(t, i) : t.setAttribute(i, i), i
            }
        }, T.each(T.expr.match.bool.source.match(/\w+/g), function(t, e) {
            var i = de[e] || T.find.attr;
            de[e] = function(t, e, n) {
                var s, o, r = e.toLowerCase();
                return n || (o = de[r], de[r] = s, s = null != i(t, e, n) ? r : null, de[r] = o), s
            }
        });
        var ue = /^(?:input|select|textarea|button)$/i,
            pe = /^(?:a|area)$/i;
  
        function fe(t) {
            return (t.match(F) || []).join(" ")
        }
  
        function me(t) {
            return t.getAttribute && t.getAttribute("class") || ""
        }
  
        function ge(t) {
            return Array.isArray(t) ? t : "string" == typeof t && t.match(F) || []
        }
        T.fn.extend({
            prop: function(t, e) {
                return q(this, T.prop, t, e, arguments.length > 1)
            },
            removeProp: function(t) {
                return this.each(function() {
                    delete this[T.propFix[t] || t]
                })
            }
        }), T.extend({
            prop: function(t, e, i) {
                var n, s, o = t.nodeType;
                if (3 !== o && 8 !== o && 2 !== o) return 1 === o && T.isXMLDoc(t) || (e = T.propFix[e] || e, s = T.propHooks[e]), void 0 !== i ? s && "set" in s && void 0 !== (n = s.set(t, i, e)) ? n : t[e] = i : s && "get" in s && null !== (n = s.get(t, e)) ? n : t[e]
            },
            propHooks: {
                tabIndex: {
                    get: function(t) {
                        var e = T.find.attr(t, "tabindex");
                        return e ? parseInt(e, 10) : ue.test(t.nodeName) || pe.test(t.nodeName) && t.href ? 0 : -1
                    }
                }
            },
            propFix: {
                for: "htmlFor",
                class: "className"
            }
        }), v.optSelected || (T.propHooks.selected = {
            get: function(t) {
                var e = t.parentNode;
                return e && e.parentNode && e.parentNode.selectedIndex, null
            },
            set: function(t) {
                var e = t.parentNode;
                e && (e.selectedIndex, e.parentNode && e.parentNode.selectedIndex)
            }
        }), T.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function() {
            T.propFix[this.toLowerCase()] = this
        }), T.fn.extend({
            addClass: function(t) {
                var e, i, n, s, o, r, a, l = 0;
                if (y(t)) return this.each(function(e) {
                    T(this).addClass(t.call(this, e, me(this)))
                });
                if ((e = ge(t)).length)
                    for (; i = this[l++];)
                        if (s = me(i), n = 1 === i.nodeType && " " + fe(s) + " ") {
                            for (r = 0; o = e[r++];) n.indexOf(" " + o + " ") < 0 && (n += o + " ");
                            s !== (a = fe(n)) && i.setAttribute("class", a)
                        } return this
            },
            removeClass: function(t) {
                var e, i, n, s, o, r, a, l = 0;
                if (y(t)) return this.each(function(e) {
                    T(this).removeClass(t.call(this, e, me(this)))
                });
                if (!arguments.length) return this.attr("class", "");
                if ((e = ge(t)).length)
                    for (; i = this[l++];)
                        if (s = me(i), n = 1 === i.nodeType && " " + fe(s) + " ") {
                            for (r = 0; o = e[r++];)
                                for (; n.indexOf(" " + o + " ") > -1;) n = n.replace(" " + o + " ", " ");
                            s !== (a = fe(n)) && i.setAttribute("class", a)
                        } return this
            },
            toggleClass: function(t, e) {
                var i = typeof t,
                    n = "string" === i || Array.isArray(t);
                return "boolean" == typeof e && n ? e ? this.addClass(t) : this.removeClass(t) : y(t) ? this.each(function(i) {
                    T(this).toggleClass(t.call(this, i, me(this), e), e)
                }) : this.each(function() {
                    var e, s, o, r;
                    if (n)
                        for (s = 0, o = T(this), r = ge(t); e = r[s++];) o.hasClass(e) ? o.removeClass(e) : o.addClass(e);
                    else void 0 !== t && "boolean" !== i || ((e = me(this)) && Z.set(this, "__className__", e), this.setAttribute && this.setAttribute("class", e || !1 === t ? "" : Z.get(this, "__className__") || ""))
                })
            },
            hasClass: function(t) {
                var e, i, n = 0;
                for (e = " " + t + " "; i = this[n++];)
                    if (1 === i.nodeType && (" " + fe(me(i)) + " ").indexOf(e) > -1) return !0;
                return !1
            }
        });
        var ve = /\r/g;
        T.fn.extend({
            val: function(t) {
                var e, i, n, s = this[0];
                return arguments.length ? (n = y(t), this.each(function(i) {
                    var s;
                    1 === this.nodeType && (null == (s = n ? t.call(this, i, T(this).val()) : t) ? s = "" : "number" == typeof s ? s += "" : Array.isArray(s) && (s = T.map(s, function(t) {
                        return null == t ? "" : t + ""
                    })), (e = T.valHooks[this.type] || T.valHooks[this.nodeName.toLowerCase()]) && "set" in e && void 0 !== e.set(this, s, "value") || (this.value = s))
                })) : s ? (e = T.valHooks[s.type] || T.valHooks[s.nodeName.toLowerCase()]) && "get" in e && void 0 !== (i = e.get(s, "value")) ? i : "string" == typeof(i = s.value) ? i.replace(ve, "") : null == i ? "" : i : void 0
            }
        }), T.extend({
            valHooks: {
                option: {
                    get: function(t) {
                        var e = T.find.attr(t, "value");
                        return null != e ? e : fe(T.text(t))
                    }
                },
                select: {
                    get: function(t) {
                        var e, i, n, s = t.options,
                            o = t.selectedIndex,
                            r = "select-one" === t.type,
                            a = r ? null : [],
                            l = r ? o + 1 : s.length;
                        for (n = o < 0 ? l : r ? o : 0; n < l; n++)
                            if (((i = s[n]).selected || n === o) && !i.disabled && (!i.parentNode.disabled || !O(i.parentNode, "optgroup"))) {
                                if (e = T(i).val(), r) return e;
                                a.push(e)
                            } return a
                    },
                    set: function(t, e) {
                        for (var i, n, s = t.options, o = T.makeArray(e), r = s.length; r--;)((n = s[r]).selected = T.inArray(T.valHooks.option.get(n), o) > -1) && (i = !0);
                        return i || (t.selectedIndex = -1), o
                    }
                }
            }
        }), T.each(["radio", "checkbox"], function() {
            T.valHooks[this] = {
                set: function(t, e) {
                    if (Array.isArray(e)) return t.checked = T.inArray(T(t).val(), e) > -1
                }
            }, v.checkOn || (T.valHooks[this].get = function(t) {
                return null === t.getAttribute("value") ? "on" : t.value
            })
        }), v.focusin = "onfocusin" in i;
        var ye = /^(?:focusinfocus|focusoutblur)$/,
            _e = function(t) {
                t.stopPropagation()
            };
        T.extend(T.event, {
            trigger: function(t, e, n, s) {
                var o, a, l, h, c, d, u, p, m = [n || r],
                    g = f.call(t, "type") ? t.type : t,
                    v = f.call(t, "namespace") ? t.namespace.split(".") : [];
                if (a = p = l = n = n || r, 3 !== n.nodeType && 8 !== n.nodeType && !ye.test(g + T.event.triggered) && (g.indexOf(".") > -1 && (g = (v = g.split(".")).shift(), v.sort()), c = g.indexOf(":") < 0 && "on" + g, (t = t[T.expando] ? t : new T.Event(g, "object" == typeof t && t)).isTrigger = s ? 2 : 3, t.namespace = v.join("."), t.rnamespace = t.namespace ? new RegExp("(^|\\.)" + v.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, t.result = void 0, t.target || (t.target = n), e = null == e ? [t] : T.makeArray(e, [t]), u = T.event.special[g] || {}, s || !u.trigger || !1 !== u.trigger.apply(n, e))) {
                    if (!s && !u.noBubble && !_(n)) {
                        for (h = u.delegateType || g, ye.test(h + g) || (a = a.parentNode); a; a = a.parentNode) m.push(a), l = a;
                        l === (n.ownerDocument || r) && m.push(l.defaultView || l.parentWindow || i)
                    }
                    for (o = 0;
                        (a = m[o++]) && !t.isPropagationStopped();) p = a, t.type = o > 1 ? h : u.bindType || g, (d = (Z.get(a, "events") || {})[t.type] && Z.get(a, "handle")) && d.apply(a, e), (d = c && a[c]) && d.apply && K(a) && (t.result = d.apply(a, e), !1 === t.result && t.preventDefault());
                    return t.type = g, s || t.isDefaultPrevented() || u._default && !1 !== u._default.apply(m.pop(), e) || !K(n) || c && y(n[g]) && !_(n) && ((l = n[c]) && (n[c] = null), T.event.triggered = g, t.isPropagationStopped() && p.addEventListener(g, _e), n[g](), t.isPropagationStopped() && p.removeEventListener(g, _e), T.event.triggered = void 0, l && (n[c] = l)), t.result
                }
            },
            simulate: function(t, e, i) {
                var n = T.extend(new T.Event, i, {
                    type: t,
                    isSimulated: !0
                });
                T.event.trigger(n, null, e)
            }
        }), T.fn.extend({
            trigger: function(t, e) {
                return this.each(function() {
                    T.event.trigger(t, e, this)
                })
            },
            triggerHandler: function(t, e) {
                var i = this[0];
                if (i) return T.event.trigger(t, e, i, !0)
            }
        }), v.focusin || T.each({
            focus: "focusin",
            blur: "focusout"
        }, function(t, e) {
            var i = function(t) {
                T.event.simulate(e, t.target, T.event.fix(t))
            };
            T.event.special[e] = {
                setup: function() {
                    var n = this.ownerDocument || this,
                        s = Z.access(n, e);
                    s || n.addEventListener(t, i, !0), Z.access(n, e, (s || 0) + 1)
                },
                teardown: function() {
                    var n = this.ownerDocument || this,
                        s = Z.access(n, e) - 1;
                    s ? Z.access(n, e, s) : (n.removeEventListener(t, i, !0), Z.remove(n, e))
                }
            }
        });
        var be = i.location,
            we = Date.now(),
            xe = /\?/;
        T.parseXML = function(t) {
            var e;
            if (!t || "string" != typeof t) return null;
            try {
                e = (new i.DOMParser).parseFromString(t, "text/xml")
            } catch (t) {
                e = void 0
            }
            return e && !e.getElementsByTagName("parsererror").length || T.error("Invalid XML: " + t), e
        };
        var Te = /\[\]$/,
            Ee = /\r?\n/g,
            Ce = /^(?:submit|button|image|reset|file)$/i,
            Se = /^(?:input|select|textarea|keygen)/i;
  
        function De(t, e, i, n) {
            var s;
            if (Array.isArray(e)) T.each(e, function(e, s) {
                i || Te.test(t) ? n(t, s) : De(t + "[" + ("object" == typeof s && null != s ? e : "") + "]", s, i, n)
            });
            else if (i || "object" !== x(e)) n(t, e);
            else
                for (s in e) De(t + "[" + s + "]", e[s], i, n)
        }
        T.param = function(t, e) {
            var i, n = [],
                s = function(t, e) {
                    var i = y(e) ? e() : e;
                    n[n.length] = encodeURIComponent(t) + "=" + encodeURIComponent(null == i ? "" : i)
                };
            if (Array.isArray(t) || t.jquery && !T.isPlainObject(t)) T.each(t, function() {
                s(this.name, this.value)
            });
            else
                for (i in t) De(i, t[i], e, s);
            return n.join("&")
        }, T.fn.extend({
            serialize: function() {
                return T.param(this.serializeArray())
            },
            serializeArray: function() {
                return this.map(function() {
                    var t = T.prop(this, "elements");
                    return t ? T.makeArray(t) : this
                }).filter(function() {
                    var t = this.type;
                    return this.name && !T(this).is(":disabled") && Se.test(this.nodeName) && !Ce.test(t) && (this.checked || !ut.test(t))
                }).map(function(t, e) {
                    var i = T(this).val();
                    return null == i ? null : Array.isArray(i) ? T.map(i, function(t) {
                        return {
                            name: e.name,
                            value: t.replace(Ee, "\r\n")
                        }
                    }) : {
                        name: e.name,
                        value: i.replace(Ee, "\r\n")
                    }
                }).get()
            }
        });
        var Ie = /%20/g,
            Me = /#.*$/,
            Oe = /([?&])_=[^&]*/,
            ke = /^(.*?):[ \t]*([^\r\n]*)$/gm,
            Ae = /^(?:GET|HEAD)$/,
            Pe = /^\/\//,
            $e = {},
            Le = {},
            Ne = "*/".concat("*"),
            ze = r.createElement("a");
  
        function Fe(t) {
            return function(e, i) {
                "string" != typeof e && (i = e, e = "*");
                var n, s = 0,
                    o = e.toLowerCase().match(F) || [];
                if (y(i))
                    for (; n = o[s++];) "+" === n[0] ? (n = n.slice(1) || "*", (t[n] = t[n] || []).unshift(i)) : (t[n] = t[n] || []).push(i)
            }
        }
  
        function He(t, e, i, n) {
            var s = {},
                o = t === Le;
  
            function r(a) {
                var l;
                return s[a] = !0, T.each(t[a] || [], function(t, a) {
                    var h = a(e, i, n);
                    return "string" != typeof h || o || s[h] ? o ? !(l = h) : void 0 : (e.dataTypes.unshift(h), r(h), !1)
                }), l
            }
            return r(e.dataTypes[0]) || !s["*"] && r("*")
        }
  
        function Re(t, e) {
            var i, n, s = T.ajaxSettings.flatOptions || {};
            for (i in e) void 0 !== e[i] && ((s[i] ? t : n || (n = {}))[i] = e[i]);
            return n && T.extend(!0, t, n), t
        }
        ze.href = be.href, T.extend({
            active: 0,
            lastModified: {},
            etag: {},
            ajaxSettings: {
                url: be.href,
                type: "GET",
                isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(be.protocol),
                global: !0,
                processData: !0,
                async: !0,
                contentType: "application/x-www-form-urlencoded; charset=UTF-8",
                accepts: {
                    "*": Ne,
                    text: "text/plain",
                    html: "text/html",
                    xml: "application/xml, text/xml",
                    json: "application/json, text/javascript"
                },
                contents: {
                    xml: /\bxml\b/,
                    html: /\bhtml/,
                    json: /\bjson\b/
                },
                responseFields: {
                    xml: "responseXML",
                    text: "responseText",
                    json: "responseJSON"
                },
                converters: {
                    "* text": String,
                    "text html": !0,
                    "text json": JSON.parse,
                    "text xml": T.parseXML
                },
                flatOptions: {
                    url: !0,
                    context: !0
                }
            },
            ajaxSetup: function(t, e) {
                return e ? Re(Re(t, T.ajaxSettings), e) : Re(T.ajaxSettings, t)
            },
            ajaxPrefilter: Fe($e),
            ajaxTransport: Fe(Le),
            ajax: function(t, e) {
                "object" == typeof t && (e = t, t = void 0), e = e || {};
                var n, s, o, a, l, h, c, d, u, p, f = T.ajaxSetup({}, e),
                    m = f.context || f,
                    g = f.context && (m.nodeType || m.jquery) ? T(m) : T.event,
                    v = T.Deferred(),
                    y = T.Callbacks("once memory"),
                    _ = f.statusCode || {},
                    b = {},
                    w = {},
                    x = "canceled",
                    E = {
                        readyState: 0,
                        getResponseHeader: function(t) {
                            var e;
                            if (c) {
                                if (!a)
                                    for (a = {}; e = ke.exec(o);) a[e[1].toLowerCase()] = e[2];
                                e = a[t.toLowerCase()]
                            }
                            return null == e ? null : e
                        },
                        getAllResponseHeaders: function() {
                            return c ? o : null
                        },
                        setRequestHeader: function(t, e) {
                            return null == c && (t = w[t.toLowerCase()] = w[t.toLowerCase()] || t, b[t] = e), this
                        },
                        overrideMimeType: function(t) {
                            return null == c && (f.mimeType = t), this
                        },
                        statusCode: function(t) {
                            var e;
                            if (t)
                                if (c) E.always(t[E.status]);
                                else
                                    for (e in t) _[e] = [_[e], t[e]];
                            return this
                        },
                        abort: function(t) {
                            var e = t || x;
                            return n && n.abort(e), C(0, e), this
                        }
                    };
                if (v.promise(E), f.url = ((t || f.url || be.href) + "").replace(Pe, be.protocol + "//"), f.type = e.method || e.type || f.method || f.type, f.dataTypes = (f.dataType || "*").toLowerCase().match(F) || [""], null == f.crossDomain) {
                    h = r.createElement("a");
                    try {
                        h.href = f.url, h.href = h.href, f.crossDomain = ze.protocol + "//" + ze.host != h.protocol + "//" + h.host
                    } catch (t) {
                        f.crossDomain = !0
                    }
                }
                if (f.data && f.processData && "string" != typeof f.data && (f.data = T.param(f.data, f.traditional)), He($e, f, e, E), c) return E;
                for (u in (d = T.event && f.global) && 0 == T.active++ && T.event.trigger("ajaxStart"), f.type = f.type.toUpperCase(), f.hasContent = !Ae.test(f.type), s = f.url.replace(Me, ""), f.hasContent ? f.data && f.processData && 0 === (f.contentType || "").indexOf("application/x-www-form-urlencoded") && (f.data = f.data.replace(Ie, "+")) : (p = f.url.slice(s.length), f.data && (f.processData || "string" == typeof f.data) && (s += (xe.test(s) ? "&" : "?") + f.data, delete f.data), !1 === f.cache && (s = s.replace(Oe, "$1"), p = (xe.test(s) ? "&" : "?") + "_=" + we++ + p), f.url = s + p), f.ifModified && (T.lastModified[s] && E.setRequestHeader("If-Modified-Since", T.lastModified[s]), T.etag[s] && E.setRequestHeader("If-None-Match", T.etag[s])), (f.data && f.hasContent && !1 !== f.contentType || e.contentType) && E.setRequestHeader("Content-Type", f.contentType), E.setRequestHeader("Accept", f.dataTypes[0] && f.accepts[f.dataTypes[0]] ? f.accepts[f.dataTypes[0]] + ("*" !== f.dataTypes[0] ? ", " + Ne + "; q=0.01" : "") : f.accepts["*"]), f.headers) E.setRequestHeader(u, f.headers[u]);
                if (f.beforeSend && (!1 === f.beforeSend.call(m, E, f) || c)) return E.abort();
                if (x = "abort", y.add(f.complete), E.done(f.success), E.fail(f.error), n = He(Le, f, e, E)) {
                    if (E.readyState = 1, d && g.trigger("ajaxSend", [E, f]), c) return E;
                    f.async && f.timeout > 0 && (l = i.setTimeout(function() {
                        E.abort("timeout")
                    }, f.timeout));
                    try {
                        c = !1, n.send(b, C)
                    } catch (t) {
                        if (c) throw t;
                        C(-1, t)
                    }
                } else C(-1, "No Transport");
  
                function C(t, e, r, a) {
                    var h, u, p, b, w, x = e;
                    c || (c = !0, l && i.clearTimeout(l), n = void 0, o = a || "", E.readyState = t > 0 ? 4 : 0, h = t >= 200 && t < 300 || 304 === t, r && (b = function(t, e, i) {
                        for (var n, s, o, r, a = t.contents, l = t.dataTypes;
                            "*" === l[0];) l.shift(), void 0 === n && (n = t.mimeType || e.getResponseHeader("Content-Type"));
                        if (n)
                            for (s in a)
                                if (a[s] && a[s].test(n)) {
                                    l.unshift(s);
                                    break
                                } if (l[0] in i) o = l[0];
                        else {
                            for (s in i) {
                                if (!l[0] || t.converters[s + " " + l[0]]) {
                                    o = s;
                                    break
                                }
                                r || (r = s)
                            }
                            o = o || r
                        }
                        if (o) return o !== l[0] && l.unshift(o), i[o]
                    }(f, E, r)), b = function(t, e, i, n) {
                        var s, o, r, a, l, h = {},
                            c = t.dataTypes.slice();
                        if (c[1])
                            for (r in t.converters) h[r.toLowerCase()] = t.converters[r];
                        for (o = c.shift(); o;)
                            if (t.responseFields[o] && (i[t.responseFields[o]] = e), !l && n && t.dataFilter && (e = t.dataFilter(e, t.dataType)), l = o, o = c.shift())
                                if ("*" === o) o = l;
                                else if ("*" !== l && l !== o) {
                            if (!(r = h[l + " " + o] || h["* " + o]))
                                for (s in h)
                                    if ((a = s.split(" "))[1] === o && (r = h[l + " " + a[0]] || h["* " + a[0]])) {
                                        !0 === r ? r = h[s] : !0 !== h[s] && (o = a[0], c.unshift(a[1]));
                                        break
                                    } if (!0 !== r)
                                if (r && t.throws) e = r(e);
                                else try {
                                    e = r(e)
                                } catch (t) {
                                    return {
                                        state: "parsererror",
                                        error: r ? t : "No conversion from " + l + " to " + o
                                    }
                                }
                        }
                        return {
                            state: "success",
                            data: e
                        }
                    }(f, b, E, h), h ? (f.ifModified && ((w = E.getResponseHeader("Last-Modified")) && (T.lastModified[s] = w), (w = E.getResponseHeader("etag")) && (T.etag[s] = w)), 204 === t || "HEAD" === f.type ? x = "nocontent" : 304 === t ? x = "notmodified" : (x = b.state, u = b.data, h = !(p = b.error))) : (p = x, !t && x || (x = "error", t < 0 && (t = 0))), E.status = t, E.statusText = (e || x) + "", h ? v.resolveWith(m, [u, x, E]) : v.rejectWith(m, [E, x, p]), E.statusCode(_), _ = void 0, d && g.trigger(h ? "ajaxSuccess" : "ajaxError", [E, f, h ? u : p]), y.fireWith(m, [E, x]), d && (g.trigger("ajaxComplete", [E, f]), --T.active || T.event.trigger("ajaxStop")))
                }
                return E
            },
            getJSON: function(t, e, i) {
                return T.get(t, e, i, "json")
            },
            getScript: function(t, e) {
                return T.get(t, void 0, e, "script")
            }
        }), T.each(["get", "post"], function(t, e) {
            T[e] = function(t, i, n, s) {
                return y(i) && (s = s || n, n = i, i = void 0), T.ajax(T.extend({
                    url: t,
                    type: e,
                    dataType: s,
                    data: i,
                    success: n
                }, T.isPlainObject(t) && t))
            }
        }), T._evalUrl = function(t) {
            return T.ajax({
                url: t,
                type: "GET",
                dataType: "script",
                cache: !0,
                async: !1,
                global: !1,
                throws: !0
            })
        }, T.fn.extend({
            wrapAll: function(t) {
                var e;
                return this[0] && (y(t) && (t = t.call(this[0])), e = T(t, this[0].ownerDocument).eq(0).clone(!0), this[0].parentNode && e.insertBefore(this[0]), e.map(function() {
                    for (var t = this; t.firstElementChild;) t = t.firstElementChild;
                    return t
                }).append(this)), this
            },
            wrapInner: function(t) {
                return y(t) ? this.each(function(e) {
                    T(this).wrapInner(t.call(this, e))
                }) : this.each(function() {
                    var e = T(this),
                        i = e.contents();
                    i.length ? i.wrapAll(t) : e.append(t)
                })
            },
            wrap: function(t) {
                var e = y(t);
                return this.each(function(i) {
                    T(this).wrapAll(e ? t.call(this, i) : t)
                })
            },
            unwrap: function(t) {
                return this.parent(t).not("body").each(function() {
                    T(this).replaceWith(this.childNodes)
                }), this
            }
        }), T.expr.pseudos.hidden = function(t) {
            return !T.expr.pseudos.visible(t)
        }, T.expr.pseudos.visible = function(t) {
            return !!(t.offsetWidth || t.offsetHeight || t.getClientRects().length)
        }, T.ajaxSettings.xhr = function() {
            try {
                return new i.XMLHttpRequest
            } catch (t) {}
        };
        var je = {
                0: 200,
                1223: 204
            },
            We = T.ajaxSettings.xhr();
        v.cors = !!We && "withCredentials" in We, v.ajax = We = !!We, T.ajaxTransport(function(t) {
            var e, n;
            if (v.cors || We && !t.crossDomain) return {
                send: function(s, o) {
                    var r, a = t.xhr();
                    if (a.open(t.type, t.url, t.async, t.username, t.password), t.xhrFields)
                        for (r in t.xhrFields) a[r] = t.xhrFields[r];
                    for (r in t.mimeType && a.overrideMimeType && a.overrideMimeType(t.mimeType), t.crossDomain || s["X-Requested-With"] || (s["X-Requested-With"] = "XMLHttpRequest"), s) a.setRequestHeader(r, s[r]);
                    e = function(t) {
                        return function() {
                            e && (e = n = a.onload = a.onerror = a.onabort = a.ontimeout = a.onreadystatechange = null, "abort" === t ? a.abort() : "error" === t ? "number" != typeof a.status ? o(0, "error") : o(a.status, a.statusText) : o(je[a.status] || a.status, a.statusText, "text" !== (a.responseType || "text") || "string" != typeof a.responseText ? {
                                binary: a.response
                            } : {
                                text: a.responseText
                            }, a.getAllResponseHeaders()))
                        }
                    }, a.onload = e(), n = a.onerror = a.ontimeout = e("error"), void 0 !== a.onabort ? a.onabort = n : a.onreadystatechange = function() {
                        4 === a.readyState && i.setTimeout(function() {
                            e && n()
                        })
                    }, e = e("abort");
                    try {
                        a.send(t.hasContent && t.data || null)
                    } catch (t) {
                        if (e) throw t
                    }
                },
                abort: function() {
                    e && e()
                }
            }
        }), T.ajaxPrefilter(function(t) {
            t.crossDomain && (t.contents.script = !1)
        }), T.ajaxSetup({
            accepts: {
                script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
            },
            contents: {
                script: /\b(?:java|ecma)script\b/
            },
            converters: {
                "text script": function(t) {
                    return T.globalEval(t), t
                }
            }
        }), T.ajaxPrefilter("script", function(t) {
            void 0 === t.cache && (t.cache = !1), t.crossDomain && (t.type = "GET")
        }), T.ajaxTransport("script", function(t) {
            var e, i;
            if (t.crossDomain) return {
                send: function(n, s) {
                    e = T("<script>").prop({
                        charset: t.scriptCharset,
                        src: t.url
                    }).on("load error", i = function(t) {
                        e.remove(), i = null, t && s("error" === t.type ? 404 : 200, t.type)
                    }), r.head.appendChild(e[0])
                },
                abort: function() {
                    i && i()
                }
            }
        });
        var Be = [],
            Ve = /(=)\?(?=&|$)|\?\?/;
        T.ajaxSetup({
            jsonp: "callback",
            jsonpCallback: function() {
                var t = Be.pop() || T.expando + "_" + we++;
                return this[t] = !0, t
            }
        }), T.ajaxPrefilter("json jsonp", function(t, e, n) {
            var s, o, r, a = !1 !== t.jsonp && (Ve.test(t.url) ? "url" : "string" == typeof t.data && 0 === (t.contentType || "").indexOf("application/x-www-form-urlencoded") && Ve.test(t.data) && "data");
            if (a || "jsonp" === t.dataTypes[0]) return s = t.jsonpCallback = y(t.jsonpCallback) ? t.jsonpCallback() : t.jsonpCallback, a ? t[a] = t[a].replace(Ve, "$1" + s) : !1 !== t.jsonp && (t.url += (xe.test(t.url) ? "&" : "?") + t.jsonp + "=" + s), t.converters["script json"] = function() {
                return r || T.error(s + " was not called"), r[0]
            }, t.dataTypes[0] = "json", o = i[s], i[s] = function() {
                r = arguments
            }, n.always(function() {
                void 0 === o ? T(i).removeProp(s) : i[s] = o, t[s] && (t.jsonpCallback = e.jsonpCallback, Be.push(s)), r && y(o) && o(r[0]), r = o = void 0
            }), "script"
        }), v.createHTMLDocument = function() {
            var t = r.implementation.createHTMLDocument("").body;
            return t.innerHTML = "<form></form><form></form>", 2 === t.childNodes.length
        }(), T.parseHTML = function(t, e, i) {
            return "string" != typeof t ? [] : ("boolean" == typeof e && (i = e, e = !1), e || (v.createHTMLDocument ? ((n = (e = r.implementation.createHTMLDocument("")).createElement("base")).href = r.location.href, e.head.appendChild(n)) : e = r), s = k.exec(t), o = !i && [], s ? [e.createElement(s[1])] : (s = _t([t], e, o), o && o.length && T(o).remove(), T.merge([], s.childNodes)));
            var n, s, o
        }, T.fn.load = function(t, e, i) {
            var n, s, o, r = this,
                a = t.indexOf(" ");
            return a > -1 && (n = fe(t.slice(a)), t = t.slice(0, a)), y(e) ? (i = e, e = void 0) : e && "object" == typeof e && (s = "POST"), r.length > 0 && T.ajax({
                url: t,
                type: s || "GET",
                dataType: "html",
                data: e
            }).done(function(t) {
                o = arguments, r.html(n ? T("<div>").append(T.parseHTML(t)).find(n) : t)
            }).always(i && function(t, e) {
                r.each(function() {
                    i.apply(this, o || [t.responseText, e, t])
                })
            }), this
        }, T.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function(t, e) {
            T.fn[e] = function(t) {
                return this.on(e, t)
            }
        }), T.expr.pseudos.animated = function(t) {
            return T.grep(T.timers, function(e) {
                return t === e.elem
            }).length
        }, T.offset = {
            setOffset: function(t, e, i) {
                var n, s, o, r, a, l, h = T.css(t, "position"),
                    c = T(t),
                    d = {};
                "static" === h && (t.style.position = "relative"), a = c.offset(), o = T.css(t, "top"), l = T.css(t, "left"), ("absolute" === h || "fixed" === h) && (o + l).indexOf("auto") > -1 ? (r = (n = c.position()).top, s = n.left) : (r = parseFloat(o) || 0, s = parseFloat(l) || 0), y(e) && (e = e.call(t, i, T.extend({}, a))), null != e.top && (d.top = e.top - a.top + r), null != e.left && (d.left = e.left - a.left + s), "using" in e ? e.using.call(t, d) : c.css(d)
            }
        }, T.fn.extend({
            offset: function(t) {
                if (arguments.length) return void 0 === t ? this : this.each(function(e) {
                    T.offset.setOffset(this, t, e)
                });
                var e, i, n = this[0];
                return n ? n.getClientRects().length ? (e = n.getBoundingClientRect(), i = n.ownerDocument.defaultView, {
                    top: e.top + i.pageYOffset,
                    left: e.left + i.pageXOffset
                }) : {
                    top: 0,
                    left: 0
                } : void 0
            },
            position: function() {
                if (this[0]) {
                    var t, e, i, n = this[0],
                        s = {
                            top: 0,
                            left: 0
                        };
                    if ("fixed" === T.css(n, "position")) e = n.getBoundingClientRect();
                    else {
                        for (e = this.offset(), i = n.ownerDocument, t = n.offsetParent || i.documentElement; t && (t === i.body || t === i.documentElement) && "static" === T.css(t, "position");) t = t.parentNode;
                        t && t !== n && 1 === t.nodeType && ((s = T(t).offset()).top += T.css(t, "borderTopWidth", !0), s.left += T.css(t, "borderLeftWidth", !0))
                    }
                    return {
                        top: e.top - s.top - T.css(n, "marginTop", !0),
                        left: e.left - s.left - T.css(n, "marginLeft", !0)
                    }
                }
            },
            offsetParent: function() {
                return this.map(function() {
                    for (var t = this.offsetParent; t && "static" === T.css(t, "position");) t = t.offsetParent;
                    return t || bt
                })
            }
        }), T.each({
            scrollLeft: "pageXOffset",
            scrollTop: "pageYOffset"
        }, function(t, e) {
            var i = "pageYOffset" === e;
            T.fn[t] = function(n) {
                return q(this, function(t, n, s) {
                    var o;
                    if (_(t) ? o = t : 9 === t.nodeType && (o = t.defaultView), void 0 === s) return o ? o[e] : t[n];
                    o ? o.scrollTo(i ? o.pageXOffset : s, i ? s : o.pageYOffset) : t[n] = s
                }, t, n, arguments.length)
            }
        }), T.each(["top", "left"], function(t, e) {
            T.cssHooks[e] = Bt(v.pixelPosition, function(t, i) {
                if (i) return i = Wt(t, e), Ht.test(i) ? T(t).position()[e] + "px" : i
            })
        }), T.each({
            Height: "height",
            Width: "width"
        }, function(t, e) {
            T.each({
                padding: "inner" + t,
                content: e,
                "": "outer" + t
            }, function(i, n) {
                T.fn[n] = function(s, o) {
                    var r = arguments.length && (i || "boolean" != typeof s),
                        a = i || (!0 === s || !0 === o ? "margin" : "border");
                    return q(this, function(e, i, s) {
                        var o;
                        return _(e) ? 0 === n.indexOf("outer") ? e["inner" + t] : e.document.documentElement["client" + t] : 9 === e.nodeType ? (o = e.documentElement, Math.max(e.body["scroll" + t], o["scroll" + t], e.body["offset" + t], o["offset" + t], o["client" + t])) : void 0 === s ? T.css(e, i, a) : T.style(e, i, s, a)
                    }, e, r ? s : void 0, r)
                }
            })
        }), T.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(t, e) {
            T.fn[e] = function(t, i) {
                return arguments.length > 0 ? this.on(e, null, t, i) : this.trigger(e)
            }
        }), T.fn.extend({
            hover: function(t, e) {
                return this.mouseenter(t).mouseleave(e || t)
            }
        }), T.fn.extend({
            bind: function(t, e, i) {
                return this.on(t, null, e, i)
            },
            unbind: function(t, e) {
                return this.off(t, null, e)
            },
            delegate: function(t, e, i, n) {
                return this.on(e, t, i, n)
            },
            undelegate: function(t, e, i) {
                return 1 === arguments.length ? this.off(t, "**") : this.off(e, t || "**", i)
            }
        }), T.proxy = function(t, e) {
            var i, n, s;
            if ("string" == typeof e && (i = t[e], e = t, t = i), y(t)) return n = l.call(arguments, 2), (s = function() {
                return t.apply(e || this, n.concat(l.call(arguments)))
            }).guid = t.guid = t.guid || T.guid++, s
        }, T.holdReady = function(t) {
            t ? T.readyWait++ : T.ready(!0)
        }, T.isArray = Array.isArray, T.parseJSON = JSON.parse, T.nodeName = O, T.isFunction = y, T.isWindow = _, T.camelCase = X, T.type = x, T.now = Date.now, T.isNumeric = function(t) {
            var e = T.type(t);
            return ("number" === e || "string" === e) && !isNaN(t - parseFloat(t))
        }, void 0 === (n = function() {
            return T
        }.apply(e, [])) || (t.exports = n);
        var qe = i.jQuery,
            Ge = i.$;
        return T.noConflict = function(t) {
            return i.$ === T && (i.$ = Ge), t && i.jQuery === T && (i.jQuery = qe), T
        }, s || (i.jQuery = i.$ = T), T
    })
  }, function(t, e) {
    var i = t.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
    "number" == typeof __g && (__g = i)
  }, function(t, e, i) {
    var n = i(13),
        s = i(44),
        o = i(21),
        r = Object.defineProperty;
    e.f = i(6) ? Object.defineProperty : function(t, e, i) {
        if (n(t), e = o(e, !0), n(i), s) try {
            return r(t, e, i)
        } catch (t) {}
        if ("get" in i || "set" in i) throw TypeError("Accessors not supported!");
        return "value" in i && (t[e] = i.value), t
    }
  }, function(t, e, i) {
    t.exports = !i(7)(function() {
        return 7 != Object.defineProperty({}, "a", {
            get: function() {
                return 7
            }
        }).a
    })
  }, function(t, e) {
    t.exports = function(t) {
        try {
            return !!t()
        } catch (t) {
            return !0
        }
    }
  }, function(t, e) {
    t.exports = function(t) {
        return "object" == typeof t ? null !== t : "function" == typeof t
    }
  }, function(t, e, i) {
    var n = i(5),
        s = i(22);
    t.exports = i(6) ? function(t, e, i) {
        return n.f(t, e, s(1, i))
    } : function(t, e, i) {
        return t[e] = i, t
    }
  }, function(t, e, i) {
    var n = i(4),
        s = i(9),
        o = i(11),
        r = i(14)("src"),
        a = Function.toString,
        l = ("" + a).split("toString");
    i(15).inspectSource = function(t) {
        return a.call(t)
    }, (t.exports = function(t, e, i, a) {
        var h = "function" == typeof i;
        h && (o(i, "name") || s(i, "name", e)), t[e] !== i && (h && (o(i, r) || s(i, r, t[e] ? "" + t[e] : l.join(String(e)))), t === n ? t[e] = i : a ? t[e] ? t[e] = i : s(t, e, i) : (delete t[e], s(t, e, i)))
    })(Function.prototype, "toString", function() {
        return "function" == typeof this && this[r] || a.call(this)
    })
  }, function(t, e) {
    var i = {}.hasOwnProperty;
    t.exports = function(t, e) {
        return i.call(t, e)
    }
  }, function(t, e, i) {
    var n = i(47),
        s = i(23);
    t.exports = function(t) {
        return n(s(t))
    }
  }, function(t, e, i) {
    var n = i(8);
    t.exports = function(t) {
        if (!n(t)) throw TypeError(t + " is not an object!");
        return t
    }
  }, function(t, e) {
    var i = 0,
        n = Math.random();
    t.exports = function(t) {
        return "Symbol(".concat(void 0 === t ? "" : t, ")_", (++i + n).toString(36))
    }
  }, function(t, e) {
    var i = t.exports = {
        version: "2.5.7"
    };
    "number" == typeof __e && (__e = i)
  }, function(t, e) {
    var i = {}.toString;
    t.exports = function(t) {
        return i.call(t).slice(8, -1)
    }
  }, function(t, e, i) {
    var n = i(52),
        s = i(38);
    t.exports = Object.keys || function(t) {
        return n(t, s)
    }
  }, function(t, e, i) {
    "use strict";
    var n = i(7);
    t.exports = function(t, e) {
        return !!t && n(function() {
            e ? t.call(null, function() {}, 1) : t.call(null)
        })
    }
  }, function(t, e, i) {
    var n, s;
    /*!
     * getSize v2.0.3
     * measure size of elements
     * MIT license
     */
    window, void 0 === (s = "function" == typeof(n = function() {
        "use strict";
  
        function t(t) {
            var e = parseFloat(t),
                i = -1 == t.indexOf("%") && !isNaN(e);
            return i && e
        }
        var e = "undefined" == typeof console ? function() {} : function(t) {
                console.error(t)
            },
            i = ["paddingLeft", "paddingRight", "paddingTop", "paddingBottom", "marginLeft", "marginRight", "marginTop", "marginBottom", "borderLeftWidth", "borderRightWidth", "borderTopWidth", "borderBottomWidth"],
            n = i.length;
  
        function s(t) {
            var i = getComputedStyle(t);
            return i || e("Style returned " + i + ". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1"), i
        }
        var o, r = !1;
  
        function a(e) {
            if (function() {
                    if (!r) {
                        r = !0;
                        var e = document.createElement("div");
                        e.style.width = "200px", e.style.padding = "1px 2px 3px 4px", e.style.borderStyle = "solid", e.style.borderWidth = "1px 2px 3px 4px", e.style.boxSizing = "border-box";
                        var i = document.body || document.documentElement;
                        i.appendChild(e);
                        var n = s(e);
                        o = 200 == Math.round(t(n.width)), a.isBoxSizeOuter = o, i.removeChild(e)
                    }
                }(), "string" == typeof e && (e = document.querySelector(e)), e && "object" == typeof e && e.nodeType) {
                var l = s(e);
                if ("none" == l.display) return function() {
                    for (var t = {
                            width: 0,
                            height: 0,
                            innerWidth: 0,
                            innerHeight: 0,
                            outerWidth: 0,
                            outerHeight: 0
                        }, e = 0; e < n; e++) {
                        var s = i[e];
                        t[s] = 0
                    }
                    return t
                }();
                var h = {};
                h.width = e.offsetWidth, h.height = e.offsetHeight;
                for (var c = h.isBorderBox = "border-box" == l.boxSizing, d = 0; d < n; d++) {
                    var u = i[d],
                        p = l[u],
                        f = parseFloat(p);
                    h[u] = isNaN(f) ? 0 : f
                }
                var m = h.paddingLeft + h.paddingRight,
                    g = h.paddingTop + h.paddingBottom,
                    v = h.marginLeft + h.marginRight,
                    y = h.marginTop + h.marginBottom,
                    _ = h.borderLeftWidth + h.borderRightWidth,
                    b = h.borderTopWidth + h.borderBottomWidth,
                    w = c && o,
                    x = t(l.width);
                !1 !== x && (h.width = x + (w ? 0 : m + _));
                var T = t(l.height);
                return !1 !== T && (h.height = T + (w ? 0 : g + b)), h.innerWidth = h.width - (m + _), h.innerHeight = h.height - (g + b), h.outerWidth = h.width + v, h.outerHeight = h.height + y, h
            }
        }
        return a
    }) ? n.call(e, i, e, t) : n) || (t.exports = s)
  }, function(t, e, i) {
    "use strict";
    var n = i(9),
        s = i(10),
        o = i(7),
        r = i(23),
        a = i(1);
    t.exports = function(t, e, i) {
        var l = a(t),
            h = i(r, l, "" [t]),
            c = h[0],
            d = h[1];
        o(function() {
            var e = {};
            return e[l] = function() {
                return 7
            }, 7 != "" [t](e)
        }) && (s(String.prototype, t, c), n(RegExp.prototype, l, 2 == e ? function(t, e) {
            return d.call(t, this, e)
        } : function(t) {
            return d.call(t, this)
        }))
    }
  }, function(t, e, i) {
    var n = i(8);
    t.exports = function(t, e) {
        if (!n(t)) return t;
        var i, s;
        if (e && "function" == typeof(i = t.toString) && !n(s = i.call(t))) return s;
        if ("function" == typeof(i = t.valueOf) && !n(s = i.call(t))) return s;
        if (!e && "function" == typeof(i = t.toString) && !n(s = i.call(t))) return s;
        throw TypeError("Can't convert object to primitive value")
    }
  }, function(t, e) {
    t.exports = function(t, e) {
        return {
            enumerable: !(1 & t),
            configurable: !(2 & t),
            writable: !(4 & t),
            value: e
        }
    }
  }, function(t, e) {
    t.exports = function(t) {
        if (void 0 == t) throw TypeError("Can't call method on  " + t);
        return t
    }
  }, function(t, e) {
    t.exports = !1
  }, function(t, e, i) {
    var n = i(23);
    t.exports = function(t) {
        return Object(n(t))
    }
  }, function(t, e, i) {
    var n = i(13),
        s = i(86),
        o = i(38),
        r = i(37)("IE_PROTO"),
        a = function() {},
        l = function() {
            var t, e = i(45)("iframe"),
                n = o.length;
            for (e.style.display = "none", i(87).appendChild(e), e.src = "javascript:", (t = e.contentWindow.document).open(), t.write("<script>document.F=Object<\/script>"), t.close(), l = t.F; n--;) delete l.prototype[o[n]];
            return l()
        };
    t.exports = Object.create || function(t, e) {
        var i;
        return null !== t ? (a.prototype = n(t), i = new a, a.prototype = null, i[r] = t) : i = l(), void 0 === e ? i : s(i, e)
    }
  }, function(t, e, i) {
    var n = i(52),
        s = i(38).concat("length", "prototype");
    e.f = Object.getOwnPropertyNames || function(t) {
        return n(t, s)
    }
  }, function(t, e, i) {
    var n, s;
    /*!
     * Outlayer v2.1.1
     * the brains and guts of a layout library
     * MIT license
     */
    /*!
     * Outlayer v2.1.1
     * the brains and guts of a layout library
     * MIT license
     */
    ! function(o, r) {
        "use strict";
        n = [i(42), i(19), i(59), i(120)], void 0 === (s = function(t, e, i, n) {
            return function(t, e, i, n, s) {
                var o = t.console,
                    r = t.jQuery,
                    a = function() {},
                    l = 0,
                    h = {};
  
                function c(t, e) {
                    var i = n.getQueryElement(t);
                    if (i) {
                        this.element = i, r && (this.$element = r(this.element)), this.options = n.extend({}, this.constructor.defaults), this.option(e);
                        var s = ++l;
                        this.element.outlayerGUID = s, h[s] = this, this._create();
                        var a = this._getOption("initLayout");
                        a && this.layout()
                    } else o && o.error("Bad element for " + this.constructor.namespace + ": " + (i || t))
                }
                c.namespace = "outlayer", c.Item = s, c.defaults = {
                    containerStyle: {
                        position: "relative"
                    },
                    initLayout: !0,
                    originLeft: !0,
                    originTop: !0,
                    resize: !0,
                    resizeContainer: !0,
                    transitionDuration: "0.4s",
                    hiddenStyle: {
                        opacity: 0,
                        transform: "scale(0.001)"
                    },
                    visibleStyle: {
                        opacity: 1,
                        transform: "scale(1)"
                    }
                };
                var d = c.prototype;
  
                function u(t) {
                    function e() {
                        t.apply(this, arguments)
                    }
                    return e.prototype = Object.create(t.prototype), e.prototype.constructor = e, e
                }
                n.extend(d, e.prototype), d.option = function(t) {
                    n.extend(this.options, t)
                }, d._getOption = function(t) {
                    var e = this.constructor.compatOptions[t];
                    return e && void 0 !== this.options[e] ? this.options[e] : this.options[t]
                }, c.compatOptions = {
                    initLayout: "isInitLayout",
                    horizontal: "isHorizontal",
                    layoutInstant: "isLayoutInstant",
                    originLeft: "isOriginLeft",
                    originTop: "isOriginTop",
                    resize: "isResizeBound",
                    resizeContainer: "isResizingContainer"
                }, d._create = function() {
                    this.reloadItems(), this.stamps = [], this.stamp(this.options.stamp), n.extend(this.element.style, this.options.containerStyle);
                    var t = this._getOption("resize");
                    t && this.bindResize()
                }, d.reloadItems = function() {
                    this.items = this._itemize(this.element.children)
                }, d._itemize = function(t) {
                    for (var e = this._filterFindItemElements(t), i = this.constructor.Item, n = [], s = 0; s < e.length; s++) {
                        var o = e[s],
                            r = new i(o, this);
                        n.push(r)
                    }
                    return n
                }, d._filterFindItemElements = function(t) {
                    return n.filterFindElements(t, this.options.itemSelector)
                }, d.getItemElements = function() {
                    return this.items.map(function(t) {
                        return t.element
                    })
                }, d.layout = function() {
                    this._resetLayout(), this._manageStamps();
                    var t = this._getOption("layoutInstant"),
                        e = void 0 !== t ? t : !this._isLayoutInited;
                    this.layoutItems(this.items, e), this._isLayoutInited = !0
                }, d._init = d.layout, d._resetLayout = function() {
                    this.getSize()
                }, d.getSize = function() {
                    this.size = i(this.element)
                }, d._getMeasurement = function(t, e) {
                    var n, s = this.options[t];
                    s ? ("string" == typeof s ? n = this.element.querySelector(s) : s instanceof HTMLElement && (n = s), this[t] = n ? i(n)[e] : s) : this[t] = 0
                }, d.layoutItems = function(t, e) {
                    t = this._getItemsForLayout(t), this._layoutItems(t, e), this._postLayout()
                }, d._getItemsForLayout = function(t) {
                    return t.filter(function(t) {
                        return !t.isIgnored
                    })
                }, d._layoutItems = function(t, e) {
                    if (this._emitCompleteOnItems("layout", t), t && t.length) {
                        var i = [];
                        t.forEach(function(t) {
                            var n = this._getItemLayoutPosition(t);
                            n.item = t, n.isInstant = e || t.isLayoutInstant, i.push(n)
                        }, this), this._processLayoutQueue(i)
                    }
                }, d._getItemLayoutPosition = function() {
                    return {
                        x: 0,
                        y: 0
                    }
                }, d._processLayoutQueue = function(t) {
                    this.updateStagger(), t.forEach(function(t, e) {
                        this._positionItem(t.item, t.x, t.y, t.isInstant, e)
                    }, this)
                }, d.updateStagger = function() {
                    var t = this.options.stagger;
                    if (null !== t && void 0 !== t) return this.stagger = function(t) {
                        if ("number" == typeof t) return t;
                        var e = t.match(/(^\d*\.?\d*)(\w*)/),
                            i = e && e[1],
                            n = e && e[2];
                        if (!i.length) return 0;
                        i = parseFloat(i);
                        var s = p[n] || 1;
                        return i * s
                    }(t), this.stagger;
                    this.stagger = 0
                }, d._positionItem = function(t, e, i, n, s) {
                    n ? t.goTo(e, i) : (t.stagger(s * this.stagger), t.moveTo(e, i))
                }, d._postLayout = function() {
                    this.resizeContainer()
                }, d.resizeContainer = function() {
                    var t = this._getOption("resizeContainer");
                    if (t) {
                        var e = this._getContainerSize();
                        e && (this._setContainerMeasure(e.width, !0), this._setContainerMeasure(e.height, !1))
                    }
                }, d._getContainerSize = a, d._setContainerMeasure = function(t, e) {
                    if (void 0 !== t) {
                        var i = this.size;
                        i.isBorderBox && (t += e ? i.paddingLeft + i.paddingRight + i.borderLeftWidth + i.borderRightWidth : i.paddingBottom + i.paddingTop + i.borderTopWidth + i.borderBottomWidth), t = Math.max(t, 0), this.element.style[e ? "width" : "height"] = t + "px"
                    }
                }, d._emitCompleteOnItems = function(t, e) {
                    var i = this;
  
                    function n() {
                        i.dispatchEvent(t + "Complete", null, [e])
                    }
                    var s = e.length;
                    if (e && s) {
                        var o = 0;
                        e.forEach(function(e) {
                            e.once(t, r)
                        })
                    } else n();
  
                    function r() {
                        ++o == s && n()
                    }
                }, d.dispatchEvent = function(t, e, i) {
                    var n = e ? [e].concat(i) : i;
                    if (this.emitEvent(t, n), r)
                        if (this.$element = this.$element || r(this.element), e) {
                            var s = r.Event(e);
                            s.type = t, this.$element.trigger(s, i)
                        } else this.$element.trigger(t, i)
                }, d.ignore = function(t) {
                    var e = this.getItem(t);
                    e && (e.isIgnored = !0)
                }, d.unignore = function(t) {
                    var e = this.getItem(t);
                    e && delete e.isIgnored
                }, d.stamp = function(t) {
                    (t = this._find(t)) && (this.stamps = this.stamps.concat(t), t.forEach(this.ignore, this))
                }, d.unstamp = function(t) {
                    (t = this._find(t)) && t.forEach(function(t) {
                        n.removeFrom(this.stamps, t), this.unignore(t)
                    }, this)
                }, d._find = function(t) {
                    if (t) return "string" == typeof t && (t = this.element.querySelectorAll(t)), t = n.makeArray(t)
                }, d._manageStamps = function() {
                    this.stamps && this.stamps.length && (this._getBoundingRect(), this.stamps.forEach(this._manageStamp, this))
                }, d._getBoundingRect = function() {
                    var t = this.element.getBoundingClientRect(),
                        e = this.size;
                    this._boundingRect = {
                        left: t.left + e.paddingLeft + e.borderLeftWidth,
                        top: t.top + e.paddingTop + e.borderTopWidth,
                        right: t.right - (e.paddingRight + e.borderRightWidth),
                        bottom: t.bottom - (e.paddingBottom + e.borderBottomWidth)
                    }
                }, d._manageStamp = a, d._getElementOffset = function(t) {
                    var e = t.getBoundingClientRect(),
                        n = this._boundingRect,
                        s = i(t),
                        o = {
                            left: e.left - n.left - s.marginLeft,
                            top: e.top - n.top - s.marginTop,
                            right: n.right - e.right - s.marginRight,
                            bottom: n.bottom - e.bottom - s.marginBottom
                        };
                    return o
                }, d.handleEvent = n.handleEvent, d.bindResize = function() {
                    t.addEventListener("resize", this), this.isResizeBound = !0
                }, d.unbindResize = function() {
                    t.removeEventListener("resize", this), this.isResizeBound = !1
                }, d.onresize = function() {
                    this.resize()
                }, n.debounceMethod(c, "onresize", 100), d.resize = function() {
                    this.isResizeBound && this.needsResizeLayout() && this.layout()
                }, d.needsResizeLayout = function() {
                    var t = i(this.element),
                        e = this.size && t;
                    return e && t.innerWidth !== this.size.innerWidth
                }, d.addItems = function(t) {
                    var e = this._itemize(t);
                    return e.length && (this.items = this.items.concat(e)), e
                }, d.appended = function(t) {
                    var e = this.addItems(t);
                    e.length && (this.layoutItems(e, !0), this.reveal(e))
                }, d.prepended = function(t) {
                    var e = this._itemize(t);
                    if (e.length) {
                        var i = this.items.slice(0);
                        this.items = e.concat(i), this._resetLayout(), this._manageStamps(), this.layoutItems(e, !0), this.reveal(e), this.layoutItems(i)
                    }
                }, d.reveal = function(t) {
                    if (this._emitCompleteOnItems("reveal", t), t && t.length) {
                        var e = this.updateStagger();
                        t.forEach(function(t, i) {
                            t.stagger(i * e), t.reveal()
                        })
                    }
                }, d.hide = function(t) {
                    if (this._emitCompleteOnItems("hide", t), t && t.length) {
                        var e = this.updateStagger();
                        t.forEach(function(t, i) {
                            t.stagger(i * e), t.hide()
                        })
                    }
                }, d.revealItemElements = function(t) {
                    var e = this.getItems(t);
                    this.reveal(e)
                }, d.hideItemElements = function(t) {
                    var e = this.getItems(t);
                    this.hide(e)
                }, d.getItem = function(t) {
                    for (var e = 0; e < this.items.length; e++) {
                        var i = this.items[e];
                        if (i.element == t) return i
                    }
                }, d.getItems = function(t) {
                    var e = [];
                    return (t = n.makeArray(t)).forEach(function(t) {
                        var i = this.getItem(t);
                        i && e.push(i)
                    }, this), e
                }, d.remove = function(t) {
                    var e = this.getItems(t);
                    this._emitCompleteOnItems("remove", e), e && e.length && e.forEach(function(t) {
                        t.remove(), n.removeFrom(this.items, t)
                    }, this)
                }, d.destroy = function() {
                    var t = this.element.style;
                    t.height = "", t.position = "", t.width = "", this.items.forEach(function(t) {
                        t.destroy()
                    }), this.unbindResize();
                    var e = this.element.outlayerGUID;
                    delete h[e], delete this.element.outlayerGUID, r && r.removeData(this.element, this.constructor.namespace)
                }, c.data = function(t) {
                    var e = (t = n.getQueryElement(t)) && t.outlayerGUID;
                    return e && h[e]
                }, c.create = function(t, e) {
                    var i = u(c);
                    return i.defaults = n.extend({}, c.defaults), n.extend(i.defaults, e), i.compatOptions = n.extend({}, c.compatOptions), i.namespace = t, i.data = c.data, i.Item = u(s), n.htmlInit(i, t), r && r.bridget && r.bridget(t, i), i
                };
                var p = {
                    ms: 1,
                    s: 1e3
                };
                return c.Item = s, c
            }(o, t, e, i, n)
        }.apply(e, n)) || (t.exports = s)
    }(window)
  }, function(t, e, i) {
    var n, s, o;
    window, s = [i(19), i(28)], void 0 === (o = "function" == typeof(n = function(t, e) {
        "use strict";
  
        function i(t) {
            this.isotope = t, t && (this.options = t.options[this.namespace], this.element = t.element, this.items = t.filteredItems, this.size = t.size)
        }
        var n = i.prototype;
        return ["_resetLayout", "_getItemLayoutPosition", "_manageStamp", "_getContainerSize", "_getElementOffset", "needsResizeLayout", "_getOption"].forEach(function(t) {
            n[t] = function() {
                return e.prototype[t].apply(this.isotope, arguments)
            }
        }), n.needsVerticalResizeLayout = function() {
            var e = t(this.isotope.element);
            return this.isotope.size && e && e.innerHeight != this.isotope.size.innerHeight
        }, n._getMeasurement = function() {
            this.isotope._getMeasurement.apply(this, arguments)
        }, n.getColumnWidth = function() {
            this.getSegmentSize("column", "Width")
        }, n.getRowHeight = function() {
            this.getSegmentSize("row", "Height")
        }, n.getSegmentSize = function(t, e) {
            var i = t + e,
                n = "outer" + e;
            if (this._getMeasurement(i, n), !this[i]) {
                var s = this.getFirstItemSize();
                this[i] = s && s[n] || this.isotope.size["inner" + e]
            }
        }, n.getFirstItemSize = function() {
            var e = this.isotope.filteredItems[0];
            return e && e.element && t(e.element)
        }, n.layout = function() {
            this.isotope.layout.apply(this.isotope, arguments)
        }, n.getSize = function() {
            this.isotope.getSize(), this.size = this.isotope.size
        }, i.modes = {}, i.create = function(t, e) {
            function s() {
                i.apply(this, arguments)
            }
            return s.prototype = Object.create(n), s.prototype.constructor = s, e && (s.options = e), s.prototype.namespace = t, i.modes[t] = s, s
        }, i
    }) ? n.apply(e, s) : n) || (t.exports = o)
  }, function(t, e, i) {
    var n = i(15),
        s = i(4),
        o = s["__core-js_shared__"] || (s["__core-js_shared__"] = {});
    (t.exports = function(t, e) {
        return o[t] || (o[t] = void 0 !== e ? e : {})
    })("versions", []).push({
        version: n.version,
        mode: i(24) ? "pure" : "global",
        copyright: "© 2018 Denis Pushkarev (zloirock.ru)"
    })
  }, function(t, e, i) {
    var n = i(32);
    t.exports = function(t, e, i) {
        if (n(t), void 0 === e) return t;
        switch (i) {
            case 1:
                return function(i) {
                    return t.call(e, i)
                };
            case 2:
                return function(i, n) {
                    return t.call(e, i, n)
                };
            case 3:
                return function(i, n, s) {
                    return t.call(e, i, n, s)
                }
        }
        return function() {
            return t.apply(e, arguments)
        }
    }
  }, function(t, e) {
    t.exports = function(t) {
        if ("function" != typeof t) throw TypeError(t + " is not a function!");
        return t
    }
  }, function(t, e, i) {
    var n = i(31),
        s = i(47),
        o = i(25),
        r = i(34),
        a = i(64);
    t.exports = function(t, e) {
        var i = 1 == t,
            l = 2 == t,
            h = 3 == t,
            c = 4 == t,
            d = 6 == t,
            u = 5 == t || d,
            p = e || a;
        return function(e, a, f) {
            for (var m, g, v = o(e), y = s(v), _ = n(a, f, 3), b = r(y.length), w = 0, x = i ? p(e, b) : l ? p(e, 0) : void 0; b > w; w++)
                if ((u || w in y) && (g = _(m = y[w], w, v), t))
                    if (i) x[w] = g;
                    else if (g) switch (t) {
                case 3:
                    return !0;
                case 5:
                    return m;
                case 6:
                    return w;
                case 2:
                    x.push(m)
            } else if (c) return !1;
            return d ? -1 : h || c ? c : x
        }
    }
  }, function(t, e, i) {
    var n = i(35),
        s = Math.min;
    t.exports = function(t) {
        return t > 0 ? s(n(t), 9007199254740991) : 0
    }
  }, function(t, e) {
    var i = Math.ceil,
        n = Math.floor;
    t.exports = function(t) {
        return isNaN(t = +t) ? 0 : (t > 0 ? n : i)(t)
    }
  }, function(t, e, i) {
    var n = i(5).f,
        s = i(11),
        o = i(1)("toStringTag");
    t.exports = function(t, e, i) {
        t && !s(t = i ? t : t.prototype, o) && n(t, o, {
            configurable: !0,
            value: e
        })
    }
  }, function(t, e, i) {
    var n = i(30)("keys"),
        s = i(14);
    t.exports = function(t) {
        return n[t] || (n[t] = s(t))
    }
  }, function(t, e) {
    t.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",")
  }, function(t, e) {
    e.f = {}.propertyIsEnumerable
  }, function(t, e, i) {
    var n = i(39),
        s = i(22),
        o = i(12),
        r = i(21),
        a = i(11),
        l = i(44),
        h = Object.getOwnPropertyDescriptor;
    e.f = i(6) ? h : function(t, e) {
        if (t = o(t), e = r(e, !0), l) try {
            return h(t, e)
        } catch (t) {}
        if (a(t, e)) return s(!n.f.call(t, e), t[e])
    }
  }, function(t, e) {
    t.exports = {}
  }, function(t, e, i) {
    var n, s;
    "undefined" != typeof window && window, void 0 === (s = "function" == typeof(n = function() {
        "use strict";
  
        function t() {}
        var e = t.prototype;
        return e.on = function(t, e) {
            if (t && e) {
                var i = this._events = this._events || {},
                    n = i[t] = i[t] || [];
                return -1 == n.indexOf(e) && n.push(e), this
            }
        }, e.once = function(t, e) {
            if (t && e) {
                this.on(t, e);
                var i = this._onceEvents = this._onceEvents || {};
                return (i[t] = i[t] || {})[e] = !0, this
            }
        }, e.off = function(t, e) {
            var i = this._events && this._events[t];
            if (i && i.length) {
                var n = i.indexOf(e);
                return -1 != n && i.splice(n, 1), this
            }
        }, e.emitEvent = function(t, e) {
            var i = this._events && this._events[t];
            if (i && i.length) {
                i = i.slice(0), e = e || [];
                for (var n = this._onceEvents && this._onceEvents[t], s = 0; s < i.length; s++) {
                    var o = i[s];
                    n && n[o] && (this.off(t, o), delete n[o]), o.apply(this, e)
                }
                return this
            }
        }, e.allOff = function() {
            delete this._events, delete this._onceEvents
        }, t
    }) ? n.call(e, i, e, t) : n) || (t.exports = s)
  }, function(t, e, i) {
    i(20)("replace", 2, function(t, e, i) {
        return [function(n, s) {
            "use strict";
            var o = t(this),
                r = void 0 == n ? void 0 : n[e];
            return void 0 !== r ? r.call(n, o, s) : i.call(String(o), n, s)
        }, i]
    })
  }, function(t, e, i) {
    t.exports = !i(6) && !i(7)(function() {
        return 7 != Object.defineProperty(i(45)("div"), "a", {
            get: function() {
                return 7
            }
        }).a
    })
  }, function(t, e, i) {
    var n = i(8),
        s = i(4).document,
        o = n(s) && n(s.createElement);
    t.exports = function(t) {
        return o ? s.createElement(t) : {}
    }
  }, function(t, e, i) {
    i(20)("match", 1, function(t, e, i) {
        return [function(i) {
            "use strict";
            var n = t(this),
                s = void 0 == i ? void 0 : i[e];
            return void 0 !== s ? s.call(i, n) : new RegExp(i)[e](String(n))
        }, i]
    })
  }, function(t, e, i) {
    var n = i(16);
    t.exports = Object("z").propertyIsEnumerable(0) ? Object : function(t) {
        return "String" == n(t) ? t.split("") : Object(t)
    }
  }, function(t, e, i) {
    var n = i(16);
    t.exports = Array.isArray || function(t) {
        return "Array" == n(t)
    }
  }, function(t, e, i) {
    var n = i(1)("unscopables"),
        s = Array.prototype;
    void 0 == s[n] && i(9)(s, n, {}), t.exports = function(t) {
        s[n][t] = !0
    }
  }, function(t, e, i) {
    var n = i(4),
        s = i(15),
        o = i(24),
        r = i(51),
        a = i(5).f;
    t.exports = function(t) {
        var e = s.Symbol || (s.Symbol = o ? {} : n.Symbol || {});
        "_" == t.charAt(0) || t in e || a(e, t, {
            value: r.f(t)
        })
    }
  }, function(t, e, i) {
    e.f = i(1)
  }, function(t, e, i) {
    var n = i(11),
        s = i(12),
        o = i(53)(!1),
        r = i(37)("IE_PROTO");
    t.exports = function(t, e) {
        var i, a = s(t),
            l = 0,
            h = [];
        for (i in a) i != r && n(a, i) && h.push(i);
        for (; e.length > l;) n(a, i = e[l++]) && (~o(h, i) || h.push(i));
        return h
    }
  }, function(t, e, i) {
    var n = i(12),
        s = i(34),
        o = i(85);
    t.exports = function(t) {
        return function(e, i, r) {
            var a, l = n(e),
                h = s(l.length),
                c = o(r, h);
            if (t && i != i) {
                for (; h > c;)
                    if ((a = l[c++]) != a) return !0
            } else
                for (; h > c; c++)
                    if ((t || c in l) && l[c] === i) return t || c || 0;
            return !t && -1
        }
    }
  }, function(t, e) {
    e.f = Object.getOwnPropertySymbols
  }, function(t, e, i) {
    var n = i(8),
        s = i(92).set;
    t.exports = function(t, e, i) {
        var o, r = e.constructor;
        return r !== i && "function" == typeof r && (o = r.prototype) !== i.prototype && n(o) && s && s(t, o), t
    }
  }, function(t, e, i) {
    var n = i(2),
        s = i(23),
        o = i(7),
        r = i(93),
        a = "[" + r + "]",
        l = RegExp("^" + a + a + "*"),
        h = RegExp(a + a + "*$"),
        c = function(t, e, i) {
            var s = {},
                a = o(function() {
                    return !!r[t]() || "​" != "​" [t]()
                }),
                l = s[t] = a ? e(d) : r[t];
            i && (s[i] = l), n(n.P + n.F * a, "String", s)
        },
        d = c.trim = function(t, e) {
            return t = String(s(t)), 1 & e && (t = t.replace(l, "")), 2 & e && (t = t.replace(h, "")), t
        };
    t.exports = c
  }, function(t, e, i) {
    var n = i(8),
        s = i(16),
        o = i(1)("match");
    t.exports = function(t) {
        var e;
        return n(t) && (void 0 !== (e = t[o]) ? !!e : "RegExp" == s(t))
    }
  }, function(t, e, i) {
    "use strict";
    var n = i(49),
        s = i(100),
        o = i(41),
        r = i(12);
    t.exports = i(101)(Array, "Array", function(t, e) {
        this._t = r(t), this._i = 0, this._k = e
    }, function() {
        var t = this._t,
            e = this._k,
            i = this._i++;
        return !t || i >= t.length ? (this._t = void 0, s(1)) : s(0, "keys" == e ? i : "values" == e ? t[i] : [i, t[i]])
    }, "values"), o.Arguments = o.Array, n("keys"), n("values"), n("entries")
  }, function(t, e, i) {
    var n, s;
    ! function(o, r) {
        n = [i(60)], void 0 === (s = function(t) {
            return function(t, e) {
                "use strict";
                var i = {
                        extend: function(t, e) {
                            for (var i in e) t[i] = e[i];
                            return t
                        },
                        modulo: function(t, e) {
                            return (t % e + e) % e
                        }
                    },
                    n = Array.prototype.slice;
                i.makeArray = function(t) {
                    if (Array.isArray(t)) return t;
                    if (null === t || void 0 === t) return [];
                    var e = "object" == typeof t && "number" == typeof t.length;
                    return e ? n.call(t) : [t]
                }, i.removeFrom = function(t, e) {
                    var i = t.indexOf(e); - 1 != i && t.splice(i, 1)
                }, i.getParent = function(t, i) {
                    for (; t.parentNode && t != document.body;)
                        if (t = t.parentNode, e(t, i)) return t
                }, i.getQueryElement = function(t) {
                    return "string" == typeof t ? document.querySelector(t) : t
                }, i.handleEvent = function(t) {
                    var e = "on" + t.type;
                    this[e] && this[e](t)
                }, i.filterFindElements = function(t, n) {
                    var s = [];
                    return (t = i.makeArray(t)).forEach(function(t) {
                        if (t instanceof HTMLElement)
                            if (n) {
                                e(t, n) && s.push(t);
                                for (var i = t.querySelectorAll(n), o = 0; o < i.length; o++) s.push(i[o])
                            } else s.push(t)
                    }), s
                }, i.debounceMethod = function(t, e, i) {
                    i = i || 100;
                    var n = t.prototype[e],
                        s = e + "Timeout";
                    t.prototype[e] = function() {
                        var t = this[s];
                        clearTimeout(t);
                        var e = arguments,
                            o = this;
                        this[s] = setTimeout(function() {
                            n.apply(o, e), delete o[s]
                        }, i)
                    }
                }, i.docReady = function(t) {
                    var e = document.readyState;
                    "complete" == e || "interactive" == e ? setTimeout(t) : document.addEventListener("DOMContentLoaded", t)
                }, i.toDashed = function(t) {
                    return t.replace(/(.)([A-Z])/g, function(t, e, i) {
                        return e + "-" + i
                    }).toLowerCase()
                };
                var s = t.console;
                return i.htmlInit = function(e, n) {
                    i.docReady(function() {
                        var o = i.toDashed(n),
                            r = "data-" + o,
                            a = document.querySelectorAll("[" + r + "]"),
                            l = document.querySelectorAll(".js-" + o),
                            h = i.makeArray(a).concat(i.makeArray(l)),
                            c = r + "-options",
                            d = t.jQuery;
                        h.forEach(function(t) {
                            var i, o = t.getAttribute(r) || t.getAttribute(c);
                            try {
                                i = o && JSON.parse(o)
                            } catch (e) {
                                return void(s && s.error("Error parsing " + r + " on " + t.className + ": " + e))
                            }
                            var a = new e(t, i);
                            d && d.data(t, n, a)
                        })
                    })
                }, i
            }(o, t)
        }.apply(e, n)) || (t.exports = s)
    }(window)
  }, function(t, e, i) {
    var n, s;
    ! function(o, r) {
        "use strict";
        void 0 === (s = "function" == typeof(n = r) ? n.call(e, i, e, t) : n) || (t.exports = s)
    }(window, function() {
        "use strict";
        var t = function() {
            var t = window.Element.prototype;
            if (t.matches) return "matches";
            if (t.matchesSelector) return "matchesSelector";
            for (var e = ["webkit", "moz", "ms", "o"], i = 0; i < e.length; i++) {
                var n = e[i] + "MatchesSelector";
                if (t[n]) return n
            }
        }();
        return function(e, i) {
            return e[t](i)
        }
    })
  }, function(t, e, i) {
    var n;
    t.exports = function t(e, i, s) {
        function o(a, l) {
            if (!i[a]) {
                if (!e[a]) {
                    var h = "function" == typeof n && n;
                    if (!l && h) return n(a, !0);
                    if (r) return r(a, !0);
                    var c = new Error("Cannot find module '" + a + "'");
                    throw c.code = "MODULE_NOT_FOUND", c
                }
                var d = i[a] = {
                    exports: {}
                };
                e[a][0].call(d.exports, function(t) {
                    var i = e[a][1][t];
                    return o(i || t)
                }, d, d.exports, t, e, i, s)
            }
            return i[a].exports
        }
        for (var r = "function" == typeof n && n, a = 0; a < s.length; a++) o(s[a]);
        return o
    }({
        1: [function(t, e, i) {
            "use strict";
            var n = ['iframe[src*="player.vimeo.com"]', 'iframe[src*="youtube.com"]', 'iframe[src*="youtube-nocookie.com"]', 'iframe[src*="kickstarter.com"][src*="video.html"]', "object"],
                s = ".fluid-width-video-wrapper{width:100%;position:relative;padding:0;}.fluid-width-video-wrapper iframe,.fluid-width-video-wrapper object,.fluid-width-video-wrapper embed {position:absolute;top:0;left:0;width:100%;height:100%;}";
  
            function o(t, e) {
                return "string" == typeof t && (e = t, t = document), Array.prototype.slice.call(t.querySelectorAll(e))
            }
  
            function r(t) {
                if (!/fluid-width-video-wrapper/.test(t.parentNode.className)) {
                    var e = parseInt(t.getAttribute("width"), 10),
                        i = parseInt(t.getAttribute("height"), 10),
                        n = isNaN(e) ? t.clientWidth : e,
                        s = isNaN(i) ? t.clientHeight : i,
                        o = s / n;
                    t.removeAttribute("width"), t.removeAttribute("height");
                    var r = document.createElement("div");
                    t.parentNode.insertBefore(r, t), r.className = "fluid-width-video-wrapper", r.style.paddingTop = 100 * o + "%", r.appendChild(t)
                }
            }
  
            function a(t) {
                return void 0 === t ? "" : Array.isArray(t) ? t.join() : t
            }
            e.exports = function(t, e) {
                e = e || {},
                    function(t) {
                        return "[object Object]" === Object.prototype.toString.call(t)
                    }(t = t || "body") && (e = t, t = "body");
                var i = o(t);
                if (!(i.length < 1)) {
                    if (!document.getElementById("fit-vids-style")) {
                        var l = document.head || document.getElementsByTagName("head")[0];
                        l.appendChild(function() {
                            var t = document.createElement("div");
                            return t.innerHTML = '<p>x</p><style id="fit-vids-style">' + s + "</style>", t.childNodes[1]
                        }())
                    }
                    var h = a(e.players),
                        c = a(n);
                    h.length && (c = c + "," + h), i.forEach(function(t) {
                        o(t, c).forEach(r)
                    })
                }
            }
        }, {}]
    }, {}, [1])(1)
  }, function(t, e, i) {
    "use strict";
    i.r(e),
        function(t) {
            i(43), i(46), i(63), i(66), i(67), i(68), i(69), i(70), i(71), i(72), i(3), i(73), i(75), i(78), i(79);
            var e = i(61),
                n = i.n(e),
                s = (i(80), i(0));
  
            function o(t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
            }
  
            function r(t, e) {
                for (var i = 0; i < e.length; i++) {
                    var n = e[i];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n)
                }
            }
  
            function a(t, e, i) {
                return e && r(t.prototype, e), i && r(t, i), t
            }
            var l = i(3);
            i(118)("isotope", i(119), l);
            var h = 0,
                c = function() {
                    function t() {
                        o(this, t)
                    }
                    return a(t, null, [{
                        key: "isMobile",
                        value: function() {
                            return l(window).width() <= 1030
                        }
                    }, {
                        key: "isDesktop",
                        value: function() {
                            return !t.isMobile()
                        }
                    }, {
                        key: "scrollDetect",
                        value: function() {
                            window.onscroll = function() {
                                var t = document.documentElement.scrollTop || document.body.scrollTop;
                                t > 0 && h <= t ? (h = t, "isDown") : (h = t, "isUp")
                            }
                        }
                    }, {
                        key: "debounce",
                        value: function(t, e, i) {
                            var n;
                            return function() {
                                var s = this,
                                    o = arguments,
                                    r = i && !n;
                                clearTimeout(n), n = setTimeout(function() {
                                    n = null, i || t.apply(s, o)
                                }, e), r && t.apply(s, o)
                            }
                        }
                    }, {
                        key: "log",
                        value: function() {}
                    }]), t
                }();
            c.scrollDetect();
            var d = function() {
                function e() {
                    o(this, e), c.log("Starts..."), this.start(), c.log("Is fully loaded")
                }
                return a(e, [{
                    key: "start",
                    value: function() {
                        this.initBackground(), this.isotopeFuncs(), this.initMenu(), this.initMobileMenu(), this.initClickTriggers(), this.initCarousels(), this.initSingleProduct(), this.initProductHoverImage(), this.initSticky(), this.getScrollbarWidth(), this.accountMeasures(), this.initImagesBackground(), this.initStates(), this.initIonRangeSlider(), this.initTranslates(), n()()
                    }
                }, {
                    key: "initMenu",
                    value: function() {
                        t(".header-seller-benefits").length && t("html").addClass("benefits-on-top"), (t(".inverse-header-colors").length || t(".Esc-returns-container").length) && t(".main-header").addClass("main-header--reverse-color"), t(".inverse-header-colors--no-border").length && t(".main-header").addClass("main-header--no-border");
                        var e = t(".main-header").offset().top;
                        t(window).scroll(function() {
                            var i = t(window).scrollTop(),
                                n = t(".main-header");
                            i > e ? n.addClass("affixed") : i <= e && n.removeClass("affixed")
                        }), t(".main-header__menu > ul > li > ul").length && (t("body").on("click", function() {
                            t("html").removeClass("megamenu-opened"), t("body").removeClass("overflow-sidebar-fix"), t(".main-header__menu > ul > li").removeClass("active")
                        }), t(".main-header__menu > ul > li > ul").each(function() {
                            var e = t(this).parent();
                            e.addClass("has-children"), e.find("> a").append('<i class="fa fa-angle-down"></i>'), e.on("click", function(t) {
                                t.stopPropagation()
                            }), e.find("> a").on("click", function(e) {
                                e.preventDefault(), e.stopPropagation(), t(this).parent().hasClass("active") ? (t(this).parent().removeClass("active"), t("html").removeClass("megamenu-opened"), t("body").removeClass("overflow-sidebar-fix")) : (t("html").addClass("megamenu-opened"), t("body").addClass("overflow-sidebar-fix"), t(".main-header__menu > ul > li").removeClass("active"), t(this).parent().addClass("active"))
                            })
                        })), t(".main-header__menu-trigger").on("click", function(e) {
                            e.preventDefault();
                            var i = t(window).scrollTop();
                            t("html").toggleClass("mobilemenu-opened"), t("html").removeClass("search-opened"), t(".main-header__menu > ul > li.has-children").removeClass("active"), t(".main-header__menu__mega-menu").removeClass("active"), t(".main-header__menu > ul").removeClass("overflow-hidden"), t("body main.main-content").scrollTop(i), t("html.mobilemenu-opened body main.main-content").attr("data-scroll", i);
                            var n = parseInt(t("body main.main-content").attr("data-scroll"));
                            t(window).scrollTop(n)
                        })
                    }
                }, {
                    key: "isotopeFuncs",
                    value: function() {
                        t(".blog-articles").isotope()
                    }
                }, {
                    key: "initMobileMenu",
                    value: function() {
                        if (c.isMobile()) {
                            t(".header-seller-benefits ul li:first-child").addClass("active first-active"), setInterval(function() {
                                t(".header-seller-benefits ul li.active").each(function() {
                                    var e = t(this),
                                        i = e.next(),
                                        n = e.parent().find("li:first-child");
                                    e.removeClass("active"), e.hide(), i.length ? (i.fadeIn(), i.addClass("active")) : (n.fadeIn(), n.addClass("active"))
                                })
                            }, 1e4), t(".main-header__menu > ul > li.has-children > a").on("click", function(e) {
                                e.preventDefault(), t(this).parent().find("> ul").addClass("active"), t(".main-header__menu > ul").addClass("overflow-hidden"),t('.mega-menu__outlet').addClass('active');

                            }), t(".main-header__menu > ul > li.has-children").each(function() {
                                var e = t(this),
                                    i = e.find("> ul"),
                                    n = e.find("> a").text(),
                                    s = '<li class="main-header__menu__get-back">\n                                        <button>\n                                            <i class="fas fa-arrow-left"></i>\n                                        </button>\n                                        <p>\n                                            '.concat(n, "\n                                        </p>\n                                    </li>");
                                i.prepend(s)
                            }), t(".main-header__menu__get-back").length && t(".main-header__menu__get-back button").on("click", function() {
                                t(this).closest(".has-children").find("> ul").removeClass("active"), t(".main-header__menu > ul").removeClass("overflow-hidden")
                            });
                            var e = t(".main-header__account__dropdown").html(),
                                i = t(".main-header__menu > ul"),
                                n = '<li class="main-header__menu__account">'.concat(e, "</li>");
                            i.append(n), t(".main-header__menu__mega-menu--larger").length && (t(".main-header__menu__mega-menu--larger > li > ul > li").on("click", function() {
                                var e = t(this);
                                e.siblings().removeClass("active"), e.toggleClass("active")
                            }), t(".main-header__menu__mega-menu--larger > li > ul > li > a").on("click", function(t) {
                                t.preventDefault()
                            }))
                        }
                    }
                }, {
                    key: "initBackground",
                    value: function() {
                        l("[data-background]").each(function(t, e) {
                            l(e).css("background-image", "url(" + l(e).data("background") + ")")
                        }), c.isDesktop() || t(".main-hero-content__video-bg").remove()
                    }
                }, {
                    key: "initClickTriggers",
                    value: function() {
                        t(".single-product-content__video-button").on("click", function () {
                            var e = t(this),
                                i = "",
                                n = e.attr("data-video").match(/^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/);
                            i = n && 11 == n[2].length ? n[2] : "error";
                            var s = '<div class="single-product-content__video-pop-up active">\n                                        <div class="single-product-content__video-pop-up__overlay"></div>\n                                        <div class="single-product-content__video-pop-up__close"></div>\n                                        <div class="single-product-content__video-pop-up__container">\n                                            <div>\n                                                <iframe src="https://www.youtube.com/embed/'.concat(i, '?autoplay=1" frameborder="0"></iframe>\n                                            </div>\n                                        </div>\n                                    </div>');
                            e.after(s), t(".single-product-content__video-pop-up__overlay, .single-product-content__video-pop-up__close").on("click", function () {
                                t(".single-product-content__video-pop-up").remove()
                            })
                        }), t(".single-product-content__view-items > a").on("click", function (e) {
                            e.preventDefault();
                            var i = t(window).scrollTop();
                            t("html").addClass("tinuta-opened"), c.isMobile && (t("body main.main-content").scrollTop(i), t("html.tinuta-opened body main.main-content").attr("data-scroll", i))
                        }), t(".single-items-pop-up__close, .single-items-pop-up__top p, .single-items-pop-up__bottom a").on("click", function (e) {
                            if (e.preventDefault(), t("html").removeClass("tinuta-opened"), c.isMobile) {
                                var i = parseInt(t("body main.main-content").attr("data-scroll"));
                                t(window).scrollTop(i)
                            }
                        }), t(".mobile-products-filter__sort > a").on("click", function (e) {
                            var i = t(window).scrollTop();
                            e.preventDefault(), t(this).parent().addClass("active"), t(".products-sort__overlay").addClass("active"), t("html").addClass("tinuta-opened"), c.isMobile && (t("body main.main-content").scrollTop(i), t("html.tinuta-opened body main.main-content").attr("data-scroll", i))
                        }), t(".single-items-pop-up__close, .single-items-pop-up__top p, .single-items-pop-up__bottom a").on("click", function (e) {
                            if (e.preventDefault(), t("html").removeClass("tinuta-opened"), c.isMobile) {
                                var i = parseInt(t("body main.main-content").attr("data-scroll"));
                                t(window).scrollTop(i)
                            }
                        }),
                            t(".products-sort__overlay, .icon-bman_final_mm_3_x-2").on("click", function (e) {
                                e.preventDefault(), t(".mobile-products-filter__sort").removeClass("active"), t(".products-sort__overlay").removeClass("active");
                                var e = parseInt(t("body main.main-content").attr("data-scroll"));
                                t("html").removeClass("tinuta-opened");
                            }),
                            t(".mobile-products-filter__filters").on("click", function (e) {
                                e.preventDefault();
                                var i = t(window).scrollTop();
                                t("html").addClass("filters-opened"), c.isMobile && (t("body main.main-content").scrollTop(i), t("html.filters-opened body main.main-content").attr("data-scroll", i))
                            }), t(".products-filter__overlay, .products-filter__top i").on("click", function () {
                                t("html").removeClass("filters-opened");
                                var e = parseInt(t("body main.main-content").attr("data-scroll"));
                                t(window).scrollTop(e), t(".products-filter__filters > li").removeClass("active"), t(".products-filter__filters").removeClass("active"), t(".products-filter__top").removeClass("active")
                            }), t(".products-filter__filters > li > a").on("click", function (e) {
                                e.preventDefault();
                                var i = t(this),
                                    n = i.next().outerHeight();
                                i.parent().parent().css("padding-bottom", n), i.parent().hasClass("active") ? (i.parent().removeClass("active"), i.parent().parent().removeClass("active")) : (t(".products-filter__top").addClass("active"), i.parent().addClass("active"), i.parent().siblings().removeClass("active"), i.parent().parent().addClass("active"))
                            }), t(".products-filter__top__get-back").on("click", function () {
                                t(".products-filter__filters > li").removeClass("active"), t(".products-filter__filters").removeClass("active"), t(".products-filter__top").removeClass("active")
                            }), t(".section-title__more").on("click", function (e) {
                                e.preventDefault(), t(this).parent().toggleClass("active")
                            }), document.querySelectorAll('.single-product-content__accordion__top').forEach(function (item) {
                                item.addEventListener('click', function () {
                                    var parent = this.parentElement;
                                    var content = parent.querySelector('.single-product-content__accordion__content');

                                    if (!parent.classList.contains('active')) {
                                        
                                        parent.classList.add('active');
                                        content.style.display = 'block';
                                    } else {
                                        parent.classList.remove('active');
                                        content.style.display = 'none';
                                    }

                                    
                                    event.preventDefault();
                                });
                            }), t(".main-hero-content__scroll-down").on("click", function() {
                            var e = t(this),
                                i = e.closest(".main-hero-content"),
                                n = i.offset().top + i.outerHeight();
                            console.log(e.parent()), t("body,html").animate({
                                scrollTop: n
                            }, 450)
                        }), t(".main-footer__top-widgets .widget > h3").on("click", function() {
                            t(this).parent().toggleClass("active")
                        }), t(".main-header__search > a").on("click", function(e) {
                            e.preventDefault();
                            var i = t(this),
                                n = t(window).scrollTop();
                            if (t("html").toggleClass("search-opened"), t("body").toggleClass("overflow-sidebar-fix"), t("html").removeClass("mobilemenu-opened"), i.delay(450).queue(function(t) {
                                    l('.main-header__search__container input[type="search"]').focus(), t()
                                }), c.isMobile) {
                                t("body main.main-content").scrollTop(n), t("html.search-opened body main.main-content").attr("data-scroll", n);
                                var s = parseInt(t("body main.main-content").attr("data-scroll"));
                                t(window).scrollTop(s)
                            }
                        }), t(".main-header__search__overlay").on("click", function() {
                            if (t("html").removeClass("search-opened"), t("body").removeClass("overflow-sidebar-fix"), c.isDesktop) {
                                var e = parseInt(t("body main.main-content").attr("data-scroll"));
                                t(window).scrollTop(e)
                            }
                        }), t(".my-account-sidebar-content__orders-list__left-side__bottom div.the-last a").on("click", function(e) {
                            e.preventDefault();
                            var i = t(this),
                                n = i.parent().parent();
                            n.find(".the-hidden").removeClass("the-hidden"), i.parent().removeClass("the-last"), n.addClass("shown")
                        }), t(".my-account-sidebar-content__returns__qty").length && (t(".my-account-sidebar-content__returns__qty__plus").on("click", function() {
                            var e = t(this).parent().find("input"),
                                i = parseInt(e.val());
                            e.val(i + 1)
                        }), t(".my-account-sidebar-content__returns__qty__minus").on("click", function() {
                            var e = t(this).parent().find("input"),
                                i = parseInt(e.val());
                            1 !== i && e.val(i - 1)
                        })), c.isDesktop() && (t(".main-header__cart > a").on("click", function(t) {
                            t.preventDefault()
                        }), t(".main-header__cart__dropdown").css("display", "block"), t(".main-header__account__dropdown").css("display", "block"), t(".single-product-content__sizes li label, .single-product-content__accordion__top").on("click", function() {
                            var e = t(this).closest(".single-product-content__right-side"),
                                i = t(".single-product-content__left-side"),
                                n = t(".single-product-content"),
                                s = e.outerHeight(),
                                o = i.outerHeight(),
                                r = n.outerHeight(),
                                a = n.offset().top,
                                l = a + r,
                                h = e.offset().top,
                                c = e.attr("data-top"),
                                d = t(window).scrollTop() - a + t(".main-header").outerHeight(),
                                u = t(window).scrollTop() + t(window).height(),
                                p = o - s,
                                f = u - d;
                            o > 1.3 * s && (d > h && 0 == c || c > 0) && (u > l && (f = l - (t(window).scrollTop() + t(".main-header").outerHeight())), setTimeout(function() {
                                var i = e.outerHeight();
                                d = t(window).scrollTop() - a + t(".main-header").outerHeight(), p = o - i, f >= i ? c = d : f < i && (c = u > l ? p : d + i >= l ? p : d), e.css("transform", "translateY(".concat(c, "px)"))
                            }, 400))
                        }))
                    }
                }, {
                    key: "initCarousels",
                    value: function() {
                        if (t(".single-product-content__thumbs").length && 1 === t(".single-product-content__thumbs li").length && t(".single-product-content__thumbs").addClass("single-image"), t(window).width() <= 1220 && t(window).width() > 800) new s.a(".styles-carousel-with-description .swiper-container", {
                            direction: "horizontal",
                            loop: !1,
                            slidesPerView: 3,
                            spaceBetween: 20,
                            navigation: {
                                nextEl: ".swiper-button-next",
                                prevEl: ".swiper-button-prev"
                            },
                            scrollbar: {
                                el: ".swiper-scrollbar",
                                hide: !1,
                                draggable: !0
                            }
                        }), new s.a(".team-carousel", {
                            direction: "horizontal",
                            loop: !1,
                            slidesPerView: 3,
                            spaceBetween: 20,
                            navigation: {
                                nextEl: ".team-carousel__swiper-button-next",
                                prevEl: ".team-carousel__swiper-button-prev"
                            },
                            scrollbar: !1
                        }), new s.a(".sub-category-listing", {
                            direction: "horizontal",
                            loop: !1,
                            slidesPerView: 3,
                            spaceBetween: 30,
                            navigation: {
                                nextEl: ".sub-category-listing__swiper-button-next",
                                prevEl: ".sub-category-listing__swiper-button-prev"
                            },
                            scrollbar: !1
                        }), new s.a(".blog-single__recomanded-carousel__container", {
                            direction: "horizontal",
                            loop: !1,
                            slidesPerView: 3,
                            spaceBetween: 26,
                            navigation: {
                                nextEl: ".blog-single__recomanded-carousel__swiper-button-next",
                                prevEl: ".blog-single__recomanded-carousel__swiper-button-prev"
                            },
                            scrollbar: !1
                        });
                        else if (t(window).width() <= 800 && t(window).width() > 500) new s.a(".styles-carousel-with-description .swiper-container", {
                            direction: "horizontal",
                            loop: !1,
                            slidesPerView: 2,
                            spaceBetween: 20,
                            navigation: {
                                nextEl: ".swiper-button-next",
                                prevEl: ".swiper-button-prev"
                            },
                            scrollbar: {
                                el: ".swiper-scrollbar",
                                hide: !1,
                                draggable: !0
                            }
                        }), new s.a(".team-carousel", {
                            direction: "horizontal",
                            loop: !1,
                            slidesPerView: 2,
                            spaceBetween: 20,
                            navigation: {
                                nextEl: ".team-carousel__swiper-button-next",
                                prevEl: ".team-carousel__swiper-button-prev"
                            },
                            scrollbar: !1
                        }), new s.a(".sub-category-listing", {
                            direction: "horizontal",
                            loop: !1,
                            slidesPerView: 2,
                            spaceBetween: 30,
                            navigation: {
                                nextEl: ".sub-category-listing__swiper-button-next",
                                prevEl: ".sub-category-listing__swiper-button-prev"
                            },
                            scrollbar: !1
                        }), new s.a(".blog-single__recomanded-carousel__container", {
                            direction: "horizontal",
                            loop: !1,
                            slidesPerView: 2,
                            spaceBetween: 26,
                            navigation: {
                                nextEl: ".blog-single__recomanded-carousel__swiper-button-next",
                                prevEl: ".blog-single__recomanded-carousel__swiper-button-prev"
                            },
                            scrollbar: !1
                        });
                        else if (t(window).width() <= 500) new s.a(".styles-carousel-with-description .swiper-container", {
                            direction: "horizontal",
                            loop: !1,
                            slidesPerView: 1,
                            spaceBetween: 20,
                            navigation: {
                                nextEl: ".swiper-button-next",
                                prevEl: ".swiper-button-prev"
                            },
                            scrollbar: {
                                el: ".swiper-scrollbar",
                                hide: !1,
                                draggable: !0
                            }
                        }), new s.a(".team-carousel", {
                            direction: "horizontal",
                            loop: !1,
                            slidesPerView: 1,
                            spaceBetween: 20,
                            navigation: {
                                nextEl: ".team-carousel__swiper-button-next",
                                prevEl: ".team-carousel__swiper-button-prev"
                            },
                            scrollbar: !1
                        }), new s.a(".sub-category-listing", {
                            direction: "horizontal",
                            loop: !1,
                            slidesPerView: 2,
                            spaceBetween: 20,
                            navigation: {
                                nextEl: ".sub-category-listing__swiper-button-next",
                                prevEl: ".sub-category-listing__swiper-button-prev"
                            },
                            scrollbar: !1
                        }), new s.a(".blog-single__recomanded-carousel__container", {
                            direction: "horizontal",
                            loop: !1,
                            slidesPerView: 1,
                            spaceBetween: 26,
                            navigation: {
                                nextEl: ".blog-single__recomanded-carousel__swiper-button-next",
                                prevEl: ".blog-single__recomanded-carousel__swiper-button-prev"
                            },
                            scrollbar: !1
                        }), new s.a(".recomanded-products", {
                            direction: "horizontal",
                            loop: !1,
                            slidesPerView: 1,
                            spaceBetween: 0,
                            scrollbar: !1
                        }), new s.a(".single-product-content__thumbs__container", {
                            direction: "horizontal",
                            loop: !1,
                            slidesPerView: 1,
                            spaceBetween: 0,
                            scrollbar: !1,
                            pagination: {
                                el: ".single-product-content__thumbs__swiper-pagination"
                            }
                        });
                        else new s.a(".styles-carousel-with-description .swiper-container", {
                            direction: "horizontal",
                            loop: !1,
                            slidesPerView: 4,
                            spaceBetween: 20,
                            navigation: {
                                nextEl: ".swiper-button-next",
                                prevEl: ".swiper-button-prev"
                            },
                            scrollbar: {
                                el: ".swiper-scrollbar",
                                hide: !1,
                                draggable: !0
                            }
                        }), new s.a(".team-carousel", {
                            direction: "horizontal",
                            loop: !1,
                            slidesPerView: 4,
                            spaceBetween: 20,
                            navigation: {
                                nextEl: ".team-carousel__swiper-button-next",
                                prevEl: ".team-carousel__swiper-button-prev"
                            },
                            scrollbar: !1
                        }), new s.a(".sub-category-listing", {
                            direction: "horizontal",
                            loop: !1,
                            slidesPerView: 3,
                            spaceBetween: 30,
                            navigation: {
                                nextEl: ".sub-category-listing__swiper-button-next",
                                prevEl: ".sub-category-listing__swiper-button-prev"
                            },
                            scrollbar: !1
                        }), new s.a(".blog-single__recomanded-carousel__container", {
                            direction: "horizontal",
                            loop: !1,
                            slidesPerView: 3,
                            spaceBetween: 26,
                            navigation: {
                                nextEl: ".blog-single__recomanded-carousel__swiper-button-next",
                                prevEl: ".blog-single__recomanded-carousel__swiper-button-prev"
                            },
                            scrollbar: !1
                        });
                        new s.a(".main-cart__testimonials__carousel__container", {
                            direction: "horizontal",
                            loop: !1,
                            slidesPerView: 1,
                            spaceBetween: 0,
                            navigation: {
                                nextEl: ".main-cart__testimonials__carousel__swiper-button-next",
                                prevEl: ".main-cart__testimonials__carousel__swiper-button-prev"
                            },
                            scrollbar: !1
                        })
                    }
                }, {
                    key: "initProductHoverImage",
                    value: function() {
                        c.isDesktop() && t(".product-item__image").each(function() {
                            var e = t(this);
                            if ("isTrue" !== e.attr("data-loaded")) {
                                var i = e.attr("data-hover"),
                                    n = e.attr("data-title"),
                                    s = '<div class="product-item__image__hover image-background">\n                                            <img src="'.concat(i, '" alt="').concat(n, '" class="image-background__image">\n                                        </div>');
                                e.append(s), e.attr("data-loaded", "isTrue")
                            }
                        })
                    }
                }, {
                    key: "initSingleProduct",
                    value: function() {
                        t(".mobx").length && new ModuloBox({
                            mediaSelector: ".mobx",
                            scrollToZoom: !0,
                            thumbnails: !0,
                            videoAutoPlay: !0,
                            videoThumbnail: !0,
                            thumbnailSizes: {
                                1280: {
                                    width: 80,
                                    height: 105,
                                    gutter: 10
                                }
                            },
                            controls: ["zoom", "fullScreen", "close"],
                            shareButtons: ["facebook", "googleplus", "twitter", "pinterest", "linkedin"]
                        }).init();
                        t(".single-product-content__colors").length && (t(".single-product-content__colors > li").each(function(e) {
                            var i = t(this),
                                n = i.find("label"),
                                s = n.attr("for"),
                                o = i.find("input"),
                                r = o.attr("id");
                            n.attr("for", s + e), o.attr("id", r + e)
                        }), t(".single-product-content__colors li input").on("change", function() {
                            var e = t(this);
                            e.is(":checked") && (e.parent().siblings().removeClass("active"), e.parent().siblings().find("input").prop("checked", !1), e.parent().addClass("active"))
                        })), t(".single-product-content__sizes").length && t(".single-product-content__sizes li input").on("change", function() {
                            var e = t(this),
                                i = e.attr("id"),
                                n = t('.single-product-content__sizes__content li[data-content="'.concat(i, '"]'));
                            e.is(":checked") && (e.parent().siblings().removeClass("active"), e.parent().siblings().find("input").prop("checked", !1), e.parent().addClass("active"), t(".single-product-content__sizes__content li").removeClass("active"), n.each(function() {
                                var e = t(this);
                                e.text().match(/[a-z]/i) && e.addClass("active")
                            }))
                        }), t(".single-product-content__qty").length && (t(".single-product-content__qty__plus").on("click", function() {
                            t(this);
                            var e = t(".single-product-content__qty input"),
                                i = parseInt(e.val());
                            e.val(i + 1)
                        }), t(".single-product-content__qty__minus").on("click", function() {
                            t(this);
                            var e = t(".single-product-content__qty input"),
                                i = parseInt(e.val());
                            1 !== i && e.val(i - 1)
                        })), c.isDesktop()
                    }
                }, {
                    key: "initSticky",
                    value: function() {
                        if (t(".mobile-products-filter").length && t(".mobile-products-filter").each(function() {
                                var e = t(this),
                                    i = e.offset().top,
                                    n = "isFalse";
                                t(window).scroll(function() {
                                    var s = t(window).scrollTop();
                                    s >= i + 54 && "isFalse" === n ? (e.addClass("affixed"), e.before('<div id="mobile-filters-placeholder" style="height: 30px; width: 100%;"></div>'), n = "isTrue") : s < i + 54 && "isTrue" === n && (e.removeClass("affixed"), t(".main-hero-content").css("margin-bottom", "0 !important"), t("#mobile-filters-placeholder").remove(), n = "isFalse")
                                })
                            }), t(".products-filter").length && (t(".products-filter").each(function() {
                                var e = t(this);
                                t(window).scroll(function() {
                                    t(window).scrollTop() >= e.offset().top ? e.addClass("affixed") : e.removeClass("affixed")
                                })
                            }), t(".products-filter__filters > li > div ul li p").each(function() {
                                t(this).parent().addClass("has-image")
                            })), t(".main-cart__total").length) {
                            t(".main-cart__total").each(function() {
                                var e = t(this),
                                    i = e.outerHeight();
                                e.before('<div class="main-cart__total__placeholder active"></div>'), t(".main-cart__total__placeholder").css("height", i)
                            });
                            var e = "isTrue",
                                i = t(".main-cart__total"),
                                n = i.offset().top + i.outerHeight() - 64;
                            // t(window).scroll(function() {
                            //     var i = t(window).scrollTop();
                            //     i >= n && "isTrue" === e ? (t("html").addClass("checkouttotal-opened"), t(".main-cart__total__placeholder").removeClass("active"), e = "isFlase") : i < n && "isFlase" === e && (t("html").removeClass("checkouttotal-opened"), t(".main-cart__total__placeholder").addClass("active"), e = "isTrue")
                            // })
                        }
                    }
                }, {
                    key: "getScrollbarWidth",
                    value: function() {
                        var t = document.createElement("div");
                        t.className = "modal-scrollbar-measure", document.body.appendChild(t);
                        var e = t.getBoundingClientRect().width - t.clientWidth;
                        document.body.removeChild(t);
                        var i = "@media (min-width: 1030px) {\n                        .overflow-sidebar-fix {\n                            padding-right: ".concat(e, "px;\n                        }\n                        .overflow-sidebar-fix .main-header {\n                            width: auto;\n                            right: ").concat(e, "px;\n                        }\n                        .main-header__menu > ul > li.active .main-header__menu__mega-menu {\n                            width: 100%;\n                            right: ").concat(e, "px;\n                        }\n                    }"),
                            n = document.head || document.getElementsByTagName("head")[0],
                            s = document.createElement("style");
                        s.type = "text/css", s.styleSheet ? s.styleSheet.cssText = i : s.appendChild(document.createTextNode(i)), n.appendChild(s)
                    }
                }, {
                    key: "insertParam",
                    value: function(t, e) {
                        var i = window.location.protocol + "//" + window.location.host + window.location.pathname + "?" + t + "=" + e;
                        window.history.pushState({
                            path: i
                        }, "", i)
                    }
                }, {
                    key: "accountChangeContentBasedOnUrlParam",
                    value: function(e) {
                        var i = window.location.href,
                            n = new URL(i).searchParams.get(e);
                        "" !== e ? (t(".my-account-sidebar-content__sidebar li a").removeClass("active"), t('.my-account-sidebar-content__sidebar li a[data-page="'.concat(n, '"]')).addClass("active"), t(".my-account-sidebar-content__content").removeClass("active"), t('.my-account-sidebar-content__content[data-content="'.concat(n, '"]')).addClass("active")) : (t(".my-account-sidebar-content__sidebar li a").removeClass("active"), t('.my-account-sidebar-content__sidebar li a[data-page="orders"]').addClass("active"), t(".my-account-sidebar-content__content").removeClass("active"), t('.my-account-sidebar-content__content[data-content="orders"]').addClass("active"))
                    }
                }, {
                    key: "accountMeasures",
                    value: function() {
                        t(".my-account-sidebar-content__measures").length && (t(".my-account-sidebar-content__measures__next-step").on("click", function() {
                            var e = t(this),
                                i = t(".my-account-sidebar-content__measures__item"),
                                n = e.closest(".my-account-sidebar-content__measures__item").next();
                            n.length && (i.removeClass("active"), n.addClass("active"))
                        }), t(".my-account-sidebar-content__measures__prev-step").on("click", function() {
                            var e = t(this),
                                i = t(".my-account-sidebar-content__measures__item"),
                                n = e.closest(".my-account-sidebar-content__measures__item").prev();
                            n.length && (i.removeClass("active"), n.addClass("active"))
                        }))
                    }
                }, {
                    key: "initImagesBackground",
                    value: function() {
                        var e = i(126);
                        t(".image-background").each(function(i) {
                            var n = t(this);
                            e(n, function() {
                                var t = n.attr("data-loadedImage"),
                                    e = n.find("> .image-background__image");
                                n.outerHeight() > e.outerHeight() && "true" !== t && e.addClass("image-background__image--max-width-inherit"), n.attr("data-loadedImage", "true"), e.addClass("active")
                            })
                        })
                    }
                }, {
                    key: "initStates",
                    value: function() {
                        var e = this;
                        t(".products-filter__filters > li").find("li.selected").length && t(".products-filter__filters > li").each(function() {
                            var e = t(this);
                            e.find("li.selected").length && (e.addClass("active-filter"), t(".clear-all-filters").addClass("displayclear"))
                        }), t(".my-account-sidebar-content").length && (e.accountChangeContentBasedOnUrlParam("view"), window.addEventListener("popstate", function(t) {
                            console.log("url has changed"), e.accountChangeContentBasedOnUrlParam("view")
                        }), t(".my-account-sidebar-content__sidebar li a").on("click", function() {
                            var i = t(this).attr("data-page");
                            "" !== i && (e.insertParam("view", i), e.accountChangeContentBasedOnUrlParam("view"))
                        })), t(".my-account-sidebar-content__measures__body-type__checkbox").length && t(".my-account-sidebar-content__measures__body-type__checkbox").each(function() {
                            t(this).find("input").on("change", function(e) {
                                var i = t(this),
                                    n = t(".my-account-sidebar-content__measures__body-type__image"),
                                    s = i.parent().parent().find(".my-account-sidebar-content__measures__body-type__image");
                                n.removeClass("active"), s.addClass("active")
                            })
                        })
                    }
                }, {
                    key: "initIonRangeSlider",
                    value: function() {
                        t(".my-account-sidebar-content__measures__height").ionRangeSlider({
                            skin: "round",
                            from_fixed: !1,
                            min: 160,
                            max: 210,
                            from: 175,
                            step: 1,
                            hide_from_to: !0,
                            hide_min_max: !0,
                            onChange: function(e) {
                                t(".my-account-sidebar-content__measures__height__label").text(e.from)
                            }
                        }), t(".my-account-sidebar-content__measures__weight").ionRangeSlider({
                            skin: "round",
                            from_fixed: !1,
                            min: 55,
                            max: 125,
                            from: 75,
                            step: 1,
                            hide_from_to: !0,
                            hide_min_max: !0,
                            onChange: function(e) {
                                t(".my-account-sidebar-content__measures__weight__label").text(e.from)
                            }
                        })
                    }
                }, {
                    key: "initTranslates",
                    value: function() {
                        if (t(".Esc-returns-container").length) {
                            var e = t(".Esc-returns-container"),
                                i = e.find("h3, h4, p, label, button, small, .alert"),
                                n = e.find("input");
                            i.each(function() {
                                var e = t(this).text();
                                t(this).text(e.replace("To start the return process for your order,", "Pentru a incepe procesul de returnare a comenzii tale,").replace("please enter your email address or phone number and the order number below.", "te rugam sa introduci adresa ta de e-mail sau numarul de telefon si numarul comenzii mai jos.").replace("Email Address / Phone Number:", "Adresa de E-mail / Numarul de Telefon:").replace("Submit a new return request", "Trimite o cerere noua de retur").replace("Order Number:", "Numarul Comenzii:").replace("Select the quantity of the products you want to return", "Selectează cantitatea produselor pe care vrei sa le returnezi").replace("Choose the reason for return for each item", "Alege motivul returnarii fiecarui produs").replace("Ordered by:", "Comandat de:").replace("Order", "Comanda").replace("Next Step", "Pasul Urmator").replace("Finish", "Finalizare").replace("Notes:", "Detalii:").replace("Submit", "Trimite").replace("You didn't select any products to return.", "Nu ai selectat niciun produs pentru retur.").replace("We couldn't find your order. Please check if you entered the right email address / phone number and order number.", "Nu am putut sa-ti gasim comanda. Te rugam sa verifici daca ai introdus corect adresa de e-mail sau numarul de telefon si numarul comenzii.").replace("Notification Email:", "E-mail-ul pentru notificari:").replace("This email is needed if we send a return label, and all notifications regarding the status of your return.", "Este nevoie de acest e-mail pentru a va tine la curent cu starea returului dumneavoastra."))
                            }), n.each(function() {
                                var e = t(this).attr("placeholder");
                                "Email Address or Phone Number" === e && t(this).attr("placeholder", "Adresa de E-mail sau Numarul de Telefon"), "Order Number" === e && t(this).attr("placeholder", "Numarul Comenzii")
                            })
                        }
                    }
                }]), e
            }();
            t(document).ready(function(t) {
                new d
            })
        }.call(this, i(3))
  }, function(t, e, i) {
    "use strict";
    var n = i(2),
        s = i(33)(5),
        o = !0;
    "find" in [] && Array(1).find(function() {
        o = !1
    }), n(n.P + n.F * o, "Array", {
        find: function(t) {
            return s(this, t, arguments.length > 1 ? arguments[1] : void 0)
        }
    }), i(49)("find")
  }, function(t, e, i) {
    var n = i(65);
    t.exports = function(t, e) {
        return new(n(t))(e)
    }
  }, function(t, e, i) {
    var n = i(8),
        s = i(48),
        o = i(1)("species");
    t.exports = function(t) {
        var e;
        return s(t) && ("function" != typeof(e = t.constructor) || e !== Array && !s(e.prototype) || (e = void 0), n(e) && null === (e = e[o]) && (e = void 0)), void 0 === e ? Array : e
    }
  }, function(t, e, i) {
    var n = i(2);
    n(n.S + n.F * !i(6), "Object", {
        defineProperty: i(5).f
    })
  }, function(t, e, i) {}, function(t, e, i) {}, function(t, e, i) {}, function(t, e, i) {}, function(t, e, i) {}, function(t, e, i) {}, function(t, e, i) {
    (function(n) {
        var s, o;
        ! function(r) {
            !n && i(74) ? (s = [i(3)], void 0 === (o = function(t) {
                return r(t, document, window, navigator)
            }.apply(e, s)) || (t.exports = o)) : r(n || "object" != typeof e ? n : i(3), document, window, navigator)
        }(function(t, e, i, n, s) {
            "use strict";
            var o = 0,
                r = function() {
                    var e = n.userAgent,
                        i = /msie\s\d+/i;
                    return e.search(i) > 0 && i.exec(e).toString().split(" ")[1] < 9 && (t("html").addClass("lt-ie9"), !0)
                }();
            Function.prototype.bind || (Function.prototype.bind = function(t) {
                var e = this,
                    i = [].slice;
                if ("function" != typeof e) throw new TypeError;
                var n = i.call(arguments, 1),
                    s = function() {
                        if (this instanceof s) {
                            var o = function() {};
                            o.prototype = e.prototype;
                            var r = new o,
                                a = e.apply(r, n.concat(i.call(arguments)));
                            return Object(a) === a ? a : r
                        }
                        return e.apply(t, n.concat(i.call(arguments)))
                    };
                return s
            }), Array.prototype.indexOf || (Array.prototype.indexOf = function(t, e) {
                var i;
                if (null == this) throw new TypeError('"this" is null or not defined');
                var n = Object(this),
                    s = n.length >>> 0;
                if (0 === s) return -1;
                var o = +e || 0;
                if (Math.abs(o) === 1 / 0 && (o = 0), o >= s) return -1;
                for (i = Math.max(o >= 0 ? o : s - Math.abs(o), 0); i < s;) {
                    if (i in n && n[i] === t) return i;
                    i++
                }
                return -1
            });
            var a = function(n, o, r) {
                this.VERSION = "2.3.0", this.input = n, this.plugin_count = r, this.current_plugin = 0, this.calc_count = 0, this.update_tm = 0, this.old_from = 0, this.old_to = 0, this.old_min_interval = null, this.raf_id = null, this.dragging = !1, this.force_redraw = !1, this.no_diapason = !1, this.has_tab_index = !0, this.is_key = !1, this.is_update = !1, this.is_start = !0, this.is_finish = !1, this.is_active = !1, this.is_resize = !1, this.is_click = !1, o = o || {}, this.$cache = {
                    win: t(i),
                    body: t(e.body),
                    input: t(n),
                    cont: null,
                    rs: null,
                    min: null,
                    max: null,
                    from: null,
                    to: null,
                    single: null,
                    bar: null,
                    line: null,
                    s_single: null,
                    s_from: null,
                    s_to: null,
                    shad_single: null,
                    shad_from: null,
                    shad_to: null,
                    edge: null,
                    grid: null,
                    grid_labels: []
                }, this.coords = {
                    x_gap: 0,
                    x_pointer: 0,
                    w_rs: 0,
                    w_rs_old: 0,
                    w_handle: 0,
                    p_gap: 0,
                    p_gap_left: 0,
                    p_gap_right: 0,
                    p_step: 0,
                    p_pointer: 0,
                    p_handle: 0,
                    p_single_fake: 0,
                    p_single_real: 0,
                    p_from_fake: 0,
                    p_from_real: 0,
                    p_to_fake: 0,
                    p_to_real: 0,
                    p_bar_x: 0,
                    p_bar_w: 0,
                    grid_gap: 0,
                    big_num: 0,
                    big: [],
                    big_w: [],
                    big_p: [],
                    big_x: []
                }, this.labels = {
                    w_min: 0,
                    w_max: 0,
                    w_from: 0,
                    w_to: 0,
                    w_single: 0,
                    p_min: 0,
                    p_max: 0,
                    p_from_fake: 0,
                    p_from_left: 0,
                    p_to_fake: 0,
                    p_to_left: 0,
                    p_single_fake: 0,
                    p_single_left: 0
                };
                var a, l, h, c = this.$cache.input,
                    d = c.prop("value");
                for (h in a = {
                        skin: "flat",
                        type: "single",
                        min: 10,
                        max: 100,
                        from: null,
                        to: null,
                        step: 1,
                        min_interval: 0,
                        max_interval: 0,
                        drag_interval: !1,
                        values: [],
                        p_values: [],
                        from_fixed: !1,
                        from_min: null,
                        from_max: null,
                        from_shadow: !1,
                        to_fixed: !1,
                        to_min: null,
                        to_max: null,
                        to_shadow: !1,
                        prettify_enabled: !0,
                        prettify_separator: " ",
                        prettify: null,
                        force_edges: !1,
                        keyboard: !0,
                        grid: !1,
                        grid_margin: !0,
                        grid_num: 4,
                        grid_snap: !1,
                        hide_min_max: !1,
                        hide_from_to: !1,
                        prefix: "",
                        postfix: "",
                        max_postfix: "",
                        decorate_both: !0,
                        values_separator: " — ",
                        input_values_separator: ";",
                        disable: !1,
                        block: !1,
                        extra_classes: "",
                        scope: null,
                        onStart: null,
                        onChange: null,
                        onFinish: null,
                        onUpdate: null
                    }, "INPUT" !== c[0].nodeName && console && console.warn && console.warn("Base element should be <input>!", c[0]), (l = {
                        skin: c.data("skin"),
                        type: c.data("type"),
                        min: c.data("min"),
                        max: c.data("max"),
                        from: c.data("from"),
                        to: c.data("to"),
                        step: c.data("step"),
                        min_interval: c.data("minInterval"),
                        max_interval: c.data("maxInterval"),
                        drag_interval: c.data("dragInterval"),
                        values: c.data("values"),
                        from_fixed: c.data("fromFixed"),
                        from_min: c.data("fromMin"),
                        from_max: c.data("fromMax"),
                        from_shadow: c.data("fromShadow"),
                        to_fixed: c.data("toFixed"),
                        to_min: c.data("toMin"),
                        to_max: c.data("toMax"),
                        to_shadow: c.data("toShadow"),
                        prettify_enabled: c.data("prettifyEnabled"),
                        prettify_separator: c.data("prettifySeparator"),
                        force_edges: c.data("forceEdges"),
                        keyboard: c.data("keyboard"),
                        grid: c.data("grid"),
                        grid_margin: c.data("gridMargin"),
                        grid_num: c.data("gridNum"),
                        grid_snap: c.data("gridSnap"),
                        hide_min_max: c.data("hideMinMax"),
                        hide_from_to: c.data("hideFromTo"),
                        prefix: c.data("prefix"),
                        postfix: c.data("postfix"),
                        max_postfix: c.data("maxPostfix"),
                        decorate_both: c.data("decorateBoth"),
                        values_separator: c.data("valuesSeparator"),
                        input_values_separator: c.data("inputValuesSeparator"),
                        disable: c.data("disable"),
                        block: c.data("block"),
                        extra_classes: c.data("extraClasses")
                    }).values = l.values && l.values.split(","), l) l.hasOwnProperty(h) && (l[h] !== s && "" !== l[h] || delete l[h]);
                d !== s && "" !== d && ((d = d.split(l.input_values_separator || o.input_values_separator || ";"))[0] && d[0] == +d[0] && (d[0] = +d[0]), d[1] && d[1] == +d[1] && (d[1] = +d[1]), o && o.values && o.values.length ? (a.from = d[0] && o.values.indexOf(d[0]), a.to = d[1] && o.values.indexOf(d[1])) : (a.from = d[0] && +d[0], a.to = d[1] && +d[1])), t.extend(a, o), t.extend(a, l), this.options = a, this.update_check = {}, this.validate(), this.result = {
                    input: this.$cache.input,
                    slider: null,
                    min: this.options.min,
                    max: this.options.max,
                    from: this.options.from,
                    from_percent: 0,
                    from_value: null,
                    to: this.options.to,
                    to_percent: 0,
                    to_value: null
                }, this.init()
            };
            a.prototype = {
                    init: function(t) {
                        this.no_diapason = !1, this.coords.p_step = this.convertToPercent(this.options.step, !0), this.target = "base", this.toggleInput(), this.append(), this.setMinMax(), t ? (this.force_redraw = !0, this.calc(!0), this.callOnUpdate()) : (this.force_redraw = !0, this.calc(!0), this.callOnStart()), this.updateScene()
                    },
                    append: function() {
                        var t = '<span class="irs irs--' + this.options.skin + " js-irs-" + this.plugin_count + " " + this.options.extra_classes + '"></span>';
                        this.$cache.input.before(t), this.$cache.input.prop("readonly", !0), this.$cache.cont = this.$cache.input.prev(), this.result.slider = this.$cache.cont, this.$cache.cont.html('<span class="irs"><span class="irs-line" tabindex="0"></span><span class="irs-min">0</span><span class="irs-max">1</span><span class="irs-from">0</span><span class="irs-to">0</span><span class="irs-single">0</span></span><span class="irs-grid"></span>'), this.$cache.rs = this.$cache.cont.find(".irs"), this.$cache.min = this.$cache.cont.find(".irs-min"), this.$cache.max = this.$cache.cont.find(".irs-max"), this.$cache.from = this.$cache.cont.find(".irs-from"), this.$cache.to = this.$cache.cont.find(".irs-to"), this.$cache.single = this.$cache.cont.find(".irs-single"), this.$cache.line = this.$cache.cont.find(".irs-line"), this.$cache.grid = this.$cache.cont.find(".irs-grid"), "single" === this.options.type ? (this.$cache.cont.append('<span class="irs-bar irs-bar--single"></span><span class="irs-shadow shadow-single"></span><span class="irs-handle single"><i></i><i></i><i></i></span>'), this.$cache.bar = this.$cache.cont.find(".irs-bar"), this.$cache.edge = this.$cache.cont.find(".irs-bar-edge"), this.$cache.s_single = this.$cache.cont.find(".single"), this.$cache.from[0].style.visibility = "hidden", this.$cache.to[0].style.visibility = "hidden", this.$cache.shad_single = this.$cache.cont.find(".shadow-single")) : (this.$cache.cont.append('<span class="irs-bar"></span><span class="irs-shadow shadow-from"></span><span class="irs-shadow shadow-to"></span><span class="irs-handle from"><i></i><i></i><i></i></span><span class="irs-handle to"><i></i><i></i><i></i></span>'), this.$cache.bar = this.$cache.cont.find(".irs-bar"), this.$cache.s_from = this.$cache.cont.find(".from"), this.$cache.s_to = this.$cache.cont.find(".to"), this.$cache.shad_from = this.$cache.cont.find(".shadow-from"), this.$cache.shad_to = this.$cache.cont.find(".shadow-to"), this.setTopHandler()), this.options.hide_from_to && (this.$cache.from[0].style.display = "none", this.$cache.to[0].style.display = "none", this.$cache.single[0].style.display = "none"), this.appendGrid(), this.options.disable ? (this.appendDisableMask(), this.$cache.input[0].disabled = !0) : (this.$cache.input[0].disabled = !1, this.removeDisableMask(), this.bindEvents()), this.options.disable || (this.options.block ? this.appendDisableMask() : this.removeDisableMask()), this.options.drag_interval && (this.$cache.bar[0].style.cursor = "ew-resize")
                    },
                    setTopHandler: function() {
                        var t = this.options.min,
                            e = this.options.max,
                            i = this.options.from,
                            n = this.options.to;
                        i > t && n === e ? this.$cache.s_from.addClass("type_last") : n < e && this.$cache.s_to.addClass("type_last")
                    },
                    changeLevel: function(t) {
                        switch (t) {
                            case "single":
                                this.coords.p_gap = this.toFixed(this.coords.p_pointer - this.coords.p_single_fake), this.$cache.s_single.addClass("state_hover");
                                break;
                            case "from":
                                this.coords.p_gap = this.toFixed(this.coords.p_pointer - this.coords.p_from_fake), this.$cache.s_from.addClass("state_hover"), this.$cache.s_from.addClass("type_last"), this.$cache.s_to.removeClass("type_last");
                                break;
                            case "to":
                                this.coords.p_gap = this.toFixed(this.coords.p_pointer - this.coords.p_to_fake), this.$cache.s_to.addClass("state_hover"), this.$cache.s_to.addClass("type_last"), this.$cache.s_from.removeClass("type_last");
                                break;
                            case "both":
                                this.coords.p_gap_left = this.toFixed(this.coords.p_pointer - this.coords.p_from_fake), this.coords.p_gap_right = this.toFixed(this.coords.p_to_fake - this.coords.p_pointer), this.$cache.s_to.removeClass("type_last"), this.$cache.s_from.removeClass("type_last")
                        }
                    },
                    appendDisableMask: function() {
                        this.$cache.cont.append('<span class="irs-disable-mask"></span>'), this.$cache.cont.addClass("irs-disabled")
                    },
                    removeDisableMask: function() {
                        this.$cache.cont.remove(".irs-disable-mask"), this.$cache.cont.removeClass("irs-disabled")
                    },
                    remove: function() {
                        this.$cache.cont.remove(), this.$cache.cont = null, this.$cache.line.off("keydown.irs_" + this.plugin_count), this.$cache.body.off("touchmove.irs_" + this.plugin_count), this.$cache.body.off("mousemove.irs_" + this.plugin_count), this.$cache.win.off("touchend.irs_" + this.plugin_count), this.$cache.win.off("mouseup.irs_" + this.plugin_count), r && (this.$cache.body.off("mouseup.irs_" + this.plugin_count), this.$cache.body.off("mouseleave.irs_" + this.plugin_count)), this.$cache.grid_labels = [], this.coords.big = [], this.coords.big_w = [], this.coords.big_p = [], this.coords.big_x = [], cancelAnimationFrame(this.raf_id)
                    },
                    bindEvents: function() {
                        this.no_diapason || (this.$cache.body.on("touchmove.irs_" + this.plugin_count, this.pointerMove.bind(this)), this.$cache.body.on("mousemove.irs_" + this.plugin_count, this.pointerMove.bind(this)), this.$cache.win.on("touchend.irs_" + this.plugin_count, this.pointerUp.bind(this)), this.$cache.win.on("mouseup.irs_" + this.plugin_count, this.pointerUp.bind(this)), this.$cache.line.on("touchstart.irs_" + this.plugin_count, this.pointerClick.bind(this, "click")), this.$cache.line.on("mousedown.irs_" + this.plugin_count, this.pointerClick.bind(this, "click")), this.$cache.line.on("focus.irs_" + this.plugin_count, this.pointerFocus.bind(this)), this.options.drag_interval && "double" === this.options.type ? (this.$cache.bar.on("touchstart.irs_" + this.plugin_count, this.pointerDown.bind(this, "both")), this.$cache.bar.on("mousedown.irs_" + this.plugin_count, this.pointerDown.bind(this, "both"))) : (this.$cache.bar.on("touchstart.irs_" + this.plugin_count, this.pointerClick.bind(this, "click")), this.$cache.bar.on("mousedown.irs_" + this.plugin_count, this.pointerClick.bind(this, "click"))), "single" === this.options.type ? (this.$cache.single.on("touchstart.irs_" + this.plugin_count, this.pointerDown.bind(this, "single")), this.$cache.s_single.on("touchstart.irs_" + this.plugin_count, this.pointerDown.bind(this, "single")), this.$cache.shad_single.on("touchstart.irs_" + this.plugin_count, this.pointerClick.bind(this, "click")), this.$cache.single.on("mousedown.irs_" + this.plugin_count, this.pointerDown.bind(this, "single")), this.$cache.s_single.on("mousedown.irs_" + this.plugin_count, this.pointerDown.bind(this, "single")), this.$cache.edge.on("mousedown.irs_" + this.plugin_count, this.pointerClick.bind(this, "click")), this.$cache.shad_single.on("mousedown.irs_" + this.plugin_count, this.pointerClick.bind(this, "click"))) : (this.$cache.single.on("touchstart.irs_" + this.plugin_count, this.pointerDown.bind(this, null)), this.$cache.single.on("mousedown.irs_" + this.plugin_count, this.pointerDown.bind(this, null)), this.$cache.from.on("touchstart.irs_" + this.plugin_count, this.pointerDown.bind(this, "from")), this.$cache.s_from.on("touchstart.irs_" + this.plugin_count, this.pointerDown.bind(this, "from")), this.$cache.to.on("touchstart.irs_" + this.plugin_count, this.pointerDown.bind(this, "to")), this.$cache.s_to.on("touchstart.irs_" + this.plugin_count, this.pointerDown.bind(this, "to")), this.$cache.shad_from.on("touchstart.irs_" + this.plugin_count, this.pointerClick.bind(this, "click")), this.$cache.shad_to.on("touchstart.irs_" + this.plugin_count, this.pointerClick.bind(this, "click")), this.$cache.from.on("mousedown.irs_" + this.plugin_count, this.pointerDown.bind(this, "from")), this.$cache.s_from.on("mousedown.irs_" + this.plugin_count, this.pointerDown.bind(this, "from")), this.$cache.to.on("mousedown.irs_" + this.plugin_count, this.pointerDown.bind(this, "to")), this.$cache.s_to.on("mousedown.irs_" + this.plugin_count, this.pointerDown.bind(this, "to")), this.$cache.shad_from.on("mousedown.irs_" + this.plugin_count, this.pointerClick.bind(this, "click")), this.$cache.shad_to.on("mousedown.irs_" + this.plugin_count, this.pointerClick.bind(this, "click"))), this.options.keyboard && this.$cache.line.on("keydown.irs_" + this.plugin_count, this.key.bind(this, "keyboard")), r && (this.$cache.body.on("mouseup.irs_" + this.plugin_count, this.pointerUp.bind(this)), this.$cache.body.on("mouseleave.irs_" + this.plugin_count, this.pointerUp.bind(this))))
                    },
                    pointerFocus: function(t) {
                        var e, i;
                        this.target || (e = (i = "single" === this.options.type ? this.$cache.single : this.$cache.from).offset().left, e += i.width() / 2 - 1, this.pointerClick("single", {
                            preventDefault: function() {},
                            pageX: e
                        }))
                    },
                    pointerMove: function(t) {
                        if (this.dragging) {
                            var e = t.pageX || t.originalEvent.touches && t.originalEvent.touches[0].pageX;
                            this.coords.x_pointer = e - this.coords.x_gap, this.calc()
                        }
                    },
                    pointerUp: function(e) {
                        this.current_plugin === this.plugin_count && this.is_active && (this.is_active = !1, this.$cache.cont.find(".state_hover").removeClass("state_hover"), this.force_redraw = !0, r && t("*").prop("unselectable", !1), this.updateScene(), this.restoreOriginalMinInterval(), (t.contains(this.$cache.cont[0], e.target) || this.dragging) && this.callOnFinish(), this.dragging = !1)
                    },
                    pointerDown: function(e, i) {
                        i.preventDefault();
                        var n = i.pageX || i.originalEvent.touches && i.originalEvent.touches[0].pageX;
                        2 !== i.button && ("both" === e && this.setTempMinInterval(), e || (e = this.target || "from"), this.current_plugin = this.plugin_count, this.target = e, this.is_active = !0, this.dragging = !0, this.coords.x_gap = this.$cache.rs.offset().left, this.coords.x_pointer = n - this.coords.x_gap, this.calcPointerPercent(), this.changeLevel(e), r && t("*").prop("unselectable", !0), this.$cache.line.trigger("focus"), this.updateScene())
                    },
                    pointerClick: function(t, e) {
                        e.preventDefault();
                        var i = e.pageX || e.originalEvent.touches && e.originalEvent.touches[0].pageX;
                        2 !== e.button && (this.current_plugin = this.plugin_count, this.target = t, this.is_click = !0, this.coords.x_gap = this.$cache.rs.offset().left, this.coords.x_pointer = +(i - this.coords.x_gap).toFixed(), this.force_redraw = !0, this.calc(), this.$cache.line.trigger("focus"))
                    },
                    key: function(t, e) {
                        if (!(this.current_plugin !== this.plugin_count || e.altKey || e.ctrlKey || e.shiftKey || e.metaKey)) {
                            switch (e.which) {
                                case 83:
                                case 65:
                                case 40:
                                case 37:
                                    e.preventDefault(), this.moveByKey(!1);
                                    break;
                                case 87:
                                case 68:
                                case 38:
                                case 39:
                                    e.preventDefault(), this.moveByKey(!0)
                            }
                            return !0
                        }
                    },
                    moveByKey: function(t) {
                        var e = this.coords.p_pointer,
                            i = (this.options.max - this.options.min) / 100;
                        i = this.options.step / i, t ? e += i : e -= i, this.coords.x_pointer = this.toFixed(this.coords.w_rs / 100 * e), this.is_key = !0, this.calc()
                    },
                    setMinMax: function() {
                        if (this.options) {
                            if (this.options.hide_min_max) return this.$cache.min[0].style.display = "none", void(this.$cache.max[0].style.display = "none");
                            if (this.options.values.length) this.$cache.min.html(this.decorate(this.options.p_values[this.options.min])), this.$cache.max.html(this.decorate(this.options.p_values[this.options.max]));
                            else {
                                var t = this._prettify(this.options.min),
                                    e = this._prettify(this.options.max);
                                this.result.min_pretty = t, this.result.max_pretty = e, this.$cache.min.html(this.decorate(t, this.options.min)), this.$cache.max.html(this.decorate(e, this.options.max))
                            }
                            this.labels.w_min = this.$cache.min.outerWidth(!1), this.labels.w_max = this.$cache.max.outerWidth(!1)
                        }
                    },
                    setTempMinInterval: function() {
                        var t = this.result.to - this.result.from;
                        null === this.old_min_interval && (this.old_min_interval = this.options.min_interval), this.options.min_interval = t
                    },
                    restoreOriginalMinInterval: function() {
                        null !== this.old_min_interval && (this.options.min_interval = this.old_min_interval, this.old_min_interval = null)
                    },
                    calc: function(t) {
                        if (this.options && (this.calc_count++, (10 === this.calc_count || t) && (this.calc_count = 0, this.coords.w_rs = this.$cache.rs.outerWidth(!1), this.calcHandlePercent()), this.coords.w_rs)) {
                            this.calcPointerPercent();
                            var e = this.getHandleX();
                            switch ("both" === this.target && (this.coords.p_gap = 0, e = this.getHandleX()), "click" === this.target && (this.coords.p_gap = this.coords.p_handle / 2, e = this.getHandleX(), this.options.drag_interval ? this.target = "both_one" : this.target = this.chooseHandle(e)), this.target) {
                                case "base":
                                    var i = (this.options.max - this.options.min) / 100,
                                        n = (this.result.from - this.options.min) / i,
                                        s = (this.result.to - this.options.min) / i;
                                    this.coords.p_single_real = this.toFixed(n), this.coords.p_from_real = this.toFixed(n), this.coords.p_to_real = this.toFixed(s), this.coords.p_single_real = this.checkDiapason(this.coords.p_single_real, this.options.from_min, this.options.from_max), this.coords.p_from_real = this.checkDiapason(this.coords.p_from_real, this.options.from_min, this.options.from_max), this.coords.p_to_real = this.checkDiapason(this.coords.p_to_real, this.options.to_min, this.options.to_max), this.coords.p_single_fake = this.convertToFakePercent(this.coords.p_single_real), this.coords.p_from_fake = this.convertToFakePercent(this.coords.p_from_real), this.coords.p_to_fake = this.convertToFakePercent(this.coords.p_to_real), this.target = null;
                                    break;
                                case "single":
                                    if (this.options.from_fixed) break;
                                    this.coords.p_single_real = this.convertToRealPercent(e), this.coords.p_single_real = this.calcWithStep(this.coords.p_single_real), this.coords.p_single_real = this.checkDiapason(this.coords.p_single_real, this.options.from_min, this.options.from_max), this.coords.p_single_fake = this.convertToFakePercent(this.coords.p_single_real);
                                    break;
                                case "from":
                                    if (this.options.from_fixed) break;
                                    this.coords.p_from_real = this.convertToRealPercent(e), this.coords.p_from_real = this.calcWithStep(this.coords.p_from_real), this.coords.p_from_real > this.coords.p_to_real && (this.coords.p_from_real = this.coords.p_to_real), this.coords.p_from_real = this.checkDiapason(this.coords.p_from_real, this.options.from_min, this.options.from_max), this.coords.p_from_real = this.checkMinInterval(this.coords.p_from_real, this.coords.p_to_real, "from"), this.coords.p_from_real = this.checkMaxInterval(this.coords.p_from_real, this.coords.p_to_real, "from"), this.coords.p_from_fake = this.convertToFakePercent(this.coords.p_from_real);
                                    break;
                                case "to":
                                    if (this.options.to_fixed) break;
                                    this.coords.p_to_real = this.convertToRealPercent(e), this.coords.p_to_real = this.calcWithStep(this.coords.p_to_real), this.coords.p_to_real < this.coords.p_from_real && (this.coords.p_to_real = this.coords.p_from_real), this.coords.p_to_real = this.checkDiapason(this.coords.p_to_real, this.options.to_min, this.options.to_max), this.coords.p_to_real = this.checkMinInterval(this.coords.p_to_real, this.coords.p_from_real, "to"), this.coords.p_to_real = this.checkMaxInterval(this.coords.p_to_real, this.coords.p_from_real, "to"), this.coords.p_to_fake = this.convertToFakePercent(this.coords.p_to_real);
                                    break;
                                case "both":
                                    if (this.options.from_fixed || this.options.to_fixed) break;
                                    e = this.toFixed(e + .001 * this.coords.p_handle), this.coords.p_from_real = this.convertToRealPercent(e) - this.coords.p_gap_left, this.coords.p_from_real = this.calcWithStep(this.coords.p_from_real), this.coords.p_from_real = this.checkDiapason(this.coords.p_from_real, this.options.from_min, this.options.from_max), this.coords.p_from_real = this.checkMinInterval(this.coords.p_from_real, this.coords.p_to_real, "from"), this.coords.p_from_fake = this.convertToFakePercent(this.coords.p_from_real), this.coords.p_to_real = this.convertToRealPercent(e) + this.coords.p_gap_right, this.coords.p_to_real = this.calcWithStep(this.coords.p_to_real), this.coords.p_to_real = this.checkDiapason(this.coords.p_to_real, this.options.to_min, this.options.to_max), this.coords.p_to_real = this.checkMinInterval(this.coords.p_to_real, this.coords.p_from_real, "to"), this.coords.p_to_fake = this.convertToFakePercent(this.coords.p_to_real);
                                    break;
                                case "both_one":
                                    if (this.options.from_fixed || this.options.to_fixed) break;
                                    var o = this.convertToRealPercent(e),
                                        r = this.result.from_percent,
                                        a = this.result.to_percent - r,
                                        l = a / 2,
                                        h = o - l,
                                        c = o + l;
                                    h < 0 && (c = (h = 0) + a), c > 100 && (h = (c = 100) - a), this.coords.p_from_real = this.calcWithStep(h), this.coords.p_from_real = this.checkDiapason(this.coords.p_from_real, this.options.from_min, this.options.from_max), this.coords.p_from_fake = this.convertToFakePercent(this.coords.p_from_real), this.coords.p_to_real = this.calcWithStep(c), this.coords.p_to_real = this.checkDiapason(this.coords.p_to_real, this.options.to_min, this.options.to_max), this.coords.p_to_fake = this.convertToFakePercent(this.coords.p_to_real)
                            }
                            "single" === this.options.type ? (this.coords.p_bar_x = this.coords.p_handle / 2, this.coords.p_bar_w = this.coords.p_single_fake, this.result.from_percent = this.coords.p_single_real, this.result.from = this.convertToValue(this.coords.p_single_real), this.result.from_pretty = this._prettify(this.result.from), this.options.values.length && (this.result.from_value = this.options.values[this.result.from])) : (this.coords.p_bar_x = this.toFixed(this.coords.p_from_fake + this.coords.p_handle / 2), this.coords.p_bar_w = this.toFixed(this.coords.p_to_fake - this.coords.p_from_fake), this.result.from_percent = this.coords.p_from_real, this.result.from = this.convertToValue(this.coords.p_from_real), this.result.from_pretty = this._prettify(this.result.from), this.result.to_percent = this.coords.p_to_real, this.result.to = this.convertToValue(this.coords.p_to_real), this.result.to_pretty = this._prettify(this.result.to), this.options.values.length && (this.result.from_value = this.options.values[this.result.from], this.result.to_value = this.options.values[this.result.to])), this.calcMinMax(), this.calcLabels()
                        }
                    },
                    calcPointerPercent: function() {
                        this.coords.w_rs ? (this.coords.x_pointer < 0 || isNaN(this.coords.x_pointer) ? this.coords.x_pointer = 0 : this.coords.x_pointer > this.coords.w_rs && (this.coords.x_pointer = this.coords.w_rs), this.coords.p_pointer = this.toFixed(this.coords.x_pointer / this.coords.w_rs * 100)) : this.coords.p_pointer = 0
                    },
                    convertToRealPercent: function(t) {
                        return t / (100 - this.coords.p_handle) * 100
                    },
                    convertToFakePercent: function(t) {
                        return t / 100 * (100 - this.coords.p_handle)
                    },
                    getHandleX: function() {
                        var t = 100 - this.coords.p_handle,
                            e = this.toFixed(this.coords.p_pointer - this.coords.p_gap);
                        return e < 0 ? e = 0 : e > t && (e = t), e
                    },
                    calcHandlePercent: function() {
                        "single" === this.options.type ? this.coords.w_handle = this.$cache.s_single.outerWidth(!1) : this.coords.w_handle = this.$cache.s_from.outerWidth(!1), this.coords.p_handle = this.toFixed(this.coords.w_handle / this.coords.w_rs * 100)
                    },
                    chooseHandle: function(t) {
                        return "single" === this.options.type ? "single" : t >= this.coords.p_from_real + (this.coords.p_to_real - this.coords.p_from_real) / 2 ? this.options.to_fixed ? "from" : "to" : this.options.from_fixed ? "to" : "from"
                    },
                    calcMinMax: function() {
                        this.coords.w_rs && (this.labels.p_min = this.labels.w_min / this.coords.w_rs * 100, this.labels.p_max = this.labels.w_max / this.coords.w_rs * 100)
                    },
                    calcLabels: function() {
                        this.coords.w_rs && !this.options.hide_from_to && ("single" === this.options.type ? (this.labels.w_single = this.$cache.single.outerWidth(!1), this.labels.p_single_fake = this.labels.w_single / this.coords.w_rs * 100, this.labels.p_single_left = this.coords.p_single_fake + this.coords.p_handle / 2 - this.labels.p_single_fake / 2, this.labels.p_single_left = this.checkEdges(this.labels.p_single_left, this.labels.p_single_fake)) : (this.labels.w_from = this.$cache.from.outerWidth(!1), this.labels.p_from_fake = this.labels.w_from / this.coords.w_rs * 100, this.labels.p_from_left = this.coords.p_from_fake + this.coords.p_handle / 2 - this.labels.p_from_fake / 2, this.labels.p_from_left = this.toFixed(this.labels.p_from_left), this.labels.p_from_left = this.checkEdges(this.labels.p_from_left, this.labels.p_from_fake), this.labels.w_to = this.$cache.to.outerWidth(!1), this.labels.p_to_fake = this.labels.w_to / this.coords.w_rs * 100, this.labels.p_to_left = this.coords.p_to_fake + this.coords.p_handle / 2 - this.labels.p_to_fake / 2, this.labels.p_to_left = this.toFixed(this.labels.p_to_left), this.labels.p_to_left = this.checkEdges(this.labels.p_to_left, this.labels.p_to_fake), this.labels.w_single = this.$cache.single.outerWidth(!1), this.labels.p_single_fake = this.labels.w_single / this.coords.w_rs * 100, this.labels.p_single_left = (this.labels.p_from_left + this.labels.p_to_left + this.labels.p_to_fake) / 2 - this.labels.p_single_fake / 2, this.labels.p_single_left = this.toFixed(this.labels.p_single_left), this.labels.p_single_left = this.checkEdges(this.labels.p_single_left, this.labels.p_single_fake)))
                    },
                    updateScene: function() {
                        this.raf_id && (cancelAnimationFrame(this.raf_id), this.raf_id = null), clearTimeout(this.update_tm), this.update_tm = null, this.options && (this.drawHandles(), this.is_active ? this.raf_id = requestAnimationFrame(this.updateScene.bind(this)) : this.update_tm = setTimeout(this.updateScene.bind(this), 300))
                    },
                    drawHandles: function() {
                        this.coords.w_rs = this.$cache.rs.outerWidth(!1), this.coords.w_rs && (this.coords.w_rs !== this.coords.w_rs_old && (this.target = "base", this.is_resize = !0), (this.coords.w_rs !== this.coords.w_rs_old || this.force_redraw) && (this.setMinMax(), this.calc(!0), this.drawLabels(), this.options.grid && (this.calcGridMargin(), this.calcGridLabels()), this.force_redraw = !0, this.coords.w_rs_old = this.coords.w_rs, this.drawShadow()), this.coords.w_rs && (this.dragging || this.force_redraw || this.is_key) && ((this.old_from !== this.result.from || this.old_to !== this.result.to || this.force_redraw || this.is_key) && (this.drawLabels(), this.$cache.bar[0].style.left = this.coords.p_bar_x + "%", this.$cache.bar[0].style.width = this.coords.p_bar_w + "%", "single" === this.options.type ? (this.$cache.bar[0].style.left = 0, this.$cache.bar[0].style.width = this.coords.p_bar_w + this.coords.p_bar_x + "%", this.$cache.s_single[0].style.left = this.coords.p_single_fake + "%", this.$cache.single[0].style.left = this.labels.p_single_left + "%") : (this.$cache.s_from[0].style.left = this.coords.p_from_fake + "%", this.$cache.s_to[0].style.left = this.coords.p_to_fake + "%", (this.old_from !== this.result.from || this.force_redraw) && (this.$cache.from[0].style.left = this.labels.p_from_left + "%"), (this.old_to !== this.result.to || this.force_redraw) && (this.$cache.to[0].style.left = this.labels.p_to_left + "%"), this.$cache.single[0].style.left = this.labels.p_single_left + "%"), this.writeToInput(), this.old_from === this.result.from && this.old_to === this.result.to || this.is_start || (this.$cache.input.trigger("change"), this.$cache.input.trigger("input")), this.old_from = this.result.from, this.old_to = this.result.to, this.is_resize || this.is_update || this.is_start || this.is_finish || this.callOnChange(), (this.is_key || this.is_click) && (this.is_key = !1, this.is_click = !1, this.callOnFinish()), this.is_update = !1, this.is_resize = !1, this.is_finish = !1), this.is_start = !1, this.is_key = !1, this.is_click = !1, this.force_redraw = !1))
                    },
                    drawLabels: function() {
                        if (this.options) {
                            var t, e, i, n, s, o = this.options.values.length,
                                r = this.options.p_values;
                            if (!this.options.hide_from_to)
                                if ("single" === this.options.type) o ? (t = this.decorate(r[this.result.from]), this.$cache.single.html(t)) : (n = this._prettify(this.result.from), t = this.decorate(n, this.result.from), this.$cache.single.html(t)), this.calcLabels(), this.labels.p_single_left < this.labels.p_min + 1 ? this.$cache.min[0].style.visibility = "hidden" : this.$cache.min[0].style.visibility = "visible", this.labels.p_single_left + this.labels.p_single_fake > 100 - this.labels.p_max - 1 ? this.$cache.max[0].style.visibility = "hidden" : this.$cache.max[0].style.visibility = "visible";
                                else {
                                    o ? (this.options.decorate_both ? (t = this.decorate(r[this.result.from]), t += this.options.values_separator, t += this.decorate(r[this.result.to])) : t = this.decorate(r[this.result.from] + this.options.values_separator + r[this.result.to]), e = this.decorate(r[this.result.from]), i = this.decorate(r[this.result.to]), this.$cache.single.html(t), this.$cache.from.html(e), this.$cache.to.html(i)) : (n = this._prettify(this.result.from), s = this._prettify(this.result.to), this.options.decorate_both ? (t = this.decorate(n, this.result.from), t += this.options.values_separator, t += this.decorate(s, this.result.to)) : t = this.decorate(n + this.options.values_separator + s, this.result.to), e = this.decorate(n, this.result.from), i = this.decorate(s, this.result.to), this.$cache.single.html(t), this.$cache.from.html(e), this.$cache.to.html(i)), this.calcLabels();
                                    var a = Math.min(this.labels.p_single_left, this.labels.p_from_left),
                                        l = this.labels.p_single_left + this.labels.p_single_fake,
                                        h = this.labels.p_to_left + this.labels.p_to_fake,
                                        c = Math.max(l, h);
                                    this.labels.p_from_left + this.labels.p_from_fake >= this.labels.p_to_left ? (this.$cache.from[0].style.visibility = "hidden", this.$cache.to[0].style.visibility = "hidden", this.$cache.single[0].style.visibility = "visible", this.result.from === this.result.to ? ("from" === this.target ? this.$cache.from[0].style.visibility = "visible" : "to" === this.target ? this.$cache.to[0].style.visibility = "visible" : this.target || (this.$cache.from[0].style.visibility = "visible"), this.$cache.single[0].style.visibility = "hidden", c = h) : (this.$cache.from[0].style.visibility = "hidden", this.$cache.to[0].style.visibility = "hidden", this.$cache.single[0].style.visibility = "visible", c = Math.max(l, h))) : (this.$cache.from[0].style.visibility = "visible", this.$cache.to[0].style.visibility = "visible", this.$cache.single[0].style.visibility = "hidden"), a < this.labels.p_min + 1 ? this.$cache.min[0].style.visibility = "hidden" : this.$cache.min[0].style.visibility = "visible", c > 100 - this.labels.p_max - 1 ? this.$cache.max[0].style.visibility = "hidden" : this.$cache.max[0].style.visibility = "visible"
                                }
                        }
                    },
                    drawShadow: function() {
                        var t, e, i, n, s = this.options,
                            o = this.$cache,
                            r = "number" == typeof s.from_min && !isNaN(s.from_min),
                            a = "number" == typeof s.from_max && !isNaN(s.from_max),
                            l = "number" == typeof s.to_min && !isNaN(s.to_min),
                            h = "number" == typeof s.to_max && !isNaN(s.to_max);
                        "single" === s.type ? s.from_shadow && (r || a) ? (t = this.convertToPercent(r ? s.from_min : s.min), e = this.convertToPercent(a ? s.from_max : s.max) - t, t = this.toFixed(t - this.coords.p_handle / 100 * t), e = this.toFixed(e - this.coords.p_handle / 100 * e), t += this.coords.p_handle / 2, o.shad_single[0].style.display = "block", o.shad_single[0].style.left = t + "%", o.shad_single[0].style.width = e + "%") : o.shad_single[0].style.display = "none" : (s.from_shadow && (r || a) ? (t = this.convertToPercent(r ? s.from_min : s.min), e = this.convertToPercent(a ? s.from_max : s.max) - t, t = this.toFixed(t - this.coords.p_handle / 100 * t), e = this.toFixed(e - this.coords.p_handle / 100 * e), t += this.coords.p_handle / 2, o.shad_from[0].style.display = "block", o.shad_from[0].style.left = t + "%", o.shad_from[0].style.width = e + "%") : o.shad_from[0].style.display = "none", s.to_shadow && (l || h) ? (i = this.convertToPercent(l ? s.to_min : s.min), n = this.convertToPercent(h ? s.to_max : s.max) - i, i = this.toFixed(i - this.coords.p_handle / 100 * i), n = this.toFixed(n - this.coords.p_handle / 100 * n), i += this.coords.p_handle / 2, o.shad_to[0].style.display = "block", o.shad_to[0].style.left = i + "%", o.shad_to[0].style.width = n + "%") : o.shad_to[0].style.display = "none")
                    },
                    writeToInput: function() {
                        "single" === this.options.type ? (this.options.values.length ? this.$cache.input.prop("value", this.result.from_value) : this.$cache.input.prop("value", this.result.from), this.$cache.input.data("from", this.result.from)) : (this.options.values.length ? this.$cache.input.prop("value", this.result.from_value + this.options.input_values_separator + this.result.to_value) : this.$cache.input.prop("value", this.result.from + this.options.input_values_separator + this.result.to), this.$cache.input.data("from", this.result.from), this.$cache.input.data("to", this.result.to))
                    },
                    callOnStart: function() {
                        this.writeToInput(), this.options.onStart && "function" == typeof this.options.onStart && (this.options.scope ? this.options.onStart.call(this.options.scope, this.result) : this.options.onStart(this.result))
                    },
                    callOnChange: function() {
                        this.writeToInput(), this.options.onChange && "function" == typeof this.options.onChange && (this.options.scope ? this.options.onChange.call(this.options.scope, this.result) : this.options.onChange(this.result))
                    },
                    callOnFinish: function() {
                        this.writeToInput(), this.options.onFinish && "function" == typeof this.options.onFinish && (this.options.scope ? this.options.onFinish.call(this.options.scope, this.result) : this.options.onFinish(this.result))
                    },
                    callOnUpdate: function() {
                        this.writeToInput(), this.options.onUpdate && "function" == typeof this.options.onUpdate && (this.options.scope ? this.options.onUpdate.call(this.options.scope, this.result) : this.options.onUpdate(this.result))
                    },
                    toggleInput: function() {
                        this.$cache.input.toggleClass("irs-hidden-input"), this.has_tab_index ? this.$cache.input.prop("tabindex", -1) : this.$cache.input.removeProp("tabindex"), this.has_tab_index = !this.has_tab_index
                    },
                    convertToPercent: function(t, e) {
                        var i, n = this.options.max - this.options.min,
                            s = n / 100;
                        return n ? (i = (e ? t : t - this.options.min) / s, this.toFixed(i)) : (this.no_diapason = !0, 0)
                    },
                    convertToValue: function(t) {
                        var e, i, n = this.options.min,
                            s = this.options.max,
                            o = n.toString().split(".")[1],
                            r = s.toString().split(".")[1],
                            a = 0,
                            l = 0;
                        if (0 === t) return this.options.min;
                        if (100 === t) return this.options.max;
                        o && (a = e = o.length), r && (a = i = r.length), e && i && (a = e >= i ? e : i), n < 0 && (n = +(n + (l = Math.abs(n))).toFixed(a), s = +(s + l).toFixed(a));
                        var h, c = (s - n) / 100 * t + n,
                            d = this.options.step.toString().split(".")[1];
                        return d ? c = +c.toFixed(d.length) : (c /= this.options.step, c = +(c *= this.options.step).toFixed(0)), l && (c -= l), (h = d ? +c.toFixed(d.length) : this.toFixed(c)) < this.options.min ? h = this.options.min : h > this.options.max && (h = this.options.max), h
                    },
                    calcWithStep: function(t) {
                        var e = Math.round(t / this.coords.p_step) * this.coords.p_step;
                        return e > 100 && (e = 100), 100 === t && (e = 100), this.toFixed(e)
                    },
                    checkMinInterval: function(t, e, i) {
                        var n, s, o = this.options;
                        return o.min_interval ? (n = this.convertToValue(t), s = this.convertToValue(e), "from" === i ? s - n < o.min_interval && (n = s - o.min_interval) : n - s < o.min_interval && (n = s + o.min_interval), this.convertToPercent(n)) : t
                    },
                    checkMaxInterval: function(t, e, i) {
                        var n, s, o = this.options;
                        return o.max_interval ? (n = this.convertToValue(t), s = this.convertToValue(e), "from" === i ? s - n > o.max_interval && (n = s - o.max_interval) : n - s > o.max_interval && (n = s + o.max_interval), this.convertToPercent(n)) : t
                    },
                    checkDiapason: function(t, e, i) {
                        var n = this.convertToValue(t),
                            s = this.options;
                        return "number" != typeof e && (e = s.min), "number" != typeof i && (i = s.max), n < e && (n = e), n > i && (n = i), this.convertToPercent(n)
                    },
                    toFixed: function(t) {
                        return +(t = t.toFixed(20))
                    },
                    _prettify: function(t) {
                        return this.options.prettify_enabled ? this.options.prettify && "function" == typeof this.options.prettify ? this.options.prettify(t) : this.prettify(t) : t
                    },
                    prettify: function(t) {
                        return t.toString().replace(/(\d{1,3}(?=(?:\d\d\d)+(?!\d)))/g, "$1" + this.options.prettify_separator)
                    },
                    checkEdges: function(t, e) {
                        return this.options.force_edges ? (t < 0 ? t = 0 : t > 100 - e && (t = 100 - e), this.toFixed(t)) : this.toFixed(t)
                    },
                    validate: function() {
                        var t, e, i = this.options,
                            n = this.result,
                            s = i.values,
                            o = s.length;
                        if ("string" == typeof i.min && (i.min = +i.min), "string" == typeof i.max && (i.max = +i.max), "string" == typeof i.from && (i.from = +i.from), "string" == typeof i.to && (i.to = +i.to), "string" == typeof i.step && (i.step = +i.step), "string" == typeof i.from_min && (i.from_min = +i.from_min), "string" == typeof i.from_max && (i.from_max = +i.from_max), "string" == typeof i.to_min && (i.to_min = +i.to_min), "string" == typeof i.to_max && (i.to_max = +i.to_max), "string" == typeof i.grid_num && (i.grid_num = +i.grid_num), i.max < i.min && (i.max = i.min), o)
                            for (i.p_values = [], i.min = 0, i.max = o - 1, i.step = 1, i.grid_num = i.max, i.grid_snap = !0, e = 0; e < o; e++) t = +s[e], isNaN(t) ? t = s[e] : (s[e] = t, t = this._prettify(t)), i.p_values.push(t);
                        ("number" != typeof i.from || isNaN(i.from)) && (i.from = i.min), ("number" != typeof i.to || isNaN(i.to)) && (i.to = i.max), "single" === i.type ? (i.from < i.min && (i.from = i.min), i.from > i.max && (i.from = i.max)) : (i.from < i.min && (i.from = i.min), i.from > i.max && (i.from = i.max), i.to < i.min && (i.to = i.min), i.to > i.max && (i.to = i.max), this.update_check.from && (this.update_check.from !== i.from && i.from > i.to && (i.from = i.to), this.update_check.to !== i.to && i.to < i.from && (i.to = i.from)), i.from > i.to && (i.from = i.to), i.to < i.from && (i.to = i.from)), ("number" != typeof i.step || isNaN(i.step) || !i.step || i.step < 0) && (i.step = 1), "number" == typeof i.from_min && i.from < i.from_min && (i.from = i.from_min), "number" == typeof i.from_max && i.from > i.from_max && (i.from = i.from_max), "number" == typeof i.to_min && i.to < i.to_min && (i.to = i.to_min), "number" == typeof i.to_max && i.from > i.to_max && (i.to = i.to_max), n && (n.min !== i.min && (n.min = i.min), n.max !== i.max && (n.max = i.max), (n.from < n.min || n.from > n.max) && (n.from = i.from), (n.to < n.min || n.to > n.max) && (n.to = i.to)), ("number" != typeof i.min_interval || isNaN(i.min_interval) || !i.min_interval || i.min_interval < 0) && (i.min_interval = 0), ("number" != typeof i.max_interval || isNaN(i.max_interval) || !i.max_interval || i.max_interval < 0) && (i.max_interval = 0), i.min_interval && i.min_interval > i.max - i.min && (i.min_interval = i.max - i.min), i.max_interval && i.max_interval > i.max - i.min && (i.max_interval = i.max - i.min)
                    },
                    decorate: function(t, e) {
                        var i = "",
                            n = this.options;
                        return n.prefix && (i += n.prefix), i += t, n.max_postfix && (n.values.length && t === n.p_values[n.max] ? (i += n.max_postfix, n.postfix && (i += " ")) : e === n.max && (i += n.max_postfix, n.postfix && (i += " "))), n.postfix && (i += n.postfix), i
                    },
                    updateFrom: function() {
                        this.result.from = this.options.from, this.result.from_percent = this.convertToPercent(this.result.from), this.result.from_pretty = this._prettify(this.result.from), this.options.values && (this.result.from_value = this.options.values[this.result.from])
                    },
                    updateTo: function() {
                        this.result.to = this.options.to, this.result.to_percent = this.convertToPercent(this.result.to), this.result.to_pretty = this._prettify(this.result.to), this.options.values && (this.result.to_value = this.options.values[this.result.to])
                    },
                    updateResult: function() {
                        this.result.min = this.options.min, this.result.max = this.options.max, this.updateFrom(), this.updateTo()
                    },
                    appendGrid: function() {
                        if (this.options.grid) {
                            var t, e, i, n, s, o, r = this.options,
                                a = r.max - r.min,
                                l = r.grid_num,
                                h = 0,
                                c = 4,
                                d = "";
                            for (this.calcGridMargin(), r.grid_snap && (l = a / r.step), l > 50 && (l = 50), i = this.toFixed(100 / l), l > 4 && (c = 3), l > 7 && (c = 2), l > 14 && (c = 1), l > 28 && (c = 0), t = 0; t < l + 1; t++) {
                                for (n = c, (h = this.toFixed(i * t)) > 100 && (h = 100), this.coords.big[t] = h, s = (h - i * (t - 1)) / (n + 1), e = 1; e <= n && 0 !== h; e++) d += '<span class="irs-grid-pol small" style="left: ' + this.toFixed(h - s * e) + '%"></span>';
                                d += '<span class="irs-grid-pol" style="left: ' + h + '%"></span>', o = this.convertToValue(h), d += '<span class="irs-grid-text js-grid-text-' + t + '" style="left: ' + h + '%">' + (o = r.values.length ? r.p_values[o] : this._prettify(o)) + "</span>"
                            }
                            this.coords.big_num = Math.ceil(l + 1), this.$cache.cont.addClass("irs-with-grid"), this.$cache.grid.html(d), this.cacheGridLabels()
                        }
                    },
                    cacheGridLabels: function() {
                        var t, e, i = this.coords.big_num;
                        for (e = 0; e < i; e++) t = this.$cache.grid.find(".js-grid-text-" + e), this.$cache.grid_labels.push(t);
                        this.calcGridLabels()
                    },
                    calcGridLabels: function() {
                        var t, e, i = [],
                            n = [],
                            s = this.coords.big_num;
                        for (t = 0; t < s; t++) this.coords.big_w[t] = this.$cache.grid_labels[t].outerWidth(!1), this.coords.big_p[t] = this.toFixed(this.coords.big_w[t] / this.coords.w_rs * 100), this.coords.big_x[t] = this.toFixed(this.coords.big_p[t] / 2), i[t] = this.toFixed(this.coords.big[t] - this.coords.big_x[t]), n[t] = this.toFixed(i[t] + this.coords.big_p[t]);
                        for (this.options.force_edges && (i[0] < -this.coords.grid_gap && (i[0] = -this.coords.grid_gap, n[0] = this.toFixed(i[0] + this.coords.big_p[0]), this.coords.big_x[0] = this.coords.grid_gap), n[s - 1] > 100 + this.coords.grid_gap && (n[s - 1] = 100 + this.coords.grid_gap, i[s - 1] = this.toFixed(n[s - 1] - this.coords.big_p[s - 1]), this.coords.big_x[s - 1] = this.toFixed(this.coords.big_p[s - 1] - this.coords.grid_gap))), this.calcGridCollision(2, i, n), this.calcGridCollision(4, i, n), t = 0; t < s; t++) e = this.$cache.grid_labels[t][0], this.coords.big_x[t] !== Number.POSITIVE_INFINITY && (e.style.marginLeft = -this.coords.big_x[t] + "%")
                    },
                    calcGridCollision: function(t, e, i) {
                        var n, s, o, r = this.coords.big_num;
                        for (n = 0; n < r && !((s = n + t / 2) >= r); n += t) o = this.$cache.grid_labels[s][0], i[n] <= e[s] ? o.style.visibility = "visible" : o.style.visibility = "hidden"
                    },
                    calcGridMargin: function() {
                        this.options.grid_margin && (this.coords.w_rs = this.$cache.rs.outerWidth(!1), this.coords.w_rs && ("single" === this.options.type ? this.coords.w_handle = this.$cache.s_single.outerWidth(!1) : this.coords.w_handle = this.$cache.s_from.outerWidth(!1), this.coords.p_handle = this.toFixed(this.coords.w_handle / this.coords.w_rs * 100), this.coords.grid_gap = this.toFixed(this.coords.p_handle / 2 - .1), this.$cache.grid[0].style.width = this.toFixed(100 - this.coords.p_handle) + "%", this.$cache.grid[0].style.left = this.coords.grid_gap + "%"))
                    },
                    update: function(e) {
                        this.input && (this.is_update = !0, this.options.from = this.result.from, this.options.to = this.result.to, this.update_check.from = this.result.from, this.update_check.to = this.result.to, this.options = t.extend(this.options, e), this.validate(), this.updateResult(e), this.toggleInput(), this.remove(), this.init(!0))
                    },
                    reset: function() {
                        this.input && (this.updateResult(), this.update())
                    },
                    destroy: function() {
                        this.input && (this.toggleInput(), this.$cache.input.prop("readonly", !1), t.data(this.input, "ionRangeSlider", null), this.remove(), this.input = null, this.options = null)
                    }
                }, t.fn.ionRangeSlider = function(e) {
                    return this.each(function() {
                        t.data(this, "ionRangeSlider") || t.data(this, "ionRangeSlider", new a(this, e, o++))
                    })
                },
                function() {
                    for (var t = 0, e = ["ms", "moz", "webkit", "o"], n = 0; n < e.length && !i.requestAnimationFrame; ++n) i.requestAnimationFrame = i[e[n] + "RequestAnimationFrame"], i.cancelAnimationFrame = i[e[n] + "CancelAnimationFrame"] || i[e[n] + "CancelRequestAnimationFrame"];
                    i.requestAnimationFrame || (i.requestAnimationFrame = function(e, n) {
                        var s = (new Date).getTime(),
                            o = Math.max(0, 16 - (s - t)),
                            r = i.setTimeout(function() {
                                e(s + o)
                            }, o);
                        return t = s + o, r
                    }), i.cancelAnimationFrame || (i.cancelAnimationFrame = function(t) {
                        clearTimeout(t)
                    })
                }()
        })
    }).call(this, i(3))
  }, function(t, e) {
    (function(e) {
        t.exports = e
    }).call(this, {})
  }, function(t, e, i) {
    /*!
     * Bootstrap v4.1.3 (https://getbootstrap.com/)
     * Copyright 2011-2018 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
     * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
     */
    ! function(t, e, i) {
        "use strict";
  
        function n(t, e) {
            for (var i = 0; i < e.length; i++) {
                var n = e[i];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n)
            }
        }
  
        function s(t, e, i) {
            return e && n(t.prototype, e), i && n(t, i), t
        }
  
        function o(t, e, i) {
            return e in t ? Object.defineProperty(t, e, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t[e] = i, t
        }
  
        function r(t) {
            for (var e = 1; e < arguments.length; e++) {
                var i = null != arguments[e] ? arguments[e] : {},
                    n = Object.keys(i);
                "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(i).filter(function(t) {
                    return Object.getOwnPropertyDescriptor(i, t).enumerable
                }))), n.forEach(function(e) {
                    o(t, e, i[e])
                })
            }
            return t
        }
        e = e && e.hasOwnProperty("default") ? e.default : e, i = i && i.hasOwnProperty("default") ? i.default : i;
        var a = function(t) {
                var e = "transitionend";
  
                function i(t) {
                    return {}.toString.call(t).match(/\s([a-z]+)/i)[1].toLowerCase()
                }
  
                function n(e) {
                    var i = this,
                        n = !1;
                    return t(this).one(s.TRANSITION_END, function() {
                        n = !0
                    }), setTimeout(function() {
                        n || s.triggerTransitionEnd(i)
                    }, e), this
                }
                var s = {
                    TRANSITION_END: "bsTransitionEnd",
                    getUID: function(t) {
                        do {
                            t += ~~(1e6 * Math.random())
                        } while (document.getElementById(t));
                        return t
                    },
                    getSelectorFromElement: function(t) {
                        var e = t.getAttribute("data-target");
                        e && "#" !== e || (e = t.getAttribute("href") || "");
                        try {
                            return document.querySelector(e) ? e : null
                        } catch (t) {
                            return null
                        }
                    },
                    getTransitionDurationFromElement: function(e) {
                        if (!e) return 0;
                        var i = t(e).css("transition-duration"),
                            n = parseFloat(i);
                        return n ? (i = i.split(",")[0], 1e3 * parseFloat(i)) : 0
                    },
                    reflow: function(t) {
                        return t.offsetHeight
                    },
                    triggerTransitionEnd: function(i) {
                        t(i).trigger(e)
                    },
                    supportsTransitionEnd: function() {
                        return Boolean(e)
                    },
                    isElement: function(t) {
                        return (t[0] || t).nodeType
                    },
                    typeCheckConfig: function(t, e, n) {
                        for (var o in n)
                            if (Object.prototype.hasOwnProperty.call(n, o)) {
                                var r = n[o],
                                    a = e[o],
                                    l = a && s.isElement(a) ? "element" : i(a);
                                if (!new RegExp(r).test(l)) throw new Error(t.toUpperCase() + ': Option "' + o + '" provided type "' + l + '" but expected type "' + r + '".')
                            }
                    }
                };
                return t.fn.emulateTransitionEnd = n, t.event.special[s.TRANSITION_END] = {
                    bindType: e,
                    delegateType: e,
                    handle: function(e) {
                        if (t(e.target).is(this)) return e.handleObj.handler.apply(this, arguments)
                    }
                }, s
            }(e),
            l = function(t) {
                var e = t.fn.alert,
                    i = {
                        CLOSE: "close.bs.alert",
                        CLOSED: "closed.bs.alert",
                        CLICK_DATA_API: "click.bs.alert.data-api"
                    },
                    n = {
                        ALERT: "alert",
                        FADE: "fade",
                        SHOW: "show"
                    },
                    o = function() {
                        function e(t) {
                            this._element = t
                        }
                        var o = e.prototype;
                        return o.close = function(t) {
                            var e = this._element;
                            t && (e = this._getRootElement(t));
                            var i = this._triggerCloseEvent(e);
                            i.isDefaultPrevented() || this._removeElement(e)
                        }, o.dispose = function() {
                            t.removeData(this._element, "bs.alert"), this._element = null
                        }, o._getRootElement = function(e) {
                            var i = a.getSelectorFromElement(e),
                                s = !1;
                            return i && (s = document.querySelector(i)), s || (s = t(e).closest("." + n.ALERT)[0]), s
                        }, o._triggerCloseEvent = function(e) {
                            var n = t.Event(i.CLOSE);
                            return t(e).trigger(n), n
                        }, o._removeElement = function(e) {
                            var i = this;
                            if (t(e).removeClass(n.SHOW), t(e).hasClass(n.FADE)) {
                                var s = a.getTransitionDurationFromElement(e);
                                t(e).one(a.TRANSITION_END, function(t) {
                                    return i._destroyElement(e, t)
                                }).emulateTransitionEnd(s)
                            } else this._destroyElement(e)
                        }, o._destroyElement = function(e) {
                            t(e).detach().trigger(i.CLOSED).remove()
                        }, e._jQueryInterface = function(i) {
                            return this.each(function() {
                                var n = t(this),
                                    s = n.data("bs.alert");
                                s || (s = new e(this), n.data("bs.alert", s)), "close" === i && s[i](this)
                            })
                        }, e._handleDismiss = function(t) {
                            return function(e) {
                                e && e.preventDefault(), t.close(this)
                            }
                        }, s(e, null, [{
                            key: "VERSION",
                            get: function() {
                                return "4.1.3"
                            }
                        }]), e
                    }();
                return t(document).on(i.CLICK_DATA_API, '[data-dismiss="alert"]', o._handleDismiss(new o)), t.fn.alert = o._jQueryInterface, t.fn.alert.Constructor = o, t.fn.alert.noConflict = function() {
                    return t.fn.alert = e, o._jQueryInterface
                }, o
            }(e),
            h = function(t) {
                var e = "button",
                    i = t.fn[e],
                    n = {
                        ACTIVE: "active",
                        BUTTON: "btn",
                        FOCUS: "focus"
                    },
                    o = {
                        DATA_TOGGLE_CARROT: '[data-toggle^="button"]',
                        DATA_TOGGLE: '[data-toggle="buttons"]',
                        INPUT: "input",
                        ACTIVE: ".active",
                        BUTTON: ".btn"
                    },
                    r = {
                        CLICK_DATA_API: "click.bs.button.data-api",
                        FOCUS_BLUR_DATA_API: "focus.bs.button.data-api blur.bs.button.data-api"
                    },
                    a = function() {
                        function e(t) {
                            this._element = t
                        }
                        var i = e.prototype;
                        return i.toggle = function() {
                            var e = !0,
                                i = !0,
                                s = t(this._element).closest(o.DATA_TOGGLE)[0];
                            if (s) {
                                var r = this._element.querySelector(o.INPUT);
                                if (r) {
                                    if ("radio" === r.type)
                                        if (r.checked && this._element.classList.contains(n.ACTIVE)) e = !1;
                                        else {
                                            var a = s.querySelector(o.ACTIVE);
                                            a && t(a).removeClass(n.ACTIVE)
                                        } if (e) {
                                        if (r.hasAttribute("disabled") || s.hasAttribute("disabled") || r.classList.contains("disabled") || s.classList.contains("disabled")) return;
                                        r.checked = !this._element.classList.contains(n.ACTIVE), t(r).trigger("change")
                                    }
                                    r.focus(), i = !1
                                }
                            }
                            i && this._element.setAttribute("aria-pressed", !this._element.classList.contains(n.ACTIVE)), e && t(this._element).toggleClass(n.ACTIVE)
                        }, i.dispose = function() {
                            t.removeData(this._element, "bs.button"), this._element = null
                        }, e._jQueryInterface = function(i) {
                            return this.each(function() {
                                var n = t(this).data("bs.button");
                                n || (n = new e(this), t(this).data("bs.button", n)), "toggle" === i && n[i]()
                            })
                        }, s(e, null, [{
                            key: "VERSION",
                            get: function() {
                                return "4.1.3"
                            }
                        }]), e
                    }();
                return t(document).on(r.CLICK_DATA_API, o.DATA_TOGGLE_CARROT, function(e) {
                    e.preventDefault();
                    var i = e.target;
                    t(i).hasClass(n.BUTTON) || (i = t(i).closest(o.BUTTON)), a._jQueryInterface.call(t(i), "toggle")
                }).on(r.FOCUS_BLUR_DATA_API, o.DATA_TOGGLE_CARROT, function(e) {
                    var i = t(e.target).closest(o.BUTTON)[0];
                    t(i).toggleClass(n.FOCUS, /^focus(in)?$/.test(e.type))
                }), t.fn[e] = a._jQueryInterface, t.fn[e].Constructor = a, t.fn[e].noConflict = function() {
                    return t.fn[e] = i, a._jQueryInterface
                }, a
            }(e),
            c = function(t) {
                var e = "carousel",
                    i = "bs.carousel",
                    n = "." + i,
                    o = t.fn[e],
                    l = {
                        interval: 5e3,
                        keyboard: !0,
                        slide: !1,
                        pause: "hover",
                        wrap: !0
                    },
                    h = {
                        interval: "(number|boolean)",
                        keyboard: "boolean",
                        slide: "(boolean|string)",
                        pause: "(string|boolean)",
                        wrap: "boolean"
                    },
                    c = {
                        NEXT: "next",
                        PREV: "prev",
                        LEFT: "left",
                        RIGHT: "right"
                    },
                    d = {
                        SLIDE: "slide" + n,
                        SLID: "slid" + n,
                        KEYDOWN: "keydown" + n,
                        MOUSEENTER: "mouseenter" + n,
                        MOUSELEAVE: "mouseleave" + n,
                        TOUCHEND: "touchend" + n,
                        LOAD_DATA_API: "load.bs.carousel.data-api",
                        CLICK_DATA_API: "click.bs.carousel.data-api"
                    },
                    u = {
                        CAROUSEL: "carousel",
                        ACTIVE: "active",
                        SLIDE: "slide",
                        RIGHT: "carousel-item-right",
                        LEFT: "carousel-item-left",
                        NEXT: "carousel-item-next",
                        PREV: "carousel-item-prev",
                        ITEM: "carousel-item"
                    },
                    p = {
                        ACTIVE: ".active",
                        ACTIVE_ITEM: ".active.carousel-item",
                        ITEM: ".carousel-item",
                        NEXT_PREV: ".carousel-item-next, .carousel-item-prev",
                        INDICATORS: ".carousel-indicators",
                        DATA_SLIDE: "[data-slide], [data-slide-to]",
                        DATA_RIDE: '[data-ride="carousel"]'
                    },
                    f = function() {
                        function o(e, i) {
                            this._items = null, this._interval = null, this._activeElement = null, this._isPaused = !1, this._isSliding = !1, this.touchTimeout = null, this._config = this._getConfig(i), this._element = t(e)[0], this._indicatorsElement = this._element.querySelector(p.INDICATORS), this._addEventListeners()
                        }
                        var f = o.prototype;
                        return f.next = function() {
                            this._isSliding || this._slide(c.NEXT)
                        }, f.nextWhenVisible = function() {
                            !document.hidden && t(this._element).is(":visible") && "hidden" !== t(this._element).css("visibility") && this.next()
                        }, f.prev = function() {
                            this._isSliding || this._slide(c.PREV)
                        }, f.pause = function(t) {
                            t || (this._isPaused = !0), this._element.querySelector(p.NEXT_PREV) && (a.triggerTransitionEnd(this._element), this.cycle(!0)), clearInterval(this._interval), this._interval = null
                        }, f.cycle = function(t) {
                            t || (this._isPaused = !1), this._interval && (clearInterval(this._interval), this._interval = null), this._config.interval && !this._isPaused && (this._interval = setInterval((document.visibilityState ? this.nextWhenVisible : this.next).bind(this), this._config.interval))
                        }, f.to = function(e) {
                            var i = this;
                            this._activeElement = this._element.querySelector(p.ACTIVE_ITEM);
                            var n = this._getItemIndex(this._activeElement);
                            if (!(e > this._items.length - 1 || e < 0))
                                if (this._isSliding) t(this._element).one(d.SLID, function() {
                                    return i.to(e)
                                });
                                else {
                                    if (n === e) return this.pause(), void this.cycle();
                                    var s = e > n ? c.NEXT : c.PREV;
                                    this._slide(s, this._items[e])
                                }
                        }, f.dispose = function() {
                            t(this._element).off(n), t.removeData(this._element, i), this._items = null, this._config = null, this._element = null, this._interval = null, this._isPaused = null, this._isSliding = null, this._activeElement = null, this._indicatorsElement = null
                        }, f._getConfig = function(t) {
                            return t = r({}, l, t), a.typeCheckConfig(e, t, h), t
                        }, f._addEventListeners = function() {
                            var e = this;
                            this._config.keyboard && t(this._element).on(d.KEYDOWN, function(t) {
                                return e._keydown(t)
                            }), "hover" === this._config.pause && (t(this._element).on(d.MOUSEENTER, function(t) {
                                return e.pause(t)
                            }).on(d.MOUSELEAVE, function(t) {
                                return e.cycle(t)
                            }), "ontouchstart" in document.documentElement && t(this._element).on(d.TOUCHEND, function() {
                                e.pause(), e.touchTimeout && clearTimeout(e.touchTimeout), e.touchTimeout = setTimeout(function(t) {
                                    return e.cycle(t)
                                }, 500 + e._config.interval)
                            }))
                        }, f._keydown = function(t) {
                            if (!/input|textarea/i.test(t.target.tagName)) switch (t.which) {
                                case 37:
                                    t.preventDefault(), this.prev();
                                    break;
                                case 39:
                                    t.preventDefault(), this.next()
                            }
                        }, f._getItemIndex = function(t) {
                            return this._items = t && t.parentNode ? [].slice.call(t.parentNode.querySelectorAll(p.ITEM)) : [], this._items.indexOf(t)
                        }, f._getItemByDirection = function(t, e) {
                            var i = t === c.NEXT,
                                n = t === c.PREV,
                                s = this._getItemIndex(e),
                                o = this._items.length - 1,
                                r = n && 0 === s || i && s === o;
                            if (r && !this._config.wrap) return e;
                            var a = t === c.PREV ? -1 : 1,
                                l = (s + a) % this._items.length;
                            return -1 === l ? this._items[this._items.length - 1] : this._items[l]
                        }, f._triggerSlideEvent = function(e, i) {
                            var n = this._getItemIndex(e),
                                s = this._getItemIndex(this._element.querySelector(p.ACTIVE_ITEM)),
                                o = t.Event(d.SLIDE, {
                                    relatedTarget: e,
                                    direction: i,
                                    from: s,
                                    to: n
                                });
                            return t(this._element).trigger(o), o
                        }, f._setActiveIndicatorElement = function(e) {
                            if (this._indicatorsElement) {
                                var i = [].slice.call(this._indicatorsElement.querySelectorAll(p.ACTIVE));
                                t(i).removeClass(u.ACTIVE);
                                var n = this._indicatorsElement.children[this._getItemIndex(e)];
                                n && t(n).addClass(u.ACTIVE)
                            }
                        }, f._slide = function(e, i) {
                            var n, s, o, r = this,
                                l = this._element.querySelector(p.ACTIVE_ITEM),
                                h = this._getItemIndex(l),
                                f = i || l && this._getItemByDirection(e, l),
                                m = this._getItemIndex(f),
                                g = Boolean(this._interval);
                            if (e === c.NEXT ? (n = u.LEFT, s = u.NEXT, o = c.LEFT) : (n = u.RIGHT, s = u.PREV, o = c.RIGHT), f && t(f).hasClass(u.ACTIVE)) this._isSliding = !1;
                            else {
                                var v = this._triggerSlideEvent(f, o);
                                if (!v.isDefaultPrevented() && l && f) {
                                    this._isSliding = !0, g && this.pause(), this._setActiveIndicatorElement(f);
                                    var y = t.Event(d.SLID, {
                                        relatedTarget: f,
                                        direction: o,
                                        from: h,
                                        to: m
                                    });
                                    if (t(this._element).hasClass(u.SLIDE)) {
                                        t(f).addClass(s), a.reflow(f), t(l).addClass(n), t(f).addClass(n);
                                        var _ = a.getTransitionDurationFromElement(l);
                                        t(l).one(a.TRANSITION_END, function() {
                                            t(f).removeClass(n + " " + s).addClass(u.ACTIVE), t(l).removeClass(u.ACTIVE + " " + s + " " + n), r._isSliding = !1, setTimeout(function() {
                                                return t(r._element).trigger(y)
                                            }, 0)
                                        }).emulateTransitionEnd(_)
                                    } else t(l).removeClass(u.ACTIVE), t(f).addClass(u.ACTIVE), this._isSliding = !1, t(this._element).trigger(y);
                                    g && this.cycle()
                                }
                            }
                        }, o._jQueryInterface = function(e) {
                            return this.each(function() {
                                var n = t(this).data(i),
                                    s = r({}, l, t(this).data());
                                "object" == typeof e && (s = r({}, s, e));
                                var a = "string" == typeof e ? e : s.slide;
                                if (n || (n = new o(this, s), t(this).data(i, n)), "number" == typeof e) n.to(e);
                                else if ("string" == typeof a) {
                                    if (void 0 === n[a]) throw new TypeError('No method named "' + a + '"');
                                    n[a]()
                                } else s.interval && (n.pause(), n.cycle())
                            })
                        }, o._dataApiClickHandler = function(e) {
                            var n = a.getSelectorFromElement(this);
                            if (n) {
                                var s = t(n)[0];
                                if (s && t(s).hasClass(u.CAROUSEL)) {
                                    var l = r({}, t(s).data(), t(this).data()),
                                        h = this.getAttribute("data-slide-to");
                                    h && (l.interval = !1), o._jQueryInterface.call(t(s), l), h && t(s).data(i).to(h), e.preventDefault()
                                }
                            }
                        }, s(o, null, [{
                            key: "VERSION",
                            get: function() {
                                return "4.1.3"
                            }
                        }, {
                            key: "Default",
                            get: function() {
                                return l
                            }
                        }]), o
                    }();
                return t(document).on(d.CLICK_DATA_API, p.DATA_SLIDE, f._dataApiClickHandler), t(window).on(d.LOAD_DATA_API, function() {
                    for (var e = [].slice.call(document.querySelectorAll(p.DATA_RIDE)), i = 0, n = e.length; i < n; i++) {
                        var s = t(e[i]);
                        f._jQueryInterface.call(s, s.data())
                    }
                }), t.fn[e] = f._jQueryInterface, t.fn[e].Constructor = f, t.fn[e].noConflict = function() {
                    return t.fn[e] = o, f._jQueryInterface
                }, f
            }(e),
            d = function(t) {
                var e = "collapse",
                    i = "bs.collapse",
                    n = t.fn[e],
                    o = {
                        toggle: !0,
                        parent: ""
                    },
                    l = {
                        toggle: "boolean",
                        parent: "(string|element)"
                    },
                    h = {
                        SHOW: "show.bs.collapse",
                        SHOWN: "shown.bs.collapse",
                        HIDE: "hide.bs.collapse",
                        HIDDEN: "hidden.bs.collapse",
                        CLICK_DATA_API: "click.bs.collapse.data-api"
                    },
                    c = {
                        SHOW: "show",
                        COLLAPSE: "collapse",
                        COLLAPSING: "collapsing",
                        COLLAPSED: "collapsed"
                    },
                    d = {
                        WIDTH: "width",
                        HEIGHT: "height"
                    },
                    u = {
                        ACTIVES: ".show, .collapsing",
                        DATA_TOGGLE: '[data-toggle="collapse"]'
                    },
                    p = function() {
                        function n(e, i) {
                            this._isTransitioning = !1, this._element = e, this._config = this._getConfig(i), this._triggerArray = t.makeArray(document.querySelectorAll('[data-toggle="collapse"][href="#' + e.id + '"],[data-toggle="collapse"][data-target="#' + e.id + '"]'));
                            for (var n = [].slice.call(document.querySelectorAll(u.DATA_TOGGLE)), s = 0, o = n.length; s < o; s++) {
                                var r = n[s],
                                    l = a.getSelectorFromElement(r),
                                    h = [].slice.call(document.querySelectorAll(l)).filter(function(t) {
                                        return t === e
                                    });
                                null !== l && h.length > 0 && (this._selector = l, this._triggerArray.push(r))
                            }
                            this._parent = this._config.parent ? this._getParent() : null, this._config.parent || this._addAriaAndCollapsedClass(this._element, this._triggerArray), this._config.toggle && this.toggle()
                        }
                        var p = n.prototype;
                        return p.toggle = function() {
                            t(this._element).hasClass(c.SHOW) ? this.hide() : this.show()
                        }, p.show = function() {
                            var e, s, o = this;
                            if (!(this._isTransitioning || t(this._element).hasClass(c.SHOW) || (this._parent && 0 === (e = [].slice.call(this._parent.querySelectorAll(u.ACTIVES)).filter(function(t) {
                                    return t.getAttribute("data-parent") === o._config.parent
                                })).length && (e = null), e && (s = t(e).not(this._selector).data(i)) && s._isTransitioning))) {
                                var r = t.Event(h.SHOW);
                                if (t(this._element).trigger(r), !r.isDefaultPrevented()) {
                                    e && (n._jQueryInterface.call(t(e).not(this._selector), "hide"), s || t(e).data(i, null));
                                    var l = this._getDimension();
                                    t(this._element).removeClass(c.COLLAPSE).addClass(c.COLLAPSING), this._element.style[l] = 0, this._triggerArray.length && t(this._triggerArray).removeClass(c.COLLAPSED).attr("aria-expanded", !0), this.setTransitioning(!0);
                                    var d = l[0].toUpperCase() + l.slice(1),
                                        p = "scroll" + d,
                                        f = a.getTransitionDurationFromElement(this._element);
                                    t(this._element).one(a.TRANSITION_END, function() {
                                        t(o._element).removeClass(c.COLLAPSING).addClass(c.COLLAPSE).addClass(c.SHOW), o._element.style[l] = "", o.setTransitioning(!1), t(o._element).trigger(h.SHOWN)
                                    }).emulateTransitionEnd(f), this._element.style[l] = this._element[p] + "px"
                                }
                            }
                        }, p.hide = function() {
                            var e = this;
                            if (!this._isTransitioning && t(this._element).hasClass(c.SHOW)) {
                                var i = t.Event(h.HIDE);
                                if (t(this._element).trigger(i), !i.isDefaultPrevented()) {
                                    var n = this._getDimension();
                                    this._element.style[n] = this._element.getBoundingClientRect()[n] + "px", a.reflow(this._element), t(this._element).addClass(c.COLLAPSING).removeClass(c.COLLAPSE).removeClass(c.SHOW);
                                    var s = this._triggerArray.length;
                                    if (s > 0)
                                        for (var o = 0; o < s; o++) {
                                            var r = this._triggerArray[o],
                                                l = a.getSelectorFromElement(r);
                                            if (null !== l) {
                                                var d = t([].slice.call(document.querySelectorAll(l)));
                                                d.hasClass(c.SHOW) || t(r).addClass(c.COLLAPSED).attr("aria-expanded", !1)
                                            }
                                        }
                                    this.setTransitioning(!0), this._element.style[n] = "";
                                    var u = a.getTransitionDurationFromElement(this._element);
                                    t(this._element).one(a.TRANSITION_END, function() {
                                        e.setTransitioning(!1), t(e._element).removeClass(c.COLLAPSING).addClass(c.COLLAPSE).trigger(h.HIDDEN)
                                    }).emulateTransitionEnd(u)
                                }
                            }
                        }, p.setTransitioning = function(t) {
                            this._isTransitioning = t
                        }, p.dispose = function() {
                            t.removeData(this._element, i), this._config = null, this._parent = null, this._element = null, this._triggerArray = null, this._isTransitioning = null
                        }, p._getConfig = function(t) {
                            return (t = r({}, o, t)).toggle = Boolean(t.toggle), a.typeCheckConfig(e, t, l), t
                        }, p._getDimension = function() {
                            var e = t(this._element).hasClass(d.WIDTH);
                            return e ? d.WIDTH : d.HEIGHT
                        }, p._getParent = function() {
                            var e = this,
                                i = null;
                            a.isElement(this._config.parent) ? (i = this._config.parent, void 0 !== this._config.parent.jquery && (i = this._config.parent[0])) : i = document.querySelector(this._config.parent);
                            var s = '[data-toggle="collapse"][data-parent="' + this._config.parent + '"]',
                                o = [].slice.call(i.querySelectorAll(s));
                            return t(o).each(function(t, i) {
                                e._addAriaAndCollapsedClass(n._getTargetFromElement(i), [i])
                            }), i
                        }, p._addAriaAndCollapsedClass = function(e, i) {
                            if (e) {
                                var n = t(e).hasClass(c.SHOW);
                                i.length && t(i).toggleClass(c.COLLAPSED, !n).attr("aria-expanded", n)
                            }
                        }, n._getTargetFromElement = function(t) {
                            var e = a.getSelectorFromElement(t);
                            return e ? document.querySelector(e) : null
                        }, n._jQueryInterface = function(e) {
                            return this.each(function() {
                                var s = t(this),
                                    a = s.data(i),
                                    l = r({}, o, s.data(), "object" == typeof e && e ? e : {});
                                if (!a && l.toggle && /show|hide/.test(e) && (l.toggle = !1), a || (a = new n(this, l), s.data(i, a)), "string" == typeof e) {
                                    if (void 0 === a[e]) throw new TypeError('No method named "' + e + '"');
                                    a[e]()
                                }
                            })
                        }, s(n, null, [{
                            key: "VERSION",
                            get: function() {
                                return "4.1.3"
                            }
                        }, {
                            key: "Default",
                            get: function() {
                                return o
                            }
                        }]), n
                    }();
                return t(document).on(h.CLICK_DATA_API, u.DATA_TOGGLE, function(e) {
                    "A" === e.currentTarget.tagName && e.preventDefault();
                    var n = t(this),
                        s = a.getSelectorFromElement(this),
                        o = [].slice.call(document.querySelectorAll(s));
                    t(o).each(function() {
                        var e = t(this),
                            s = e.data(i),
                            o = s ? "toggle" : n.data();
                        p._jQueryInterface.call(e, o)
                    })
                }), t.fn[e] = p._jQueryInterface, t.fn[e].Constructor = p, t.fn[e].noConflict = function() {
                    return t.fn[e] = n, p._jQueryInterface
                }, p
            }(e),
            u = function(t) {
                var e = "dropdown",
                    n = "bs.dropdown",
                    o = "." + n,
                    l = t.fn[e],
                    h = new RegExp("38|40|27"),
                    c = {
                        HIDE: "hide" + o,
                        HIDDEN: "hidden" + o,
                        SHOW: "show" + o,
                        SHOWN: "shown" + o,
                        CLICK: "click" + o,
                        CLICK_DATA_API: "click.bs.dropdown.data-api",
                        KEYDOWN_DATA_API: "keydown.bs.dropdown.data-api",
                        KEYUP_DATA_API: "keyup.bs.dropdown.data-api"
                    },
                    d = {
                        DISABLED: "disabled",
                        SHOW: "show",
                        DROPUP: "dropup",
                        DROPRIGHT: "dropright",
                        DROPLEFT: "dropleft",
                        MENURIGHT: "dropdown-menu-right",
                        MENULEFT: "dropdown-menu-left",
                        POSITION_STATIC: "position-static"
                    },
                    u = {
                        DATA_TOGGLE: '[data-toggle="dropdown"]',
                        FORM_CHILD: ".dropdown form",
                        MENU: ".dropdown-menu",
                        NAVBAR_NAV: ".navbar-nav",
                        VISIBLE_ITEMS: ".dropdown-menu .dropdown-item:not(.disabled):not(:disabled)"
                    },
                    p = {
                        TOP: "top-start",
                        TOPEND: "top-end",
                        BOTTOM: "bottom-start",
                        BOTTOMEND: "bottom-end",
                        RIGHT: "right-start",
                        RIGHTEND: "right-end",
                        LEFT: "left-start",
                        LEFTEND: "left-end"
                    },
                    f = {
                        offset: 0,
                        flip: !0,
                        boundary: "scrollParent",
                        reference: "toggle",
                        display: "dynamic"
                    },
                    m = {
                        offset: "(number|string|function)",
                        flip: "boolean",
                        boundary: "(string|element)",
                        reference: "(string|element)",
                        display: "string"
                    },
                    g = function() {
                        function l(t, e) {
                            this._element = t, this._popper = null, this._config = this._getConfig(e), this._menu = this._getMenuElement(), this._inNavbar = this._detectNavbar(), this._addEventListeners()
                        }
                        var g = l.prototype;
                        return g.toggle = function() {
                            if (!this._element.disabled && !t(this._element).hasClass(d.DISABLED)) {
                                var e = l._getParentFromElement(this._element),
                                    n = t(this._menu).hasClass(d.SHOW);
                                if (l._clearMenus(), !n) {
                                    var s = {
                                            relatedTarget: this._element
                                        },
                                        o = t.Event(c.SHOW, s);
                                    if (t(e).trigger(o), !o.isDefaultPrevented()) {
                                        if (!this._inNavbar) {
                                            if (void 0 === i) throw new TypeError("Bootstrap dropdown require Popper.js (https://popper.js.org)");
                                            var r = this._element;
                                            "parent" === this._config.reference ? r = e : a.isElement(this._config.reference) && (r = this._config.reference, void 0 !== this._config.reference.jquery && (r = this._config.reference[0])), "scrollParent" !== this._config.boundary && t(e).addClass(d.POSITION_STATIC), this._popper = new i(r, this._menu, this._getPopperConfig())
                                        }
                                        "ontouchstart" in document.documentElement && 0 === t(e).closest(u.NAVBAR_NAV).length && t(document.body).children().on("mouseover", null, t.noop), this._element.focus(), this._element.setAttribute("aria-expanded", !0), t(this._menu).toggleClass(d.SHOW), t(e).toggleClass(d.SHOW).trigger(t.Event(c.SHOWN, s))
                                    }
                                }
                            }
                        }, g.dispose = function() {
                            t.removeData(this._element, n), t(this._element).off(o), this._element = null, this._menu = null, null !== this._popper && (this._popper.destroy(), this._popper = null)
                        }, g.update = function() {
                            this._inNavbar = this._detectNavbar(), null !== this._popper && this._popper.scheduleUpdate()
                        }, g._addEventListeners = function() {
                            var e = this;
                            t(this._element).on(c.CLICK, function(t) {
                                t.preventDefault(), t.stopPropagation(), e.toggle()
                            })
                        }, g._getConfig = function(i) {
                            return i = r({}, this.constructor.Default, t(this._element).data(), i), a.typeCheckConfig(e, i, this.constructor.DefaultType), i
                        }, g._getMenuElement = function() {
                            if (!this._menu) {
                                var t = l._getParentFromElement(this._element);
                                t && (this._menu = t.querySelector(u.MENU))
                            }
                            return this._menu
                        }, g._getPlacement = function() {
                            var e = t(this._element.parentNode),
                                i = p.BOTTOM;
                            return e.hasClass(d.DROPUP) ? (i = p.TOP, t(this._menu).hasClass(d.MENURIGHT) && (i = p.TOPEND)) : e.hasClass(d.DROPRIGHT) ? i = p.RIGHT : e.hasClass(d.DROPLEFT) ? i = p.LEFT : t(this._menu).hasClass(d.MENURIGHT) && (i = p.BOTTOMEND), i
                        }, g._detectNavbar = function() {
                            return t(this._element).closest(".navbar").length > 0
                        }, g._getPopperConfig = function() {
                            var t = this,
                                e = {};
                            "function" == typeof this._config.offset ? e.fn = function(e) {
                                return e.offsets = r({}, e.offsets, t._config.offset(e.offsets) || {}), e
                            } : e.offset = this._config.offset;
                            var i = {
                                placement: this._getPlacement(),
                                modifiers: {
                                    offset: e,
                                    flip: {
                                        enabled: this._config.flip
                                    },
                                    preventOverflow: {
                                        boundariesElement: this._config.boundary
                                    }
                                }
                            };
                            return "static" === this._config.display && (i.modifiers.applyStyle = {
                                enabled: !1
                            }), i
                        }, l._jQueryInterface = function(e) {
                            return this.each(function() {
                                var i = t(this).data(n),
                                    s = "object" == typeof e ? e : null;
                                if (i || (i = new l(this, s), t(this).data(n, i)), "string" == typeof e) {
                                    if (void 0 === i[e]) throw new TypeError('No method named "' + e + '"');
                                    i[e]()
                                }
                            })
                        }, l._clearMenus = function(e) {
                            if (!e || 3 !== e.which && ("keyup" !== e.type || 9 === e.which))
                                for (var i = [].slice.call(document.querySelectorAll(u.DATA_TOGGLE)), s = 0, o = i.length; s < o; s++) {
                                    var r = l._getParentFromElement(i[s]),
                                        a = t(i[s]).data(n),
                                        h = {
                                            relatedTarget: i[s]
                                        };
                                    if (e && "click" === e.type && (h.clickEvent = e), a) {
                                        var p = a._menu;
                                        if (t(r).hasClass(d.SHOW) && !(e && ("click" === e.type && /input|textarea/i.test(e.target.tagName) || "keyup" === e.type && 9 === e.which) && t.contains(r, e.target))) {
                                            var f = t.Event(c.HIDE, h);
                                            t(r).trigger(f), f.isDefaultPrevented() || ("ontouchstart" in document.documentElement && t(document.body).children().off("mouseover", null, t.noop), i[s].setAttribute("aria-expanded", "false"), t(p).removeClass(d.SHOW), t(r).removeClass(d.SHOW).trigger(t.Event(c.HIDDEN, h)))
                                        }
                                    }
                                }
                        }, l._getParentFromElement = function(t) {
                            var e, i = a.getSelectorFromElement(t);
                            return i && (e = document.querySelector(i)), e || t.parentNode
                        }, l._dataApiKeydownHandler = function(e) {
                            if ((/input|textarea/i.test(e.target.tagName) ? !(32 === e.which || 27 !== e.which && (40 !== e.which && 38 !== e.which || t(e.target).closest(u.MENU).length)) : h.test(e.which)) && (e.preventDefault(), e.stopPropagation(), !this.disabled && !t(this).hasClass(d.DISABLED))) {
                                var i = l._getParentFromElement(this),
                                    n = t(i).hasClass(d.SHOW);
                                if ((n || 27 === e.which && 32 === e.which) && (!n || 27 !== e.which && 32 !== e.which)) {
                                    var s = [].slice.call(i.querySelectorAll(u.VISIBLE_ITEMS));
                                    if (0 !== s.length) {
                                        var o = s.indexOf(e.target);
                                        38 === e.which && o > 0 && o--, 40 === e.which && o < s.length - 1 && o++, o < 0 && (o = 0), s[o].focus()
                                    }
                                } else {
                                    if (27 === e.which) {
                                        var r = i.querySelector(u.DATA_TOGGLE);
                                        t(r).trigger("focus")
                                    }
                                    t(this).trigger("click")
                                }
                            }
                        }, s(l, null, [{
                            key: "VERSION",
                            get: function() {
                                return "4.1.3"
                            }
                        }, {
                            key: "Default",
                            get: function() {
                                return f
                            }
                        }, {
                            key: "DefaultType",
                            get: function() {
                                return m
                            }
                        }]), l
                    }();
                return t(document).on(c.KEYDOWN_DATA_API, u.DATA_TOGGLE, g._dataApiKeydownHandler).on(c.KEYDOWN_DATA_API, u.MENU, g._dataApiKeydownHandler).on(c.CLICK_DATA_API + " " + c.KEYUP_DATA_API, g._clearMenus).on(c.CLICK_DATA_API, u.DATA_TOGGLE, function(e) {
                    e.preventDefault(), e.stopPropagation(), g._jQueryInterface.call(t(this), "toggle")
                }).on(c.CLICK_DATA_API, u.FORM_CHILD, function(t) {
                    t.stopPropagation()
                }), t.fn[e] = g._jQueryInterface, t.fn[e].Constructor = g, t.fn[e].noConflict = function() {
                    return t.fn[e] = l, g._jQueryInterface
                }, g
            }(e),
            p = function(t) {
                var e = "modal",
                    i = ".bs.modal",
                    n = t.fn.modal,
                    o = {
                        backdrop: !0,
                        keyboard: !0,
                        focus: !0,
                        show: !0
                    },
                    l = {
                        backdrop: "(boolean|string)",
                        keyboard: "boolean",
                        focus: "boolean",
                        show: "boolean"
                    },
                    h = {
                        HIDE: "hide.bs.modal",
                        HIDDEN: "hidden.bs.modal",
                        SHOW: "show.bs.modal",
                        SHOWN: "shown.bs.modal",
                        FOCUSIN: "focusin.bs.modal",
                        RESIZE: "resize.bs.modal",
                        CLICK_DISMISS: "click.dismiss.bs.modal",
                        KEYDOWN_DISMISS: "keydown.dismiss.bs.modal",
                        MOUSEUP_DISMISS: "mouseup.dismiss.bs.modal",
                        MOUSEDOWN_DISMISS: "mousedown.dismiss.bs.modal",
                        CLICK_DATA_API: "click.bs.modal.data-api"
                    },
                    c = {
                        SCROLLBAR_MEASURER: "modal-scrollbar-measure",
                        BACKDROP: "modal-backdrop",
                        OPEN: "modal-open",
                        FADE: "fade",
                        SHOW: "show"
                    },
                    d = {
                        DIALOG: ".modal-dialog",
                        DATA_TOGGLE: '[data-toggle="modal"]',
                        DATA_DISMISS: '[data-dismiss="modal"]',
                        FIXED_CONTENT: ".fixed-top, .fixed-bottom, .is-fixed, .sticky-top",
                        STICKY_CONTENT: ".sticky-top"
                    },
                    u = function() {
                        function n(t, e) {
                            this._config = this._getConfig(e), this._element = t, this._dialog = t.querySelector(d.DIALOG), this._backdrop = null, this._isShown = !1, this._isBodyOverflowing = !1, this._ignoreBackdropClick = !1, this._scrollbarWidth = 0
                        }
                        var u = n.prototype;
                        return u.toggle = function(t) {
                            return this._isShown ? this.hide() : this.show(t)
                        }, u.show = function(e) {
                            var i = this;
                            if (!this._isTransitioning && !this._isShown) {
                                t(this._element).hasClass(c.FADE) && (this._isTransitioning = !0);
                                var n = t.Event(h.SHOW, {
                                    relatedTarget: e
                                });
                                t(this._element).trigger(n), this._isShown || n.isDefaultPrevented() || (this._isShown = !0, this._checkScrollbar(), this._setScrollbar(), this._adjustDialog(), t(document.body).addClass(c.OPEN), this._setEscapeEvent(), this._setResizeEvent(), t(this._element).on(h.CLICK_DISMISS, d.DATA_DISMISS, function(t) {
                                    return i.hide(t)
                                }), t(this._dialog).on(h.MOUSEDOWN_DISMISS, function() {
                                    t(i._element).one(h.MOUSEUP_DISMISS, function(e) {
                                        t(e.target).is(i._element) && (i._ignoreBackdropClick = !0)
                                    })
                                }), this._showBackdrop(function() {
                                    return i._showElement(e)
                                }))
                            }
                        }, u.hide = function(e) {
                            var i = this;
                            if (e && e.preventDefault(), !this._isTransitioning && this._isShown) {
                                var n = t.Event(h.HIDE);
                                if (t(this._element).trigger(n), this._isShown && !n.isDefaultPrevented()) {
                                    this._isShown = !1;
                                    var s = t(this._element).hasClass(c.FADE);
                                    if (s && (this._isTransitioning = !0), this._setEscapeEvent(), this._setResizeEvent(), t(document).off(h.FOCUSIN), t(this._element).removeClass(c.SHOW), t(this._element).off(h.CLICK_DISMISS), t(this._dialog).off(h.MOUSEDOWN_DISMISS), s) {
                                        var o = a.getTransitionDurationFromElement(this._element);
                                        t(this._element).one(a.TRANSITION_END, function(t) {
                                            return i._hideModal(t)
                                        }).emulateTransitionEnd(o)
                                    } else this._hideModal()
                                }
                            }
                        }, u.dispose = function() {
                            t.removeData(this._element, "bs.modal"), t(window, document, this._element, this._backdrop).off(i), this._config = null, this._element = null, this._dialog = null, this._backdrop = null, this._isShown = null, this._isBodyOverflowing = null, this._ignoreBackdropClick = null, this._scrollbarWidth = null
                        }, u.handleUpdate = function() {
                            this._adjustDialog()
                        }, u._getConfig = function(t) {
                            return t = r({}, o, t), a.typeCheckConfig(e, t, l), t
                        }, u._showElement = function(e) {
                            var i = this,
                                n = t(this._element).hasClass(c.FADE);
                            this._element.parentNode && this._element.parentNode.nodeType === Node.ELEMENT_NODE || document.body.appendChild(this._element), this._element.style.display = "block", this._element.removeAttribute("aria-hidden"), this._element.scrollTop = 0, n && a.reflow(this._element), t(this._element).addClass(c.SHOW), this._config.focus && this._enforceFocus();
                            var s = t.Event(h.SHOWN, {
                                    relatedTarget: e
                                }),
                                o = function() {
                                    i._config.focus && i._element.focus(), i._isTransitioning = !1, t(i._element).trigger(s)
                                };
                            if (n) {
                                var r = a.getTransitionDurationFromElement(this._element);
                                t(this._dialog).one(a.TRANSITION_END, o).emulateTransitionEnd(r)
                            } else o()
                        }, u._enforceFocus = function() {
                            var e = this;
                            t(document).off(h.FOCUSIN).on(h.FOCUSIN, function(i) {
                                document !== i.target && e._element !== i.target && 0 === t(e._element).has(i.target).length && e._element.focus()
                            })
                        }, u._setEscapeEvent = function() {
                            var e = this;
                            this._isShown && this._config.keyboard ? t(this._element).on(h.KEYDOWN_DISMISS, function(t) {
                                27 === t.which && (t.preventDefault(), e.hide())
                            }) : this._isShown || t(this._element).off(h.KEYDOWN_DISMISS)
                        }, u._setResizeEvent = function() {
                            var e = this;
                            this._isShown ? t(window).on(h.RESIZE, function(t) {
                                return e.handleUpdate(t)
                            }) : t(window).off(h.RESIZE)
                        }, u._hideModal = function() {
                            var e = this;
                            this._element.style.display = "none", this._element.setAttribute("aria-hidden", !0), this._isTransitioning = !1, this._showBackdrop(function() {
                                t(document.body).removeClass(c.OPEN), e._resetAdjustments(), e._resetScrollbar(), t(e._element).trigger(h.HIDDEN)
                            })
                        }, u._removeBackdrop = function() {
                            this._backdrop && (t(this._backdrop).remove(), this._backdrop = null)
                        }, u._showBackdrop = function(e) {
                            var i = this,
                                n = t(this._element).hasClass(c.FADE) ? c.FADE : "";
                            if (this._isShown && this._config.backdrop) {
                                if (this._backdrop = document.createElement("div"), this._backdrop.className = c.BACKDROP, n && this._backdrop.classList.add(n), t(this._backdrop).appendTo(document.body), t(this._element).on(h.CLICK_DISMISS, function(t) {
                                        i._ignoreBackdropClick ? i._ignoreBackdropClick = !1 : t.target === t.currentTarget && ("static" === i._config.backdrop ? i._element.focus() : i.hide())
                                    }), n && a.reflow(this._backdrop), t(this._backdrop).addClass(c.SHOW), !e) return;
                                if (!n) return void e();
                                var s = a.getTransitionDurationFromElement(this._backdrop);
                                t(this._backdrop).one(a.TRANSITION_END, e).emulateTransitionEnd(s)
                            } else if (!this._isShown && this._backdrop) {
                                t(this._backdrop).removeClass(c.SHOW);
                                var o = function() {
                                    i._removeBackdrop(), e && e()
                                };
                                if (t(this._element).hasClass(c.FADE)) {
                                    var r = a.getTransitionDurationFromElement(this._backdrop);
                                    t(this._backdrop).one(a.TRANSITION_END, o).emulateTransitionEnd(r)
                                } else o()
                            } else e && e()
                        }, u._adjustDialog = function() {
                            var t = this._element.scrollHeight > document.documentElement.clientHeight;
                            !this._isBodyOverflowing && t && (this._element.style.paddingLeft = this._scrollbarWidth + "px"), this._isBodyOverflowing && !t && (this._element.style.paddingRight = this._scrollbarWidth + "px")
                        }, u._resetAdjustments = function() {
                            this._element.style.paddingLeft = "", this._element.style.paddingRight = ""
                        }, u._checkScrollbar = function() {
                            var t = document.body.getBoundingClientRect();
                            this._isBodyOverflowing = t.left + t.right < window.innerWidth, this._scrollbarWidth = this._getScrollbarWidth()
                        }, u._setScrollbar = function() {
                            var e = this;
                            if (this._isBodyOverflowing) {
                                var i = [].slice.call(document.querySelectorAll(d.FIXED_CONTENT)),
                                    n = [].slice.call(document.querySelectorAll(d.STICKY_CONTENT));
                                t(i).each(function(i, n) {
                                    var s = n.style.paddingRight,
                                        o = t(n).css("padding-right");
                                    t(n).data("padding-right", s).css("padding-right", parseFloat(o) + e._scrollbarWidth + "px")
                                }), t(n).each(function(i, n) {
                                    var s = n.style.marginRight,
                                        o = t(n).css("margin-right");
                                    t(n).data("margin-right", s).css("margin-right", parseFloat(o) - e._scrollbarWidth + "px")
                                });
                                var s = document.body.style.paddingRight,
                                    o = t(document.body).css("padding-right");
                                t(document.body).data("padding-right", s).css("padding-right", parseFloat(o) + this._scrollbarWidth + "px")
                            }
                        }, u._resetScrollbar = function() {
                            var e = [].slice.call(document.querySelectorAll(d.FIXED_CONTENT));
                            t(e).each(function(e, i) {
                                var n = t(i).data("padding-right");
                                t(i).removeData("padding-right"), i.style.paddingRight = n || ""
                            });
                            var i = [].slice.call(document.querySelectorAll("" + d.STICKY_CONTENT));
                            t(i).each(function(e, i) {
                                var n = t(i).data("margin-right");
                                void 0 !== n && t(i).css("margin-right", n).removeData("margin-right")
                            });
                            var n = t(document.body).data("padding-right");
                            t(document.body).removeData("padding-right"), document.body.style.paddingRight = n || ""
                        }, u._getScrollbarWidth = function() {
                            var t = document.createElement("div");
                            t.className = c.SCROLLBAR_MEASURER, document.body.appendChild(t);
                            var e = t.getBoundingClientRect().width - t.clientWidth;
                            return document.body.removeChild(t), e
                        }, n._jQueryInterface = function(e, i) {
                            return this.each(function() {
                                var s = t(this).data("bs.modal"),
                                    a = r({}, o, t(this).data(), "object" == typeof e && e ? e : {});
                                if (s || (s = new n(this, a), t(this).data("bs.modal", s)), "string" == typeof e) {
                                    if (void 0 === s[e]) throw new TypeError('No method named "' + e + '"');
                                    s[e](i)
                                } else a.show && s.show(i)
                            })
                        }, s(n, null, [{
                            key: "VERSION",
                            get: function() {
                                return "4.1.3"
                            }
                        }, {
                            key: "Default",
                            get: function() {
                                return o
                            }
                        }]), n
                    }();
                return t(document).on(h.CLICK_DATA_API, d.DATA_TOGGLE, function(e) {
                    var i, n = this,
                        s = a.getSelectorFromElement(this);
                    s && (i = document.querySelector(s));
                    var o = t(i).data("bs.modal") ? "toggle" : r({}, t(i).data(), t(this).data());
                    "A" !== this.tagName && "AREA" !== this.tagName || e.preventDefault();
                    var l = t(i).one(h.SHOW, function(e) {
                        e.isDefaultPrevented() || l.one(h.HIDDEN, function() {
                            t(n).is(":visible") && n.focus()
                        })
                    });
                    u._jQueryInterface.call(t(i), o, this)
                }), t.fn.modal = u._jQueryInterface, t.fn.modal.Constructor = u, t.fn.modal.noConflict = function() {
                    return t.fn.modal = n, u._jQueryInterface
                }, u
            }(e),
            f = function(t) {
                var e = "tooltip",
                    n = ".bs.tooltip",
                    o = t.fn[e],
                    l = new RegExp("(^|\\s)bs-tooltip\\S+", "g"),
                    h = {
                        animation: "boolean",
                        template: "string",
                        title: "(string|element|function)",
                        trigger: "string",
                        delay: "(number|object)",
                        html: "boolean",
                        selector: "(string|boolean)",
                        placement: "(string|function)",
                        offset: "(number|string)",
                        container: "(string|element|boolean)",
                        fallbackPlacement: "(string|array)",
                        boundary: "(string|element)"
                    },
                    c = {
                        AUTO: "auto",
                        TOP: "top",
                        RIGHT: "right",
                        BOTTOM: "bottom",
                        LEFT: "left"
                    },
                    d = {
                        animation: !0,
                        template: '<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',
                        trigger: "hover focus",
                        title: "",
                        delay: 0,
                        html: !1,
                        selector: !1,
                        placement: "top",
                        offset: 0,
                        container: !1,
                        fallbackPlacement: "flip",
                        boundary: "scrollParent"
                    },
                    u = {
                        SHOW: "show",
                        OUT: "out"
                    },
                    p = {
                        HIDE: "hide" + n,
                        HIDDEN: "hidden" + n,
                        SHOW: "show" + n,
                        SHOWN: "shown" + n,
                        INSERTED: "inserted" + n,
                        CLICK: "click" + n,
                        FOCUSIN: "focusin" + n,
                        FOCUSOUT: "focusout" + n,
                        MOUSEENTER: "mouseenter" + n,
                        MOUSELEAVE: "mouseleave" + n
                    },
                    f = {
                        FADE: "fade",
                        SHOW: "show"
                    },
                    m = {
                        TOOLTIP: ".tooltip",
                        TOOLTIP_INNER: ".tooltip-inner",
                        ARROW: ".arrow"
                    },
                    g = {
                        HOVER: "hover",
                        FOCUS: "focus",
                        CLICK: "click",
                        MANUAL: "manual"
                    },
                    v = function() {
                        function o(t, e) {
                            if (void 0 === i) throw new TypeError("Bootstrap tooltips require Popper.js (https://popper.js.org)");
                            this._isEnabled = !0, this._timeout = 0, this._hoverState = "", this._activeTrigger = {}, this._popper = null, this.element = t, this.config = this._getConfig(e), this.tip = null, this._setListeners()
                        }
                        var v = o.prototype;
                        return v.enable = function() {
                            this._isEnabled = !0
                        }, v.disable = function() {
                            this._isEnabled = !1
                        }, v.toggleEnabled = function() {
                            this._isEnabled = !this._isEnabled
                        }, v.toggle = function(e) {
                            if (this._isEnabled)
                                if (e) {
                                    var i = this.constructor.DATA_KEY,
                                        n = t(e.currentTarget).data(i);
                                    n || (n = new this.constructor(e.currentTarget, this._getDelegateConfig()), t(e.currentTarget).data(i, n)), n._activeTrigger.click = !n._activeTrigger.click, n._isWithActiveTrigger() ? n._enter(null, n) : n._leave(null, n)
                                } else {
                                    if (t(this.getTipElement()).hasClass(f.SHOW)) return void this._leave(null, this);
                                    this._enter(null, this)
                                }
                        }, v.dispose = function() {
                            clearTimeout(this._timeout), t.removeData(this.element, this.constructor.DATA_KEY), t(this.element).off(this.constructor.EVENT_KEY), t(this.element).closest(".modal").off("hide.bs.modal"), this.tip && t(this.tip).remove(), this._isEnabled = null, this._timeout = null, this._hoverState = null, this._activeTrigger = null, null !== this._popper && this._popper.destroy(), this._popper = null, this.element = null, this.config = null, this.tip = null
                        }, v.show = function() {
                            var e = this;
                            if ("none" === t(this.element).css("display")) throw new Error("Please use show on visible elements");
                            var n = t.Event(this.constructor.Event.SHOW);
                            if (this.isWithContent() && this._isEnabled) {
                                t(this.element).trigger(n);
                                var s = t.contains(this.element.ownerDocument.documentElement, this.element);
                                if (n.isDefaultPrevented() || !s) return;
                                var o = this.getTipElement(),
                                    r = a.getUID(this.constructor.NAME);
                                o.setAttribute("id", r), this.element.setAttribute("aria-describedby", r), this.setContent(), this.config.animation && t(o).addClass(f.FADE);
                                var l = "function" == typeof this.config.placement ? this.config.placement.call(this, o, this.element) : this.config.placement,
                                    h = this._getAttachment(l);
                                this.addAttachmentClass(h);
                                var c = !1 === this.config.container ? document.body : t(document).find(this.config.container);
                                t(o).data(this.constructor.DATA_KEY, this), t.contains(this.element.ownerDocument.documentElement, this.tip) || t(o).appendTo(c), t(this.element).trigger(this.constructor.Event.INSERTED), this._popper = new i(this.element, o, {
                                    placement: h,
                                    modifiers: {
                                        offset: {
                                            offset: this.config.offset
                                        },
                                        flip: {
                                            behavior: this.config.fallbackPlacement
                                        },
                                        arrow: {
                                            element: m.ARROW
                                        },
                                        preventOverflow: {
                                            boundariesElement: this.config.boundary
                                        }
                                    },
                                    onCreate: function(t) {
                                        t.originalPlacement !== t.placement && e._handlePopperPlacementChange(t)
                                    },
                                    onUpdate: function(t) {
                                        e._handlePopperPlacementChange(t)
                                    }
                                }), t(o).addClass(f.SHOW), "ontouchstart" in document.documentElement && t(document.body).children().on("mouseover", null, t.noop);
                                var d = function() {
                                    e.config.animation && e._fixTransition();
                                    var i = e._hoverState;
                                    e._hoverState = null, t(e.element).trigger(e.constructor.Event.SHOWN), i === u.OUT && e._leave(null, e)
                                };
                                if (t(this.tip).hasClass(f.FADE)) {
                                    var p = a.getTransitionDurationFromElement(this.tip);
                                    t(this.tip).one(a.TRANSITION_END, d).emulateTransitionEnd(p)
                                } else d()
                            }
                        }, v.hide = function(e) {
                            var i = this,
                                n = this.getTipElement(),
                                s = t.Event(this.constructor.Event.HIDE),
                                o = function() {
                                    i._hoverState !== u.SHOW && n.parentNode && n.parentNode.removeChild(n), i._cleanTipClass(), i.element.removeAttribute("aria-describedby"), t(i.element).trigger(i.constructor.Event.HIDDEN), null !== i._popper && i._popper.destroy(), e && e()
                                };
                            if (t(this.element).trigger(s), !s.isDefaultPrevented()) {
                                if (t(n).removeClass(f.SHOW), "ontouchstart" in document.documentElement && t(document.body).children().off("mouseover", null, t.noop), this._activeTrigger[g.CLICK] = !1, this._activeTrigger[g.FOCUS] = !1, this._activeTrigger[g.HOVER] = !1, t(this.tip).hasClass(f.FADE)) {
                                    var r = a.getTransitionDurationFromElement(n);
                                    t(n).one(a.TRANSITION_END, o).emulateTransitionEnd(r)
                                } else o();
                                this._hoverState = ""
                            }
                        }, v.update = function() {
                            null !== this._popper && this._popper.scheduleUpdate()
                        }, v.isWithContent = function() {
                            return Boolean(this.getTitle())
                        }, v.addAttachmentClass = function(e) {
                            t(this.getTipElement()).addClass("bs-tooltip-" + e)
                        }, v.getTipElement = function() {
                            return this.tip = this.tip || t(this.config.template)[0], this.tip
                        }, v.setContent = function() {
                            var e = this.getTipElement();
                            this.setElementContent(t(e.querySelectorAll(m.TOOLTIP_INNER)), this.getTitle()), t(e).removeClass(f.FADE + " " + f.SHOW)
                        }, v.setElementContent = function(e, i) {
                            var n = this.config.html;
                            "object" == typeof i && (i.nodeType || i.jquery) ? n ? t(i).parent().is(e) || e.empty().append(i) : e.text(t(i).text()) : e[n ? "html" : "text"](i)
                        }, v.getTitle = function() {
                            var t = this.element.getAttribute("data-original-title");
                            return t || (t = "function" == typeof this.config.title ? this.config.title.call(this.element) : this.config.title), t
                        }, v._getAttachment = function(t) {
                            return c[t.toUpperCase()]
                        }, v._setListeners = function() {
                            var e = this,
                                i = this.config.trigger.split(" ");
                            i.forEach(function(i) {
                                if ("click" === i) t(e.element).on(e.constructor.Event.CLICK, e.config.selector, function(t) {
                                    return e.toggle(t)
                                });
                                else if (i !== g.MANUAL) {
                                    var n = i === g.HOVER ? e.constructor.Event.MOUSEENTER : e.constructor.Event.FOCUSIN,
                                        s = i === g.HOVER ? e.constructor.Event.MOUSELEAVE : e.constructor.Event.FOCUSOUT;
                                    t(e.element).on(n, e.config.selector, function(t) {
                                        return e._enter(t)
                                    }).on(s, e.config.selector, function(t) {
                                        return e._leave(t)
                                    })
                                }
                                t(e.element).closest(".modal").on("hide.bs.modal", function() {
                                    return e.hide()
                                })
                            }), this.config.selector ? this.config = r({}, this.config, {
                                trigger: "manual",
                                selector: ""
                            }) : this._fixTitle()
                        }, v._fixTitle = function() {
                            var t = typeof this.element.getAttribute("data-original-title");
                            (this.element.getAttribute("title") || "string" !== t) && (this.element.setAttribute("data-original-title", this.element.getAttribute("title") || ""), this.element.setAttribute("title", ""))
                        }, v._enter = function(e, i) {
                            var n = this.constructor.DATA_KEY;
                            (i = i || t(e.currentTarget).data(n)) || (i = new this.constructor(e.currentTarget, this._getDelegateConfig()), t(e.currentTarget).data(n, i)), e && (i._activeTrigger["focusin" === e.type ? g.FOCUS : g.HOVER] = !0), t(i.getTipElement()).hasClass(f.SHOW) || i._hoverState === u.SHOW ? i._hoverState = u.SHOW : (clearTimeout(i._timeout), i._hoverState = u.SHOW, i.config.delay && i.config.delay.show ? i._timeout = setTimeout(function() {
                                i._hoverState === u.SHOW && i.show()
                            }, i.config.delay.show) : i.show())
                        }, v._leave = function(e, i) {
                            var n = this.constructor.DATA_KEY;
                            (i = i || t(e.currentTarget).data(n)) || (i = new this.constructor(e.currentTarget, this._getDelegateConfig()), t(e.currentTarget).data(n, i)), e && (i._activeTrigger["focusout" === e.type ? g.FOCUS : g.HOVER] = !1), i._isWithActiveTrigger() || (clearTimeout(i._timeout), i._hoverState = u.OUT, i.config.delay && i.config.delay.hide ? i._timeout = setTimeout(function() {
                                i._hoverState === u.OUT && i.hide()
                            }, i.config.delay.hide) : i.hide())
                        }, v._isWithActiveTrigger = function() {
                            for (var t in this._activeTrigger)
                                if (this._activeTrigger[t]) return !0;
                            return !1
                        }, v._getConfig = function(i) {
                            return "number" == typeof(i = r({}, this.constructor.Default, t(this.element).data(), "object" == typeof i && i ? i : {})).delay && (i.delay = {
                                show: i.delay,
                                hide: i.delay
                            }), "number" == typeof i.title && (i.title = i.title.toString()), "number" == typeof i.content && (i.content = i.content.toString()), a.typeCheckConfig(e, i, this.constructor.DefaultType), i
                        }, v._getDelegateConfig = function() {
                            var t = {};
                            if (this.config)
                                for (var e in this.config) this.constructor.Default[e] !== this.config[e] && (t[e] = this.config[e]);
                            return t
                        }, v._cleanTipClass = function() {
                            var e = t(this.getTipElement()),
                                i = e.attr("class").match(l);
                            null !== i && i.length && e.removeClass(i.join(""))
                        }, v._handlePopperPlacementChange = function(t) {
                            var e = t.instance;
                            this.tip = e.popper, this._cleanTipClass(), this.addAttachmentClass(this._getAttachment(t.placement))
                        }, v._fixTransition = function() {
                            var e = this.getTipElement(),
                                i = this.config.animation;
                            null === e.getAttribute("x-placement") && (t(e).removeClass(f.FADE), this.config.animation = !1, this.hide(), this.show(), this.config.animation = i)
                        }, o._jQueryInterface = function(e) {
                            return this.each(function() {
                                var i = t(this).data("bs.tooltip"),
                                    n = "object" == typeof e && e;
                                if ((i || !/dispose|hide/.test(e)) && (i || (i = new o(this, n), t(this).data("bs.tooltip", i)), "string" == typeof e)) {
                                    if (void 0 === i[e]) throw new TypeError('No method named "' + e + '"');
                                    i[e]()
                                }
                            })
                        }, s(o, null, [{
                            key: "VERSION",
                            get: function() {
                                return "4.1.3"
                            }
                        }, {
                            key: "Default",
                            get: function() {
                                return d
                            }
                        }, {
                            key: "NAME",
                            get: function() {
                                return e
                            }
                        }, {
                            key: "DATA_KEY",
                            get: function() {
                                return "bs.tooltip"
                            }
                        }, {
                            key: "Event",
                            get: function() {
                                return p
                            }
                        }, {
                            key: "EVENT_KEY",
                            get: function() {
                                return n
                            }
                        }, {
                            key: "DefaultType",
                            get: function() {
                                return h
                            }
                        }]), o
                    }();
                return t.fn[e] = v._jQueryInterface, t.fn[e].Constructor = v, t.fn[e].noConflict = function() {
                    return t.fn[e] = o, v._jQueryInterface
                }, v
            }(e),
            m = function(t) {
                var e = "popover",
                    i = ".bs.popover",
                    n = t.fn[e],
                    o = new RegExp("(^|\\s)bs-popover\\S+", "g"),
                    a = r({}, f.Default, {
                        placement: "right",
                        trigger: "click",
                        content: "",
                        template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>'
                    }),
                    l = r({}, f.DefaultType, {
                        content: "(string|element|function)"
                    }),
                    h = {
                        FADE: "fade",
                        SHOW: "show"
                    },
                    c = {
                        TITLE: ".popover-header",
                        CONTENT: ".popover-body"
                    },
                    d = {
                        HIDE: "hide" + i,
                        HIDDEN: "hidden" + i,
                        SHOW: "show" + i,
                        SHOWN: "shown" + i,
                        INSERTED: "inserted" + i,
                        CLICK: "click" + i,
                        FOCUSIN: "focusin" + i,
                        FOCUSOUT: "focusout" + i,
                        MOUSEENTER: "mouseenter" + i,
                        MOUSELEAVE: "mouseleave" + i
                    },
                    u = function(n) {
                        function r() {
                            return n.apply(this, arguments) || this
                        }! function(t, e) {
                            t.prototype = Object.create(e.prototype), t.prototype.constructor = t, t.__proto__ = e
                        }(r, n);
                        var u = r.prototype;
                        return u.isWithContent = function() {
                            return this.getTitle() || this._getContent()
                        }, u.addAttachmentClass = function(e) {
                            t(this.getTipElement()).addClass("bs-popover-" + e)
                        }, u.getTipElement = function() {
                            return this.tip = this.tip || t(this.config.template)[0], this.tip
                        }, u.setContent = function() {
                            var e = t(this.getTipElement());
                            this.setElementContent(e.find(c.TITLE), this.getTitle());
                            var i = this._getContent();
                            "function" == typeof i && (i = i.call(this.element)), this.setElementContent(e.find(c.CONTENT), i), e.removeClass(h.FADE + " " + h.SHOW)
                        }, u._getContent = function() {
                            return this.element.getAttribute("data-content") || this.config.content
                        }, u._cleanTipClass = function() {
                            var e = t(this.getTipElement()),
                                i = e.attr("class").match(o);
                            null !== i && i.length > 0 && e.removeClass(i.join(""))
                        }, r._jQueryInterface = function(e) {
                            return this.each(function() {
                                var i = t(this).data("bs.popover"),
                                    n = "object" == typeof e ? e : null;
                                if ((i || !/destroy|hide/.test(e)) && (i || (i = new r(this, n), t(this).data("bs.popover", i)), "string" == typeof e)) {
                                    if (void 0 === i[e]) throw new TypeError('No method named "' + e + '"');
                                    i[e]()
                                }
                            })
                        }, s(r, null, [{
                            key: "VERSION",
                            get: function() {
                                return "4.1.3"
                            }
                        }, {
                            key: "Default",
                            get: function() {
                                return a
                            }
                        }, {
                            key: "NAME",
                            get: function() {
                                return e
                            }
                        }, {
                            key: "DATA_KEY",
                            get: function() {
                                return "bs.popover"
                            }
                        }, {
                            key: "Event",
                            get: function() {
                                return d
                            }
                        }, {
                            key: "EVENT_KEY",
                            get: function() {
                                return i
                            }
                        }, {
                            key: "DefaultType",
                            get: function() {
                                return l
                            }
                        }]), r
                    }(f);
                return t.fn[e] = u._jQueryInterface, t.fn[e].Constructor = u, t.fn[e].noConflict = function() {
                    return t.fn[e] = n, u._jQueryInterface
                }, u
            }(e),
            g = function(t) {
                var e = "scrollspy",
                    i = t.fn[e],
                    n = {
                        offset: 10,
                        method: "auto",
                        target: ""
                    },
                    o = {
                        offset: "number",
                        method: "string",
                        target: "(string|element)"
                    },
                    l = {
                        ACTIVATE: "activate.bs.scrollspy",
                        SCROLL: "scroll.bs.scrollspy",
                        LOAD_DATA_API: "load.bs.scrollspy.data-api"
                    },
                    h = {
                        DROPDOWN_ITEM: "dropdown-item",
                        DROPDOWN_MENU: "dropdown-menu",
                        ACTIVE: "active"
                    },
                    c = {
                        DATA_SPY: '[data-spy="scroll"]',
                        ACTIVE: ".active",
                        NAV_LIST_GROUP: ".nav, .list-group",
                        NAV_LINKS: ".nav-link",
                        NAV_ITEMS: ".nav-item",
                        LIST_ITEMS: ".list-group-item",
                        DROPDOWN: ".dropdown",
                        DROPDOWN_ITEMS: ".dropdown-item",
                        DROPDOWN_TOGGLE: ".dropdown-toggle"
                    },
                    d = {
                        OFFSET: "offset",
                        POSITION: "position"
                    },
                    u = function() {
                        function i(e, i) {
                            var n = this;
                            this._element = e, this._scrollElement = "BODY" === e.tagName ? window : e, this._config = this._getConfig(i), this._selector = this._config.target + " " + c.NAV_LINKS + "," + this._config.target + " " + c.LIST_ITEMS + "," + this._config.target + " " + c.DROPDOWN_ITEMS, this._offsets = [], this._targets = [], this._activeTarget = null, this._scrollHeight = 0, t(this._scrollElement).on(l.SCROLL, function(t) {
                                return n._process(t)
                            }), this.refresh(), this._process()
                        }
                        var u = i.prototype;
                        return u.refresh = function() {
                            var e = this,
                                i = this._scrollElement === this._scrollElement.window ? d.OFFSET : d.POSITION,
                                n = "auto" === this._config.method ? i : this._config.method,
                                s = n === d.POSITION ? this._getScrollTop() : 0;
                            this._offsets = [], this._targets = [], this._scrollHeight = this._getScrollHeight();
                            var o = [].slice.call(document.querySelectorAll(this._selector));
                            o.map(function(e) {
                                var i, o = a.getSelectorFromElement(e);
                                if (o && (i = document.querySelector(o)), i) {
                                    var r = i.getBoundingClientRect();
                                    if (r.width || r.height) return [t(i)[n]().top + s, o]
                                }
                                return null
                            }).filter(function(t) {
                                return t
                            }).sort(function(t, e) {
                                return t[0] - e[0]
                            }).forEach(function(t) {
                                e._offsets.push(t[0]), e._targets.push(t[1])
                            })
                        }, u.dispose = function() {
                            t.removeData(this._element, "bs.scrollspy"), t(this._scrollElement).off(".bs.scrollspy"), this._element = null, this._scrollElement = null, this._config = null, this._selector = null, this._offsets = null, this._targets = null, this._activeTarget = null, this._scrollHeight = null
                        }, u._getConfig = function(i) {
                            if ("string" != typeof(i = r({}, n, "object" == typeof i && i ? i : {})).target) {
                                var s = t(i.target).attr("id");
                                s || (s = a.getUID(e), t(i.target).attr("id", s)), i.target = "#" + s
                            }
                            return a.typeCheckConfig(e, i, o), i
                        }, u._getScrollTop = function() {
                            return this._scrollElement === window ? this._scrollElement.pageYOffset : this._scrollElement.scrollTop
                        }, u._getScrollHeight = function() {
                            return this._scrollElement.scrollHeight || Math.max(document.body.scrollHeight, document.documentElement.scrollHeight)
                        }, u._getOffsetHeight = function() {
                            return this._scrollElement === window ? window.innerHeight : this._scrollElement.getBoundingClientRect().height
                        }, u._process = function() {
                            var t = this._getScrollTop() + this._config.offset,
                                e = this._getScrollHeight(),
                                i = this._config.offset + e - this._getOffsetHeight();
                            if (this._scrollHeight !== e && this.refresh(), t >= i) {
                                var n = this._targets[this._targets.length - 1];
                                this._activeTarget !== n && this._activate(n)
                            } else {
                                if (this._activeTarget && t < this._offsets[0] && this._offsets[0] > 0) return this._activeTarget = null, void this._clear();
                                for (var s = this._offsets.length, o = s; o--;) {
                                    var r = this._activeTarget !== this._targets[o] && t >= this._offsets[o] && (void 0 === this._offsets[o + 1] || t < this._offsets[o + 1]);
                                    r && this._activate(this._targets[o])
                                }
                            }
                        }, u._activate = function(e) {
                            this._activeTarget = e, this._clear();
                            var i = this._selector.split(",");
                            i = i.map(function(t) {
                                return t + '[data-target="' + e + '"],' + t + '[href="' + e + '"]'
                            });
                            var n = t([].slice.call(document.querySelectorAll(i.join(","))));
                            n.hasClass(h.DROPDOWN_ITEM) ? (n.closest(c.DROPDOWN).find(c.DROPDOWN_TOGGLE).addClass(h.ACTIVE), n.addClass(h.ACTIVE)) : (n.addClass(h.ACTIVE), n.parents(c.NAV_LIST_GROUP).prev(c.NAV_LINKS + ", " + c.LIST_ITEMS).addClass(h.ACTIVE), n.parents(c.NAV_LIST_GROUP).prev(c.NAV_ITEMS).children(c.NAV_LINKS).addClass(h.ACTIVE)), t(this._scrollElement).trigger(l.ACTIVATE, {
                                relatedTarget: e
                            })
                        }, u._clear = function() {
                            var e = [].slice.call(document.querySelectorAll(this._selector));
                            t(e).filter(c.ACTIVE).removeClass(h.ACTIVE)
                        }, i._jQueryInterface = function(e) {
                            return this.each(function() {
                                var n = t(this).data("bs.scrollspy"),
                                    s = "object" == typeof e && e;
                                if (n || (n = new i(this, s), t(this).data("bs.scrollspy", n)), "string" == typeof e) {
                                    if (void 0 === n[e]) throw new TypeError('No method named "' + e + '"');
                                    n[e]()
                                }
                            })
                        }, s(i, null, [{
                            key: "VERSION",
                            get: function() {
                                return "4.1.3"
                            }
                        }, {
                            key: "Default",
                            get: function() {
                                return n
                            }
                        }]), i
                    }();
                return t(window).on(l.LOAD_DATA_API, function() {
                    for (var e = [].slice.call(document.querySelectorAll(c.DATA_SPY)), i = e.length, n = i; n--;) {
                        var s = t(e[n]);
                        u._jQueryInterface.call(s, s.data())
                    }
                }), t.fn[e] = u._jQueryInterface, t.fn[e].Constructor = u, t.fn[e].noConflict = function() {
                    return t.fn[e] = i, u._jQueryInterface
                }, u
            }(e),
            v = function(t) {
                var e = t.fn.tab,
                    i = {
                        HIDE: "hide.bs.tab",
                        HIDDEN: "hidden.bs.tab",
                        SHOW: "show.bs.tab",
                        SHOWN: "shown.bs.tab",
                        CLICK_DATA_API: "click.bs.tab.data-api"
                    },
                    n = {
                        DROPDOWN_MENU: "dropdown-menu",
                        ACTIVE: "active",
                        DISABLED: "disabled",
                        FADE: "fade",
                        SHOW: "show"
                    },
                    o = {
                        DROPDOWN: ".dropdown",
                        NAV_LIST_GROUP: ".nav, .list-group",
                        ACTIVE: ".active",
                        ACTIVE_UL: "> li > .active",
                        DATA_TOGGLE: '[data-toggle="tab"], [data-toggle="pill"], [data-toggle="list"]',
                        DROPDOWN_TOGGLE: ".dropdown-toggle",
                        DROPDOWN_ACTIVE_CHILD: "> .dropdown-menu .active"
                    },
                    r = function() {
                        function e(t) {
                            this._element = t
                        }
                        var r = e.prototype;
                        return r.show = function() {
                            var e = this;
                            if (!(this._element.parentNode && this._element.parentNode.nodeType === Node.ELEMENT_NODE && t(this._element).hasClass(n.ACTIVE) || t(this._element).hasClass(n.DISABLED))) {
                                var s, r, l = t(this._element).closest(o.NAV_LIST_GROUP)[0],
                                    h = a.getSelectorFromElement(this._element);
                                if (l) {
                                    var c = "UL" === l.nodeName ? o.ACTIVE_UL : o.ACTIVE;
                                    r = (r = t.makeArray(t(l).find(c)))[r.length - 1]
                                }
                                var d = t.Event(i.HIDE, {
                                        relatedTarget: this._element
                                    }),
                                    u = t.Event(i.SHOW, {
                                        relatedTarget: r
                                    });
                                if (r && t(r).trigger(d), t(this._element).trigger(u), !u.isDefaultPrevented() && !d.isDefaultPrevented()) {
                                    h && (s = document.querySelector(h)), this._activate(this._element, l);
                                    var p = function() {
                                        var n = t.Event(i.HIDDEN, {
                                                relatedTarget: e._element
                                            }),
                                            s = t.Event(i.SHOWN, {
                                                relatedTarget: r
                                            });
                                        t(r).trigger(n), t(e._element).trigger(s)
                                    };
                                    s ? this._activate(s, s.parentNode, p) : p()
                                }
                            }
                        }, r.dispose = function() {
                            t.removeData(this._element, "bs.tab"), this._element = null
                        }, r._activate = function(e, i, s) {
                            var r = this,
                                l = ("UL" === i.nodeName ? t(i).find(o.ACTIVE_UL) : t(i).children(o.ACTIVE))[0],
                                h = s && l && t(l).hasClass(n.FADE),
                                c = function() {
                                    return r._transitionComplete(e, l, s)
                                };
                            if (l && h) {
                                var d = a.getTransitionDurationFromElement(l);
                                t(l).one(a.TRANSITION_END, c).emulateTransitionEnd(d)
                            } else c()
                        }, r._transitionComplete = function(e, i, s) {
                            if (i) {
                                t(i).removeClass(n.SHOW + " " + n.ACTIVE);
                                var r = t(i.parentNode).find(o.DROPDOWN_ACTIVE_CHILD)[0];
                                r && t(r).removeClass(n.ACTIVE), "tab" === i.getAttribute("role") && i.setAttribute("aria-selected", !1)
                            }
                            if (t(e).addClass(n.ACTIVE), "tab" === e.getAttribute("role") && e.setAttribute("aria-selected", !0), a.reflow(e), t(e).addClass(n.SHOW), e.parentNode && t(e.parentNode).hasClass(n.DROPDOWN_MENU)) {
                                var l = t(e).closest(o.DROPDOWN)[0];
                                if (l) {
                                    var h = [].slice.call(l.querySelectorAll(o.DROPDOWN_TOGGLE));
                                    t(h).addClass(n.ACTIVE)
                                }
                                e.setAttribute("aria-expanded", !0)
                            }
                            s && s()
                        }, e._jQueryInterface = function(i) {
                            return this.each(function() {
                                var n = t(this),
                                    s = n.data("bs.tab");
                                if (s || (s = new e(this), n.data("bs.tab", s)), "string" == typeof i) {
                                    if (void 0 === s[i]) throw new TypeError('No method named "' + i + '"');
                                    s[i]()
                                }
                            })
                        }, s(e, null, [{
                            key: "VERSION",
                            get: function() {
                                return "4.1.3"
                            }
                        }]), e
                    }();
                return t(document).on(i.CLICK_DATA_API, o.DATA_TOGGLE, function(e) {
                    e.preventDefault(), r._jQueryInterface.call(t(this), "show")
                }), t.fn.tab = r._jQueryInterface, t.fn.tab.Constructor = r, t.fn.tab.noConflict = function() {
                    return t.fn.tab = e, r._jQueryInterface
                }, r
            }(e);
        (function(t) {
            if (void 0 === t) throw new TypeError("Bootstrap's JavaScript requires jQuery. jQuery must be included before Bootstrap's JavaScript.");
            var e = t.fn.jquery.split(" ")[0].split(".");
            if (e[0] < 2 && e[1] < 9 || 1 === e[0] && 9 === e[1] && e[2] < 1 || e[0] >= 4) throw new Error("Bootstrap's JavaScript requires at least jQuery v1.9.1 but less than v4.0.0")
        })(e), t.Util = a, t.Alert = l, t.Button = h, t.Carousel = c, t.Collapse = d, t.Dropdown = u, t.Modal = p, t.Popover = m, t.Scrollspy = g, t.Tab = v, t.Tooltip = f, Object.defineProperty(t, "__esModule", {
            value: !0
        })
    }(e, i(3), i(76))
  }, function(t, e, i) {
    "use strict";
    i.r(e),
        function(t) {
            for (
                /**!
                 * @fileOverview Kickass library to create and place poppers near their reference elements.
                 * @version 1.14.5
                 * @license
                 * Copyright (c) 2016 Federico Zivolo and contributors
                 *
                 * Permission is hereby granted, free of charge, to any person obtaining a copy
                 * of this software and associated documentation files (the "Software"), to deal
                 * in the Software without restriction, including without limitation the rights
                 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
                 * copies of the Software, and to permit persons to whom the Software is
                 * furnished to do so, subject to the following conditions:
                 *
                 * The above copyright notice and this permission notice shall be included in all
                 * copies or substantial portions of the Software.
                 *
                 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
                 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
                 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
                 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
                 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
                 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
                 * SOFTWARE.
                 */
                var i = "undefined" != typeof window && "undefined" != typeof document, n = ["Edge", "Trident", "Firefox"], s = 0, o = 0; o < n.length; o += 1)
                if (i && navigator.userAgent.indexOf(n[o]) >= 0) {
                    s = 1;
                    break
                } var r = i && window.Promise ? function(t) {
                var e = !1;
                return function() {
                    e || (e = !0, window.Promise.resolve().then(function() {
                        e = !1, t()
                    }))
                }
            } : function(t) {
                var e = !1;
                return function() {
                    e || (e = !0, setTimeout(function() {
                        e = !1, t()
                    }, s))
                }
            };
  
            function a(t) {
                return t && "[object Function]" === {}.toString.call(t)
            }
  
            function l(t, e) {
                if (1 !== t.nodeType) return [];
                var i = t.ownerDocument.defaultView.getComputedStyle(t, null);
                return e ? i[e] : i
            }
  
            function h(t) {
                return "HTML" === t.nodeName ? t : t.parentNode || t.host
            }
  
            function c(t) {
                if (!t) return document.body;
                switch (t.nodeName) {
                    case "HTML":
                    case "BODY":
                        return t.ownerDocument.body;
                    case "#document":
                        return t.body
                }
                var e = l(t),
                    i = e.overflow,
                    n = e.overflowX,
                    s = e.overflowY;
                return /(auto|scroll|overlay)/.test(i + s + n) ? t : c(h(t))
            }
            var d = i && !(!window.MSInputMethodContext || !document.documentMode),
                u = i && /MSIE 10/.test(navigator.userAgent);
  
            function p(t) {
                return 11 === t ? d : 10 === t ? u : d || u
            }
  
            function f(t) {
                if (!t) return document.documentElement;
                for (var e = p(10) ? document.body : null, i = t.offsetParent || null; i === e && t.nextElementSibling;) i = (t = t.nextElementSibling).offsetParent;
                var n = i && i.nodeName;
                return n && "BODY" !== n && "HTML" !== n ? -1 !== ["TH", "TD", "TABLE"].indexOf(i.nodeName) && "static" === l(i, "position") ? f(i) : i : t ? t.ownerDocument.documentElement : document.documentElement
            }
  
            function m(t) {
                return null !== t.parentNode ? m(t.parentNode) : t
            }
  
            function g(t, e) {
                if (!(t && t.nodeType && e && e.nodeType)) return document.documentElement;
                var i = t.compareDocumentPosition(e) & Node.DOCUMENT_POSITION_FOLLOWING,
                    n = i ? t : e,
                    s = i ? e : t,
                    o = document.createRange();
                o.setStart(n, 0), o.setEnd(s, 0);
                var r = o.commonAncestorContainer;
                if (t !== r && e !== r || n.contains(s)) return function(t) {
                    var e = t.nodeName;
                    return "BODY" !== e && ("HTML" === e || f(t.firstElementChild) === t)
                }(r) ? r : f(r);
                var a = m(t);
                return a.host ? g(a.host, e) : g(t, m(e).host)
            }
  
            function v(t) {
                var e = "top" === (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "top") ? "scrollTop" : "scrollLeft",
                    i = t.nodeName;
                if ("BODY" === i || "HTML" === i) {
                    var n = t.ownerDocument.documentElement;
                    return (t.ownerDocument.scrollingElement || n)[e]
                }
                return t[e]
            }
  
            function y(t, e) {
                var i = "x" === e ? "Left" : "Top",
                    n = "Left" === i ? "Right" : "Bottom";
                return parseFloat(t["border" + i + "Width"], 10) + parseFloat(t["border" + n + "Width"], 10)
            }
  
            function _(t, e, i, n) {
                return Math.max(e["offset" + t], e["scroll" + t], i["client" + t], i["offset" + t], i["scroll" + t], p(10) ? parseInt(i["offset" + t]) + parseInt(n["margin" + ("Height" === t ? "Top" : "Left")]) + parseInt(n["margin" + ("Height" === t ? "Bottom" : "Right")]) : 0)
            }
  
            function b(t) {
                var e = t.body,
                    i = t.documentElement,
                    n = p(10) && getComputedStyle(i);
                return {
                    height: _("Height", e, i, n),
                    width: _("Width", e, i, n)
                }
            }
            var w = function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
                },
                x = function() {
                    function t(t, e) {
                        for (var i = 0; i < e.length; i++) {
                            var n = e[i];
                            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n)
                        }
                    }
                    return function(e, i, n) {
                        return i && t(e.prototype, i), n && t(e, n), e
                    }
                }(),
                T = function(t, e, i) {
                    return e in t ? Object.defineProperty(t, e, {
                        value: i,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : t[e] = i, t
                },
                E = Object.assign || function(t) {
                    for (var e = 1; e < arguments.length; e++) {
                        var i = arguments[e];
                        for (var n in i) Object.prototype.hasOwnProperty.call(i, n) && (t[n] = i[n])
                    }
                    return t
                };
  
            function C(t) {
                return E({}, t, {
                    right: t.left + t.width,
                    bottom: t.top + t.height
                })
            }
  
            function S(t) {
                var e = {};
                try {
                    if (p(10)) {
                        e = t.getBoundingClientRect();
                        var i = v(t, "top"),
                            n = v(t, "left");
                        e.top += i, e.left += n, e.bottom += i, e.right += n
                    } else e = t.getBoundingClientRect()
                } catch (t) {}
                var s = {
                        left: e.left,
                        top: e.top,
                        width: e.right - e.left,
                        height: e.bottom - e.top
                    },
                    o = "HTML" === t.nodeName ? b(t.ownerDocument) : {},
                    r = o.width || t.clientWidth || s.right - s.left,
                    a = o.height || t.clientHeight || s.bottom - s.top,
                    h = t.offsetWidth - r,
                    c = t.offsetHeight - a;
                if (h || c) {
                    var d = l(t);
                    h -= y(d, "x"), c -= y(d, "y"), s.width -= h, s.height -= c
                }
                return C(s)
            }
  
            function D(t, e) {
                var i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
                    n = p(10),
                    s = "HTML" === e.nodeName,
                    o = S(t),
                    r = S(e),
                    a = c(t),
                    h = l(e),
                    d = parseFloat(h.borderTopWidth, 10),
                    u = parseFloat(h.borderLeftWidth, 10);
                i && s && (r.top = Math.max(r.top, 0), r.left = Math.max(r.left, 0));
                var f = C({
                    top: o.top - r.top - d,
                    left: o.left - r.left - u,
                    width: o.width,
                    height: o.height
                });
                if (f.marginTop = 0, f.marginLeft = 0, !n && s) {
                    var m = parseFloat(h.marginTop, 10),
                        g = parseFloat(h.marginLeft, 10);
                    f.top -= d - m, f.bottom -= d - m, f.left -= u - g, f.right -= u - g, f.marginTop = m, f.marginLeft = g
                }
                return (n && !i ? e.contains(a) : e === a && "BODY" !== a.nodeName) && (f = function(t, e) {
                    var i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
                        n = v(e, "top"),
                        s = v(e, "left"),
                        o = i ? -1 : 1;
                    return t.top += n * o, t.bottom += n * o, t.left += s * o, t.right += s * o, t
                }(f, e)), f
            }
  
            function I(t) {
                if (!t || !t.parentElement || p()) return document.documentElement;
                for (var e = t.parentElement; e && "none" === l(e, "transform");) e = e.parentElement;
                return e || document.documentElement
            }
  
            function M(t, e, i, n) {
                var s = arguments.length > 4 && void 0 !== arguments[4] && arguments[4],
                    o = {
                        top: 0,
                        left: 0
                    },
                    r = s ? I(t) : g(t, e);
                if ("viewport" === n) o = function(t) {
                    var e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
                        i = t.ownerDocument.documentElement,
                        n = D(t, i),
                        s = Math.max(i.clientWidth, window.innerWidth || 0),
                        o = Math.max(i.clientHeight, window.innerHeight || 0),
                        r = e ? 0 : v(i),
                        a = e ? 0 : v(i, "left");
                    return C({
                        top: r - n.top + n.marginTop,
                        left: a - n.left + n.marginLeft,
                        width: s,
                        height: o
                    })
                }(r, s);
                else {
                    var a = void 0;
                    "scrollParent" === n ? "BODY" === (a = c(h(e))).nodeName && (a = t.ownerDocument.documentElement) : a = "window" === n ? t.ownerDocument.documentElement : n;
                    var d = D(a, r, s);
                    if ("HTML" !== a.nodeName || function t(e) {
                            var i = e.nodeName;
                            return "BODY" !== i && "HTML" !== i && ("fixed" === l(e, "position") || t(h(e)))
                        }(r)) o = d;
                    else {
                        var u = b(t.ownerDocument),
                            p = u.height,
                            f = u.width;
                        o.top += d.top - d.marginTop, o.bottom = p + d.top, o.left += d.left - d.marginLeft, o.right = f + d.left
                    }
                }
                var m = "number" == typeof(i = i || 0);
                return o.left += m ? i : i.left || 0, o.top += m ? i : i.top || 0, o.right -= m ? i : i.right || 0, o.bottom -= m ? i : i.bottom || 0, o
            }
  
            function O(t, e, i, n, s) {
                var o = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 0;
                if (-1 === t.indexOf("auto")) return t;
                var r = M(i, n, o, s),
                    a = {
                        top: {
                            width: r.width,
                            height: e.top - r.top
                        },
                        right: {
                            width: r.right - e.right,
                            height: r.height
                        },
                        bottom: {
                            width: r.width,
                            height: r.bottom - e.bottom
                        },
                        left: {
                            width: e.left - r.left,
                            height: r.height
                        }
                    },
                    l = Object.keys(a).map(function(t) {
                        return E({
                            key: t
                        }, a[t], {
                            area: function(t) {
                                return t.width * t.height
                            }(a[t])
                        })
                    }).sort(function(t, e) {
                        return e.area - t.area
                    }),
                    h = l.filter(function(t) {
                        var e = t.width,
                            n = t.height;
                        return e >= i.clientWidth && n >= i.clientHeight
                    }),
                    c = h.length > 0 ? h[0].key : l[0].key,
                    d = t.split("-")[1];
                return c + (d ? "-" + d : "")
            }
  
            function k(t, e, i) {
                var n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null;
                return D(i, n ? I(e) : g(e, i), n)
            }
  
            function A(t) {
                var e = t.ownerDocument.defaultView.getComputedStyle(t),
                    i = parseFloat(e.marginTop) + parseFloat(e.marginBottom),
                    n = parseFloat(e.marginLeft) + parseFloat(e.marginRight);
                return {
                    width: t.offsetWidth + n,
                    height: t.offsetHeight + i
                }
            }
  
            function P(t) {
                var e = {
                    left: "right",
                    right: "left",
                    bottom: "top",
                    top: "bottom"
                };
                return t.replace(/left|right|bottom|top/g, function(t) {
                    return e[t]
                })
            }
  
            function $(t, e, i) {
                i = i.split("-")[0];
                var n = A(t),
                    s = {
                        width: n.width,
                        height: n.height
                    },
                    o = -1 !== ["right", "left"].indexOf(i),
                    r = o ? "top" : "left",
                    a = o ? "left" : "top",
                    l = o ? "height" : "width",
                    h = o ? "width" : "height";
                return s[r] = e[r] + e[l] / 2 - n[l] / 2, s[a] = i === a ? e[a] - n[h] : e[P(a)], s
            }
  
            function L(t, e) {
                return Array.prototype.find ? t.find(e) : t.filter(e)[0]
            }
  
            function N(t, e, i) {
                return (void 0 === i ? t : t.slice(0, function(t, e, i) {
                    if (Array.prototype.findIndex) return t.findIndex(function(t) {
                        return t[e] === i
                    });
                    var n = L(t, function(t) {
                        return t[e] === i
                    });
                    return t.indexOf(n)
                }(t, "name", i))).forEach(function(t) {
                    t.function && console.warn("`modifier.function` is deprecated, use `modifier.fn`!");
                    var i = t.function || t.fn;
                    t.enabled && a(i) && (e.offsets.popper = C(e.offsets.popper), e.offsets.reference = C(e.offsets.reference), e = i(e, t))
                }), e
            }
  
            function z(t, e) {
                return t.some(function(t) {
                    var i = t.name;
                    return t.enabled && i === e
                })
            }
  
            function F(t) {
                for (var e = [!1, "ms", "Webkit", "Moz", "O"], i = t.charAt(0).toUpperCase() + t.slice(1), n = 0; n < e.length; n++) {
                    var s = e[n],
                        o = s ? "" + s + i : t;
                    if (void 0 !== document.body.style[o]) return o
                }
                return null
            }
  
            function H(t) {
                var e = t.ownerDocument;
                return e ? e.defaultView : window
            }
  
            function R(t, e, i, n) {
                i.updateBound = n, H(t).addEventListener("resize", i.updateBound, {
                    passive: !0
                });
                var s = c(t);
                return function t(e, i, n, s) {
                    var o = "BODY" === e.nodeName,
                        r = o ? e.ownerDocument.defaultView : e;
                    r.addEventListener(i, n, {
                        passive: !0
                    }), o || t(c(r.parentNode), i, n, s), s.push(r)
                }(s, "scroll", i.updateBound, i.scrollParents), i.scrollElement = s, i.eventsEnabled = !0, i
            }
  
            function j() {
                this.state.eventsEnabled && (cancelAnimationFrame(this.scheduleUpdate), this.state = function(t, e) {
                    return H(t).removeEventListener("resize", e.updateBound), e.scrollParents.forEach(function(t) {
                        t.removeEventListener("scroll", e.updateBound)
                    }), e.updateBound = null, e.scrollParents = [], e.scrollElement = null, e.eventsEnabled = !1, e
                }(this.reference, this.state))
            }
  
            function W(t) {
                return "" !== t && !isNaN(parseFloat(t)) && isFinite(t)
            }
  
            function B(t, e) {
                Object.keys(e).forEach(function(i) {
                    var n = ""; - 1 !== ["width", "height", "top", "right", "bottom", "left"].indexOf(i) && W(e[i]) && (n = "px"), t.style[i] = e[i] + n
                })
            }
  
            function V(t, e, i) {
                var n = L(t, function(t) {
                        return t.name === e
                    }),
                    s = !!n && t.some(function(t) {
                        return t.name === i && t.enabled && t.order < n.order
                    });
                if (!s) {
                    var o = "`" + e + "`",
                        r = "`" + i + "`";
                    console.warn(r + " modifier is required by " + o + " modifier in order to work, be sure to include it before " + o + "!")
                }
                return s
            }
            var q = ["auto-start", "auto", "auto-end", "top-start", "top", "top-end", "right-start", "right", "right-end", "bottom-end", "bottom", "bottom-start", "left-end", "left", "left-start"],
                G = q.slice(3);
  
            function U(t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
                    i = G.indexOf(t),
                    n = G.slice(i + 1).concat(G.slice(0, i));
                return e ? n.reverse() : n
            }
            var Y = {
                FLIP: "flip",
                CLOCKWISE: "clockwise",
                COUNTERCLOCKWISE: "counterclockwise"
            };
  
            function X(t, e, i, n) {
                var s = [0, 0],
                    o = -1 !== ["right", "left"].indexOf(n),
                    r = t.split(/(\+|\-)/).map(function(t) {
                        return t.trim()
                    }),
                    a = r.indexOf(L(r, function(t) {
                        return -1 !== t.search(/,|\s/)
                    }));
                r[a] && -1 === r[a].indexOf(",") && console.warn("Offsets separated by white space(s) are deprecated, use a comma (,) instead.");
                var l = /\s*,\s*|\s+/,
                    h = -1 !== a ? [r.slice(0, a).concat([r[a].split(l)[0]]), [r[a].split(l)[1]].concat(r.slice(a + 1))] : [r];
                return (h = h.map(function(t, n) {
                    var s = (1 === n ? !o : o) ? "height" : "width",
                        r = !1;
                    return t.reduce(function(t, e) {
                        return "" === t[t.length - 1] && -1 !== ["+", "-"].indexOf(e) ? (t[t.length - 1] = e, r = !0, t) : r ? (t[t.length - 1] += e, r = !1, t) : t.concat(e)
                    }, []).map(function(t) {
                        return function(t, e, i, n) {
                            var s = t.match(/((?:\-|\+)?\d*\.?\d*)(.*)/),
                                o = +s[1],
                                r = s[2];
                            if (!o) return t;
                            if (0 === r.indexOf("%")) {
                                var a = void 0;
                                switch (r) {
                                    case "%p":
                                        a = i;
                                        break;
                                    case "%":
                                    case "%r":
                                    default:
                                        a = n
                                }
                                return C(a)[e] / 100 * o
                            }
                            if ("vh" === r || "vw" === r) return ("vh" === r ? Math.max(document.documentElement.clientHeight, window.innerHeight || 0) : Math.max(document.documentElement.clientWidth, window.innerWidth || 0)) / 100 * o;
                            return o
                        }(t, s, e, i)
                    })
                })).forEach(function(t, e) {
                    t.forEach(function(i, n) {
                        W(i) && (s[e] += i * ("-" === t[n - 1] ? -1 : 1))
                    })
                }), s
            }
            var K = {
                    placement: "bottom",
                    positionFixed: !1,
                    eventsEnabled: !0,
                    removeOnDestroy: !1,
                    onCreate: function() {},
                    onUpdate: function() {},
                    modifiers: {
                        shift: {
                            order: 100,
                            enabled: !0,
                            fn: function(t) {
                                var e = t.placement,
                                    i = e.split("-")[0],
                                    n = e.split("-")[1];
                                if (n) {
                                    var s = t.offsets,
                                        o = s.reference,
                                        r = s.popper,
                                        a = -1 !== ["bottom", "top"].indexOf(i),
                                        l = a ? "left" : "top",
                                        h = a ? "width" : "height",
                                        c = {
                                            start: T({}, l, o[l]),
                                            end: T({}, l, o[l] + o[h] - r[h])
                                        };
                                    t.offsets.popper = E({}, r, c[n])
                                }
                                return t
                            }
                        },
                        offset: {
                            order: 200,
                            enabled: !0,
                            fn: function(t, e) {
                                var i = e.offset,
                                    n = t.placement,
                                    s = t.offsets,
                                    o = s.popper,
                                    r = s.reference,
                                    a = n.split("-")[0],
                                    l = void 0;
                                return l = W(+i) ? [+i, 0] : X(i, o, r, a), "left" === a ? (o.top += l[0], o.left -= l[1]) : "right" === a ? (o.top += l[0], o.left += l[1]) : "top" === a ? (o.left += l[0], o.top -= l[1]) : "bottom" === a && (o.left += l[0], o.top += l[1]), t.popper = o, t
                            },
                            offset: 0
                        },
                        preventOverflow: {
                            order: 300,
                            enabled: !0,
                            fn: function(t, e) {
                                var i = e.boundariesElement || f(t.instance.popper);
                                t.instance.reference === i && (i = f(i));
                                var n = F("transform"),
                                    s = t.instance.popper.style,
                                    o = s.top,
                                    r = s.left,
                                    a = s[n];
                                s.top = "", s.left = "", s[n] = "";
                                var l = M(t.instance.popper, t.instance.reference, e.padding, i, t.positionFixed);
                                s.top = o, s.left = r, s[n] = a, e.boundaries = l;
                                var h = e.priority,
                                    c = t.offsets.popper,
                                    d = {
                                        primary: function(t) {
                                            var i = c[t];
                                            return c[t] < l[t] && !e.escapeWithReference && (i = Math.max(c[t], l[t])), T({}, t, i)
                                        },
                                        secondary: function(t) {
                                            var i = "right" === t ? "left" : "top",
                                                n = c[i];
                                            return c[t] > l[t] && !e.escapeWithReference && (n = Math.min(c[i], l[t] - ("right" === t ? c.width : c.height))), T({}, i, n)
                                        }
                                    };
                                return h.forEach(function(t) {
                                    var e = -1 !== ["left", "top"].indexOf(t) ? "primary" : "secondary";
                                    c = E({}, c, d[e](t))
                                }), t.offsets.popper = c, t
                            },
                            priority: ["left", "right", "top", "bottom"],
                            padding: 5,
                            boundariesElement: "scrollParent"
                        },
                        keepTogether: {
                            order: 400,
                            enabled: !0,
                            fn: function(t) {
                                var e = t.offsets,
                                    i = e.popper,
                                    n = e.reference,
                                    s = t.placement.split("-")[0],
                                    o = Math.floor,
                                    r = -1 !== ["top", "bottom"].indexOf(s),
                                    a = r ? "right" : "bottom",
                                    l = r ? "left" : "top",
                                    h = r ? "width" : "height";
                                return i[a] < o(n[l]) && (t.offsets.popper[l] = o(n[l]) - i[h]), i[l] > o(n[a]) && (t.offsets.popper[l] = o(n[a])), t
                            }
                        },
                        arrow: {
                            order: 500,
                            enabled: !0,
                            fn: function(t, e) {
                                var i;
                                if (!V(t.instance.modifiers, "arrow", "keepTogether")) return t;
                                var n = e.element;
                                if ("string" == typeof n) {
                                    if (!(n = t.instance.popper.querySelector(n))) return t
                                } else if (!t.instance.popper.contains(n)) return console.warn("WARNING: `arrow.element` must be child of its popper element!"), t;
                                var s = t.placement.split("-")[0],
                                    o = t.offsets,
                                    r = o.popper,
                                    a = o.reference,
                                    h = -1 !== ["left", "right"].indexOf(s),
                                    c = h ? "height" : "width",
                                    d = h ? "Top" : "Left",
                                    u = d.toLowerCase(),
                                    p = h ? "left" : "top",
                                    f = h ? "bottom" : "right",
                                    m = A(n)[c];
                                a[f] - m < r[u] && (t.offsets.popper[u] -= r[u] - (a[f] - m)), a[u] + m > r[f] && (t.offsets.popper[u] += a[u] + m - r[f]), t.offsets.popper = C(t.offsets.popper);
                                var g = a[u] + a[c] / 2 - m / 2,
                                    v = l(t.instance.popper),
                                    y = parseFloat(v["margin" + d], 10),
                                    _ = parseFloat(v["border" + d + "Width"], 10),
                                    b = g - t.offsets.popper[u] - y - _;
                                return b = Math.max(Math.min(r[c] - m, b), 0), t.arrowElement = n, t.offsets.arrow = (T(i = {}, u, Math.round(b)), T(i, p, ""), i), t
                            },
                            element: "[x-arrow]"
                        },
                        flip: {
                            order: 600,
                            enabled: !0,
                            fn: function(t, e) {
                                if (z(t.instance.modifiers, "inner")) return t;
                                if (t.flipped && t.placement === t.originalPlacement) return t;
                                var i = M(t.instance.popper, t.instance.reference, e.padding, e.boundariesElement, t.positionFixed),
                                    n = t.placement.split("-")[0],
                                    s = P(n),
                                    o = t.placement.split("-")[1] || "",
                                    r = [];
                                switch (e.behavior) {
                                    case Y.FLIP:
                                        r = [n, s];
                                        break;
                                    case Y.CLOCKWISE:
                                        r = U(n);
                                        break;
                                    case Y.COUNTERCLOCKWISE:
                                        r = U(n, !0);
                                        break;
                                    default:
                                        r = e.behavior
                                }
                                return r.forEach(function(a, l) {
                                    if (n !== a || r.length === l + 1) return t;
                                    n = t.placement.split("-")[0], s = P(n);
                                    var h = t.offsets.popper,
                                        c = t.offsets.reference,
                                        d = Math.floor,
                                        u = "left" === n && d(h.right) > d(c.left) || "right" === n && d(h.left) < d(c.right) || "top" === n && d(h.bottom) > d(c.top) || "bottom" === n && d(h.top) < d(c.bottom),
                                        p = d(h.left) < d(i.left),
                                        f = d(h.right) > d(i.right),
                                        m = d(h.top) < d(i.top),
                                        g = d(h.bottom) > d(i.bottom),
                                        v = "left" === n && p || "right" === n && f || "top" === n && m || "bottom" === n && g,
                                        y = -1 !== ["top", "bottom"].indexOf(n),
                                        _ = !!e.flipVariations && (y && "start" === o && p || y && "end" === o && f || !y && "start" === o && m || !y && "end" === o && g);
                                    (u || v || _) && (t.flipped = !0, (u || v) && (n = r[l + 1]), _ && (o = function(t) {
                                        return "end" === t ? "start" : "start" === t ? "end" : t
                                    }(o)), t.placement = n + (o ? "-" + o : ""), t.offsets.popper = E({}, t.offsets.popper, $(t.instance.popper, t.offsets.reference, t.placement)), t = N(t.instance.modifiers, t, "flip"))
                                }), t
                            },
                            behavior: "flip",
                            padding: 5,
                            boundariesElement: "viewport"
                        },
                        inner: {
                            order: 700,
                            enabled: !1,
                            fn: function(t) {
                                var e = t.placement,
                                    i = e.split("-")[0],
                                    n = t.offsets,
                                    s = n.popper,
                                    o = n.reference,
                                    r = -1 !== ["left", "right"].indexOf(i),
                                    a = -1 === ["top", "left"].indexOf(i);
                                return s[r ? "left" : "top"] = o[i] - (a ? s[r ? "width" : "height"] : 0), t.placement = P(e), t.offsets.popper = C(s), t
                            }
                        },
                        hide: {
                            order: 800,
                            enabled: !0,
                            fn: function(t) {
                                if (!V(t.instance.modifiers, "hide", "preventOverflow")) return t;
                                var e = t.offsets.reference,
                                    i = L(t.instance.modifiers, function(t) {
                                        return "preventOverflow" === t.name
                                    }).boundaries;
                                if (e.bottom < i.top || e.left > i.right || e.top > i.bottom || e.right < i.left) {
                                    if (!0 === t.hide) return t;
                                    t.hide = !0, t.attributes["x-out-of-boundaries"] = ""
                                } else {
                                    if (!1 === t.hide) return t;
                                    t.hide = !1, t.attributes["x-out-of-boundaries"] = !1
                                }
                                return t
                            }
                        },
                        computeStyle: {
                            order: 850,
                            enabled: !0,
                            fn: function(t, e) {
                                var i = e.x,
                                    n = e.y,
                                    s = t.offsets.popper,
                                    o = L(t.instance.modifiers, function(t) {
                                        return "applyStyle" === t.name
                                    }).gpuAcceleration;
                                void 0 !== o && console.warn("WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!");
                                var r = void 0 !== o ? o : e.gpuAcceleration,
                                    a = f(t.instance.popper),
                                    l = S(a),
                                    h = {
                                        position: s.position
                                    },
                                    c = {
                                        left: Math.floor(s.left),
                                        top: Math.round(s.top),
                                        bottom: Math.round(s.bottom),
                                        right: Math.floor(s.right)
                                    },
                                    d = "bottom" === i ? "top" : "bottom",
                                    u = "right" === n ? "left" : "right",
                                    p = F("transform"),
                                    m = void 0,
                                    g = void 0;
                                if (g = "bottom" === d ? "HTML" === a.nodeName ? -a.clientHeight + c.bottom : -l.height + c.bottom : c.top, m = "right" === u ? "HTML" === a.nodeName ? -a.clientWidth + c.right : -l.width + c.right : c.left, r && p) h[p] = "translate3d(" + m + "px, " + g + "px, 0)", h[d] = 0, h[u] = 0, h.willChange = "transform";
                                else {
                                    var v = "bottom" === d ? -1 : 1,
                                        y = "right" === u ? -1 : 1;
                                    h[d] = g * v, h[u] = m * y, h.willChange = d + ", " + u
                                }
                                var _ = {
                                    "x-placement": t.placement
                                };
                                return t.attributes = E({}, _, t.attributes), t.styles = E({}, h, t.styles), t.arrowStyles = E({}, t.offsets.arrow, t.arrowStyles), t
                            },
                            gpuAcceleration: !0,
                            x: "bottom",
                            y: "right"
                        },
                        applyStyle: {
                            order: 900,
                            enabled: !0,
                            fn: function(t) {
                                return B(t.instance.popper, t.styles),
                                    function(t, e) {
                                        Object.keys(e).forEach(function(i) {
                                            !1 !== e[i] ? t.setAttribute(i, e[i]) : t.removeAttribute(i)
                                        })
                                    }(t.instance.popper, t.attributes), t.arrowElement && Object.keys(t.arrowStyles).length && B(t.arrowElement, t.arrowStyles), t
                            },
                            onLoad: function(t, e, i, n, s) {
                                var o = k(s, e, t, i.positionFixed),
                                    r = O(i.placement, o, e, t, i.modifiers.flip.boundariesElement, i.modifiers.flip.padding);
                                return e.setAttribute("x-placement", r), B(e, {
                                    position: i.positionFixed ? "fixed" : "absolute"
                                }), i
                            },
                            gpuAcceleration: void 0
                        }
                    }
                },
                Q = function() {
                    function t(e, i) {
                        var n = this,
                            s = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                        w(this, t), this.scheduleUpdate = function() {
                            return requestAnimationFrame(n.update)
                        }, this.update = r(this.update.bind(this)), this.options = E({}, t.Defaults, s), this.state = {
                            isDestroyed: !1,
                            isCreated: !1,
                            scrollParents: []
                        }, this.reference = e && e.jquery ? e[0] : e, this.popper = i && i.jquery ? i[0] : i, this.options.modifiers = {}, Object.keys(E({}, t.Defaults.modifiers, s.modifiers)).forEach(function(e) {
                            n.options.modifiers[e] = E({}, t.Defaults.modifiers[e] || {}, s.modifiers ? s.modifiers[e] : {})
                        }), this.modifiers = Object.keys(this.options.modifiers).map(function(t) {
                            return E({
                                name: t
                            }, n.options.modifiers[t])
                        }).sort(function(t, e) {
                            return t.order - e.order
                        }), this.modifiers.forEach(function(t) {
                            t.enabled && a(t.onLoad) && t.onLoad(n.reference, n.popper, n.options, t, n.state)
                        }), this.update();
                        var o = this.options.eventsEnabled;
                        o && this.enableEventListeners(), this.state.eventsEnabled = o
                    }
                    return x(t, [{
                        key: "update",
                        value: function() {
                            return function() {
                                if (!this.state.isDestroyed) {
                                    var t = {
                                        instance: this,
                                        styles: {},
                                        arrowStyles: {},
                                        attributes: {},
                                        flipped: !1,
                                        offsets: {}
                                    };
                                    t.offsets.reference = k(this.state, this.popper, this.reference, this.options.positionFixed), t.placement = O(this.options.placement, t.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding), t.originalPlacement = t.placement, t.positionFixed = this.options.positionFixed, t.offsets.popper = $(this.popper, t.offsets.reference, t.placement), t.offsets.popper.position = this.options.positionFixed ? "fixed" : "absolute", t = N(this.modifiers, t), this.state.isCreated ? this.options.onUpdate(t) : (this.state.isCreated = !0, this.options.onCreate(t))
                                }
                            }.call(this)
                        }
                    }, {
                        key: "destroy",
                        value: function() {
                            return function() {
                                return this.state.isDestroyed = !0, z(this.modifiers, "applyStyle") && (this.popper.removeAttribute("x-placement"), this.popper.style.position = "", this.popper.style.top = "", this.popper.style.left = "", this.popper.style.right = "", this.popper.style.bottom = "", this.popper.style.willChange = "", this.popper.style[F("transform")] = ""), this.disableEventListeners(), this.options.removeOnDestroy && this.popper.parentNode.removeChild(this.popper), this
                            }.call(this)
                        }
                    }, {
                        key: "enableEventListeners",
                        value: function() {
                            return function() {
                                this.state.eventsEnabled || (this.state = R(this.reference, this.options, this.state, this.scheduleUpdate))
                            }.call(this)
                        }
                    }, {
                        key: "disableEventListeners",
                        value: function() {
                            return j.call(this)
                        }
                    }]), t
                }();
            Q.Utils = ("undefined" != typeof window ? window : t).PopperUtils, Q.placements = q, Q.Defaults = K, e.default = Q
        }.call(this, i(77))
  }, function(t, e) {
    var i;
    i = function() {
        return this
    }();
    try {
        i = i || Function("return this")() || (0, eval)("this")
    } catch (t) {
        "object" == typeof window && (i = window)
    }
    t.exports = i
  }, function(t, e, i) {
    (function(t, e) {
        ! function(t, i, n, s) {
            function o(e, i) {
                this.settings = null, this.options = t.extend({}, o.Defaults, i), this.$element = t(e), this._handlers = {}, this._plugins = {}, this._supress = {}, this._current = null, this._speed = null, this._coordinates = [], this._breakpoint = null, this._width = null, this._items = [], this._clones = [], this._mergers = [], this._widths = [], this._invalidated = {}, this._pipe = [], this._drag = {
                    time: null,
                    target: null,
                    pointer: null,
                    stage: {
                        start: null,
                        current: null
                    },
                    direction: null
                }, this._states = {
                    current: {},
                    tags: {
                        initializing: ["busy"],
                        animating: ["busy"],
                        dragging: ["interacting"]
                    }
                }, t.each(["onResize", "onThrottledResize"], t.proxy(function(e, i) {
                    this._handlers[i] = t.proxy(this[i], this)
                }, this)), t.each(o.Plugins, t.proxy(function(t, e) {
                    this._plugins[t.charAt(0).toLowerCase() + t.slice(1)] = new e(this)
                }, this)), t.each(o.Workers, t.proxy(function(e, i) {
                    this._pipe.push({
                        filter: i.filter,
                        run: t.proxy(i.run, this)
                    })
                }, this)), this.setup(), this.initialize()
            }
            o.Defaults = {
                items: 3,
                loop: !1,
                center: !1,
                rewind: !1,
                checkVisibility: !0,
                mouseDrag: !0,
                touchDrag: !0,
                pullDrag: !0,
                freeDrag: !1,
                margin: 0,
                stagePadding: 0,
                merge: !1,
                mergeFit: !0,
                autoWidth: !1,
                startPosition: 0,
                rtl: !1,
                smartSpeed: 250,
                fluidSpeed: !1,
                dragEndSpeed: !1,
                responsive: {},
                responsiveRefreshRate: 200,
                responsiveBaseElement: i,
                fallbackEasing: "swing",
                slideTransition: "",
                info: !1,
                nestedItemSelector: !1,
                itemElement: "div",
                stageElement: "div",
                refreshClass: "owl-refresh",
                loadedClass: "owl-loaded",
                loadingClass: "owl-loading",
                rtlClass: "owl-rtl",
                responsiveClass: "owl-responsive",
                dragClass: "owl-drag",
                itemClass: "owl-item",
                stageClass: "owl-stage",
                stageOuterClass: "owl-stage-outer",
                grabClass: "owl-grab"
            }, o.Width = {
                Default: "default",
                Inner: "inner",
                Outer: "outer"
            }, o.Type = {
                Event: "event",
                State: "state"
            }, o.Plugins = {}, o.Workers = [{
                filter: ["width", "settings"],
                run: function() {
                    this._width = this.$element.width()
                }
            }, {
                filter: ["width", "items", "settings"],
                run: function(t) {
                    t.current = this._items && this._items[this.relative(this._current)]
                }
            }, {
                filter: ["items", "settings"],
                run: function() {
                    this.$stage.children(".cloned").remove()
                }
            }, {
                filter: ["width", "items", "settings"],
                run: function(t) {
                    var e = this.settings.margin || "",
                        i = !this.settings.autoWidth,
                        n = this.settings.rtl,
                        s = {
                            width: "auto",
                            "margin-left": n ? e : "",
                            "margin-right": n ? "" : e
                        };
                    !i && this.$stage.children().css(s), t.css = s
                }
            }, {
                filter: ["width", "items", "settings"],
                run: function(t) {
                    var e = (this.width() / this.settings.items).toFixed(3) - this.settings.margin,
                        i = null,
                        n = this._items.length,
                        s = !this.settings.autoWidth,
                        o = [];
                    for (t.items = {
                            merge: !1,
                            width: e
                        }; n--;) i = this._mergers[n], i = this.settings.mergeFit && Math.min(i, this.settings.items) || i, t.items.merge = i > 1 || t.items.merge, o[n] = s ? e * i : this._items[n].width();
                    this._widths = o
                }
            }, {
                filter: ["items", "settings"],
                run: function() {
                    var e = [],
                        i = this._items,
                        n = this.settings,
                        s = Math.max(2 * n.items, 4),
                        o = 2 * Math.ceil(i.length / 2),
                        r = n.loop && i.length ? n.rewind ? s : Math.max(s, o) : 0,
                        a = "",
                        l = "";
                    for (r /= 2; r > 0;) e.push(this.normalize(e.length / 2, !0)), a += i[e[e.length - 1]][0].outerHTML, e.push(this.normalize(i.length - 1 - (e.length - 1) / 2, !0)), l = i[e[e.length - 1]][0].outerHTML + l, r -= 1;
                    this._clones = e, t(a).addClass("cloned").appendTo(this.$stage), t(l).addClass("cloned").prependTo(this.$stage)
                }
            }, {
                filter: ["width", "items", "settings"],
                run: function() {
                    for (var t = this.settings.rtl ? 1 : -1, e = this._clones.length + this._items.length, i = -1, n = 0, s = 0, o = []; ++i < e;) n = o[i - 1] || 0, s = this._widths[this.relative(i)] + this.settings.margin, o.push(n + s * t);
                    this._coordinates = o
                }
            }, {
                filter: ["width", "items", "settings"],
                run: function() {
                    var t = this.settings.stagePadding,
                        e = this._coordinates,
                        i = {
                            width: Math.ceil(Math.abs(e[e.length - 1])) + 2 * t,
                            "padding-left": t || "",
                            "padding-right": t || ""
                        };
                    this.$stage.css(i)
                }
            }, {
                filter: ["width", "items", "settings"],
                run: function(t) {
                    var e = this._coordinates.length,
                        i = !this.settings.autoWidth,
                        n = this.$stage.children();
                    if (i && t.items.merge)
                        for (; e--;) t.css.width = this._widths[this.relative(e)], n.eq(e).css(t.css);
                    else i && (t.css.width = t.items.width, n.css(t.css))
                }
            }, {
                filter: ["items"],
                run: function() {
                    this._coordinates.length < 1 && this.$stage.removeAttr("style")
                }
            }, {
                filter: ["width", "items", "settings"],
                run: function(t) {
                    t.current = t.current ? this.$stage.children().index(t.current) : 0, t.current = Math.max(this.minimum(), Math.min(this.maximum(), t.current)), this.reset(t.current)
                }
            }, {
                filter: ["position"],
                run: function() {
                    this.animate(this.coordinates(this._current))
                }
            }, {
                filter: ["width", "position", "items", "settings"],
                run: function() {
                    var t, e, i, n, s = this.settings.rtl ? 1 : -1,
                        o = 2 * this.settings.stagePadding,
                        r = this.coordinates(this.current()) + o,
                        a = r + this.width() * s,
                        l = [];
                    for (i = 0, n = this._coordinates.length; i < n; i++) t = this._coordinates[i - 1] || 0, e = Math.abs(this._coordinates[i]) + o * s, (this.op(t, "<=", r) && this.op(t, ">", a) || this.op(e, "<", r) && this.op(e, ">", a)) && l.push(i);
                    this.$stage.children(".active").removeClass("active"), this.$stage.children(":eq(" + l.join("), :eq(") + ")").addClass("active"), this.$stage.children(".center").removeClass("center"), this.settings.center && this.$stage.children().eq(this.current()).addClass("center")
                }
            }], o.prototype.initializeStage = function() {
                this.$stage = this.$element.find("." + this.settings.stageClass), this.$stage.length || (this.$element.addClass(this.options.loadingClass), this.$stage = t("<" + this.settings.stageElement + ">", {
                    class: this.settings.stageClass
                }).wrap(t("<div/>", {
                    class: this.settings.stageOuterClass
                })), this.$element.append(this.$stage.parent()))
            }, o.prototype.initializeItems = function() {
                var e = this.$element.find(".owl-item");
                if (e.length) return this._items = e.get().map(function(e) {
                    return t(e)
                }), this._mergers = this._items.map(function() {
                    return 1
                }), void this.refresh();
                this.replace(this.$element.children().not(this.$stage.parent())), this.isVisible() ? this.refresh() : this.invalidate("width"), this.$element.removeClass(this.options.loadingClass).addClass(this.options.loadedClass)
            }, o.prototype.initialize = function() {
                var t, e, i;
                (this.enter("initializing"), this.trigger("initialize"), this.$element.toggleClass(this.settings.rtlClass, this.settings.rtl), this.settings.autoWidth && !this.is("pre-loading")) && (t = this.$element.find("img"), e = this.settings.nestedItemSelector ? "." + this.settings.nestedItemSelector : void 0, i = this.$element.children(e).width(), t.length && i <= 0 && this.preloadAutoWidthImages(t));
                this.initializeStage(), this.initializeItems(), this.registerEventHandlers(), this.leave("initializing"), this.trigger("initialized")
            }, o.prototype.isVisible = function() {
                return !this.settings.checkVisibility || this.$element.is(":visible")
            }, o.prototype.setup = function() {
                var e = this.viewport(),
                    i = this.options.responsive,
                    n = -1,
                    s = null;
                i ? (t.each(i, function(t) {
                    t <= e && t > n && (n = Number(t))
                }), "function" == typeof(s = t.extend({}, this.options, i[n])).stagePadding && (s.stagePadding = s.stagePadding()), delete s.responsive, s.responsiveClass && this.$element.attr("class", this.$element.attr("class").replace(new RegExp("(" + this.options.responsiveClass + "-)\\S+\\s", "g"), "$1" + n))) : s = t.extend({}, this.options), this.trigger("change", {
                    property: {
                        name: "settings",
                        value: s
                    }
                }), this._breakpoint = n, this.settings = s, this.invalidate("settings"), this.trigger("changed", {
                    property: {
                        name: "settings",
                        value: this.settings
                    }
                })
            }, o.prototype.optionsLogic = function() {
                this.settings.autoWidth && (this.settings.stagePadding = !1, this.settings.merge = !1)
            }, o.prototype.prepare = function(e) {
                var i = this.trigger("prepare", {
                    content: e
                });
                return i.data || (i.data = t("<" + this.settings.itemElement + "/>").addClass(this.options.itemClass).append(e)), this.trigger("prepared", {
                    content: i.data
                }), i.data
            }, o.prototype.update = function() {
                for (var e = 0, i = this._pipe.length, n = t.proxy(function(t) {
                        return this[t]
                    }, this._invalidated), s = {}; e < i;)(this._invalidated.all || t.grep(this._pipe[e].filter, n).length > 0) && this._pipe[e].run(s), e++;
                this._invalidated = {}, !this.is("valid") && this.enter("valid")
            }, o.prototype.width = function(t) {
                switch (t = t || o.Width.Default) {
                    case o.Width.Inner:
                    case o.Width.Outer:
                        return this._width;
                    default:
                        return this._width - 2 * this.settings.stagePadding + this.settings.margin
                }
            }, o.prototype.refresh = function() {
                this.enter("refreshing"), this.trigger("refresh"), this.setup(), this.optionsLogic(), this.$element.addClass(this.options.refreshClass), this.update(), this.$element.removeClass(this.options.refreshClass), this.leave("refreshing"), this.trigger("refreshed")
            }, o.prototype.onThrottledResize = function() {
                i.clearTimeout(this.resizeTimer), this.resizeTimer = i.setTimeout(this._handlers.onResize, this.settings.responsiveRefreshRate)
            }, o.prototype.onResize = function() {
                return !!this._items.length && (this._width !== this.$element.width() && (!!this.isVisible() && (this.enter("resizing"), this.trigger("resize").isDefaultPrevented() ? (this.leave("resizing"), !1) : (this.invalidate("width"), this.refresh(), this.leave("resizing"), void this.trigger("resized")))))
            }, o.prototype.registerEventHandlers = function() {
                t.support.transition && this.$stage.on(t.support.transition.end + ".owl.core", t.proxy(this.onTransitionEnd, this)), !1 !== this.settings.responsive && this.on(i, "resize", this._handlers.onThrottledResize), this.settings.mouseDrag && (this.$element.addClass(this.options.dragClass), this.$stage.on("mousedown.owl.core", t.proxy(this.onDragStart, this)), this.$stage.on("dragstart.owl.core selectstart.owl.core", function() {
                    return !1
                })), this.settings.touchDrag && (this.$stage.on("touchstart.owl.core", t.proxy(this.onDragStart, this)), this.$stage.on("touchcancel.owl.core", t.proxy(this.onDragEnd, this)))
            }, o.prototype.onDragStart = function(e) {
                var i = null;
                3 !== e.which && (t.support.transform ? i = {
                    x: (i = this.$stage.css("transform").replace(/.*\(|\)| /g, "").split(","))[16 === i.length ? 12 : 4],
                    y: i[16 === i.length ? 13 : 5]
                } : (i = this.$stage.position(), i = {
                    x: this.settings.rtl ? i.left + this.$stage.width() - this.width() + this.settings.margin : i.left,
                    y: i.top
                }), this.is("animating") && (t.support.transform ? this.animate(i.x) : this.$stage.stop(), this.invalidate("position")), this.$element.toggleClass(this.options.grabClass, "mousedown" === e.type), this.speed(0), this._drag.time = (new Date).getTime(), this._drag.target = t(e.target), this._drag.stage.start = i, this._drag.stage.current = i, this._drag.pointer = this.pointer(e), t(n).on("mouseup.owl.core touchend.owl.core", t.proxy(this.onDragEnd, this)), t(n).one("mousemove.owl.core touchmove.owl.core", t.proxy(function(e) {
                    var i = this.difference(this._drag.pointer, this.pointer(e));
                    t(n).on("mousemove.owl.core touchmove.owl.core", t.proxy(this.onDragMove, this)), Math.abs(i.x) < Math.abs(i.y) && this.is("valid") || (e.preventDefault(), this.enter("dragging"), this.trigger("drag"))
                }, this)))
            }, o.prototype.onDragMove = function(t) {
                var e = null,
                    i = null,
                    n = null,
                    s = this.difference(this._drag.pointer, this.pointer(t)),
                    o = this.difference(this._drag.stage.start, s);
                this.is("dragging") && (t.preventDefault(), this.settings.loop ? (e = this.coordinates(this.minimum()), i = this.coordinates(this.maximum() + 1) - e, o.x = ((o.x - e) % i + i) % i + e) : (e = this.settings.rtl ? this.coordinates(this.maximum()) : this.coordinates(this.minimum()), i = this.settings.rtl ? this.coordinates(this.minimum()) : this.coordinates(this.maximum()), n = this.settings.pullDrag ? -1 * s.x / 5 : 0, o.x = Math.max(Math.min(o.x, e + n), i + n)), this._drag.stage.current = o, this.animate(o.x))
            }, o.prototype.onDragEnd = function(e) {
                var i = this.difference(this._drag.pointer, this.pointer(e)),
                    s = this._drag.stage.current,
                    o = i.x > 0 ^ this.settings.rtl ? "left" : "right";
                t(n).off(".owl.core"), this.$element.removeClass(this.options.grabClass), (0 !== i.x && this.is("dragging") || !this.is("valid")) && (this.speed(this.settings.dragEndSpeed || this.settings.smartSpeed), this.current(this.closest(s.x, 0 !== i.x ? o : this._drag.direction)), this.invalidate("position"), this.update(), this._drag.direction = o, (Math.abs(i.x) > 3 || (new Date).getTime() - this._drag.time > 300) && this._drag.target.one("click.owl.core", function() {
                    return !1
                })), this.is("dragging") && (this.leave("dragging"), this.trigger("dragged"))
            }, o.prototype.closest = function(e, i) {
                var n = -1,
                    s = this.width(),
                    o = this.coordinates();
                return this.settings.freeDrag || t.each(o, t.proxy(function(t, r) {
                    return "left" === i && e > r - 30 && e < r + 30 ? n = t : "right" === i && e > r - s - 30 && e < r - s + 30 ? n = t + 1 : this.op(e, "<", r) && this.op(e, ">", void 0 !== o[t + 1] ? o[t + 1] : r - s) && (n = "left" === i ? t + 1 : t), -1 === n
                }, this)), this.settings.loop || (this.op(e, ">", o[this.minimum()]) ? n = e = this.minimum() : this.op(e, "<", o[this.maximum()]) && (n = e = this.maximum())), n
            }, o.prototype.animate = function(e) {
                var i = this.speed() > 0;
                this.is("animating") && this.onTransitionEnd(), i && (this.enter("animating"), this.trigger("translate")), t.support.transform3d && t.support.transition ? this.$stage.css({
                    transform: "translate3d(" + e + "px,0px,0px)",
                    transition: this.speed() / 1e3 + "s" + (this.settings.slideTransition ? " " + this.settings.slideTransition : "")
                }) : i ? this.$stage.animate({
                    left: e + "px"
                }, this.speed(), this.settings.fallbackEasing, t.proxy(this.onTransitionEnd, this)) : this.$stage.css({
                    left: e + "px"
                })
            }, o.prototype.is = function(t) {
                return this._states.current[t] && this._states.current[t] > 0
            }, o.prototype.current = function(t) {
                if (void 0 === t) return this._current;
                if (0 !== this._items.length) {
                    if (t = this.normalize(t), this._current !== t) {
                        var e = this.trigger("change", {
                            property: {
                                name: "position",
                                value: t
                            }
                        });
                        void 0 !== e.data && (t = this.normalize(e.data)), this._current = t, this.invalidate("position"), this.trigger("changed", {
                            property: {
                                name: "position",
                                value: this._current
                            }
                        })
                    }
                    return this._current
                }
            }, o.prototype.invalidate = function(e) {
                return "string" === t.type(e) && (this._invalidated[e] = !0, this.is("valid") && this.leave("valid")), t.map(this._invalidated, function(t, e) {
                    return e
                })
            }, o.prototype.reset = function(t) {
                void 0 !== (t = this.normalize(t)) && (this._speed = 0, this._current = t, this.suppress(["translate", "translated"]), this.animate(this.coordinates(t)), this.release(["translate", "translated"]))
            }, o.prototype.normalize = function(t, e) {
                var i = this._items.length,
                    n = e ? 0 : this._clones.length;
                return !this.isNumeric(t) || i < 1 ? t = void 0 : (t < 0 || t >= i + n) && (t = ((t - n / 2) % i + i) % i + n / 2), t
            }, o.prototype.relative = function(t) {
                return t -= this._clones.length / 2, this.normalize(t, !0)
            }, o.prototype.maximum = function(t) {
                var e, i, n, s = this.settings,
                    o = this._coordinates.length;
                if (s.loop) o = this._clones.length / 2 + this._items.length - 1;
                else if (s.autoWidth || s.merge) {
                    if (e = this._items.length)
                        for (i = this._items[--e].width(), n = this.$element.width(); e-- && !((i += this._items[e].width() + this.settings.margin) > n););
                    o = e + 1
                } else o = s.center ? this._items.length - 1 : this._items.length - s.items;
                return t && (o -= this._clones.length / 2), Math.max(o, 0)
            }, o.prototype.minimum = function(t) {
                return t ? 0 : this._clones.length / 2
            }, o.prototype.items = function(t) {
                return void 0 === t ? this._items.slice() : (t = this.normalize(t, !0), this._items[t])
            }, o.prototype.mergers = function(t) {
                return void 0 === t ? this._mergers.slice() : (t = this.normalize(t, !0), this._mergers[t])
            }, o.prototype.clones = function(e) {
                var i = this._clones.length / 2,
                    n = i + this._items.length,
                    s = function(t) {
                        return t % 2 == 0 ? n + t / 2 : i - (t + 1) / 2
                    };
                return void 0 === e ? t.map(this._clones, function(t, e) {
                    return s(e)
                }) : t.map(this._clones, function(t, i) {
                    return t === e ? s(i) : null
                })
            }, o.prototype.speed = function(t) {
                return void 0 !== t && (this._speed = t), this._speed
            }, o.prototype.coordinates = function(e) {
                var i, n = 1,
                    s = e - 1;
                return void 0 === e ? t.map(this._coordinates, t.proxy(function(t, e) {
                    return this.coordinates(e)
                }, this)) : (this.settings.center ? (this.settings.rtl && (n = -1, s = e + 1), i = this._coordinates[e], i += (this.width() - i + (this._coordinates[s] || 0)) / 2 * n) : i = this._coordinates[s] || 0, i = Math.ceil(i))
            }, o.prototype.duration = function(t, e, i) {
                return 0 === i ? 0 : Math.min(Math.max(Math.abs(e - t), 1), 6) * Math.abs(i || this.settings.smartSpeed)
            }, o.prototype.to = function(t, e) {
                var i = this.current(),
                    n = null,
                    s = t - this.relative(i),
                    o = (s > 0) - (s < 0),
                    r = this._items.length,
                    a = this.minimum(),
                    l = this.maximum();
                this.settings.loop ? (!this.settings.rewind && Math.abs(s) > r / 2 && (s += -1 * o * r), (n = (((t = i + s) - a) % r + r) % r + a) !== t && n - s <= l && n - s > 0 && (i = n - s, t = n, this.reset(i))) : t = this.settings.rewind ? (t % (l += 1) + l) % l : Math.max(a, Math.min(l, t)), this.speed(this.duration(i, t, e)), this.current(t), this.isVisible() && this.update()
            }, o.prototype.next = function(t) {
                t = t || !1, this.to(this.relative(this.current()) + 1, t)
            }, o.prototype.prev = function(t) {
                t = t || !1, this.to(this.relative(this.current()) - 1, t)
            }, o.prototype.onTransitionEnd = function(t) {
                if (void 0 !== t && (t.stopPropagation(), (t.target || t.srcElement || t.originalTarget) !== this.$stage.get(0))) return !1;
                this.leave("animating"), this.trigger("translated")
            }, o.prototype.viewport = function() {
                var e;
                return this.options.responsiveBaseElement !== i ? e = t(this.options.responsiveBaseElement).width() : i.innerWidth ? e = i.innerWidth : n.documentElement && n.documentElement.clientWidth ? e = n.documentElement.clientWidth : console.warn("Can not detect viewport width."), e
            }, o.prototype.replace = function(i) {
                this.$stage.empty(), this._items = [], i && (i = i instanceof e ? i : t(i)), this.settings.nestedItemSelector && (i = i.find("." + this.settings.nestedItemSelector)), i.filter(function() {
                    return 1 === this.nodeType
                }).each(t.proxy(function(t, e) {
                    e = this.prepare(e), this.$stage.append(e), this._items.push(e), this._mergers.push(1 * e.find("[data-merge]").addBack("[data-merge]").attr("data-merge") || 1)
                }, this)), this.reset(this.isNumeric(this.settings.startPosition) ? this.settings.startPosition : 0), this.invalidate("items")
            }, o.prototype.add = function(i, n) {
                var s = this.relative(this._current);
                n = void 0 === n ? this._items.length : this.normalize(n, !0), i = i instanceof e ? i : t(i), this.trigger("add", {
                    content: i,
                    position: n
                }), i = this.prepare(i), 0 === this._items.length || n === this._items.length ? (0 === this._items.length && this.$stage.append(i), 0 !== this._items.length && this._items[n - 1].after(i), this._items.push(i), this._mergers.push(1 * i.find("[data-merge]").addBack("[data-merge]").attr("data-merge") || 1)) : (this._items[n].before(i), this._items.splice(n, 0, i), this._mergers.splice(n, 0, 1 * i.find("[data-merge]").addBack("[data-merge]").attr("data-merge") || 1)), this._items[s] && this.reset(this._items[s].index()), this.invalidate("items"), this.trigger("added", {
                    content: i,
                    position: n
                })
            }, o.prototype.remove = function(t) {
                void 0 !== (t = this.normalize(t, !0)) && (this.trigger("remove", {
                    content: this._items[t],
                    position: t
                }), this._items[t].remove(), this._items.splice(t, 1), this._mergers.splice(t, 1), this.invalidate("items"), this.trigger("removed", {
                    content: null,
                    position: t
                }))
            }, o.prototype.preloadAutoWidthImages = function(e) {
                e.each(t.proxy(function(e, i) {
                    this.enter("pre-loading"), i = t(i), t(new Image).one("load", t.proxy(function(t) {
                        i.attr("src", t.target.src), i.css("opacity", 1), this.leave("pre-loading"), !this.is("pre-loading") && !this.is("initializing") && this.refresh()
                    }, this)).attr("src", i.attr("src") || i.attr("data-src") || i.attr("data-src-retina"))
                }, this))
            }, o.prototype.destroy = function() {
                for (var e in this.$element.off(".owl.core"), this.$stage.off(".owl.core"), t(n).off(".owl.core"), !1 !== this.settings.responsive && (i.clearTimeout(this.resizeTimer), this.off(i, "resize", this._handlers.onThrottledResize)), this._plugins) this._plugins[e].destroy();
                this.$stage.children(".cloned").remove(), this.$stage.unwrap(), this.$stage.children().contents().unwrap(), this.$stage.children().unwrap(), this.$stage.remove(), this.$element.removeClass(this.options.refreshClass).removeClass(this.options.loadingClass).removeClass(this.options.loadedClass).removeClass(this.options.rtlClass).removeClass(this.options.dragClass).removeClass(this.options.grabClass).attr("class", this.$element.attr("class").replace(new RegExp(this.options.responsiveClass + "-\\S+\\s", "g"), "")).removeData("owl.carousel")
            }, o.prototype.op = function(t, e, i) {
                var n = this.settings.rtl;
                switch (e) {
                    case "<":
                        return n ? t > i : t < i;
                    case ">":
                        return n ? t < i : t > i;
                    case ">=":
                        return n ? t <= i : t >= i;
                    case "<=":
                        return n ? t >= i : t <= i
                }
            }, o.prototype.on = function(t, e, i, n) {
                t.addEventListener ? t.addEventListener(e, i, n) : t.attachEvent && t.attachEvent("on" + e, i)
            }, o.prototype.off = function(t, e, i, n) {
                t.removeEventListener ? t.removeEventListener(e, i, n) : t.detachEvent && t.detachEvent("on" + e, i)
            }, o.prototype.trigger = function(e, i, n, s, r) {
                var a = {
                        item: {
                            count: this._items.length,
                            index: this.current()
                        }
                    },
                    l = t.camelCase(t.grep(["on", e, n], function(t) {
                        return t
                    }).join("-").toLowerCase()),
                    h = t.Event([e, "owl", n || "carousel"].join(".").toLowerCase(), t.extend({
                        relatedTarget: this
                    }, a, i));
                return this._supress[e] || (t.each(this._plugins, function(t, e) {
                    e.onTrigger && e.onTrigger(h)
                }), this.register({
                    type: o.Type.Event,
                    name: e
                }), this.$element.trigger(h), this.settings && "function" == typeof this.settings[l] && this.settings[l].call(this, h)), h
            }, o.prototype.enter = function(e) {
                t.each([e].concat(this._states.tags[e] || []), t.proxy(function(t, e) {
                    void 0 === this._states.current[e] && (this._states.current[e] = 0), this._states.current[e]++
                }, this))
            }, o.prototype.leave = function(e) {
                t.each([e].concat(this._states.tags[e] || []), t.proxy(function(t, e) {
                    this._states.current[e]--
                }, this))
            }, o.prototype.register = function(e) {
                if (e.type === o.Type.Event) {
                    if (t.event.special[e.name] || (t.event.special[e.name] = {}), !t.event.special[e.name].owl) {
                        var i = t.event.special[e.name]._default;
                        t.event.special[e.name]._default = function(t) {
                            return !i || !i.apply || t.namespace && -1 !== t.namespace.indexOf("owl") ? t.namespace && t.namespace.indexOf("owl") > -1 : i.apply(this, arguments)
                        }, t.event.special[e.name].owl = !0
                    }
                } else e.type === o.Type.State && (this._states.tags[e.name] ? this._states.tags[e.name] = this._states.tags[e.name].concat(e.tags) : this._states.tags[e.name] = e.tags, this._states.tags[e.name] = t.grep(this._states.tags[e.name], t.proxy(function(i, n) {
                    return t.inArray(i, this._states.tags[e.name]) === n
                }, this)))
            }, o.prototype.suppress = function(e) {
                t.each(e, t.proxy(function(t, e) {
                    this._supress[e] = !0
                }, this))
            }, o.prototype.release = function(e) {
                t.each(e, t.proxy(function(t, e) {
                    delete this._supress[e]
                }, this))
            }, o.prototype.pointer = function(t) {
                var e = {
                    x: null,
                    y: null
                };
                return (t = (t = t.originalEvent || t || i.event).touches && t.touches.length ? t.touches[0] : t.changedTouches && t.changedTouches.length ? t.changedTouches[0] : t).pageX ? (e.x = t.pageX, e.y = t.pageY) : (e.x = t.clientX, e.y = t.clientY), e
            }, o.prototype.isNumeric = function(t) {
                return !isNaN(parseFloat(t))
            }, o.prototype.difference = function(t, e) {
                return {
                    x: t.x - e.x,
                    y: t.y - e.y
                }
            }, t.fn.owlCarousel = function(e) {
                var i = Array.prototype.slice.call(arguments, 1);
                return this.each(function() {
                    var n = t(this),
                        s = n.data("owl.carousel");
                    s || (s = new o(this, "object" == typeof e && e), n.data("owl.carousel", s), t.each(["next", "prev", "to", "destroy", "refresh", "replace", "add", "remove"], function(e, i) {
                        s.register({
                            type: o.Type.Event,
                            name: i
                        }), s.$element.on(i + ".owl.carousel.core", t.proxy(function(t) {
                            t.namespace && t.relatedTarget !== this && (this.suppress([i]), s[i].apply(this, [].slice.call(arguments, 1)), this.release([i]))
                        }, s))
                    })), "string" == typeof e && "_" !== e.charAt(0) && s[e].apply(s, i)
                })
            }, t.fn.owlCarousel.Constructor = o
        }(window.Zepto || t, window, document),
        function(t, e, i, n) {
            var s = function(e) {
                this._core = e, this._interval = null, this._visible = null, this._handlers = {
                    "initialized.owl.carousel": t.proxy(function(t) {
                        t.namespace && this._core.settings.autoRefresh && this.watch()
                    }, this)
                }, this._core.options = t.extend({}, s.Defaults, this._core.options), this._core.$element.on(this._handlers)
            };
            s.Defaults = {
                autoRefresh: !0,
                autoRefreshInterval: 500
            }, s.prototype.watch = function() {
                this._interval || (this._visible = this._core.isVisible(), this._interval = e.setInterval(t.proxy(this.refresh, this), this._core.settings.autoRefreshInterval))
            }, s.prototype.refresh = function() {
                this._core.isVisible() !== this._visible && (this._visible = !this._visible, this._core.$element.toggleClass("owl-hidden", !this._visible), this._visible && this._core.invalidate("width") && this._core.refresh())
            }, s.prototype.destroy = function() {
                var t, i;
                for (t in e.clearInterval(this._interval), this._handlers) this._core.$element.off(t, this._handlers[t]);
                for (i in Object.getOwnPropertyNames(this)) "function" != typeof this[i] && (this[i] = null)
            }, t.fn.owlCarousel.Constructor.Plugins.AutoRefresh = s
        }(window.Zepto || t, window, document),
        function(t, e, i, n) {
            var s = function(e) {
                this._core = e, this._loaded = [], this._handlers = {
                    "initialized.owl.carousel change.owl.carousel resized.owl.carousel": t.proxy(function(e) {
                        if (e.namespace && this._core.settings && this._core.settings.lazyLoad && (e.property && "position" == e.property.name || "initialized" == e.type)) {
                            var i = this._core.settings,
                                n = i.center && Math.ceil(i.items / 2) || i.items,
                                s = i.center && -1 * n || 0,
                                o = (e.property && void 0 !== e.property.value ? e.property.value : this._core.current()) + s,
                                r = this._core.clones().length,
                                a = t.proxy(function(t, e) {
                                    this.load(e)
                                }, this);
                            for (i.lazyLoadEager > 0 && (n += i.lazyLoadEager, i.loop && (o -= i.lazyLoadEager, n++)); s++ < n;) this.load(r / 2 + this._core.relative(o)), r && t.each(this._core.clones(this._core.relative(o)), a), o++
                        }
                    }, this)
                }, this._core.options = t.extend({}, s.Defaults, this._core.options), this._core.$element.on(this._handlers)
            };
            s.Defaults = {
                lazyLoad: !1,
                lazyLoadEager: 0
            }, s.prototype.load = function(i) {
                var n = this._core.$stage.children().eq(i),
                    s = n && n.find(".owl-lazy");
                !s || t.inArray(n.get(0), this._loaded) > -1 || (s.each(t.proxy(function(i, n) {
                    var s, o = t(n),
                        r = e.devicePixelRatio > 1 && o.attr("data-src-retina") || o.attr("data-src") || o.attr("data-srcset");
                    this._core.trigger("load", {
                        element: o,
                        url: r
                    }, "lazy"), o.is("img") ? o.one("load.owl.lazy", t.proxy(function() {
                        o.css("opacity", 1), this._core.trigger("loaded", {
                            element: o,
                            url: r
                        }, "lazy")
                    }, this)).attr("src", r) : o.is("source") ? o.one("load.owl.lazy", t.proxy(function() {
                        this._core.trigger("loaded", {
                            element: o,
                            url: r
                        }, "lazy")
                    }, this)).attr("srcset", r) : ((s = new Image).onload = t.proxy(function() {
                        o.css({
                            "background-image": 'url("' + r + '")',
                            opacity: "1"
                        }), this._core.trigger("loaded", {
                            element: o,
                            url: r
                        }, "lazy")
                    }, this), s.src = r)
                }, this)), this._loaded.push(n.get(0)))
            }, s.prototype.destroy = function() {
                var t, e;
                for (t in this.handlers) this._core.$element.off(t, this.handlers[t]);
                for (e in Object.getOwnPropertyNames(this)) "function" != typeof this[e] && (this[e] = null)
            }, t.fn.owlCarousel.Constructor.Plugins.Lazy = s
        }(window.Zepto || t, window, document),
        function(t, e, i, n) {
            var s = function(i) {
                this._core = i, this._previousHeight = null, this._handlers = {
                    "initialized.owl.carousel refreshed.owl.carousel": t.proxy(function(t) {
                        t.namespace && this._core.settings.autoHeight && this.update()
                    }, this),
                    "changed.owl.carousel": t.proxy(function(t) {
                        t.namespace && this._core.settings.autoHeight && "position" === t.property.name && this.update()
                    }, this),
                    "loaded.owl.lazy": t.proxy(function(t) {
                        t.namespace && this._core.settings.autoHeight && t.element.closest("." + this._core.settings.itemClass).index() === this._core.current() && this.update()
                    }, this)
                }, this._core.options = t.extend({}, s.Defaults, this._core.options), this._core.$element.on(this._handlers), this._intervalId = null;
                var n = this;
                t(e).on("load", function() {
                    n._core.settings.autoHeight && n.update()
                }), t(e).resize(function() {
                    n._core.settings.autoHeight && (null != n._intervalId && clearTimeout(n._intervalId), n._intervalId = setTimeout(function() {
                        n.update()
                    }, 250))
                })
            };
            s.Defaults = {
                autoHeight: !1,
                autoHeightClass: "owl-height"
            }, s.prototype.update = function() {
                var e = this._core._current,
                    i = e + this._core.settings.items,
                    n = this._core.settings.lazyLoad,
                    s = this._core.$stage.children().toArray().slice(e, i),
                    o = [],
                    r = 0;
                t.each(s, function(e, i) {
                    o.push(t(i).height())
                }), (r = Math.max.apply(null, o)) <= 1 && n && this._previousHeight && (r = this._previousHeight), this._previousHeight = r, this._core.$stage.parent().height(r).addClass(this._core.settings.autoHeightClass)
            }, s.prototype.destroy = function() {
                var t, e;
                for (t in this._handlers) this._core.$element.off(t, this._handlers[t]);
                for (e in Object.getOwnPropertyNames(this)) "function" != typeof this[e] && (this[e] = null)
            }, t.fn.owlCarousel.Constructor.Plugins.AutoHeight = s
        }(window.Zepto || t, window, document),
        function(t, e, i, n) {
            var s = function(e) {
                this._core = e, this._videos = {}, this._playing = null, this._handlers = {
                    "initialized.owl.carousel": t.proxy(function(t) {
                        t.namespace && this._core.register({
                            type: "state",
                            name: "playing",
                            tags: ["interacting"]
                        })
                    }, this),
                    "resize.owl.carousel": t.proxy(function(t) {
                        t.namespace && this._core.settings.video && this.isInFullScreen() && t.preventDefault()
                    }, this),
                    "refreshed.owl.carousel": t.proxy(function(t) {
                        t.namespace && this._core.is("resizing") && this._core.$stage.find(".cloned .owl-video-frame").remove()
                    }, this),
                    "changed.owl.carousel": t.proxy(function(t) {
                        t.namespace && "position" === t.property.name && this._playing && this.stop()
                    }, this),
                    "prepared.owl.carousel": t.proxy(function(e) {
                        if (e.namespace) {
                            var i = t(e.content).find(".owl-video");
                            i.length && (i.css("display", "none"), this.fetch(i, t(e.content)))
                        }
                    }, this)
                }, this._core.options = t.extend({}, s.Defaults, this._core.options), this._core.$element.on(this._handlers), this._core.$element.on("click.owl.video", ".owl-video-play-icon", t.proxy(function(t) {
                    this.play(t)
                }, this))
            };
            s.Defaults = {
                video: !1,
                videoHeight: !1,
                videoWidth: !1
            }, s.prototype.fetch = function(t, e) {
                var i = t.attr("data-vimeo-id") ? "vimeo" : t.attr("data-vzaar-id") ? "vzaar" : "youtube",
                    n = t.attr("data-vimeo-id") || t.attr("data-youtube-id") || t.attr("data-vzaar-id"),
                    s = t.attr("data-width") || this._core.settings.videoWidth,
                    o = t.attr("data-height") || this._core.settings.videoHeight,
                    r = t.attr("href");
                if (!r) throw new Error("Missing video URL.");
                if ((n = r.match(/(http:|https:|)\/\/(player.|www.|app.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com|be\-nocookie\.com)|vzaar\.com)\/(video\/|videos\/|embed\/|channels\/.+\/|groups\/.+\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/))[3].indexOf("youtu") > -1) i = "youtube";
                else if (n[3].indexOf("vimeo") > -1) i = "vimeo";
                else {
                    if (!(n[3].indexOf("vzaar") > -1)) throw new Error("Video URL not supported.");
                    i = "vzaar"
                }
                n = n[6], this._videos[r] = {
                    type: i,
                    id: n,
                    width: s,
                    height: o
                }, e.attr("data-video", r), this.thumbnail(t, this._videos[r])
            }, s.prototype.thumbnail = function(e, i) {
                var n, s, o, r = i.width && i.height ? "width:" + i.width + "px;height:" + i.height + "px;" : "",
                    a = e.find("img"),
                    l = "src",
                    h = "",
                    c = this._core.settings,
                    d = function(i) {
                        s = '<div class="owl-video-play-icon"></div>', n = c.lazyLoad ? t("<div/>", {
                            class: "owl-video-tn " + h,
                            srcType: i
                        }) : t("<div/>", {
                            class: "owl-video-tn",
                            style: "opacity:1;background-image:url(" + i + ")"
                        }), e.after(n), e.after(s)
                    };
                if (e.wrap(t("<div/>", {
                        class: "owl-video-wrapper",
                        style: r
                    })), this._core.settings.lazyLoad && (l = "data-src", h = "owl-lazy"), a.length) return d(a.attr(l)), a.remove(), !1;
                "youtube" === i.type ? (o = "//img.youtube.com/vi/" + i.id + "/hqdefault.jpg", d(o)) : "vimeo" === i.type ? t.ajax({
                    type: "GET",
                    url: "//vimeo.com/api/v2/video/" + i.id + ".json",
                    jsonp: "callback",
                    dataType: "jsonp",
                    success: function(t) {
                        o = t[0].thumbnail_large, d(o)
                    }
                }) : "vzaar" === i.type && t.ajax({
                    type: "GET",
                    url: "//vzaar.com/api/videos/" + i.id + ".json",
                    jsonp: "callback",
                    dataType: "jsonp",
                    success: function(t) {
                        o = t.framegrab_url, d(o)
                    }
                })
            }, s.prototype.stop = function() {
                this._core.trigger("stop", null, "video"), this._playing.find(".owl-video-frame").remove(), this._playing.removeClass("owl-video-playing"), this._playing = null, this._core.leave("playing"), this._core.trigger("stopped", null, "video")
            }, s.prototype.play = function(e) {
                var i, n = t(e.target).closest("." + this._core.settings.itemClass),
                    s = this._videos[n.attr("data-video")],
                    o = s.width || "100%",
                    r = s.height || this._core.$stage.height();
                this._playing || (this._core.enter("playing"), this._core.trigger("play", null, "video"), n = this._core.items(this._core.relative(n.index())), this._core.reset(n.index()), (i = t('<iframe frameborder="0" allowfullscreen mozallowfullscreen webkitAllowFullScreen ></iframe>')).attr("height", r), i.attr("width", o), "youtube" === s.type ? i.attr("src", "//www.youtube.com/embed/" + s.id + "?autoplay=1&rel=0&v=" + s.id) : "vimeo" === s.type ? i.attr("src", "//player.vimeo.com/video/" + s.id + "?autoplay=1") : "vzaar" === s.type && i.attr("src", "//view.vzaar.com/" + s.id + "/player?autoplay=true"), t(i).wrap('<div class="owl-video-frame" />').insertAfter(n.find(".owl-video")), this._playing = n.addClass("owl-video-playing"))
            }, s.prototype.isInFullScreen = function() {
                var e = i.fullscreenElement || i.mozFullScreenElement || i.webkitFullscreenElement;
                return e && t(e).parent().hasClass("owl-video-frame")
            }, s.prototype.destroy = function() {
                var t, e;
                for (t in this._core.$element.off("click.owl.video"), this._handlers) this._core.$element.off(t, this._handlers[t]);
                for (e in Object.getOwnPropertyNames(this)) "function" != typeof this[e] && (this[e] = null)
            }, t.fn.owlCarousel.Constructor.Plugins.Video = s
        }(window.Zepto || t, window, document),
        function(t, e, i, n) {
            var s = function(e) {
                this.core = e, this.core.options = t.extend({}, s.Defaults, this.core.options), this.swapping = !0, this.previous = void 0, this.next = void 0, this.handlers = {
                    "change.owl.carousel": t.proxy(function(t) {
                        t.namespace && "position" == t.property.name && (this.previous = this.core.current(), this.next = t.property.value)
                    }, this),
                    "drag.owl.carousel dragged.owl.carousel translated.owl.carousel": t.proxy(function(t) {
                        t.namespace && (this.swapping = "translated" == t.type)
                    }, this),
                    "translate.owl.carousel": t.proxy(function(t) {
                        t.namespace && this.swapping && (this.core.options.animateOut || this.core.options.animateIn) && this.swap()
                    }, this)
                }, this.core.$element.on(this.handlers)
            };
            s.Defaults = {
                animateOut: !1,
                animateIn: !1
            }, s.prototype.swap = function() {
                if (1 === this.core.settings.items && t.support.animation && t.support.transition) {
                    this.core.speed(0);
                    var e, i = t.proxy(this.clear, this),
                        n = this.core.$stage.children().eq(this.previous),
                        s = this.core.$stage.children().eq(this.next),
                        o = this.core.settings.animateIn,
                        r = this.core.settings.animateOut;
                    this.core.current() !== this.previous && (r && (e = this.core.coordinates(this.previous) - this.core.coordinates(this.next), n.one(t.support.animation.end, i).css({
                        left: e + "px"
                    }).addClass("animated owl-animated-out").addClass(r)), o && s.one(t.support.animation.end, i).addClass("animated owl-animated-in").addClass(o))
                }
            }, s.prototype.clear = function(e) {
                t(e.target).css({
                    left: ""
                }).removeClass("animated owl-animated-out owl-animated-in").removeClass(this.core.settings.animateIn).removeClass(this.core.settings.animateOut), this.core.onTransitionEnd()
            }, s.prototype.destroy = function() {
                var t, e;
                for (t in this.handlers) this.core.$element.off(t, this.handlers[t]);
                for (e in Object.getOwnPropertyNames(this)) "function" != typeof this[e] && (this[e] = null)
            }, t.fn.owlCarousel.Constructor.Plugins.Animate = s
        }(window.Zepto || t, window, document),
        function(t, e, i, n) {
            var s = function(e) {
                this._core = e, this._call = null, this._time = 0, this._timeout = 0, this._paused = !0, this._handlers = {
                    "changed.owl.carousel": t.proxy(function(t) {
                        t.namespace && "settings" === t.property.name ? this._core.settings.autoplay ? this.play() : this.stop() : t.namespace && "position" === t.property.name && this._paused && (this._time = 0)
                    }, this),
                    "initialized.owl.carousel": t.proxy(function(t) {
                        t.namespace && this._core.settings.autoplay && this.play()
                    }, this),
                    "play.owl.autoplay": t.proxy(function(t, e, i) {
                        t.namespace && this.play(e, i)
                    }, this),
                    "stop.owl.autoplay": t.proxy(function(t) {
                        t.namespace && this.stop()
                    }, this),
                    "mouseover.owl.autoplay": t.proxy(function() {
                        this._core.settings.autoplayHoverPause && this._core.is("rotating") && this.pause()
                    }, this),
                    "mouseleave.owl.autoplay": t.proxy(function() {
                        this._core.settings.autoplayHoverPause && this._core.is("rotating") && this.play()
                    }, this),
                    "touchstart.owl.core": t.proxy(function() {
                        this._core.settings.autoplayHoverPause && this._core.is("rotating") && this.pause()
                    }, this),
                    "touchend.owl.core": t.proxy(function() {
                        this._core.settings.autoplayHoverPause && this.play()
                    }, this)
                }, this._core.$element.on(this._handlers), this._core.options = t.extend({}, s.Defaults, this._core.options)
            };
            s.Defaults = {
                autoplay: !1,
                autoplayTimeout: 5e3,
                autoplayHoverPause: !1,
                autoplaySpeed: !1
            }, s.prototype._next = function(n) {
                this._call = e.setTimeout(t.proxy(this._next, this, n), this._timeout * (Math.round(this.read() / this._timeout) + 1) - this.read()), this._core.is("interacting") || i.hidden || this._core.next(n || this._core.settings.autoplaySpeed)
            }, s.prototype.read = function() {
                return (new Date).getTime() - this._time
            }, s.prototype.play = function(i, n) {
                var s;
                this._core.is("rotating") || this._core.enter("rotating"), i = i || this._core.settings.autoplayTimeout, s = Math.min(this._time % (this._timeout || i), i), this._paused ? (this._time = this.read(), this._paused = !1) : e.clearTimeout(this._call), this._time += this.read() % i - s, this._timeout = i, this._call = e.setTimeout(t.proxy(this._next, this, n), i - s)
            }, s.prototype.stop = function() {
                this._core.is("rotating") && (this._time = 0, this._paused = !0, e.clearTimeout(this._call), this._core.leave("rotating"))
            }, s.prototype.pause = function() {
                this._core.is("rotating") && !this._paused && (this._time = this.read(), this._paused = !0, e.clearTimeout(this._call))
            }, s.prototype.destroy = function() {
                var t, e;
                for (t in this.stop(), this._handlers) this._core.$element.off(t, this._handlers[t]);
                for (e in Object.getOwnPropertyNames(this)) "function" != typeof this[e] && (this[e] = null)
            }, t.fn.owlCarousel.Constructor.Plugins.autoplay = s
        }(window.Zepto || t, window, document),
        function(t, e, i, n) {
            "use strict";
            var s = function(e) {
                this._core = e, this._initialized = !1, this._pages = [], this._controls = {}, this._templates = [], this.$element = this._core.$element, this._overrides = {
                    next: this._core.next,
                    prev: this._core.prev,
                    to: this._core.to
                }, this._handlers = {
                    "prepared.owl.carousel": t.proxy(function(e) {
                        e.namespace && this._core.settings.dotsData && this._templates.push('<div class="' + this._core.settings.dotClass + '">' + t(e.content).find("[data-dot]").addBack("[data-dot]").attr("data-dot") + "</div>")
                    }, this),
                    "added.owl.carousel": t.proxy(function(t) {
                        t.namespace && this._core.settings.dotsData && this._templates.splice(t.position, 0, this._templates.pop())
                    }, this),
                    "remove.owl.carousel": t.proxy(function(t) {
                        t.namespace && this._core.settings.dotsData && this._templates.splice(t.position, 1)
                    }, this),
                    "changed.owl.carousel": t.proxy(function(t) {
                        t.namespace && "position" == t.property.name && this.draw()
                    }, this),
                    "initialized.owl.carousel": t.proxy(function(t) {
                        t.namespace && !this._initialized && (this._core.trigger("initialize", null, "navigation"), this.initialize(), this.update(), this.draw(), this._initialized = !0, this._core.trigger("initialized", null, "navigation"))
                    }, this),
                    "refreshed.owl.carousel": t.proxy(function(t) {
                        t.namespace && this._initialized && (this._core.trigger("refresh", null, "navigation"), this.update(), this.draw(), this._core.trigger("refreshed", null, "navigation"))
                    }, this)
                }, this._core.options = t.extend({}, s.Defaults, this._core.options), this.$element.on(this._handlers)
            };
            s.Defaults = {
                nav: !1,
                navText: ['<span aria-label="Previous">&#x2039;</span>', '<span aria-label="Next">&#x203a;</span>'],
                navSpeed: !1,
                navElement: 'button type="button" role="presentation"',
                navContainer: !1,
                navContainerClass: "owl-nav",
                navClass: ["owl-prev", "owl-next"],
                slideBy: 1,
                dotClass: "owl-dot",
                dotsClass: "owl-dots",
                dots: !0,
                dotsEach: !1,
                dotsData: !1,
                dotsSpeed: !1,
                dotsContainer: !1
            }, s.prototype.initialize = function() {
                var e, i = this._core.settings;
                for (e in this._controls.$relative = (i.navContainer ? t(i.navContainer) : t("<div>").addClass(i.navContainerClass).appendTo(this.$element)).addClass("disabled"), this._controls.$previous = t("<" + i.navElement + ">").addClass(i.navClass[0]).html(i.navText[0]).prependTo(this._controls.$relative).on("click", t.proxy(function(t) {
                        this.prev(i.navSpeed)
                    }, this)), this._controls.$next = t("<" + i.navElement + ">").addClass(i.navClass[1]).html(i.navText[1]).appendTo(this._controls.$relative).on("click", t.proxy(function(t) {
                        this.next(i.navSpeed)
                    }, this)), i.dotsData || (this._templates = [t('<button role="button">').addClass(i.dotClass).append(t("<span>")).prop("outerHTML")]), this._controls.$absolute = (i.dotsContainer ? t(i.dotsContainer) : t("<div>").addClass(i.dotsClass).appendTo(this.$element)).addClass("disabled"), this._controls.$absolute.on("click", "button", t.proxy(function(e) {
                        var n = t(e.target).parent().is(this._controls.$absolute) ? t(e.target).index() : t(e.target).parent().index();
                        e.preventDefault(), this.to(n, i.dotsSpeed)
                    }, this)), this._overrides) this._core[e] = t.proxy(this[e], this)
            }, s.prototype.destroy = function() {
                var t, e, i, n, s;
                for (t in s = this._core.settings, this._handlers) this.$element.off(t, this._handlers[t]);
                for (e in this._controls) "$relative" === e && s.navContainer ? this._controls[e].html("") : this._controls[e].remove();
                for (n in this.overides) this._core[n] = this._overrides[n];
                for (i in Object.getOwnPropertyNames(this)) "function" != typeof this[i] && (this[i] = null)
            }, s.prototype.update = function() {
                var t, e, i = this._core.clones().length / 2,
                    n = i + this._core.items().length,
                    s = this._core.maximum(!0),
                    o = this._core.settings,
                    r = o.center || o.autoWidth || o.dotsData ? 1 : o.dotsEach || o.items;
                if ("page" !== o.slideBy && (o.slideBy = Math.min(o.slideBy, o.items)), o.dots || "page" == o.slideBy)
                    for (this._pages = [], t = i, e = 0, 0; t < n; t++) {
                        if (e >= r || 0 === e) {
                            if (this._pages.push({
                                    start: Math.min(s, t - i),
                                    end: t - i + r - 1
                                }), Math.min(s, t - i) === s) break;
                            e = 0, 0
                        }
                        e += this._core.mergers(this._core.relative(t))
                    }
            }, s.prototype.draw = function() {
                var e, i = this._core.settings,
                    n = this._core.items().length <= i.items,
                    s = this._core.relative(this._core.current()),
                    o = i.loop || i.rewind;
                this._controls.$relative.toggleClass("disabled", !i.nav || n), i.nav && (this._controls.$previous.toggleClass("disabled", !o && s <= this._core.minimum(!0)), this._controls.$next.toggleClass("disabled", !o && s >= this._core.maximum(!0))), this._controls.$absolute.toggleClass("disabled", !i.dots || n), i.dots && (e = this._pages.length - this._controls.$absolute.children().length, i.dotsData && 0 !== e ? this._controls.$absolute.html(this._templates.join("")) : e > 0 ? this._controls.$absolute.append(new Array(e + 1).join(this._templates[0])) : e < 0 && this._controls.$absolute.children().slice(e).remove(), this._controls.$absolute.find(".active").removeClass("active"), this._controls.$absolute.children().eq(t.inArray(this.current(), this._pages)).addClass("active"))
            }, s.prototype.onTrigger = function(e) {
                var i = this._core.settings;
                e.page = {
                    index: t.inArray(this.current(), this._pages),
                    count: this._pages.length,
                    size: i && (i.center || i.autoWidth || i.dotsData ? 1 : i.dotsEach || i.items)
                }
            }, s.prototype.current = function() {
                var e = this._core.relative(this._core.current());
                return t.grep(this._pages, t.proxy(function(t, i) {
                    return t.start <= e && t.end >= e
                }, this)).pop()
            }, s.prototype.getPosition = function(e) {
                var i, n, s = this._core.settings;
                return "page" == s.slideBy ? (i = t.inArray(this.current(), this._pages), n = this._pages.length, e ? ++i : --i, i = this._pages[(i % n + n) % n].start) : (i = this._core.relative(this._core.current()), n = this._core.items().length, e ? i += s.slideBy : i -= s.slideBy), i
            }, s.prototype.next = function(e) {
                t.proxy(this._overrides.to, this._core)(this.getPosition(!0), e)
            }, s.prototype.prev = function(e) {
                t.proxy(this._overrides.to, this._core)(this.getPosition(!1), e)
            }, s.prototype.to = function(e, i, n) {
                var s;
                !n && this._pages.length ? (s = this._pages.length, t.proxy(this._overrides.to, this._core)(this._pages[(e % s + s) % s].start, i)) : t.proxy(this._overrides.to, this._core)(e, i)
            }, t.fn.owlCarousel.Constructor.Plugins.Navigation = s
        }(window.Zepto || t, window, document),
        function(t, e, i, n) {
            "use strict";
            var s = function(i) {
                this._core = i, this._hashes = {}, this.$element = this._core.$element, this._handlers = {
                    "initialized.owl.carousel": t.proxy(function(i) {
                        i.namespace && "URLHash" === this._core.settings.startPosition && t(e).trigger("hashchange.owl.navigation")
                    }, this),
                    "prepared.owl.carousel": t.proxy(function(e) {
                        if (e.namespace) {
                            var i = t(e.content).find("[data-hash]").addBack("[data-hash]").attr("data-hash");
                            if (!i) return;
                            this._hashes[i] = e.content
                        }
                    }, this),
                    "changed.owl.carousel": t.proxy(function(i) {
                        if (i.namespace && "position" === i.property.name) {
                            var n = this._core.items(this._core.relative(this._core.current())),
                                s = t.map(this._hashes, function(t, e) {
                                    return t === n ? e : null
                                }).join();
                            if (!s || e.location.hash.slice(1) === s) return;
                            e.location.hash = s
                        }
                    }, this)
                }, this._core.options = t.extend({}, s.Defaults, this._core.options), this.$element.on(this._handlers), t(e).on("hashchange.owl.navigation", t.proxy(function(t) {
                    var i = e.location.hash.substring(1),
                        n = this._core.$stage.children(),
                        s = this._hashes[i] && n.index(this._hashes[i]);
                    void 0 !== s && s !== this._core.current() && this._core.to(this._core.relative(s), !1, !0)
                }, this))
            };
            s.Defaults = {
                URLhashListener: !1
            }, s.prototype.destroy = function() {
                var i, n;
                for (i in t(e).off("hashchange.owl.navigation"), this._handlers) this._core.$element.off(i, this._handlers[i]);
                for (n in Object.getOwnPropertyNames(this)) "function" != typeof this[n] && (this[n] = null)
            }, t.fn.owlCarousel.Constructor.Plugins.Hash = s
        }(window.Zepto || t, window, document),
        function(t, e, i, n) {
            var s = t("<support>").get(0).style,
                o = "Webkit Moz O ms".split(" "),
                r = {
                    transition: {
                        end: {
                            WebkitTransition: "webkitTransitionEnd",
                            MozTransition: "transitionend",
                            OTransition: "oTransitionEnd",
                            transition: "transitionend"
                        }
                    },
                    animation: {
                        end: {
                            WebkitAnimation: "webkitAnimationEnd",
                            MozAnimation: "animationend",
                            OAnimation: "oAnimationEnd",
                            animation: "animationend"
                        }
                    }
                },
                a = function() {
                    return !!c("transform")
                },
                l = function() {
                    return !!c("perspective")
                },
                h = function() {
                    return !!c("animation")
                };
  
            function c(e, i) {
                var r = !1,
                    a = e.charAt(0).toUpperCase() + e.slice(1);
                return t.each((e + " " + o.join(a + " ") + a).split(" "), function(t, e) {
                    if (s[e] !== n) return r = !i || e, !1
                }), r
            }
  
            function d(t) {
                return c(t, !0)
            }(function() {
                return !!c("transition")
            })() && (t.support.transition = new String(d("transition")), t.support.transition.end = r.transition.end[t.support.transition]), h() && (t.support.animation = new String(d("animation")), t.support.animation.end = r.animation.end[t.support.animation]), a() && (t.support.transform = new String(d("transform")), t.support.transform3d = l())
        }(window.Zepto || t, window, document)
    }).call(this, i(3), i(3))
  }, function(t, e, i) {
    (function(t) {
        /*! fixto - v0.5.0 - 2016-06-16
         * http://github.com/bbarakaci/fixto/*/
        ! function(t, e, i) {
            function n() {
                this._vendor = null
            }
  
            function s() {
                var t = !1,
                    e = i.createElement("div"),
                    n = i.createElement("div");
                return e.appendChild(n), e.style[p] = "translate(0)", e.style.marginTop = "10px", e.style.visibility = "hidden", n.style.position = "fixed", n.style.top = 0, i.body.appendChild(e), n.getBoundingClientRect().top > 0 && (t = !0), i.body.removeChild(e), t
            }
  
            function o(e, i, n) {
                this.child = e, this._$child = t(e), this.parent = i, this.options = {
                    className: "fixto-fixed",
                    top: 0,
                    mindViewport: !1
                }, this._setOptions(n)
            }
  
            function r(t, e, i) {
                o.call(this, t, e, i), this._replacer = new h.MimicNode(t), this._ghostNode = this._replacer.replacer, this._saveStyles(), this._saveViewportHeight(), this._proxied_onscroll = this._bind(this._onscroll, this), this._proxied_onresize = this._bind(this._onresize, this), this.start()
            }
  
            function a(t, e, i) {
                o.call(this, t, e, i), this.start()
            }
            var l = function() {
                    var t = {
                        getAll: function(t) {
                            return i.defaultView.getComputedStyle(t)
                        },
                        get: function(t, e) {
                            return this.getAll(t)[e]
                        },
                        toFloat: function(t) {
                            return parseFloat(t, 10) || 0
                        },
                        getFloat: function(t, e) {
                            return this.toFloat(this.get(t, e))
                        },
                        _getAllCurrentStyle: function(t) {
                            return t.currentStyle
                        }
                    };
                    return i.documentElement.currentStyle && (t.getAll = t._getAllCurrentStyle), t
                }(),
                h = function() {
                    function e(t) {
                        this.element = t, this.replacer = i.createElement("div"), this.replacer.style.visibility = "hidden", this.hide(), t.parentNode.insertBefore(this.replacer, t)
                    }
                    return e.prototype = {
                        replace: function() {
                            var t = this.replacer.style,
                                e = l.getAll(this.element);
                            t.width = this._width(), t.height = this._height(), t.marginTop = e.marginTop, t.marginBottom = e.marginBottom, t.marginLeft = e.marginLeft, t.marginRight = e.marginRight, t.cssFloat = e.cssFloat, t.styleFloat = e.styleFloat, t.position = e.position, t.top = e.top, t.right = e.right, t.bottom = e.bottom, t.left = e.left, t.display = e.display
                        },
                        hide: function() {
                            this.replacer.style.display = "none"
                        },
                        _width: function() {
                            return this.element.getBoundingClientRect().width + "px"
                        },
                        _widthOffset: function() {
                            return this.element.offsetWidth + "px"
                        },
                        _height: function() {
                            return this.element.getBoundingClientRect().height + "px"
                        },
                        _heightOffset: function() {
                            return this.element.offsetHeight + "px"
                        },
                        destroy: function() {
                            for (var e in t(this.replacer).remove(), this) this.hasOwnProperty(e) && (this[e] = null)
                        }
                    }, i.documentElement.getBoundingClientRect().width || (e.prototype._width = e.prototype._widthOffset, e.prototype._height = e.prototype._heightOffset), {
                        MimicNode: e,
                        computedStyle: l
                    }
                }();
            n.prototype = {
                _vendors: {
                    webkit: {
                        cssPrefix: "-webkit-",
                        jsPrefix: "Webkit"
                    },
                    moz: {
                        cssPrefix: "-moz-",
                        jsPrefix: "Moz"
                    },
                    ms: {
                        cssPrefix: "-ms-",
                        jsPrefix: "ms"
                    },
                    opera: {
                        cssPrefix: "-o-",
                        jsPrefix: "O"
                    }
                },
                _prefixJsProperty: function(t, e) {
                    return t.jsPrefix + e[0].toUpperCase() + e.substr(1)
                },
                _prefixValue: function(t, e) {
                    return t.cssPrefix + e
                },
                _valueSupported: function(t, e, i) {
                    try {
                        return i.style[t] = e, i.style[t] === e
                    } catch (t) {
                        return !1
                    }
                },
                propertySupported: function(t) {
                    return void 0 !== i.documentElement.style[t]
                },
                getJsProperty: function(t) {
                    if (this.propertySupported(t)) return t;
                    if (this._vendor) return this._prefixJsProperty(this._vendor, t);
                    var e;
                    for (var i in this._vendors)
                        if (e = this._prefixJsProperty(this._vendors[i], t), this.propertySupported(e)) return this._vendor = this._vendors[i], e;
                    return null
                },
                getCssValue: function(t, e) {
                    var n, s = i.createElement("div"),
                        o = this.getJsProperty(t);
                    if (this._valueSupported(o, e, s)) return e;
                    if (this._vendor && (n = this._prefixValue(this._vendor, e), this._valueSupported(o, n, s))) return n;
                    for (var r in this._vendors)
                        if (n = this._prefixValue(this._vendors[r], e), this._valueSupported(o, n, s)) return this._vendor = this._vendors[r], n;
                    return null
                }
            };
            var c, d, u = new n,
                p = u.getJsProperty("transform"),
                f = u.getCssValue("position", "sticky"),
                m = u.getCssValue("position", "fixed");
            "Microsoft Internet Explorer" === navigator.appName && (d = parseFloat(navigator.appVersion.split("MSIE")[1])), o.prototype = {
                _mindtop: function() {
                    var t = 0;
                    if (this._$mind)
                        for (var e, i, n = 0, s = this._$mind.length; n < s; n++)
                            if ((i = (e = this._$mind[n]).getBoundingClientRect()).height) t += i.height;
                            else {
                                var o = l.getAll(e);
                                t += e.offsetHeight + l.toFloat(o.marginTop) + l.toFloat(o.marginBottom)
                            } return t
                },
                stop: function() {
                    this._stop(), this._running = !1
                },
                start: function() {
                    this._running || (this._start(), this._running = !0)
                },
                destroy: function() {
                    for (var t in this.stop(), this._destroy(), this._$child.removeData("fixto-instance"), this) this.hasOwnProperty(t) && (this[t] = null)
                },
                _setOptions: function(e) {
                    t.extend(this.options, e), this.options.mind && (this._$mind = t(this.options.mind)), this.options.zIndex && (this.child.style.zIndex = this.options.zIndex)
                },
                setOptions: function(t) {
                    this._setOptions(t), this.refresh()
                },
                _stop: function() {},
                _start: function() {},
                _destroy: function() {},
                refresh: function() {}
            }, r.prototype = new o, t.extend(r.prototype, {
                _bind: function(t, e) {
                    return function() {
                        return t.call(e)
                    }
                },
                _toresize: 8 === d ? i.documentElement : e,
                _onscroll: function() {
                    if (this._scrollTop = i.documentElement.scrollTop || i.body.scrollTop, this._parentBottom = this.parent.offsetHeight + this._fullOffset("offsetTop", this.parent), !1 !== this.options.mindBottomPadding && (this._parentBottom -= l.getFloat(this.parent, "paddingBottom")), !this.fixed && this._shouldFix()) this._fix(), this._adjust();
                    else {
                        if (this._scrollTop > this._parentBottom || this._scrollTop < this._fullOffset("offsetTop", this._ghostNode) - this.options.top - this._mindtop()) return void this._unfix();
                        this._adjust()
                    }
                },
                _shouldFix: function() {
                    if (this._scrollTop < this._parentBottom && this._scrollTop > this._fullOffset("offsetTop", this.child) - this.options.top - this._mindtop()) return !(this.options.mindViewport && !this._isViewportAvailable())
                },
                _isViewportAvailable: function() {
                    var t = l.getAll(this.child);
                    return this._viewportHeight > this.child.offsetHeight + l.toFloat(t.marginTop) + l.toFloat(t.marginBottom)
                },
                _adjust: function() {
                    var t = 0,
                        e = this._mindtop(),
                        i = 0,
                        n = l.getAll(this.child),
                        s = null;
                    c && ((s = this._getContext()) && (t = Math.abs(s.getBoundingClientRect().top))), (i = this._parentBottom - this._scrollTop - (this.child.offsetHeight + l.toFloat(n.marginBottom) + e + this.options.top)) > 0 && (i = 0), this.child.style.top = i + e + t + this.options.top - l.toFloat(n.marginTop) + "px"
                },
                _fullOffset: function(t, e, i) {
                    for (var n = e[t], s = e.offsetParent; null !== s && s !== i;) n += s[t], s = s.offsetParent;
                    return n
                },
                _getContext: function() {
                    for (var t, e = this.child, n = null; !n;) {
                        if ((t = e.parentNode) === i.documentElement) return null;
                        if ("none" !== l.getAll(t)[p]) {
                            n = t;
                            break
                        }
                        e = t
                    }
                    return n
                },
                _fix: function() {
                    var t = this.child,
                        e = t.style,
                        n = l.getAll(t),
                        s = t.getBoundingClientRect().left,
                        o = n.width;
                    if (this._saveStyles(), i.documentElement.currentStyle && (o = t.offsetWidth - (l.toFloat(n.paddingLeft) + l.toFloat(n.paddingRight) + l.toFloat(n.borderLeftWidth) + l.toFloat(n.borderRightWidth)) + "px"), c) {
                        var r = this._getContext();
                        r && (s = t.getBoundingClientRect().left - r.getBoundingClientRect().left)
                    }
                    this._replacer.replace(), e.left = s - l.toFloat(n.marginLeft) + "px", e.width = o, e.position = "fixed", e.top = this._mindtop() + this.options.top - l.toFloat(n.marginTop) + "px", this._$child.addClass(this.options.className), this.fixed = !0
                },
                _unfix: function() {
                    var t = this.child.style;
                    this._replacer.hide(), t.position = this._childOriginalPosition, t.top = this._childOriginalTop, t.width = this._childOriginalWidth, t.left = this._childOriginalLeft, this._$child.removeClass(this.options.className), this.fixed = !1
                },
                _saveStyles: function() {
                    var t = this.child.style;
                    this._childOriginalPosition = t.position, this._childOriginalTop = t.top, this._childOriginalWidth = t.width, this._childOriginalLeft = t.left
                },
                _onresize: function() {
                    this.refresh()
                },
                _saveViewportHeight: function() {
                    this._viewportHeight = e.innerHeight || i.documentElement.clientHeight
                },
                _stop: function() {
                    this._unfix(), t(e).unbind("scroll", this._proxied_onscroll), t(this._toresize).unbind("resize", this._proxied_onresize)
                },
                _start: function() {
                    this._onscroll(), t(e).bind("scroll", this._proxied_onscroll), t(this._toresize).bind("resize", this._proxied_onresize)
                },
                _destroy: function() {
                    this._replacer.destroy()
                },
                refresh: function() {
                    this._saveViewportHeight(), this._unfix(), this._onscroll()
                }
            }), a.prototype = new o, t.extend(a.prototype, {
                _start: function() {
                    var t = l.getAll(this.child);
                    this._childOriginalPosition = t.position, this._childOriginalTop = t.top, this.child.style.position = f, this.refresh()
                },
                _stop: function() {
                    this.child.style.position = this._childOriginalPosition, this.child.style.top = this._childOriginalTop
                },
                refresh: function() {
                    this.child.style.top = this._mindtop() + this.options.top + "px"
                }
            });
            var g = function(t, e, i) {
                return f && !i || f && i && !1 !== i.useNativeSticky ? new a(t, e, i) : m ? (void 0 === c && (c = s()), new r(t, e, i)) : "Neither fixed nor sticky positioning supported"
            };
            d < 8 && (g = function() {
                return "not supported"
            }), t.fn.fixTo = function(e, i) {
                var n = t(e),
                    s = 0;
                return this.each(function() {
                    var o = t(this).data("fixto-instance");
                    o ? o[e].call(o, i) : t(this).data("fixto-instance", g(this, n[s], i));
                    s++
                })
            }
        }(t, window, document)
    }).call(this, i(3))
  }, function(t, e, i) {
    "use strict";
    (function(t) {
        i(81), i(82), i(89), i(90), i(91), i(94), i(95), i(96), i(97), i(98), i(99), i(58), i(104), i(106), i(108), i(109), i(46), i(110), i(113), i(114), i(115), i(43);
  
        function e(t) {
            return (e = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
            })(t)
        }! function() {
            var t = window,
                e = 0;
            t.requestAnimationFrame = t.requestAnimationFrame || t.webkitRequestAnimationFrame, t.requestAnimationFrame || (t.requestAnimationFrame = function(t) {
                var i = (new Date).getTime(),
                    n = Math.max(0, 16 - (i - e)),
                    s = setTimeout(t, n);
                return e = i + n, s
            }), t.cancelAnimationFrame || (t.cancelAnimationFrame = function(t) {
                clearTimeout(t)
            })
        }(), window.ThemeoneUtils = function() {
                var t = {},
                    i = window.console;
                return t.error = function(t) {
                    void 0 !== i && i.error(t)
                }, t.extend = function(t, i) {
                    if (t)
                        if ("object" !== e(t)) this.error("Custom options must be an object");
                        else
                            for (var n in i) i.hasOwnProperty(n) && t.hasOwnProperty(n) && (i[n] = t[n]);
                    return i
                }, t.prop = function(t) {
                    for (var e = this.createEl(), i = ["", "Webkit", "Moz", "ms", "O"], n = 0, s = i.length; n < s; n++) {
                        var o = i[n] ? i[n] + t.charAt(0).toUpperCase() + t.slice(1) : t;
                        if (void 0 !== e.style[o]) return o
                    }
                    return ""
                }, t.cloneObject = function(t) {
                    var e = {};
                    for (var i in t) t.hasOwnProperty(i) && (e[i] = t[i]);
                    return e
                }, t.createEl = function(t, e) {
                    var i = document.createElement(t || "div");
                    return e && (i.className = e), i
                }, t.camelize = function(t) {
                    return t.replace(/-([a-z])/g, function(t) {
                        return t[1].toUpperCase()
                    })
                }, t.handleEvents = function(t, i, n, s, o) {
                    "object" !== e(this.event_handlers) && (this.event_handlers = {}), this.event_handlers[s] || (this.event_handlers[s] = t[s].bind(t));
                    var r = (o = void 0 === o || !!o) ? "addEventListener" : "removeEventListener";
                    n.forEach(function(t) {
                        i[r](t, this.event_handlers[s], !1)
                    }.bind(this))
                }, t.dispatchEvent = function(t, e, i, n, s) {
                    i += e ? "." + e : "";
                    var o = n ? [n].concat(s) : [s];
                    t.emitEvent(i, o)
                }, t.throttle = function(t, e) {
                    var i = null,
                        n = e;
                    return function() {
                        var e = arguments,
                            s = Date.now();
                        (!i || s - i >= n) && (i = s, t.apply(this, e))
                    }
                }, t.modulo = function(t, e) {
                    return (t + e % t) % t
                }, t.classReg = function(t) {
                    return new RegExp("(^|\\s+)" + t + "(\\s+|$)")
                }, t.hasClass = function(t, e) {
                    return !!t.className.match(this.classReg(e))
                }, t.addClass = function(t, e) {
                    this.hasClass(t, e) || (t.className += (t.className ? " " : "") + e)
                }, t.removeClass = function(t, e) {
                    this.hasClass(t, e) && (t.className = t.className.replace(this.classReg(e), " ").replace(/\s+$/, ""))
                }, t.translate = function(t, e, i, n) {
                    var s = n ? " scale(" + n + "," + n + ")" : "";
                    t.style[this.browser.trans] = this.browser.gpu ? "translate3d(" + (e || 0) + "px, " + (i || 0) + "px, 0)" + s : "translate(" + (e || 0) + "px, " + (i || 0) + "px)" + s
                }, t.browser = {
                    trans: t.prop("transform"),
                    gpu: !!t.prop("perspective")
                }, t
            }(), window.ThemeoneEvent = function() {
                var t = function() {},
                    e = t.prototype;
                return e.on = function(t, e) {
                    if (!t || !e) return null;
                    var i = this._events = this._events || {},
                        n = i[t] = i[t] || [];
                    return -1 === n.indexOf(e) && n.push(e), this
                }, e.off = function(t, e) {
                    var i = this._events && this._events[t];
                    if (!i || !i.length) return null;
                    var n = i.indexOf(e);
                    return -1 !== n && i.splice(n, 1), this
                }, e.emitEvent = function(t, e) {
                    var i = this._events && this._events[t];
                    if (!i || !i.length) return null;
                    var n = 0,
                        s = i[n];
                    e = e || [];
                    for (var o = this._onceEvents && this._onceEvents[t]; s;) {
                        var r = o && o[s];
                        r && (this.off(t, s), delete o[s]), s.apply(this, e), s = i[n += r ? 0 : 1]
                    }
                    return this
                }, t
            }(),
            function(t, e) {
                t.ThemeoneAnimate = function(t, e) {
                    var i = function(t, e, i, n) {
                            this.element = t, this.defaults = e, this.forces = {
                                friction: i || .28,
                                attraction: n || .028
                            }, this.resetAnimate()
                        },
                        n = i.prototype = Object.create(e.prototype);
                    return n.updateDrag = function(t) {
                        this.move = !0, this.drag = t
                    }, n.releaseDrag = function() {
                        this.move = !1
                    }, n.animateTo = function(t) {
                        this.attraction = t
                    }, n.startAnimate = function() {
                        this.move = !0, this.settle = !1, this.restingFrames = 0, this.RAF || this.animate()
                    }, n.stopAnimate = function() {
                        this.move = !1, this.restingFrames = 0, this.RAF && (cancelAnimationFrame(this.RAF), this.RAF = !1), this.start = t.cloneObject(this.position), this.velocity = {
                            x: 0,
                            y: 0,
                            s: 0
                        }
                    }, n.resetAnimate = function() {
                        this.stopAnimate(), this.settle = !0, this.drag = t.cloneObject(this.defaults), this.start = t.cloneObject(this.defaults), this.resting = t.cloneObject(this.defaults), this.position = t.cloneObject(this.defaults), this.attraction = t.cloneObject(this.defaults)
                    }, n.animate = function() {
                        var e = function() {
                            if (void 0 !== this.position) {
                                var i = t.cloneObject(this.position);
                                this.applyDragForce(), this.applyAttractionForce(), t.dispatchEvent(this, "toanimate", "render", this), this.integratePhysics(), this.getRestingPosition(), this.render(100), this.RAF = requestAnimationFrame(e), this.checkSettle(i)
                            }
                        }.bind(this);
                        this.RAF = requestAnimationFrame(e)
                    }, n.integratePhysics = function() {
                        for (var t in this.position) void 0 !== this.position[t] && (this.position[t] += this.velocity[t], this.position[t] = "s" === t ? Math.max(.1, this.position[t]) : this.position[t], this.velocity[t] *= this.getFrictionFactor())
                    }, n.applyDragForce = function() {
                        if (this.move)
                            for (var t in this.drag)
                                if (void 0 !== this.drag[t]) {
                                    var e = this.drag[t] - this.position[t] - this.velocity[t];
                                    this.applyForce(t, e)
                                }
                    }, n.applyAttractionForce = function() {
                        if (!this.move)
                            for (var t in this.attraction)
                                if (void 0 !== this.attraction[t]) {
                                    var e = (this.attraction[t] - this.position[t]) * this.forces.attraction;
                                    this.applyForce(t, e)
                                }
                    }, n.getRestingPosition = function() {
                        for (var t in this.position) void 0 !== this.position[t] && (this.resting[t] = this.position[t] + this.velocity[t] / (1 - this.getFrictionFactor()))
                    }, n.applyForce = function(t, e) {
                        this.velocity[t] += e
                    }, n.getFrictionFactor = function() {
                        return 1 - this.forces.friction
                    }, n.roundValues = function(t, e) {
                        for (var i in t) void 0 !== t[i] && (e = "s" === i ? 100 * e : e, t[i] = Math.round(t[i] * e) / e)
                    }, n.checkSettle = function(e) {
                        if (!this.move) {
                            var i = 0;
                            for (var n in this.position)
                                if (void 0 !== this.position[n]) {
                                    var s = "s" === n ? 1e4 : 100;
                                    Math.round(this.position[n] * s) === Math.round(e[n] * s) && ++i === Object.keys(this.position).length && this.restingFrames++
                                }
                        }
                        this.restingFrames > 2 && (this.stopAnimate(), this.render(this.position.s > 1 ? 10 : 1), this.settle = !0, JSON.stringify(this.start) !== JSON.stringify(this.position) && t.dispatchEvent(this, "toanimate", "settle", this))
                    }, n.render = function(e) {
                        this.roundValues(this.position, e), t.translate(this.element, this.position.x, this.position.y, this.position.s)
                    }, i
                }(t.ThemeoneUtils, t.ThemeoneEvent)
            }(window),
            function(i, n) {
                i.ModuloBox = function(i, n, s) {
                    var o = 0,
                        r = {},
                        a = "mobx" + ("1.5.0" + Math.random()).replace(/\D/g, ""),
                        l = {
                            uid: 0
                        },
                        h = {
                            mediaSelector: ".mobx",
                            threshold: 5,
                            attraction: {
                                slider: .055,
                                slide: .018,
                                thumbs: .016
                            },
                            friction: {
                                slider: .62,
                                slide: .18,
                                thumbs: .22
                            },
                            rightToLeft: !1,
                            loop: 3,
                            preload: 1,
                            unload: !1,
                            timeToIdle: 4e3,
                            history: !1,
                            mouseWheel: !0,
                            contextMenu: !0,
                            scrollBar: !0,
                            fadeIfSettle: !1,
                            controls: ["close"],
                            prevNext: !0,
                            prevNextTouch: !1,
                            counterMessage: "[index] / [total]",
                            caption: !0,
                            autoCaption: !1,
                            captionSmallDevice: !0,
                            thumbnails: !0,
                            thumbnailsNav: "basic",
                            thumbnailSizes: {
                                1920: {
                                    width: 110,
                                    height: 80,
                                    gutter: 10
                                },
                                1280: {
                                    width: 90,
                                    height: 65,
                                    gutter: 10
                                },
                                680: {
                                    width: 70,
                                    height: 50,
                                    gutter: 8
                                },
                                480: {
                                    width: 60,
                                    height: 44,
                                    gutter: 5
                                }
                            },
                            spacing: .1,
                            smartResize: !0,
                            overflow: !1,
                            loadError: "Sorry, an error occured while loading the content...",
                            noContent: "Sorry, no content was found!",
                            prevNextKey: !0,
                            scrollToNav: !1,
                            scrollSensitivity: 15,
                            zoomTo: "auto",
                            minZoom: 1.2,
                            maxZoom: 4,
                            doubleTapToZoom: !0,
                            scrollToZoom: !1,
                            pinchToZoom: !0,
                            escapeToClose: !0,
                            scrollToClose: !1,
                            pinchToClose: !0,
                            dragToClose: !0,
                            tapToClose: !0,
                            shareButtons: ["facebook", "googleplus", "twitter", "pinterest", "linkedin", "reddit"],
                            shareText: "Share on",
                            sharedUrl: "deeplink",
                            slideShowInterval: 4e3,
                            slideShowAutoPlay: !1,
                            slideShowAutoStop: !1,
                            countTimer: !0,
                            countTimerBg: "rgba(255,255,255,0.25)",
                            countTimerColor: "rgba(255,255,255,0.75)",
                            mediaelement: !1,
                            videoRatio: 16 / 9,
                            videoMaxWidth: 1180,
                            videoAutoPlay: !1,
                            videoThumbnail: !1
                        },
                        c = function(t) {
                            var e = document.querySelector(".mobx-holder");
                            if (e && e.GUID) return r[e.GUID];
                            this.options = i.extend(t, h), this.setVar()
                        },
                        d = c.prototype = Object.create(n.prototype);
                    d.init = function() {
                        this.GUID || (this.createDOM(), this.GUID = ++o, this.DOM.holder.GUID = o, r[this.GUID] = this, this.setAnimation(), this.getGalleries(), this.openFromQuery())
                    }, d.setVar = function() {
                        var t = window,
                            e = document,
                            i = navigator;
                        this.pre = "mobx", this.gesture = {}, this.buttons = {}, this.slider = {}, this.slides = {}, this.cells = {}, this.states = {}, this.pointers = [], this.expando = a, this.cache = l, this.dragEvents = this.detectPointerEvents(), this.browser = {
                            touchDevice: "ontouchstart" in t || i.maxTouchPoints > 0 || i.msMaxTouchPoints > 0,
                            pushState: "history" in t && "pushState" in history,
                            fullScreen: this.detectFullScreen(),
                            mouseWheel: "onwheel" in e.createElement("div") ? "wheel" : void 0 !== e.onmousewheel ? "mousewheel" : "DOMMouseScroll"
                        }, this.iframeVideo = this.iframeVideo(), this.socialMedia = this.socialMedia()
                    }, d.detectPointerEvents = function() {
                        var t = navigator;
                        return t.pointerEnabled ? {
                            start: ["pointerdown"],
                            move: ["pointermove"],
                            end: ["pointerup", "pointercancel"]
                        } : t.msPointerEnabled ? {
                            start: ["MSPointerDown"],
                            move: ["MSPointerMove"],
                            end: ["MSPointerUp", "MSPointerCancel"]
                        } : {
                            start: ["mousedown", "touchstart"],
                            move: ["mousemove", "touchmove"],
                            end: ["mouseup", "mouseleave", "touchend", "touchcancel"]
                        }
                    }, d.detectFullScreen = function() {
                        for (var t = ["fullscreenEnabled", "webkitFullscreenEnabled", "mozFullScreenEnabled", "msFullscreenEnabled"], e = 0, i = t.length; e < i; e++)
                            if (document[t[e]]) return {
                                element: ["fullscreenElement", "webkitFullscreenElement", "mozFullScreenElement", "msFullscreenElement"][e],
                                request: ["requestFullscreen", "webkitRequestFullscreen", "mozRequestFullScreen", "msRequestFullscreen"][e],
                                change: ["fullscreenchange", "webkitfullscreenchange", "mozfullscreenchange", "MSFullscreenChange"][e],
                                exit: ["exitFullscreen", "webkitExitFullscreen", "mozCancelFullScreen", "msExitFullscreen"][e]
                            };
                        var n = this.options.controls,
                            s = n.indexOf("fullScreen");
                        return s > -1 && n.splice(s, 1), null
                    }, d.iframeVideo = function() {
                        return {
                            youtube: {
                                reg: /(?:www\.)?youtu\.?be(?:\.com)?\/?.*?(?:watch|embed)?(?:.*v=|v\/|watch%3Fv%3D|\/)([\w\-_]+)&?/i,
                                url: "https://www.youtube.com/embed/[ID]?enablejsapi=1&rel=0&autoplay=1",
                                share: "https://www.youtube.com/watch?v=[ID]",
                                poster: "https://img.youtube.com/vi/[ID]/maxresdefault.jpg",
                                thumb: "https://img.youtube.com/vi/[ID]/default.jpg",
                                play: {
                                    event: "command",
                                    func: "playVideo"
                                },
                                pause: {
                                    event: "command",
                                    func: "pauseVideo"
                                }
                            },
                            vimeo: {
                                reg: /(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/)?(\d+)(?:[a-zA-Z0-9_\-]+)?/i,
                                url: "https://player.vimeo.com/video/[ID]?autoplay=1&api=1",
                                share: "https://vimeo.com/[ID]",
                                poster: "https://vimeo.com/api/v2/video/[ID].json",
                                play: {
                                    event: "command",
                                    method: "play"
                                },
                                pause: {
                                    event: "command",
                                    method: "pause"
                                }
                            },
                            dailymotion: {
                                reg: /(?:www\.)?(?:dailymotion\.com(?:\/embed)(?:\/video|\/hub)|dai\.ly)\/([0-9a-z]+)(?:[\-_0-9a-zA-Z]+#video=(?:[a-zA-Z0-9_\-]+))?/i,
                                url: "https://dailymotion.com/embed/video/[ID]?autoplay=1&api=postMessage",
                                share: "https://www.dailymotion.com/video/[ID]",
                                poster: "https://www.dailymotion.com/thumbnail/video/[ID]",
                                thumb: "https://www.dailymotion.com/thumbnail/video/[ID]",
                                play: "play",
                                pause: "pause"
                            },
                            wistia: {
                                reg: /(?:www\.)?(?:wistia\.(?:com|net)|wi\.st)\/(?:(?:m|medias|projects)|embed\/(?:iframe|playlists))\/([a-zA-Z0-9_\-]+)/i,
                                url: "https://fast.wistia.net/embed/iframe/[ID]?version=3&enablejsapi=1&html5=1&autoplay=1",
                                share: "https://fast.wistia.net/embed/iframe/[ID]",
                                poster: "https://fast.wistia.com/oembed?url=https://home.wistia.com/medias/[ID].json",
                                play: {
                                    event: "cmd",
                                    method: "play"
                                },
                                pause: {
                                    event: "cmd",
                                    method: "pause"
                                }
                            }
                        }
                    }, d.socialMedia = function() {
                        return {
                            facebook: "https://www.facebook.com/sharer/sharer.php?u=[url]",
                            googleplus: "https://plus.google.com/share?url=[url]",
                            twitter: "https://twitter.com/intent/tweet?text=[text]&url=[url]",
                            pinterest: "https://www.pinterest.com/pin/create/button/?url=[url]&media=[image]&description=[text]",
                            linkedin: "https://www.linkedin.com/shareArticle?url=[url]&mini=true&title=[text]",
                            reddit: "https://www.reddit.com/submit?url=[url]&title=[text]",
                            stumbleupon: "https://www.stumbleupon.com/badge?url=[url]&title=[text]",
                            tumblr: "https://www.tumblr.com/share?v=3&u=[url]&t=[text]",
                            blogger: "https://www.blogger.com/blog_this.pyra?t&u=[url]&n=[text]",
                            buffer: "https://bufferapp.com/add?url=[url]title=[text]",
                            digg: "https://digg.com/submit?url=[url]&title=[text]",
                            evernote: "https://www.evernote.com/clip.action?url=[url]&title=[text]"
                        }
                    }, d.createDOM = function() {
                        this.DOM = {};
                        for (var t = ["holder", "overlay", "slider", "item", "item-inner", "ui", "top-bar", "bottom-bar", "share-tooltip", "counter", "caption", "caption-inner", "thumbs-holder", "thumbs-inner"], e = 0; e < t.length; e++) this.DOM[i.camelize(t[e])] = i.createEl("div", this.pre + "-" + t[e]);
                        this.appendDOM(this.DOM)
                    }, d.appendDOM = function(t) {
                        var e = this.options;
                        t.holder.appendChild(t.overlay), t.holder.appendChild(t.slider), t.holder.appendChild(t.ui);
                        for (var n = 0; n < 5; n++) {
                            var s = t.item.cloneNode(!0);
                            s.appendChild(t.itemInner.cloneNode(!0)), t.slider.appendChild(s), this.slides[n] = s
                        }
                        this.slides.length = t.slider.children.length, this.createUI(t, e), t.holder.setAttribute("tabindex", -1), t.holder.setAttribute("aria-hidden", !0), this.DOM.comment = document.createComment(" ModuloBox (v1.5.0) by Themeone "), document.body.appendChild(this.DOM.comment), i.dispatchEvent(this, "modulobox", "beforeAppendDOM", t), document.body.appendChild(t.holder), t.topBar.height = t.topBar.clientHeight
                    }, d.createUI = function(t, e) {
                        var n = e.controls.indexOf("share");
                        if (n > -1) {
                            for (var s = e.shareButtons, o = s.length; o--;) this.socialMedia.hasOwnProperty(s[o]) || s.splice(o, 1);
                            s.length ? (t.ui.appendChild(t.shareTooltip), e.shareText && (t.shareTooltip.appendChild(i.createEl("span")).textContent = e.shareText), this.createButtons(s, t.shareTooltip, "shareOn")) : e.controls.splice(n, 1)
                        }
                        if (e.controls.length || e.counterMessage) {
                            var r = e.controls.indexOf("play");
                            if (t.ui.appendChild(t.topBar), e.counterMessage && t.topBar.appendChild(t.counter), e.slideShowInterval < 1 && r > -1 && e.controls.splice(r, 1), e.countTimer && r > -1) {
                                var a = this.DOM.timer = i.createEl("canvas", this.pre + "-timer");
                                a.setAttribute("width", 48), a.setAttribute("height", 48), t.topBar.appendChild(a)
                            }
                            if (e.controls.length) {
                                var l = e.controls.slice();
                                this.createButtons(l.reverse(), t.topBar)
                            }
                        }(e.caption || e.thumbnails) && (t.ui.appendChild(t.bottomBar), e.caption && t.bottomBar.appendChild(t.caption).appendChild(t.captionInner), e.thumbnails && t.bottomBar.appendChild(t.thumbsHolder).appendChild(t.thumbsInner)), e.prevNext && this.createButtons(["prev", "next"], t.ui)
                    }, d.createButtons = function(t, e, n) {
                        for (var s = t.length, o = 0; o < s; o++) {
                            var r = t[o];
                            this.buttons[r] = i.createEl("BUTTON", this.pre + "-" + r.toLowerCase()), e.appendChild(this.buttons[r]), (r && "function" == typeof this[r] || n) && (this.buttons[r].event = n || r, this.buttons[r].action = r, "shareOn" === n && this.buttons[r].setAttribute("title", r.charAt(0).toUpperCase() + r.slice(1)))
                        }
                    }, d.getGalleries = function() {
                        this.galleries = {};
                        var t = this.options.mediaSelector,
                            e = "";
                        if (!t) return !1;
                        try {
                            e = document.querySelectorAll(t)
                        } catch (e) {
                            i.error('Your current mediaSelector is not a valid selector: "' + t + '"')
                        }
                        for (var n = 0, s = e.length; n < s; n++) {
                            var o = e[n],
                                r = {};
                            if (r.src = "A" === o.tagName ? o.getAttribute("href") : null, r.src = "IMG" === o.tagName ? o.currentSrc || o.src : r.src, r.src = o.getAttribute("data-src") || r.src, r.src && (this.getMediaAtts(o, r), this.setMediaType(r), r.type)) {
                                this.getMediaThumb(o, r), this.getVideoThumb(r), this.getMediaCaption(o, r), this.setMediaCaption(r);
                                var a = this.setGalleryName(o);
                                this.setGalleryFeatures(a, r), r.index = a.length, a.push(r), this.setMediaEvent(o, a.name, r.index)
                            }
                        }
                        i.dispatchEvent(this, "modulobox", "updateGalleries", this.galleries)
                    }, d.addMedia = function(t, n) {
                        if (!n || "object" !== e(n)) return i.error("No media was found to addMedia() in a gallery"), !1;
                        t = "" === t ? 1 : t;
                        var s = this.galleries[t];
                        (s = s || (this.galleries[t] = [])).name = t;
                        for (var o = n.length, r = 0; r < o; r++) {
                            var a = i.cloneObject(n[r]);
                            a.src && (this.setMediaType(a), this.getVideoThumb(a), this.setMediaCaption(a), this.setGalleryFeatures(s, a), a.index = s.length, s.push(a))
                        }
                    }, d.setMediaType = function(t) {
                        if (!(["image", "video", "iframe", "HTML"].indexOf(t.type) > -1)) {
                            t.type = null;
                            var e = t.src ? t.src : null,
                                i = (e.split(/[?#]/)[0] || e).substr(2 + (~-e.lastIndexOf(".") >>> 0));
                            if (/(jpg|jpeg|png|bmp|gif|tif|tiff|jfi|jfif|exif|svg)/i.test(i) || ["external.xx.fbcdn", "drscdn.500px.org"].indexOf(e) > -1) t.type = "image", t.src = this.getSrc(e);
                            else if (/(mp4|webm|ogv)/i.test(i)) t.type = "video", t.format = "html5";
                            else {
                                var n = this.iframeVideo;
                                for (var s in n)
                                    if (n.hasOwnProperty(s)) {
                                        var o = e.match(n[s].reg);
                                        if (o && o[1]) {
                                            var r = n[s];
                                            t.type = "video", t.format = s, t.share = r.share.replace("[ID]", o[1]), t.src = r.url.replace("[ID]", o[1]), t.pause = r.pause, t.play = r.play, this.options.videoThumbnail && (t.poster = !t.poster && r.poster ? r.poster.replace("[ID]", o[1]) : t.poster, t.thumb = !t.thumb && r.poster ? r.poster.replace("[ID]", o[1]) : t.thumb);
                                            break
                                        }
                                    }
                            }
                        }
                    }, d.getSrc = function(t) {
                        var e = (t || "").split(/,/),
                            i = e.length,
                            n = 0;
                        if (i <= 1) return t;
                        for (var s = 0; s < i; s++) {
                            var o = e[s].replace(/\s+/g, " ").trim().split(/ /),
                                r = parseFloat(o[1]) || 0;
                            ("w" === (o[1] ? o[1].slice(-1) : null) && screen.width >= r && r > n || !r || 0 === s) && (n = r, t = o[0])
                        }
                        return t
                    }, d.getMediaAtts = function(t, e) {
                        var i = this.options.autoCaption,
                            n = this.getAttr(t),
                            s = t.firstElementChild;
                        s = "IMG" !== t.tagName && s && "IMG" === s.tagName ? s : t, e.type = e.type ? e.type : n.type || t.getAttribute("data-type"), e.title = n.title || t.getAttribute("data-title") || (i ? s.title : null), e.desc = n.desc || t.getAttribute("data-desc") || (i ? s.alt : null), e.thumb = n.thumb || t.getAttribute("data-thumb"), e.poster = this.getSrc(n.poster || t.getAttribute("data-poster")), e.width = n.width || t.getAttribute("data-width"), e.height = n.height || t.getAttribute("data-height"), e.title === e.desc && (e.desc = null)
                    }, d.getMediaThumb = function(t, e) {
                        var i = t.getElementsByTagName("img");
                        !e.thumb && i[0] && (e.thumb = i[0].src)
                    }, d.getVideoThumb = function(t) {
                        if (this.options.videoThumbnail && "video" === t.type && "html5" !== t.format) {
                            var i = t.poster && t.poster.indexOf(".json") > -1,
                                n = t.thumb && t.thumb.indexOf(".json") > -1;
                            if (i || n) {
                                var s = i ? t.poster : t.thumb,
                                    o = new XMLHttpRequest;
                                o.onload = function(i) {
                                    var s = i.target.responseText;
                                    if ((s = (s = JSON.parse(s)).hasOwnProperty(0) ? s[0] : s) && (t.poster = s.thumbnail_large || s.thumbnail_url, t.dom && (t.dom.style.backgroundImage = 'url("' + t.poster + '")'), n)) {
                                        var o = s.thumbnail_small || s.thumbnail_url;
                                        "object" === e(t.thumb) ? t.thumb.style.backgroundImage = 'url("' + o + '")' : t.thumb = o
                                    }
                                }.bind(this), o.open("GET", encodeURI(s), !0), setTimeout(function() {
                                    o.send()
                                }, 0)
                            }
                        }
                    }, d.getMediaCaption = function(t, e) {
                        var i = t.nextElementSibling;
                        if (i && "FIGCAPTION" === i.tagName) {
                            var n = i.innerHTML;
                            e.title ? e.desc || (e.desc = n) : e.title = n
                        }
                    }, d.setMediaCaption = function(t) {
                        t.title = t.title ? '<div class="' + this.pre + '-title">' + t.title.trim() + "</div>" : "", t.desc = t.desc ? '<div class="' + this.pre + '-desc">' + t.desc.trim() + "</div>" : "", t.caption = t.title + t.desc
                    }, d.getGalleryName = function(t) {
                        for (var e = t, i = 0; e && i < 2;) {
                            if ((e = e.parentNode) && "FIGURE" === e.tagName && e.parentNode) return e.parentNode.getAttribute("id");
                            i++
                        }
                    }, d.setGalleryName = function(t) {
                        var e = this.getAttr(t).rel || t.getAttribute("data-rel");
                        e = (e = e || this.getGalleryName(t)) || Object.keys(this.galleries).length + 1;
                        var i = this.galleries[e];
                        return (i = i || (this.galleries[e] = [])).name = e, i
                    }, d.setGalleryFeatures = function(t, e) {
                        t.zoom || "image" !== e.type || (t.zoom = !0), t.download || "image" !== e.type && "html5" !== e.format || (t.download = !0)
                    }, d.setMediaEvent = function(t, e, i) {
                        t.mobxListener && t.removeEventListener("click", t.mobxListener, !1), t.mobxListener = this.open.bind(this, e, i), t.addEventListener("click", t.mobxListener, !1)
                    }, d.open = function(t, e, n) {
                        return n && (n.preventDefault(), n.stopPropagation()), !!this.GUID && (this.galleries.hasOwnProperty(t) ? this.galleries[t].length ? this.galleries[t][e] ? (i.dispatchEvent(this, "modulobox", "beforeOpen", t, e), this.slides.index = e, this.gallery = this.galleries[t], this.gallery.name = t, this.gallery.index = e, this.gallery.loaded = !1, this.removeContent(), this.wrapAround(), this.hideScrollBar(), this.setSlider(), this.setThumbs(), this.setCaption(), this.setMedia(this.options.preload), this.updateMediaInfo(), this.replaceState(), this.setControls(), this.bindEvents(!0), this.show(), this.options.videoAutoPlay && this.appendVideo(), this.options.slideShowAutoPlay && this.options.controls.indexOf("play") > -1 && (!this.options.videoAutoPlay || "video" !== this.galleries[t][e].type) && this.startSlideShow(), this.states.zoom = !1, void(this.states.open = !0)) : (i.error("Sorry, no media was found for the current media index: " + e), !1) : (i.error("Sorry, no media was found for the current gallery."), !1) : (i.error('This gallery name : "' + t + '", does not exist!'), !1))
                    }, d.openFromQuery = function() {
                        var t = this.getQueryString(window.location.search);
                        t.hasOwnProperty("guid") && t.hasOwnProperty("mid") && !1 === this.open(decodeURIComponent(t.guid), decodeURIComponent(t.mid) - 1) && this.replaceState(!0)
                    }, d.show = function() {
                        var t = this.DOM.holder,
                            e = this.options.rightToLeft ? "add" : "remove";
                        t.setAttribute("aria-hidden", !1), i.removeClass(t, this.pre + "-idle"), i.removeClass(t, this.pre + "-panzoom"), i.removeClass(t, this.pre + "-will-close"), i[e + "Class"](t, this.pre + "-rtl"), i.addClass(t, this.pre + "-open")
                    }, d.close = function(t) {
                        t && t.preventDefault();
                        var e = this.DOM.holder,
                            n = this.gallery,
                            s = n ? n.index : "undefined",
                            o = n ? n.name : "undefined";
                        i.dispatchEvent(this, "modulobox", "beforeClose", o, s), this.states.fullScreen && (this.exitFullScreen(), i.removeClass(e, this.pre + "-fullscreen")), this.share(), this.stopSlideShow(), this.pauseVideo(), this.bindEvents(!1), this.replaceState(!0), this.hideScrollBar(), e.setAttribute("aria-hidden", !0), i.removeClass(e, this.pre + "-open"), this.states.open = !1
                    }, d.setControls = function() {
                        var t = this.gallery,
                            e = this.options,
                            i = this.buttons;
                        this.DOM.counter && (this.DOM.counter.style.display = t.initialLength > 1 ? "" : "none"), e.controls.indexOf("play") > -1 && (i.play.style.display = t.initialLength > 1 ? "" : "none"), e.controls.indexOf("zoom") > -1 && (i.zoom.style.display = t.zoom ? "" : "none"), e.controls.indexOf("download") > -1 && (i.download.style.display = t.download ? "" : "none"), this.setPrevNextButtons()
                    }, d.setPrevNextButtons = function() {
                        if (this.options.prevNext) {
                            var t = this.slider.width < 680 && this.browser.touchDevice && !this.options.prevNextTouch;
                            this.buttons.prev.style.display = this.buttons.next.style.display = this.gallery.length > 1 && !t ? "" : "none"
                        }
                    }, d.setCaption = function() {
                        this.states.caption = !(!this.options.captionSmallDevice && (this.slider.width <= 480 || this.slider.height <= 480)), this.DOM.caption.style.display = this.states.caption ? "" : "none"
                    }, d.hideScrollBar = function() {
                        if (!this.options.scrollBar) {
                            var t = this.states.open,
                                e = "undefined" === t || !t;
                            document.body.style.overflow = document.documentElement.style.overflow = e ? "hidden" : ""
                        }
                    }, d.bindEvents = function(t) {
                        var e, n = window,
                            s = document,
                            o = this.options,
                            r = this.DOM.holder,
                            a = this.buttons;
                        for (var l in a)
                            if (a.hasOwnProperty(l)) {
                                var h = "share" !== l ? a[l] : n;
                                i.handleEvents(this, h, ["click", "touchend"], a[l].event, t)
                            } i.handleEvents(this, r, this.dragEvents.start, "touchStart", t), i.handleEvents(this, n, ["keydown"], "keyDown", t), i.handleEvents(this, n, ["resize", "orientationchange"], "resize", t), i.handleEvents(this, r, ["transitionend", "webkitTransitionEnd", "oTransitionEnd", "otransitionend", "MSTransitionEnd"], "opened"), i.handleEvents(this, r, ["touchend"], "disableZoom", t), this.browser.fullScreen && i.handleEvents(this, s, [this.browser.fullScreen.change], "toggleFullScreen", t), o.history && i.handleEvents(this, n, ["mouseout"], "mouseOut", t), o.timeToIdle > 0 && i.handleEvents(this, r, ["mousemove"], "mouseMove", t), o.contextMenu || i.handleEvents(this, r, ["contextmenu"], "contextMenu", t), o.mouseWheel || this.disableScroll(t), o.scrollToZoom ? e = "scrollToZoom" : o.scrollToNav ? e = "scrollToNav" : o.scrollToClose && (e = "scrollToClose"), e && i.handleEvents(this, r, [this.browser.mouseWheel], e, t)
                    }, d.opened = function(t) {
                        if ("visibility" === t.propertyName && t.target === this.DOM.holder) {
                            var e = this.gallery.name,
                                n = this.gallery.index;
                            this.states.open ? i.dispatchEvent(this, "modulobox", "afterOpen", e, n) : (this.removeContent(), i.dispatchEvent(this, "modulobox", "afterClose", e, n))
                        }
                    }, d.mouseOut = function(t) {
                        var e = t || window.event,
                            i = e.relatedTarget || e.toElement;
                        i && "HTML" !== i.nodeName || this.replaceState()
                    }, d.mouseMove = function() {
                        var t = this.DOM.holder,
                            e = this.pre + "-idle";
                        clearTimeout(this.states.idle), this.states.idle = setTimeout(function() {
                            i.hasClass(t, this.pre + "-open-tooltip") || i.addClass(t, e)
                        }.bind(this), this.options.timeToIdle), i.removeClass(t, e)
                    }, d.contextMenu = function(t) {
                        var e = t.target,
                            i = e.tagName,
                            n = e.className;
                        ("IMG" === i || "VIDEO" === i || n.indexOf(this.pre + "-video") > -1 || n.indexOf(this.pre + "-thumb-bg") > -1 || n === this.pre + "-thumb") && t.preventDefault()
                    }, d.disableScroll = function(t) {
                        var e = document,
                            i = window;
                        i.onwheel = i.ontouchmove = i.onmousewheel = e.onmousewheel = e.onmousewheel = t ? function(t) {
                            if (this.isEl(t)) return (t = t || i.event).preventDefault ? (t.preventDefault(), t.returnValue = !1, !1) : void 0
                        }.bind(this) : null
                    }, d.scrollToZoom = function(t) {
                        if (this.isEl(t)) {
                            var e = this.normalizeWheel(t);
                            if (e && e.deltaY) {
                                var i = this.getCell(),
                                    n = i.attraction.s || i.position.s;
                                n = Math.min(this.options.maxZoom, Math.max(1, n - Math.abs(e.deltaY) / e.deltaY)), this.stopSlideShow(), this.zoomTo(t.clientX, t.clientY, Math.round(10 * n) / 10)
                            }
                        }
                    }, d.scrollToNav = function(t) {
                        if (this.isEl(t)) {
                            var e = this.normalizeWheel(t);
                            e && e.delta && this[e.delta * this.isRTL() < 0 ? "prev" : "next"]()
                        }
                    }, d.scrollToClose = function(t) {
                        this.isEl(t) && (t.preventDefault(), this.close())
                    }, d.disableZoom = function(t) {
                        for (var e = t.target; e;) {
                            if (["VIDEO", "INPUT", "A"].indexOf(e.tagName) > -1) return;
                            e = e.parentElement
                        }
                        t.preventDefault()
                    }, d.resize = function(t) {
                        this.DOM.topBar.height = this.DOM.topBar.clientHeight, this.share(), this.setSlider(), this.setThumbsPosition(), this.setCaption(), this.resizeMedia(), this.updateMediaInfo(), this.setPrevNextButtons(), this.states.zoom = !1, i.removeClass(this.DOM.holder, this.pre + "-panzoom"), i.dispatchEvent(this, "modulobox", "resize", t)
                    }, d.resizeMedia = function() {
                        for (var t = this.slides, e = 0; e < t.length && this.gallery; e++) {
                            var i = this.gallery[t[e].media];
                            i && (i.dom && i.dom.loaded || i.dom && ["video", "iframe", "HTML"].indexOf(i.type) > -1) && this.setMediaSize(i, t[e])
                        }
                    }, d.isEl = function(t) {
                        var e = t.target.className;
                        return (e = "string" == typeof e ? e : e.baseVal).indexOf(this.pre) > -1
                    }, d.isZoomable = function() {
                        var t = this.getMedia(),
                            e = !1;
                        return "image" === t.type && t.dom && t.dom.size && t.dom.size.scale > 1 && (e = !0), this.DOM.holder.setAttribute("data-zoom", e), e
                    }, d.isDownloadable = function() {
                        var t = this.getMedia(),
                            e = !0;
                        return "image" !== t.type && "html5" !== t.format && (e = !1), this.DOM.holder.setAttribute("data-download", e), e
                    }, d.isRTL = function() {
                        return this.options.rightToLeft ? -1 : 1
                    }, d.addAttr = function(t, e) {
                        var i;
                        for (var n in void 0 === t[this.expando] ? (i = this.cache.uid++, t[this.expando] = i, this.cache[i] = {}) : i = t[this.expando], e) e.hasOwnProperty(n) && (this.cache[i][n] = e[n])
                    }, d.getAttr = function(t) {
                        return this.cache[t[this.expando]] || {}
                    }, d.getThumbHeight = function() {
                        var t = this.thumbs;
                        return t.height > 0 && t.width > 0 ? t.height + 2 * Math.min(10, t.gutter) : 0
                    }, d.getMedia = function() {
                        var t = this.gallery;
                        return t ? t[t.index] : null
                    }, d.getCell = function() {
                        var t = this.slides,
                            e = i.modulo(t.length, t.index);
                        return this.cells[e]
                    }, d.removeContent = function() {
                        for (var t = 0; t < this.slides.length; t++) {
                            var e = this.slides[t];
                            this.unloadMedia(e), this.removeMedia(e), e.index = e.media = null
                        }
                        this.removeMedia(this.DOM.thumbsHolder)
                    }, d.getQueryString = function(t) {
                        var e = {};
                        return t.substr(1).split("&").forEach(function(t) {
                            t = t.split("="), e[decodeURIComponent(t[0])] = t.length > 1 ? decodeURIComponent(t[1]) : ""
                        }), e
                    }, d.setQueryString = function(t) {
                        var e = window.location.search,
                            i = this.getQueryString(e);
                        for (var n in e = decodeURI(e), t)
                            if (t.hasOwnProperty(n)) {
                                var s = encodeURIComponent(t[n]);
                                if (i.hasOwnProperty(n)) {
                                    var o = i[n];
                                    e = s ? e.replace(n + "=" + o, n + "=" + s) : (e = e.replace("&" + n + "=" + o, "")).replace(n + "=" + o, "")
                                } else e = s ? e + (e ? "&" : "?") + n + "=" + s : e.replace(n + "=", "")
                            } var r = [location.protocol, "//", location.host, location.pathname].join("");
                        return e = e.substr(1) ? e : e.substr(1), encodeURI(r + e)
                    }, d.replaceState = function(t) {
                        if ((this.options.history || t) && this.browser.pushState && !this.states.push) {
                            var e = window.history.state,
                                n = {
                                    guid: t ? "" : this.gallery.name,
                                    mid: t ? "" : i.modulo(this.gallery.initialLength, this.gallery.index) + 1
                                };
                            if (!e || e.mid !== n.mid) {
                                var s = this.setQueryString(n);
                                try {
                                    window.history.replaceState(n, "", s)
                                } catch (t) {
                                    this.options.history = !1, i.error("SecurityError: A history state object with origin 'null' cannot be created. Please run the script on a server.")
                                }
                            }
                        }
                        this.states.push = !1
                    }, d.normalizeWheel = function(t) {
                        var e, i, n, s = t || window.event,
                            o = null;
                        if (t.preventDefault(), "detail" in s && (i = -1 * s.detail), "wheelDelta" in s && (i = -1 * s.wheelDelta), "wheelDeltaY" in s && (i = -1 * s.wheelDeltaY), "wheelDeltaX" in s && (e = -1 * s.wheelDeltaX), "deltaY" in s && (i = s.deltaY), "deltaX" in s && (e = -1 * s.deltaX), 1 === s.deltaMode ? (e *= 40, i *= 40) : 2 === s.deltaMode && (e *= 100, i *= 100), n = Math.abs(e) > Math.abs(i) ? e : i, n = Math.min(100, Math.max(-100, n)), Math.abs(n) < this.options.scrollSensitivity) return this.states.prevDelta = n, o;
                        var r = +new Date;
                        return (Math.abs(n) > Math.abs(this.states.prevDelta) || r - this.states.prevScroll > 60) && (o = {
                            deltaX: e,
                            deltaY: i,
                            delta: n
                        }), this.states.prevDelta = n, this.states.prevScroll = r, o
                    }, d.share = function(t) {
                        if (!t || "VIDEO" !== t.target.tagName) {
                            var e = this.DOM.holder,
                                n = this.pre + "-open-tooltip",
                                s = t ? t.target.className : null,
                                o = i.hasClass(e, n) ? "remove" : "add";
                            ("remove" !== o || s === this.pre + "-share" && t) && s !== this.pre + "-share" || ("add" === o && this.setShareTooltip(), i[o + "Class"](e, n))
                        }
                    }, d.shareOn = function(t) {
                        var e, n = t.target.action,
                            s = this.gallery,
                            o = this.getMedia(),
                            r = "image" === o.type ? o.src : o.poster,
                            a = this.socialMedia[n];
                        if (a) {
                            "page" === this.options.sharedUrl ? e = [location.protocol, "//", location.host, location.pathname].join("") : "deeplink" === this.options.sharedUrl || ["iframe", "HTML"].indexOf(o.type) > -1 ? e = this.setQueryString({
                                guid: s.name,
                                mid: s.index + 1
                            }) : (e = o.src.replace(/\s/g, "").split(",")[0], "video" === o.type && "html5" !== o.format && (e = o.share));
                            var l = i.createEl("a");
                            l.href = r, r = l.href, l.href = e, e = l.href;
                            var h = i.createEl("div");
                            h.innerHTML = o.caption;
                            var c = (h.textContent || h.innerText).replace(/\s+/g, " ").trim() || "";
                            if (a = a.replace("[url]", encodeURIComponent(e)).replace("[image]", encodeURIComponent(r)).replace("[text]", encodeURIComponent(c || document.title))) {
                                var d = Math.round(window.screenX + (window.outerWidth - 626) / 2),
                                    u = Math.round(window.screenY + (window.outerHeight - 436) / 2);
                                window.open(a, this.pre + "_share", "status=0,resizable=1,location=1,toolbar=0,width=626,height=436,top=" + u + ",left=" + d)
                            }
                        } else i.error("This social share media does not exist");
                        return !1
                    }, d.setShareTooltip = function() {
                        if (this.options.controls.indexOf("share") > -1) {
                            var t = "right",
                                e = this.DOM.shareTooltip,
                                i = e.clientWidth,
                                n = this.buttons.share.getBoundingClientRect(),
                                s = n.left - i + n.width / 2 + 20;
                            s < 0 && (t = "left", s = n.left + n.width / 2 - 20), e.setAttribute("data-position", t), e.style.top = this.DOM.topBar.height + 6 + "px", e.style.left = s + "px"
                        }
                    }, d.download = function() {
                        if (!this.isDownloadable()) return !1;
                        var t = this.getMedia().src.replace(/\s/g, "").split(",")[0],
                            e = document.createElement("a"),
                            i = t.split("/");
                        e.href = t, e.download = i.pop().split("?")[0], e.setAttribute("target", "_blank"), document.body.appendChild(e), e.click(), document.body.removeChild(e)
                    }, d.fullScreen = function() {
                        var t = this.browser.fullScreen.element;
                        document[t] ? this.exitFullScreen() : this.requestFullScreen()
                    }, d.toggleFullScreen = function() {
                        var t = this.DOM.holder,
                            e = document[this.browser.fullScreen.element];
                        e ? e === t && (this.setShareTooltip(), this.states.fullScreen = !0, i.addClass(t, this.pre + "-fullscreen")) : (this.share(), this.states.fullScreen = !1, i.removeClass(t, this.pre + "-fullscreen")), this.videoFullScreen()
                    }, d.requestFullScreen = function() {
                        var t = this.browser.fullScreen.request;
                        document.documentElement[t] && this.DOM.holder[t]()
                    }, d.exitFullScreen = function() {
                        var t = this.browser.fullScreen.exit;
                        document[t] && document[t]()
                    }, d.play = function() {
                        this.states.play ? this.stopSlideShow() : this.startSlideShow()
                    }, d.startSlideShow = function() {
                        var t = 0,
                            e = this.gallery,
                            n = this.options,
                            s = this.states.loop,
                            o = n.slideShowAutoStop,
                            r = Math.max(120, n.slideShowInterval),
                            a = n.countTimer,
                            l = a && this.DOM.timer ? this.DOM.timer.getContext("2d") : null,
                            h = function(i) {
                                if (i = i || +new Date, t = t || i, s && !o || e.index !== e.initialLength - 1) {
                                    if (a && l) {
                                        var c = 360 * Math.min(1, (i - t + r) / r - 1) * (Math.PI / 180);
                                        l.clearRect(0, 0, 48, 48), this.timerProgress(l, n.countTimerBg, 100), this.timerProgress(l, n.countTimerColor, c)
                                    }
                                    i >= t + r && (t = i, this.slideTo(this.slides.index + 1, !0)), this.timer = requestAnimationFrame(h)
                                } else this.stopSlideShow()
                            }.bind(this);
                        i.addClass(this.DOM.holder, this.pre + "-autoplay"), this.states.play = !0, this.timer = requestAnimationFrame(h)
                    }, d.stopSlideShow = function() {
                        cancelAnimationFrame(this.timer), i.removeClass(this.DOM.holder, this.pre + "-autoplay"), this.states.play = !1
                    }, d.timerProgress = function(t, e, i) {
                        var n = 1.5 * Math.PI;
                        t.strokeStyle = e, t.lineWidth = 5, t.beginPath(), t.arc(24, 24, 18, n, n + i, !1), t.stroke()
                    }, d.appendVideo = function() {
                        var t = this.getMedia();
                        if ("video" === t.type) {
                            if (i.addClass(t.dom, this.pre + "-loading"), i.removeClass(t.dom, this.pre + "-playing"), !t.video) {
                                if ("html5" === t.format) {
                                    t.video = i.createEl("video"), t.video.setAttribute("controls", ""), t.video.setAttribute("autoplay", "");
                                    for (var e = t.src.replace(/\s/g, "").split(","), n = 0; n < e.length; n++) {
                                        var s = document.createDocumentFragment(),
                                            o = i.createEl("source"),
                                            r = /^.+\.([^.]+)$/.exec(e[n]);
                                        r && ["mp4", "webm", "ogv"].indexOf(r[1]) > -1 && (o.src = e[n], o.setAttribute("type", "video/" + ("ogv" === r[1] ? "ogg" : r[1])), s.appendChild(o)), t.video.appendChild(s)
                                    }
                                } else t.format && (t.video = i.createEl("iframe"), t.video.src = t.src, t.video.setAttribute("frameborder", 0), t.video.setAttribute("allowfullscreen", ""));
                                t.video.setAttribute("width", "100%"), t.video.setAttribute("height", "100%")
                            }
                            t.dom.firstChild || (t.dom.appendChild(t.video), "html5" !== t.format && (t.video.loaded = !1)), this.playVideo(t)
                        }
                    }, d.onVideoLoaded = function(t) {
                        t.video.loaded = !0, i.removeClass(t.dom, this.pre + "-loading"), i.addClass(t.dom, this.pre + "-playing"), this.cloneVideo(t)
                    }, d.cloneVideo = function(t) {
                        if (this.states.loop && "html5" === t.format)
                            for (var e = this.gallery, n = e.length, s = e.initialLength, o = i.modulo(s, t.index), r = 0; r < n; r++) i.modulo(s, e[r].index) === o && e[r].index !== t.index && (e[r].video = t.video)
                    }, d.videoFullScreen = function() {
                        var t = this.getMedia(),
                            e = this.states.fullScreen;
                        "video" === t.type && "html5" !== t.format && t.video && t.video[e ? "removeAttribute" : "setAttribute"]("allowfullscreen", "")
                    }, d.playVideo = function(t) {
                        if (t.video.loaded) {
                            if (t.video.getClientRects(), i.removeClass(t.dom, this.pre + "-loading"), i.addClass(t.dom, this.pre + "-playing"), "html5" !== t.format) {
                                if (t.play) {
                                    var n = "object" === e(t.play) ? JSON.stringify(t.play) : String(t.play);
                                    t.video.contentWindow.postMessage(n, "*")
                                }
                            } else if (!t.video.error)
                                if ("function" == typeof MediaElementPlayer && this.options.mediaelement) {
                                    var s = "VIDEO" === t.video.tagName ? t.video : t.video.getElementsByTagName("video")[0];
                                    s.player && s.player.setControlsSize(), s.play()
                                } else t.video.play()
                        } else {
                            var o = this;
                            "function" != typeof MediaElementPlayer || t.play || !this.options.mediaelement || t.video.player ? t.video.onload || (t.video.onload = t.video.onerror = t.video.onloadedmetadata = function() {
                                t.dom.firstChild && (o.onVideoLoaded(t), o.videoFullScreen())
                            }, t.video.src = t.src.replace(/\s/g, "").split(",")[0]) : new MediaElementPlayer(t.video, {
                                features: ["playpause", "stop", "current", "progress", "duration", "volume", "fullscreen"],
                                videoVolume: "horizontal",
                                startVolume: .8,
                                classPrefix: "mejs-",
                                keyActions: [],
                                enableKeyboard: !1,
                                iPadUseNativeControls: !0,
                                iPhoneUseNativeControls: !0,
                                AndroidUseNativeControls: !0,
                                success: function(e) {
                                    e.addEventListener("loadeddata", function() {
                                        if (t.video = t.dom.lastChild, t.video) {
                                            var e = t.video.previousSibling;
                                            e && e.parentNode && e.parentNode.removeChild(e), o.onVideoLoaded(t)
                                        }
                                    }, t, !1)
                                },
                                error: function() {
                                    o.onVideoLoaded(t)
                                }
                            })
                        }
                    }, d.pauseVideo = function() {
                        var t = this.getMedia();
                        if (t && "video" === t.type && t.video) {
                            if (i.removeClass(t.dom, this.pre + "-playing"), !t.video.loaded) return t.dom.innerHTML = "", void i.removeClass(t.dom, this.pre + "-loading");
                            if ("html5" === t.format) "function" == typeof MediaElementPlayer && this.options.mediaelement ? ("VIDEO" === t.video.tagName ? t.video : t.video.getElementsByTagName("video")[0]).pause() : t.video.pause();
                            else if (t.pause && "dailymotion" !== t.format) {
                                var n = "object" === e(t.pause) ? JSON.stringify(t.pause) : String(t.pause);
                                t.video.contentWindow.postMessage(n, "*")
                            } else t.dom.innerHTML = "", t.video = null
                        }
                    }, d.insertMedia = function(t, e) {
                        var i = this.gallery[t];
                        i && (void 0 === i.index && (i.index = this.gallery.indexOf(i)), this.buildMedia(i), this.appendMedia(i, e), this.loadMedia(i, e))
                    }, d.buildMedia = function(t) {
                        if (void 0 === t.dom) {
                            switch (t.type) {
                                case "image":
                                    t.dom = i.createEl("img", this.pre + "-img"), t.dom.src = t.src;
                                    break;
                                case "video":
                                    t.dom = i.createEl("div", this.pre + "-video"), t.poster ? t.dom.style.backgroundImage = 'url("' + t.poster + '")' : t.dom.loaded = !0;
                                    break;
                                case "iframe":
                                    t.dom = i.createEl("iframe", this.pre + "-iframe"), t.dom.setAttribute("allowfullscreen", ""), t.dom.setAttribute("frameborder", 0), t.dom.src = t.src;
                                    break;
                                case "HTML":
                                    var e = t.src,
                                        n = document.querySelector(e);
                                    t.dom = i.createEl("div", this.pre + "-html"), t.dom.appendChild(i.createEl("div", this.pre + "-html-inner")), t.dom.firstChild.innerHTML = n ? n.innerHTML : null, t.src = n || "", t.dom.loaded = !0
                            }
                            t.type && t.src || (t.dom = i.createEl("div", this.pre + "-error"), t.dom.textContent = this.options.noContent, t.dom.loaded = !0, t.dom.error = !0, i.dispatchEvent(this, "modulobox", "noContent", this.gallery.name, parseInt(t.index, 10)))
                        }
                    }, d.appendMedia = function(t, e) {
                        var n, s = this.slides[e],
                            o = s.firstChild;
                        if (o.childElementCount) {
                            var r = o.lastChild;
                            (n = o.firstChild).style.visibility = "", t.dom !== r && o[1 === o.childElementCount ? "appendChild" : "replaceChild"](t.dom, r)
                        } else {
                            var a = document.createDocumentFragment();
                            n = i.createEl("div", this.pre + "-loader"), a.appendChild(n), a.appendChild(t.dom), o.appendChild(a)
                        }
                        s.media = t.index
                    }, d.loadMedia = function(t, e) {
                        if (t.dom.loaded) this.showMedia(t, e);
                        else {
                            var n = this,
                                s = "iframe" === t.type ? t.dom : t.dom.img = new Image,
                                o = function() {
                                    t.dom.error || i.dispatchEvent(n, "modulobox", "loadComplete", n.gallery.name, parseInt(t.index, 10)), t.dom.loaded = "iframe" !== t.type, n.showMedia(t, e)
                                };
                            s.onload = o, s.onerror = function(s) {
                                "video" !== t.type && (t.dom = i.createEl("p", n.pre + "-error"), t.dom.textContent = n.options.loadError, t.dom.error = !0, n.appendMedia(t, e)), i.dispatchEvent(n, "modulobox", "loadError", n.gallery.name, parseInt(t.index, 10)), o()
                            }, s.src = "video" === t.type ? t.poster : t.src
                        }
                    }, d.unloadMedia = function(t) {
                        if (this.gallery) {
                            var e = t.media,
                                i = this.gallery[e];
                            i && i.dom && (!this.options.unload || "image" !== i.type || i.dom.loaded || i.dom.complete || i.dom.naturalWidth ? "video" === i.type && "html5" !== i.format && i.dom.firstChild && (i.video = null, i.dom.removeChild(i.dom.firstChild)) : (i.dom.onload = null, i.dom.onerror = null, i.dom.src = "", i.dom.img && (i.dom.img.onload = null, i.dom.img.onerror = null, i.dom.img.src = "", delete i.dom.img), delete i.dom))
                        }
                    }, d.removeMedia = function(t) {
                        var e = t.firstChild;
                        if (e)
                            for (; e.firstChild;) e.removeChild(e.firstChild)
                    }, d.showMedia = function(t, e) {
                        var n = this.slider;
                        if (!this.options.fadeIfSettle || n.settle || t.dom.revealed) {
                            var s = this.slides[e],
                                o = this.gallery,
                                r = s.firstChild.firstChild,
                                a = this.options.preload;
                            this.setMediaSize(t, s), t.index === o.index && this.isZoomable(), i.addClass(t.dom, this.pre + "-media-loaded"), t.dom.revealed = !0, s.media === t.index && (r.style.visibility = "hidden", o.loaded += 1, o.loaded === a && a < 4 && this.setMedia(a + 2)), "iframe" === t.type && (t.dom.loaded = !1)
                        }
                    }, d.setMediaSize = function(t, e) {
                        var i = t.dom,
                            n = this.slider,
                            s = i.viewport,
                            o = this.getThumbHeight();
                        if (!i.error) {
                            s && s.width === n.width && s.height === n.height - o || (this.getCaptionHeight(t, e), this.getMediaSize(t, e), this.fitMediaSize(t, e), this.setMediaOffset(t, e));
                            var r = i.style;
                            r.width = i.size.width + "px", r.height = i.size.height + "px", r.left = i.offset.left + "px", r.top = i.offset.top + "px"
                        }
                    }, d.getCaptionHeight = function(t, e) {
                        var i = this.DOM.captionInner,
                            n = this.DOM.topBar.height,
                            s = i.innerHTML,
                            o = this.getThumbHeight();
                        this.options.caption && this.states.caption && t.caption ? (i.innerHTML = t.caption, i.height = Math.max(n, parseInt(i.clientHeight, 10)) || n, i.innerHTML = s) : i.height = o ? 0 : n, e.width = this.slider.width, e.height = this.slider.height - n - i.height - o
                    }, d.getMediaSize = function(t, e) {
                        var i = t.dom.size = {};
                        switch (t.type) {
                            case "image":
                                i.width = t.dom.naturalWidth, i.height = t.dom.naturalHeight;
                                break;
                            case "video":
                                i.width = this.options.videoMaxWidth, i.height = i.width / this.options.videoRatio;
                                break;
                            case "iframe":
                                i.width = t.width ? t.width : e.width > 680 ? .8 * e.width : e.width, i.height = t.height ? t.height : e.height;
                                break;
                            case "HTML":
                                i.width = t.width ? t.width : e.width, i.height = t.height ? t.height : e.height
                        }
                    }, d.fitMediaSize = function(t, e) {
                        var i, n, s = this.slider,
                            o = this.options,
                            r = o.zoomTo,
                            a = t.dom.size,
                            l = a.width / a.height,
                            h = this.getThumbHeight(),
                            c = s.width <= 480 || s.height <= 680,
                            d = ["video", "iframe", "HTML"].indexOf(t.type) < 0,
                            u = o.smartResize && c,
                            p = [e.height];
                        (u || o.overflow) && d && p.unshift(s.height - h), p.forEach(function(t) {
                            (!n || n < s.height - h) && (i = (i = Math.min(a.width, l * t)) > e.width ? e.width : Math.round(i), n = (n = Math.ceil(1 / l * i)) % t < 2 ? t : n)
                        });
                        var f = Number((a.width / i).toFixed(3));
                        r = "auto" === r ? f : r, t.dom.size = {
                            width: i,
                            height: n,
                            scale: f >= o.minZoom ? Math.min(o.maxZoom, r) : 1
                        }
                    }, d.setMediaOffset = function(t, e) {
                        var i = t.dom.size,
                            n = this.slider,
                            s = this.DOM.topBar.height,
                            o = this.getThumbHeight(),
                            r = 0;
                        i.height <= e.height && (r = s + .5 * (e.height - i.height)), t.dom.offset = {
                            top: r < 0 ? 0 : Math.round(r),
                            left: Math.round(.5 * (e.width - i.width))
                        }, t.dom.viewport = {
                            width: n.width,
                            height: n.height - o
                        }
                    }, d.mediaViewport = function(t) {
                        var e = this.getMedia();
                        if (!e.dom || !e.dom.size) return {
                            top: 0,
                            bottom: 0,
                            left: 0,
                            right: 0
                        };
                        var i = e.dom.size,
                            n = e.dom.offset,
                            s = this.slider.height,
                            o = this.slider.width,
                            r = .5 * (s - i.height),
                            a = 2 * n.top - r,
                            l = .5 * (r - a),
                            h = l * t - 2 * l - a,
                            c = i.width / 2 * (t - 1) - n.left,
                            d = i.height * t <= s ? l * t : -i.height / 2 * (t - 1) + s - i.height + h,
                            u = i.height * t <= s ? l * t : i.height / 2 * (t - 1) + h;
                        return {
                            top: t <= 1 ? 0 : Math.round(d),
                            bottom: t <= 1 ? 0 : Math.round(u),
                            left: i.width * t < o ? 0 : Math.round(c),
                            right: i.width * t < o ? 0 : Math.round(-c)
                        }
                    }, d.setMedia = function(t) {
                        var e, n = this.gallery,
                            s = this.slides,
                            o = this.states.loop,
                            r = this.isRTL(),
                            a = Math.round(-r * this.slider.position.x / s.width),
                            l = n.initialLength - 1,
                            h = 0,
                            c = [];
                        if (!t && !n.loaded) {
                            for (t = 0, e = 0; e < s.length; e++) s[e].firstChild.childElementCount && t++;
                            t += 2, n.loaded = this.options.preload
                        }
                        switch (t) {
                            case 0:
                            case 1:
                                c = [0];
                                break;
                            case 2:
                            case 3:
                                c = [-1, 0, 1];
                                break;
                            default:
                                t = 5, c = [-2, -1, 0, 1, 2]
                        }
                        if (!o) {
                            var d = a + c[t - 1],
                                u = a + c[0];
                            h = u < 0 ? -u : 0, h = d > l ? l - d : h
                        }
                        for (c = c.map(function(t) {
                                return i.modulo(n.length, t + h + a)
                            }), e = 0; e < s.length; e++) {
                            var p = s[e],
                                f = i.modulo(n.length, p.index);
                            !o && p.index > f || c.indexOf(f) > -1 && p.media !== f && (this.unloadMedia(p), this.insertMedia(f, e))
                        }
                    }, d.updateMediaInfo = function() {
                        var t = this.slides,
                            e = this.gallery;
                        e.index = i.modulo(e.length, t.index), this.isZoomable(), this.isDownloadable(), this.updateCounter(), this.updateCaption(), this.updateThumbs(), i.dispatchEvent(this, "modulobox", "updateMedia", this.getMedia())
                    }, d.setThumbs = function() {
                        var t = this.gallery,
                            e = this.thumbs,
                            n = t.initialLength,
                            s = this.options.thumbnails,
                            o = this.DOM.thumbsHolder;
                        if (!s || n < 2) return this.DOM.caption.style.bottom = 0, o.style.visibility = "hidden", o.style.height = 0, void(e.height = e.gutter = 0);
                        var r, a = this.options.thumbnailSizes,
                            l = Math.max(window.innerWidth, Math.max(screen.width, screen.height)),
                            h = 0,
                            c = Object.keys(a).sort(function(t, e) {
                                return t - e
                            });
                        for (r = 0; r < c.length; r++) {
                            var d = c[r],
                                u = r === c.length - 1 ? l : Math.min(l, d),
                                p = Math.ceil(u / (a[d].width + a[d].gutter) * 2);
                            if (isFinite(p) && p > h && (h = p), d >= l) break
                        }
                        var f = document.createDocumentFragment();
                        for (n = n > 50 ? Math.min(h, n) : n, r = 0; r < n; r++) {
                            var m = i.createEl("div", this.pre + "-thumb");
                            f.appendChild(m)
                        }
                        this.DOM.thumbsInner.appendChild(f), this.setThumbsPosition()
                    }, d.thumbClick = function(t) {
                        var e = t.target;
                        i.hasClass(e, this.pre + "-thumb") || (e = e.parentNode), parseInt(e.index, 10) >= 0 && this.slideTo(e.index)
                    }, d.loadThumb = function(t, n) {
                        var s, o = this.gallery[n];
                        if (o.thumb && "object" === e(o.thumb) || (s = o.thumb, o.thumb = i.createEl("div", this.pre + "-thumb-bg"), o.thumb.style.backgroundImage = s && s.indexOf(".json") < 0 ? "url(" + s + ")" : null, "video" === o.type && (i.addClass(o.thumb, this.pre + "-thumb-video"), i.addClass(o.thumb, this.pre + "-thumb-loaded"))), t[t.firstChild ? "replaceChild" : "appendChild"](o.thumb, t.firstChild), t.media = n, s) {
                            var r = new Image;
                            r.onload = function() {
                                i.addClass(o.thumb, this.pre + "-thumb-loaded")
                            }.bind(this), r.src = s
                        }
                    }, d.updateThumbs = function() {
                        var t = this.gallery;
                        if (this.options.thumbnails && !(t.initialLength < 2)) {
                            var e = this.thumbs,
                                n = this.getThumbPosition(e);
                            e.stopAnimate(), n !== e.position.x ? Math.abs(n - e.position.x) > 50 * e.size ? (this.DOM.thumbsHolder.style.visibility = "hidden", e.position.x = n, i.translate(this.DOM.thumbsInner, n, 0), this.renderThumbs(e), this.DOM.thumbsHolder.style.visibility = "") : (e.startAnimate(), e.releaseDrag(), e.animateTo({
                                x: n
                            })) : this.shiftThumbs(e)
                        }
                    }, d.updateCaption = function() {
                        if (this.options.caption) {
                            var t = this.getMedia(),
                                e = t.caption ? t.caption : "",
                                i = this.DOM.captionInner;
                            i.innerHTML !== e && (i.innerHTML = e)
                        }
                    }, d.updateCounter = function() {
                        if (this.options.counterMessage) {
                            var t = this.gallery,
                                e = t.initialLength,
                                n = i.modulo(e, t.index),
                                s = this.options.counterMessage.replace("[index]", n + 1).replace("[total]", e),
                                o = this.DOM.counter;
                            o.textContent !== s && (o.textContent = s)
                        }
                    }, d.wrapAround = function() {
                        var t = this.options.loop,
                            e = this.gallery,
                            n = e.length;
                        if (e.initialLength || (e.initialLength = n), this.states.loop = !!(t && t <= n), this.states.loop && n < this.slides.length)
                            for (var s = Math.ceil(this.slides.length / n) * n - n, o = 0; o < s; o++) {
                                var r = n + o;
                                e[r] = i.cloneObject(e[i.modulo(n, o)]), e[r].index = r
                            }
                    }, d.setSlider = function() {
                        var t = this.slider,
                            e = this.slides;
                        this.setSizes(t, e), this.setSliderPosition(t, e), this.setSlidesPositions(e), this.DOM.overlay.style.opacity = 1
                    }, d.setSizes = function(t, e) {
                        t.width = document.body.clientWidth, t.height = window.innerHeight, e.width = t.width + Math.round(t.width * this.options.spacing)
                    }, d.setSlidesPositions = function(t) {
                        for (var e = 0; e < t.length; e++) t[e].position = null, this.setCellPosition(e);
                        this.shiftSlides()
                    }, d.setThumbsPosition = function() {
                        if (this.options.thumbnails && !(this.gallery.initialLength < 2)) {
                            for (var t, e = this.thumbs, n = this.slider, s = this.DOM.thumbsHolder, o = this.DOM.thumbsInner, r = this.options.thumbnailSizes, a = this.options.rightToLeft, l = Object.keys(r).sort(function(t, e) {
                                    return e - t
                                }), h = Math.max.apply(null, l), c = window.innerWidth, d = 0; d < l.length; d++) c <= (t = Number(l[d])) && (h = t);
                            e.width = Number(r[h].width), e.gutter = Number(r[h].gutter), e.height = Number(r[h].height), e.size = e.width + e.gutter, e.length = this.gallery.initialLength;
                            var u = e.length * e.size;
                            e.bound = {
                                left: 0,
                                right: u > n.width ? n.width - u : 0
                            }, a && (e.bound.right = u > n.width ? n.width - e.size : u - e.size, e.bound.left = u - e.size), "centered" === this.options.thumbnailsNav && (e.bound = {
                                left: u > n.width ? Math.floor(.5 * n.width - .5 * e.size) : Math.floor(.5 * u - .5 * e.size),
                                right: u > n.width ? Math.ceil(.5 * n.width - u + .5 * e.size) : -Math.ceil(.5 * u - .5 * e.size)
                            }, a && (e.bound.right = e.bound.left, e.bound.left = e.bound.left + u - e.size)), e.resetAnimate();
                            var p = this.getThumbPosition(e);
                            e.position.x = p, i.translate(o, p, 0);
                            var f = this.getThumbHeight();
                            s.style.visibility = f ? "" : "hidden", s.style.height = f ? f + "px" : "", o.style.height = f ? e.height + Math.min(10, e.gutter) + "px" : "", o.style.width = e.length * e.size + "px", o.style.right = u > n.width && a ? "auto" : ""
                        }
                    }, d.getThumbPosition = function(t) {
                        var e = this.slider,
                            n = this.gallery,
                            s = this.options.thumbnailsNav,
                            o = this.isRTL(),
                            r = o < 0 ? "right" : "left",
                            a = i.modulo(n.initialLength, n.index),
                            l = .5 * e.width - .5 * t.size,
                            h = t.bound[r] - a * t.size * o;
                        return h = t.bound[r] ? h + (o < 0 && "centered" !== s ? -l : 0) : h + l, Math.max(t.bound.right, Math.min(t.bound.left, h))
                    }, d.setCellPosition = function(t) {
                        this.cells[t].resetAnimate(), i.translate(this.slides[t].children[0], 0, 0, 1)
                    }, d.setSliderPosition = function(t, e) {
                        var n = this.options.rightToLeft,
                            s = -e.index * e.width;
                        s = n ? -s : s, t.resetAnimate(), t.position.x = t.attraction.x = s, t.bound = {
                            left: 0,
                            right: -(this.gallery.length - 1) * e.width
                        }, n && (t.bound.left = -t.bound.right, t.bound.right = 0), i.translate(this.DOM.slider, s, 0)
                    }, d.setAnimation = function() {
                        var t = this.DOM.slider,
                            e = this.options.friction,
                            i = this.options.attraction;
                        this.slider = new s(t, {
                            x: 0,
                            y: 0
                        }, Math.min(Math.max(e.slider, 0), 1), Math.min(Math.max(i.slider, 0), 1)), this.slider.on("settle.toanimate", this.settleSider.bind(this)), this.slider.on("render.toanimate", this.renderSlider.bind(this));
                        for (var n = t.children, o = n.length, r = 0; r < o; r++) this.cells[r] = new s(n[r].children[0], {
                            x: 0,
                            y: 0,
                            s: 1
                        }, Math.min(Math.max(e.slide, 0), 1), Math.min(Math.max(i.slide, 0), 1)), this.cells[r].on("settle.toanimate", this.settleCell.bind(this)), this.cells[r].on("render.toanimate", this.renderCell.bind(this));
                        this.thumbs = new s(this.DOM.thumbsInner, {
                            x: 0
                        }, Math.min(Math.max(e.thumbs, 0), 1), Math.min(Math.max(i.thumbs, 0), 1)), this.thumbs.on("settle.toanimate", this.settleThumbs.bind(this)), this.thumbs.on("render.toanimate", this.renderThumbs.bind(this))
                    }, d.settleSider = function(t) {
                        var e;
                        if (i.dispatchEvent(this, "modulobox", "sliderSettled", t.position), this.states.open && (this.setMedia(), this.replaceState()), this.options.fadeIfSettle)
                            for (var n = this.slides, s = 0; s < n.length; s++) {
                                var o = n[s].media;
                                (e = this.gallery[o]).dom.loaded && this.showMedia(e, s)
                            }
                    }, d.settleCell = function(t) {
                        var e = this.gesture;
                        e.closeBy && i.dispatchEvent(this, "modulobox", "panYSettled", null, t.position), (e.closeBy && !1 === e.canClose || !e.closeBy) && i.dispatchEvent(this, "modulobox", "panZoomSettled", null, t.position)
                    }, d.settleThumbs = function(t) {
                        i.dispatchEvent(this, "modulobox", "thumbsSettled", null, t.position)
                    }, d.renderSlider = function(t) {
                        this.shiftSlides();
                        var e = this.isRTL(),
                            n = this.gallery.initialLength,
                            s = -e * t.position.x / this.slides.width,
                            o = i.modulo(n, s),
                            r = (o > n - .5 ? 0 : o) / (n - 1);
                        i.dispatchEvent(this, "modulobox", "sliderProgress", null, Math.min(1, Math.max(0, r)))
                    }, d.renderCell = function(t) {
                        var e;
                        this.willClose(t), ("panY" === this.gesture.type || this.gesture.closeBy || "dragSlider" === this.gesture.type && 0 !== t.position.y) && (e = 1 - Math.abs(t.position.y) / (.5 * this.slider.height), i.dispatchEvent(this, "modulobox", "panYProgress", null, e)), "panY" !== this.gesture.type && 1 !== t.position.s && (e = t.position.s, i.dispatchEvent(this, "modulobox", "panZoomProgress", null, e))
                    }, d.renderThumbs = function(t) {
                        this.shiftThumbs(t);
                        var e = t.bound.left !== t.bound.right ? (t.bound.left - t.position.x) / (t.bound.left - t.bound.right) : 0;
                        i.dispatchEvent(this, "modulobox", "thumbsProgress", null, e)
                    }, d.touchStart = function(t) {
                        var e = t.target,
                            n = e.tagName,
                            s = e.className;
                        if (3 !== t.which && e !== this.buttons.play && this.stopSlideShow(), 3 !== t.which && this.isEl(t) && !(["BUTTON", "VIDEO", "INPUT", "A"].indexOf(n) > -1) && ("IMG" === n && this.gallery.length > 1 && i.addClass(this.DOM.holder, this.pre + "-dragging"), t.preventDefault(), !i.hasClass(this.DOM.holder, this.pre + "-open-tooltip"))) {
                            if (this.pointers.length || (this.gesture.canClose = void 0, i.handleEvents(this, window, this.dragEvents.move, "touchMove"), i.handleEvents(this, window, this.dragEvents.end, "touchEnd")), this.addPointer(t), s.indexOf("-thumb") < 0) {
                                this.slider.stopAnimate();
                                var o = this.getCell();
                                (Math.round(100 * o.position.s) / 100 != 1 || 2 === this.pointers.length || this.gesture.closeBy) && o.stopAnimate()
                            } else this.thumbs.stopAnimate();
                            this.gestures("start")
                        }
                    }, d.touchMove = function(t) {
                        this.updatePointer(t);
                        var e = this.gesture,
                            n = this.pointers.length,
                            s = this.isSliderSettle();
                        if (this.switchPointers(), this.gestures("move"), e.type) this[e.type](t), i.dispatchEvent(this, "modulobox", e.type + "Move", t, e), e.move = !0;
                        else if (2 === n && s || Math.abs(e.dx) > this.options.threshold || Math.abs(e.dy) > this.options.threshold) {
                            if (e.sx += e.dx, e.sy += e.dy, e.canZoom = this.isZoomable(), e.closeBy = !1, e.type = !(Math.abs(e.dx) < Math.abs(e.dy) / 2) && "dragSlider", e.type = this.options.dragToClose && !e.type && s ? "panY" : e.type, e.type = (this.options.pinchToZoom || this.states.zoom) && e.canZoom && s && (2 === n || this.states.zoom) ? "panZoom" : e.type, e.type = this.options.pinchToClose && e.scale < 1 && s && 2 === n ? "panZoom" : e.type, e.type = t.target.className.indexOf("-thumb") > -1 ? "dragThumbs" : e.type, "dragSlider" === e.type && this.setMedia(), ["dragSlider", "dragThumbs"].indexOf(e.type) > -1) {
                                var o = this.getCell();
                                o.startAnimate(), o.releaseDrag(), o.animateTo({
                                    x: 0,
                                    y: 0,
                                    s: 1
                                })
                            }
                            if ("dragSlider" !== e.type) {
                                var r = this.slider,
                                    a = this.slides; - this.isRTL() * r.position.x != a.index * a.width && (r.startAnimate(), r.releaseDrag())
                            }
                            e.type && (this.pauseVideo(), i.dispatchEvent(this, "modulobox", e.type + "Start", t, e), (this.gallery.length > 1 || "dragSlider" !== e.type) && i.addClass(this.DOM.holder, this.pre + "-dragging"))
                        }
                    }, d.touchEnd = function(t) {
                        if (this.deletePointer(t), !this.pointers.length) {
                            if (i.removeClass(this.DOM.holder, this.pre + "-dragging"), i.handleEvents(this, window, this.dragEvents.move, "touchMove", !1), i.handleEvents(this, window, this.dragEvents.end, "touchEnd", !1), this.isSliderSettle()) {
                                var e = t.target.className;
                                if (i.hasClass(t.target, this.pre + "-video")) this.appendVideo();
                                else if (this.options.tapToClose && !this.states.zoom && (e === this.pre + "-item-inner" || e === this.pre + "-top-bar") && Math.abs(this.gesture.dx) < this.options.threshold) return void this.close();
                                "IMG" === t.target.tagName && this.doubleTap(t)
                            }
                            this.options.thumbnails && !this.gesture.move && this.thumbClick(t);
                            var n = this.gesture.type + "End";
                            if (this.gesture.type && "function" == typeof this[n] && (this[n](t), i.dispatchEvent(this, "modulobox", n, t, this.gesture)), this.gesture.type = this.gesture.move = !1, !this.states.open) return;
                            var s = this.getCell();
                            s.settle || (s.startAnimate(), s.releaseDrag());
                            var o = this.slider;
                            o.settle || (o.startAnimate(), o.releaseDrag())
                        }
                    }, d.switchPointers = function() {
                        if ("panZoom" === this.gesture.type && 1 === this.pointers.length && 0 !== this.gesture.distance) {
                            var t = this.getCell();
                            t.stopAnimate(), t.startAnimate(), this.gesture.move = !1, this.gestures("start"), this.gestures("move")
                        }
                    }, d.doubleTap = function(t) {
                        t.preventDefault();
                        var e = this.mapPointer(t),
                            n = e[0].clientX,
                            s = e[0].clientY;
                        void 0 !== this.tap && +new Date - this.tap.delay < 350 && Math.abs(this.tap.deltaX - n) < 30 && Math.abs(this.tap.deltaY - s) < 30 ? (this.states.tapIdle && clearTimeout(this.states.tapIdle), this.options.doubleTapToZoom && this.zoomTo(n, s), this.tap = void 0) : (this.browser.touchDevice && this.options.timeToIdle && !this.states.idle && (this.states.tapIdle = setTimeout(function() {
                            var t = i.hasClass(this.DOM.holder, this.pre + "-idle") ? "remove" : "add";
                            i[t + "Class"](this.DOM.holder, this.pre + "-idle")
                        }.bind(this), 350)), this.tap = {
                            delay: +new Date,
                            deltaX: e[0].clientX,
                            deltaY: e[0].clientY
                        })
                    }, d.isSliderSettle = function() {
                        if (this.gesture.type) return !1;
                        var t = this.isRTL(),
                            e = this.slides,
                            i = e.width;
                        return Math.abs(t * this.slider.position.x + e.index * i) / i * 100 <= 3
                    }, d.mapPointer = function(t) {
                        return t.touches ? t.changedTouches : [t]
                    }, d.addPointer = function(t) {
                        for (var e = this.mapPointer(t), i = 0; i < e.length; i++)
                            if (this.pointers.length < 2 && -1 === ["dragSlider", "panY", "dragThumbs"].indexOf(this.gesture.type)) {
                                var n = e[i],
                                    s = void 0 !== n.pointerId ? n.pointerId : n.identifier;
                                this.getPointer(s) || (this.pointers[this.pointers.length] = {
                                    id: s,
                                    x: Math.round(n.clientX),
                                    y: Math.round(n.clientY)
                                })
                            }
                    }, d.updatePointer = function(t) {
                        for (var e = this.mapPointer(t), i = 0; i < e.length; i++) {
                            var n = e[i],
                                s = void 0 !== n.pointerId ? n.pointerId : n.identifier,
                                o = this.getPointer(s);
                            o && (o.x = Math.round(n.clientX), o.y = Math.round(n.clientY))
                        }
                    }, d.deletePointer = function(t) {
                        for (var e = this.mapPointer(t), i = 0; i < e.length; i++)
                            for (var n = e[i], s = void 0 !== n.pointerId ? n.pointerId : n.identifier, o = 0; o < this.pointers.length; o++) this.pointers[o].id === s && this.pointers.splice(o, 1)
                    }, d.getPointer = function(t) {
                        for (var e in this.pointers)
                            if (this.pointers[e].id === t) return this.pointers[e];
                        return null
                    }, d.gestures = function(t) {
                        var e, i = this.gesture,
                            n = this.pointers;
                        if (n.length) {
                            if (i.direction = i.x ? n[0].x > i.x ? 1 : -1 : 0, i.x = n[0].x, i.y = n[0].y, 2 === n.length) {
                                var s = n[1].x,
                                    o = n[1].y;
                                e = this.getDistance([i.x, i.y], [s, o]), i.x = i.x - (i.x - s) / 2, i.y = i.y - (i.y - o) / 2
                            }
                            "start" === t ? (i.dx = 0, i.dy = 0, i.sx = i.x, i.sy = i.y, i.distance = e || 0) : (i.dx = i.x - i.sx, i.dy = i.y - i.sy, i.scale = e && i.distance ? e / i.distance : 1)
                        }
                    }, d.getDistance = function(t, e) {
                        var i = e[0] - t[0],
                            n = e[1] - t[1];
                        return Math.sqrt(i * i + n * n)
                    }, d.panY = function() {
                        var t = this.getCell();
                        t.startAnimate(), t.updateDrag({
                            x: t.position.x,
                            y: t.start.y + this.gesture.dy,
                            s: t.position.s
                        })
                    }, d.panYEnd = function() {
                        var t = 0,
                            e = this.getCell(),
                            i = this.slider.height,
                            n = e.resting.y;
                        1 - Math.abs(n) / (.5 * i) < .8 && (t = Math.abs(n) < .5 * i ? Math.abs(n) / n * i * .5 : n, this.close(), e.animateTo({
                            x: 0,
                            y: t,
                            s: t ? e.resting.s : 1
                        }), e.startAnimate(), e.releaseDrag())
                    }, d.panZoom = function() {
                        var t = this.getCell(),
                            e = this.gesture,
                            i = this.mediaViewport(t.position.s),
                            n = this.options.pinchToClose && e.canClose ? .1 : .6,
                            s = Math.min(1.5 * this.options.maxZoom, Math.max(n, t.start.s * e.scale)),
                            o = t.start.x + e.dx,
                            r = t.start.y + e.dy,
                            a = e.sx - .5 * this.slider.width,
                            l = e.sy - .5 * this.slider.height;
                        e.canZoom && (this.options.pinchToZoom || this.states.zoom) || (s = Math.min(1, s)), !this.options.pinchToZoom && this.states.zoom && (s = t.position.s), e.move || 1 !== this.pointers.length || (t.start.x += o > i.left ? o - i.left : o < i.right ? o - i.right : 0, t.start.y += r > i.bottom ? r - i.bottom : r < i.top ? r - i.top : 0), o = e.dx + a + (t.start.x - a) * (s / t.start.s), r = e.dy + l + (t.start.y - l) * (s / t.start.s), 1 === this.pointers.length && (o = o > i.left ? .5 * (o + i.left) : o < i.right ? .5 * (o + i.right) : o, r = r > i.bottom ? .5 * (r + i.bottom) : r < i.top ? .5 * (r + i.top) : r), t.startAnimate(), t.updateDrag({
                            x: o,
                            y: r,
                            s: s
                        }), this.updateZoom(s)
                    }, d.panZoomEnd = function() {
                        var t, e, i = this.getCell(),
                            n = this.gesture,
                            s = i.resting.s > this.options.maxZoom ? this.options.maxZoom : i.resting.s < 1 ? 1 : i.resting.s,
                            o = this.mediaViewport(s);
                        if (Math.round(10 * i.resting.s) / 10 > this.options.maxZoom) {
                            var r = n.distance ? n.sx - .5 * this.slider.width : 0,
                                a = n.distance ? n.sy - .5 * this.slider.height : 0;
                            t = n.dx + r + (i.start.x - r) * (s / i.start.s), e = n.dy + a + (i.start.y - a) * (s / i.start.s), t = t > o.left ? o.left : t < o.right ? o.right : t, e = e > o.bottom ? o.bottom : e < o.top ? o.top : e
                        } else t = i.resting.x > o.left ? o.left : i.resting.x < o.right ? o.right : void 0, e = i.resting.y > o.bottom ? o.bottom : i.resting.y < o.top ? o.top : void 0;
                        this.options.pinchToClose && i.resting.s < .8 && n.canClose && (s = i.resting.s < .3 ? i.resting.s : .15, t = i.resting.x, e = i.resting.y, this.close()), i.animateTo({
                            x: t,
                            y: e,
                            s: s !== i.resting.s ? s : void 0
                        }), i.startAnimate(), i.releaseDrag(), this.updateZoom(i.resting.s)
                    }, d.dragThumbs = function() {
                        var t = this.thumbs,
                            e = t.bound,
                            i = t.start.x + this.gesture.dx;
                        this.gesture.move || (t.start.x += i > e.left ? i - e.left : i < e.right ? i - e.right : 0, i = t.start.x + this.gesture.dx), i = i > e.left ? .5 * (i + e.left) : i < e.right ? .5 * (i + e.right) : i, t.startAnimate(), t.attraction.x = void 0, t.updateDrag({
                            x: i
                        })
                    }, d.dragThumbsEnd = function() {
                        var t = this.thumbs,
                            e = t.bound,
                            i = t.resting.x;
                        (i = i > e.left ? e.left : i < e.right ? e.right : i) !== t.resting.x && t.animateTo({
                            x: i
                        }), t.startAnimate(), t.releaseDrag()
                    }, d.dragSlider = function() {
                        if (1 !== this.gallery.length) {
                            var t = this.slider,
                                e = t.start.x + this.gesture.dx;
                            if (!this.states.loop) {
                                var i = t.bound;
                                this.gesture.move || (t.start.x += e > i.left ? e - i.left : e < i.right ? e - i.right : 0, e = t.start.x + this.gesture.dx), e = e > i.left ? .5 * (e + i.left) : e < i.right ? .5 * (e + i.right) : e
                            }
                            t.startAnimate(), t.updateDrag({
                                x: e
                            })
                        }
                    }, d.dragSliderEnd = function() {
                        if (1 !== this.gallery.length) {
                            var t = this.slider,
                                e = this.slides,
                                i = e.index,
                                n = this.isRTL(),
                                s = t.resting.x,
                                o = t.position.x;
                            this.getRestingIndex(o, s), i !== e.index && this.updateMediaInfo(), this.slider.animateTo({
                                x: -n * e.index * e.width,
                                y: void 0,
                                s: void 0
                            }), t.startAnimate(), t.releaseDrag()
                        }
                    }, d.getRestingIndex = function(t, e) {
                        var i = this.gesture.direction,
                            n = this.gallery,
                            s = this.slides,
                            o = this.gesture.dx,
                            r = this.isRTL(),
                            a = Math.round(-r * t / s.width),
                            l = Math.abs(e - t);
                        Math.abs(o) < .5 * s.width && l && (o > 0 && i > 0 ? a -= 1 * r : o < 0 && i < 0 && (a += 1 * r));
                        var h = Math.max(-1, Math.min(1, a - s.index));
                        !this.states.loop && (n.index + h < 0 || n.index + h > n.length - 1) || (s.index += h)
                    }, d.shiftSlides = function() {
                        var t = this.slides,
                            e = this.gallery,
                            n = this.states.loop,
                            s = this.isRTL(),
                            o = s * Math.round(-this.slider.position.x / t.width) - 2,
                            r = o + 5;
                        !n && r > e.initialLength - 1 && (r = 5 + (o = e.initialLength - 5)), !n && o < 0 && (o = 0, r = 5);
                        for (var a = o; a < r; a++) {
                            var l = s * a * t.width,
                                h = t[i.modulo(t.length, a)];
                            h.index === a && h.position === l || (h.index = a, h.position = l, h.style.left = l + "px")
                        }
                        this.states.open && this.setMedia(3)
                    }, d.shiftThumbs = function(t) {
                        var e = this.DOM.thumbsInner.children,
                            n = this.slider,
                            s = this.gallery,
                            o = this.isRTL(),
                            r = e.length,
                            a = i.modulo(s.initialLength, s.index),
                            l = t.size * r * .5,
                            h = Math.round((-o * t.position.x + o * l * .5) / t.size),
                            c = Math.max(0, h - Math.floor(r / 2)),
                            d = c + r,
                            u = .5 * n.width,
                            p = t.position.x + u,
                            f = t.position.x - n.width - u;
                        d > s.initialLength && (c = (d = s.initialLength) - r), d === s.initialLength - 1 && c - d < r && (c = s.initialLength - r);
                        for (var m = c; m < d; m++) {
                            var g = e[i.modulo(r, m)],
                                v = o * m * t.size + .5 * t.gutter,
                                y = this.pre + "-active-thumb",
                                _ = i.hasClass(g, y);
                            g.index === m && g.position === v || (g.index = m, g.position = v, g.style.left = v + "px"), this.setThumbSize(g, t), -g.position <= p && -g.position >= f && g.media !== m && this.loadThumb(g, m), _ && a !== m ? i.removeClass(g, y) : _ || a !== m || i.addClass(g, y)
                        }
                    }, d.setThumbSize = function(t, e) {
                        t.width === e.width && t.height === e.height && t.gutter === e.gutter || (t.width = e.width, t.height = e.height, t.gutter = e.gutter, t.style.width = e.width + "px", t.style.height = e.height + "px")
                    }, d.willClose = function(t) {
                        var e = this.DOM.overlay.style.opacity,
                            n = this.gesture.canClose,
                            s = this.gesture.type,
                            o = this.gesture.closeBy,
                            r = "panZoom" === s || "panZoom" === o,
                            a = "panY" === s || "panY" === o;
                        t.position.s > 1.1 && void 0 === n ? this.gesture.canClose = !1 : t.position.s < 1 && void 0 === n && (this.gesture.canClose = !0), this.options.pinchToClose && r && this.gesture.canClose ? (e = t.position.s, this.gesture.closeBy = "panZoom") : a ? (e = 1 - Math.abs(t.position.y) / (.5 * this.slider.height), this.gesture.closeBy = "panY") : e && e < 1 && (e = 1, this.gesture.closeBy = !1), e = e ? Math.max(0, Math.min(1, e)) : 1, i[(e <= .8 || !e ? "add" : "remove") + "Class"](this.DOM.holder, this.pre + "-will-close"), this.DOM.overlay.style.opacity = e
                    }, d.prev = i.throttle(function() {
                        this.gesture.move || this.slideTo(this.slides.index - 1 * this.isRTL())
                    }, 120), d.next = i.throttle(function() {
                        this.gesture.move || this.slideTo(this.slides.index + 1 * this.isRTL())
                    }, 120), d.slideTo = function(t, e) {
                        var n = this.slides,
                            s = this.gallery,
                            o = this.DOM.slider,
                            r = this.isRTL(),
                            a = s.initialLength,
                            l = i.modulo(a, t),
                            h = l - i.modulo(a, s.index),
                            c = a - Math.abs(h);
                        if ((this.states.loop || !(t < 0 || t > this.gallery.initialLength - 1)) && (this.states.loop && c < 3 && 2 * c < a && (h = h < 0 ? c : -c), l === t && (t = n.index + h), h = t - n.index)) {
                            this.states.zoom && this.zoom(), this.pauseVideo(), this.share(), e || this.stopSlideShow(), n.index = t;
                            var d = this.slider;
                            if (Math.abs(h) > 2) {
                                i.addClass(o, this.pre + "-hide"), this.setSliderPosition(d, n), this.setSlidesPositions(n);
                                var u = r * n.width * Math.min(2, Math.abs(h)) * Math.abs(h) / h;
                                d.position.x = d.attraction.x = d.position.x + u, i.translate(o, d.position.x, 0), o.getClientRects()
                            }
                            this.updateMediaInfo(), i.removeClass(o, this.pre + "-hide"), d.startAnimate(), d.releaseDrag(), d.animateTo({
                                x: -r * t * n.width,
                                y: 0,
                                s: void 0
                            })
                        }
                    }, d.keyDown = function(t) {
                        var e = t.keyCode,
                            i = this.options;
                        if (i.prevNextKey && (37 === e ? this.prev(t) : 39 === e && this.next(t)), 27 === e && i.escapeToClose && this.close(), !i.mouseWheel && [32, 33, 34, 35, 36, 38, 40].indexOf(e) > -1) return t.preventDefault(), !1
                    }, d.zoom = function() {
                        this.zoomTo()
                    }, d.zoomTo = function(t, e, i) {
                        if (!(!this.isSliderSettle() || !this.isZoomable() && i > 1)) {
                            this.gesture.closeBy = !1;
                            var n = this.getMedia();
                            i = i || (this.states.zoom ? 1 : n.dom.size.scale);
                            var s = this.getCell(),
                                o = this.mediaViewport(i),
                                r = t ? t - .5 * this.slider.width : 0,
                                a = e ? e - .5 * this.slider.height : 0,
                                l = i > 1 ? Math.ceil(r + (s.position.x - r) * (i / s.position.s)) : 0,
                                h = i > 1 ? Math.ceil(a + (s.position.y - a) * (i / s.position.s)) : 0;
                            s.startAnimate(), s.releaseDrag(), s.animateTo({
                                x: l > o.left ? o.left : l < o.right ? o.right : l,
                                y: h > o.bottom ? o.bottom : h < o.top ? o.top : h,
                                s: i
                            }), this.updateZoom(i)
                        }
                    }, d.updateZoom = function(t) {
                        this.states.zoom = t > 1, i[this.states.zoom ? "addClass" : "removeClass"](this.DOM.holder, this.pre + "-panzoom")
                    }, d.destroy = function() {
                        if (this.GUID) {
                            this.states.open && this.close();
                            var t = this.options.mediaSelector,
                                e = "";
                            try {
                                e = document.querySelectorAll(t)
                            } catch (t) {}
                            for (var i = 0, n = e.length; i < n; i++) {
                                var s = e[i];
                                s.mobxListener && s.removeEventListener("click", s.mobxListener, !1)
                            }
                            for (this.bindEvents(!1), this.slider.resetAnimate(), i = 0; i < this.slides.length; i++) this.cells[i].resetAnimate();
                            this.thumbs && this.thumbs.resetAnimate(), this.DOM.holder.parentNode.removeChild(this.DOM.holder), this.DOM.comment.parentNode.removeChild(this.DOM.comment), delete r[this.GUID], delete this.DOM.holder.GUID, delete this.GUID
                        }
                    }, void 0 !== t && function(t) {
                        t.ModuloBox = function(t) {
                            return new c(t)
                        }
                    }(t);
                    return c
                }(i.ThemeoneUtils, i.ThemeoneEvent, i.ThemeoneAnimate)
            }(window)
    }).call(this, i(3))
  }, function(t, e, i) {
    i(50)("asyncIterator")
  }, function(t, e, i) {
    "use strict";
    var n = i(4),
        s = i(11),
        o = i(6),
        r = i(2),
        a = i(10),
        l = i(83).KEY,
        h = i(7),
        c = i(30),
        d = i(36),
        u = i(14),
        p = i(1),
        f = i(51),
        m = i(50),
        g = i(84),
        v = i(48),
        y = i(13),
        _ = i(8),
        b = i(12),
        w = i(21),
        x = i(22),
        T = i(26),
        E = i(88),
        C = i(40),
        S = i(5),
        D = i(17),
        I = C.f,
        M = S.f,
        O = E.f,
        k = n.Symbol,
        A = n.JSON,
        P = A && A.stringify,
        $ = p("_hidden"),
        L = p("toPrimitive"),
        N = {}.propertyIsEnumerable,
        z = c("symbol-registry"),
        F = c("symbols"),
        H = c("op-symbols"),
        R = Object.prototype,
        j = "function" == typeof k,
        W = n.QObject,
        B = !W || !W.prototype || !W.prototype.findChild,
        V = o && h(function() {
            return 7 != T(M({}, "a", {
                get: function() {
                    return M(this, "a", {
                        value: 7
                    }).a
                }
            })).a
        }) ? function(t, e, i) {
            var n = I(R, e);
            n && delete R[e], M(t, e, i), n && t !== R && M(R, e, n)
        } : M,
        q = function(t) {
            var e = F[t] = T(k.prototype);
            return e._k = t, e
        },
        G = j && "symbol" == typeof k.iterator ? function(t) {
            return "symbol" == typeof t
        } : function(t) {
            return t instanceof k
        },
        U = function(t, e, i) {
            return t === R && U(H, e, i), y(t), e = w(e, !0), y(i), s(F, e) ? (i.enumerable ? (s(t, $) && t[$][e] && (t[$][e] = !1), i = T(i, {
                enumerable: x(0, !1)
            })) : (s(t, $) || M(t, $, x(1, {})), t[$][e] = !0), V(t, e, i)) : M(t, e, i)
        },
        Y = function(t, e) {
            y(t);
            for (var i, n = g(e = b(e)), s = 0, o = n.length; o > s;) U(t, i = n[s++], e[i]);
            return t
        },
        X = function(t) {
            var e = N.call(this, t = w(t, !0));
            return !(this === R && s(F, t) && !s(H, t)) && (!(e || !s(this, t) || !s(F, t) || s(this, $) && this[$][t]) || e)
        },
        K = function(t, e) {
            if (t = b(t), e = w(e, !0), t !== R || !s(F, e) || s(H, e)) {
                var i = I(t, e);
                return !i || !s(F, e) || s(t, $) && t[$][e] || (i.enumerable = !0), i
            }
        },
        Q = function(t) {
            for (var e, i = O(b(t)), n = [], o = 0; i.length > o;) s(F, e = i[o++]) || e == $ || e == l || n.push(e);
            return n
        },
        Z = function(t) {
            for (var e, i = t === R, n = O(i ? H : b(t)), o = [], r = 0; n.length > r;) !s(F, e = n[r++]) || i && !s(R, e) || o.push(F[e]);
            return o
        };
    j || (a((k = function() {
        if (this instanceof k) throw TypeError("Symbol is not a constructor!");
        var t = u(arguments.length > 0 ? arguments[0] : void 0),
            e = function(i) {
                this === R && e.call(H, i), s(this, $) && s(this[$], t) && (this[$][t] = !1), V(this, t, x(1, i))
            };
        return o && B && V(R, t, {
            configurable: !0,
            set: e
        }), q(t)
    }).prototype, "toString", function() {
        return this._k
    }), C.f = K, S.f = U, i(27).f = E.f = Q, i(39).f = X, i(54).f = Z, o && !i(24) && a(R, "propertyIsEnumerable", X, !0), f.f = function(t) {
        return q(p(t))
    }), r(r.G + r.W + r.F * !j, {
        Symbol: k
    });
    for (var J = "hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","), tt = 0; J.length > tt;) p(J[tt++]);
    for (var et = D(p.store), it = 0; et.length > it;) m(et[it++]);
    r(r.S + r.F * !j, "Symbol", {
        for: function(t) {
            return s(z, t += "") ? z[t] : z[t] = k(t)
        },
        keyFor: function(t) {
            if (!G(t)) throw TypeError(t + " is not a symbol!");
            for (var e in z)
                if (z[e] === t) return e
        },
        useSetter: function() {
            B = !0
        },
        useSimple: function() {
            B = !1
        }
    }), r(r.S + r.F * !j, "Object", {
        create: function(t, e) {
            return void 0 === e ? T(t) : Y(T(t), e)
        },
        defineProperty: U,
        defineProperties: Y,
        getOwnPropertyDescriptor: K,
        getOwnPropertyNames: Q,
        getOwnPropertySymbols: Z
    }), A && r(r.S + r.F * (!j || h(function() {
        var t = k();
        return "[null]" != P([t]) || "{}" != P({
            a: t
        }) || "{}" != P(Object(t))
    })), "JSON", {
        stringify: function(t) {
            for (var e, i, n = [t], s = 1; arguments.length > s;) n.push(arguments[s++]);
            if (i = e = n[1], (_(e) || void 0 !== t) && !G(t)) return v(e) || (e = function(t, e) {
                if ("function" == typeof i && (e = i.call(this, t, e)), !G(e)) return e
            }), n[1] = e, P.apply(A, n)
        }
    }), k.prototype[L] || i(9)(k.prototype, L, k.prototype.valueOf), d(k, "Symbol"), d(Math, "Math", !0), d(n.JSON, "JSON", !0)
  }, function(t, e, i) {
    var n = i(14)("meta"),
        s = i(8),
        o = i(11),
        r = i(5).f,
        a = 0,
        l = Object.isExtensible || function() {
            return !0
        },
        h = !i(7)(function() {
            return l(Object.preventExtensions({}))
        }),
        c = function(t) {
            r(t, n, {
                value: {
                    i: "O" + ++a,
                    w: {}
                }
            })
        },
        d = t.exports = {
            KEY: n,
            NEED: !1,
            fastKey: function(t, e) {
                if (!s(t)) return "symbol" == typeof t ? t : ("string" == typeof t ? "S" : "P") + t;
                if (!o(t, n)) {
                    if (!l(t)) return "F";
                    if (!e) return "E";
                    c(t)
                }
                return t[n].i
            },
            getWeak: function(t, e) {
                if (!o(t, n)) {
                    if (!l(t)) return !0;
                    if (!e) return !1;
                    c(t)
                }
                return t[n].w
            },
            onFreeze: function(t) {
                return h && d.NEED && l(t) && !o(t, n) && c(t), t
            }
        }
  }, function(t, e, i) {
    var n = i(17),
        s = i(54),
        o = i(39);
    t.exports = function(t) {
        var e = n(t),
            i = s.f;
        if (i)
            for (var r, a = i(t), l = o.f, h = 0; a.length > h;) l.call(t, r = a[h++]) && e.push(r);
        return e
    }
  }, function(t, e, i) {
    var n = i(35),
        s = Math.max,
        o = Math.min;
    t.exports = function(t, e) {
        return (t = n(t)) < 0 ? s(t + e, 0) : o(t, e)
    }
  }, function(t, e, i) {
    var n = i(5),
        s = i(13),
        o = i(17);
    t.exports = i(6) ? Object.defineProperties : function(t, e) {
        s(t);
        for (var i, r = o(e), a = r.length, l = 0; a > l;) n.f(t, i = r[l++], e[i]);
        return t
    }
  }, function(t, e, i) {
    var n = i(4).document;
    t.exports = n && n.documentElement
  }, function(t, e, i) {
    var n = i(12),
        s = i(27).f,
        o = {}.toString,
        r = "object" == typeof window && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
    t.exports.f = function(t) {
        return r && "[object Window]" == o.call(t) ? function(t) {
            try {
                return s(t)
            } catch (t) {
                return r.slice()
            }
        }(t) : s(n(t))
    }
  }, function(t, e, i) {
    "use strict";
    var n = i(2),
        s = i(32),
        o = i(25),
        r = i(7),
        a = [].sort,
        l = [1, 2, 3];
    n(n.P + n.F * (r(function() {
        l.sort(void 0)
    }) || !r(function() {
        l.sort(null)
    }) || !i(18)(a)), "Array", {
        sort: function(t) {
            return void 0 === t ? a.call(o(this)) : a.call(o(this), s(t))
        }
    })
  }, function(t, e, i) {
    "use strict";
    var n = i(2),
        s = i(33)(1);
    n(n.P + n.F * !i(18)([].map, !0), "Array", {
        map: function(t) {
            return s(this, t, arguments[1])
        }
    })
  }, function(t, e, i) {
    "use strict";
    var n = i(4),
        s = i(11),
        o = i(16),
        r = i(55),
        a = i(21),
        l = i(7),
        h = i(27).f,
        c = i(40).f,
        d = i(5).f,
        u = i(56).trim,
        p = n.Number,
        f = p,
        m = p.prototype,
        g = "Number" == o(i(26)(m)),
        v = "trim" in String.prototype,
        y = function(t) {
            var e = a(t, !1);
            if ("string" == typeof e && e.length > 2) {
                var i, n, s, o = (e = v ? e.trim() : u(e, 3)).charCodeAt(0);
                if (43 === o || 45 === o) {
                    if (88 === (i = e.charCodeAt(2)) || 120 === i) return NaN
                } else if (48 === o) {
                    switch (e.charCodeAt(1)) {
                        case 66:
                        case 98:
                            n = 2, s = 49;
                            break;
                        case 79:
                        case 111:
                            n = 8, s = 55;
                            break;
                        default:
                            return +e
                    }
                    for (var r, l = e.slice(2), h = 0, c = l.length; h < c; h++)
                        if ((r = l.charCodeAt(h)) < 48 || r > s) return NaN;
                    return parseInt(l, n)
                }
            }
            return +e
        };
    if (!p(" 0o1") || !p("0b1") || p("+0x1")) {
        p = function(t) {
            var e = arguments.length < 1 ? 0 : t,
                i = this;
            return i instanceof p && (g ? l(function() {
                m.valueOf.call(i)
            }) : "Number" != o(i)) ? r(new f(y(e)), i, p) : y(e)
        };
        for (var _, b = i(6) ? h(f) : "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger".split(","), w = 0; b.length > w; w++) s(f, _ = b[w]) && !s(p, _) && d(p, _, c(f, _));
        p.prototype = m, m.constructor = p, i(10)(n, "Number", p)
    }
  }, function(t, e, i) {
    var n = i(8),
        s = i(13),
        o = function(t, e) {
            if (s(t), !n(e) && null !== e) throw TypeError(e + ": can't set as prototype!")
        };
    t.exports = {
        set: Object.setPrototypeOf || ("__proto__" in {} ? function(t, e, n) {
            try {
                (n = i(31)(Function.call, i(40).f(Object.prototype, "__proto__").set, 2))(t, []), e = !(t instanceof Array)
            } catch (t) {
                e = !0
            }
            return function(t, i) {
                return o(t, i), e ? t.__proto__ = i : n(t, i), t
            }
        }({}, !1) : void 0),
        check: o
    }
  }, function(t, e) {
    t.exports = "\t\n\v\f\r   ᠎             　\u2028\u2029\ufeff"
  }, function(t, e, i) {
    i(20)("search", 1, function(t, e, i) {
        return [function(i) {
            "use strict";
            var n = t(this),
                s = void 0 == i ? void 0 : i[e];
            return void 0 !== s ? s.call(i, n) : new RegExp(i)[e](String(n))
        }, i]
    })
  }, function(t, e, i) {
    "use strict";
    i(56)("trim", function(t) {
        return function() {
            return t(this, 3)
        }
    })
  }, function(t, e, i) {
    "use strict";
    var n = i(2),
        s = i(12),
        o = i(35),
        r = i(34),
        a = [].lastIndexOf,
        l = !!a && 1 / [1].lastIndexOf(1, -0) < 0;
    n(n.P + n.F * (l || !i(18)(a)), "Array", {
        lastIndexOf: function(t) {
            if (l) return a.apply(this, arguments) || 0;
            var e = s(this),
                i = r(e.length),
                n = i - 1;
            for (arguments.length > 1 && (n = Math.min(n, o(arguments[1]))), n < 0 && (n = i + n); n >= 0; n--)
                if (n in e && e[n] === t) return n || 0;
            return -1
        }
    })
  }, function(t, e, i) {
    i(20)("split", 2, function(t, e, n) {
        "use strict";
        var s = i(57),
            o = n,
            r = [].push;
        if ("c" == "abbc".split(/(b)*/)[1] || 4 != "test".split(/(?:)/, -1).length || 2 != "ab".split(/(?:ab)*/).length || 4 != ".".split(/(.?)(.?)/).length || ".".split(/()()/).length > 1 || "".split(/.?/).length) {
            var a = void 0 === /()??/.exec("")[1];
            n = function(t, e) {
                var i = String(this);
                if (void 0 === t && 0 === e) return [];
                if (!s(t)) return o.call(i, t, e);
                var n, l, h, c, d, u = [],
                    p = (t.ignoreCase ? "i" : "") + (t.multiline ? "m" : "") + (t.unicode ? "u" : "") + (t.sticky ? "y" : ""),
                    f = 0,
                    m = void 0 === e ? 4294967295 : e >>> 0,
                    g = new RegExp(t.source, p + "g");
                for (a || (n = new RegExp("^" + g.source + "$(?!\\s)", p));
                    (l = g.exec(i)) && !((h = l.index + l[0].length) > f && (u.push(i.slice(f, l.index)), !a && l.length > 1 && l[0].replace(n, function() {
                        for (d = 1; d < arguments.length - 2; d++) void 0 === arguments[d] && (l[d] = void 0)
                    }), l.length > 1 && l.index < i.length && r.apply(u, l.slice(1)), c = l[0].length, f = h, u.length >= m));) g.lastIndex === l.index && g.lastIndex++;
                return f === i.length ? !c && g.test("") || u.push("") : u.push(i.slice(f)), u.length > m ? u.slice(0, m) : u
            }
        } else "0".split(void 0, 0).length && (n = function(t, e) {
            return void 0 === t && 0 === e ? [] : o.call(this, t, e)
        });
        return [function(i, s) {
            var o = t(this),
                r = void 0 == i ? void 0 : i[e];
            return void 0 !== r ? r.call(i, o, s) : n.call(String(o), i, s)
        }, n]
    })
  }, function(t, e, i) {
    var n = i(5).f,
        s = Function.prototype,
        o = /^\s*function ([^ (]*)/;
    "name" in s || i(6) && n(s, "name", {
        configurable: !0,
        get: function() {
            try {
                return ("" + this).match(o)[1]
            } catch (t) {
                return ""
            }
        }
    })
  }, function(t, e, i) {
    for (var n = i(58), s = i(17), o = i(10), r = i(4), a = i(9), l = i(41), h = i(1), c = h("iterator"), d = h("toStringTag"), u = l.Array, p = {
            CSSRuleList: !0,
            CSSStyleDeclaration: !1,
            CSSValueList: !1,
            ClientRectList: !1,
            DOMRectList: !1,
            DOMStringList: !1,
            DOMTokenList: !0,
            DataTransferItemList: !1,
            FileList: !1,
            HTMLAllCollection: !1,
            HTMLCollection: !1,
            HTMLFormElement: !1,
            HTMLSelectElement: !1,
            MediaList: !0,
            MimeTypeArray: !1,
            NamedNodeMap: !1,
            NodeList: !0,
            PaintRequestList: !1,
            Plugin: !1,
            PluginArray: !1,
            SVGLengthList: !1,
            SVGNumberList: !1,
            SVGPathSegList: !1,
            SVGPointList: !1,
            SVGStringList: !1,
            SVGTransformList: !1,
            SourceBufferList: !1,
            StyleSheetList: !0,
            TextTrackCueList: !1,
            TextTrackList: !1,
            TouchList: !1
        }, f = s(p), m = 0; m < f.length; m++) {
        var g, v = f[m],
            y = p[v],
            _ = r[v],
            b = _ && _.prototype;
        if (b && (b[c] || a(b, c, u), b[d] || a(b, d, v), l[v] = u, y))
            for (g in n) b[g] || o(b, g, n[g], !0)
    }
  }, function(t, e) {
    t.exports = function(t, e) {
        return {
            value: e,
            done: !!t
        }
    }
  }, function(t, e, i) {
    "use strict";
    var n = i(24),
        s = i(2),
        o = i(10),
        r = i(9),
        a = i(41),
        l = i(102),
        h = i(36),
        c = i(103),
        d = i(1)("iterator"),
        u = !([].keys && "next" in [].keys()),
        p = function() {
            return this
        };
    t.exports = function(t, e, i, f, m, g, v) {
        l(i, e, f);
        var y, _, b, w = function(t) {
                if (!u && t in C) return C[t];
                switch (t) {
                    case "keys":
                    case "values":
                        return function() {
                            return new i(this, t)
                        }
                }
                return function() {
                    return new i(this, t)
                }
            },
            x = e + " Iterator",
            T = "values" == m,
            E = !1,
            C = t.prototype,
            S = C[d] || C["@@iterator"] || m && C[m],
            D = S || w(m),
            I = m ? T ? w("entries") : D : void 0,
            M = "Array" == e && C.entries || S;
        if (M && (b = c(M.call(new t))) !== Object.prototype && b.next && (h(b, x, !0), n || "function" == typeof b[d] || r(b, d, p)), T && S && "values" !== S.name && (E = !0, D = function() {
                return S.call(this)
            }), n && !v || !u && !E && C[d] || r(C, d, D), a[e] = D, a[x] = p, m)
            if (y = {
                    values: T ? D : w("values"),
                    keys: g ? D : w("keys"),
                    entries: I
                }, v)
                for (_ in y) _ in C || o(C, _, y[_]);
            else s(s.P + s.F * (u || E), e, y);
        return y
    }
  }, function(t, e, i) {
    "use strict";
    var n = i(26),
        s = i(22),
        o = i(36),
        r = {};
    i(9)(r, i(1)("iterator"), function() {
        return this
    }), t.exports = function(t, e, i) {
        t.prototype = n(r, {
            next: s(1, i)
        }), o(t, e + " Iterator")
    }
  }, function(t, e, i) {
    var n = i(11),
        s = i(25),
        o = i(37)("IE_PROTO"),
        r = Object.prototype;
    t.exports = Object.getPrototypeOf || function(t) {
        return t = s(t), n(t, o) ? t[o] : "function" == typeof t.constructor && t instanceof t.constructor ? t.constructor.prototype : t instanceof Object ? r : null
    }
  }, function(t, e, i) {
    "use strict";
    var n = i(105),
        s = {};
    s[i(1)("toStringTag")] = "z", s + "" != "[object z]" && i(10)(Object.prototype, "toString", function() {
        return "[object " + n(this) + "]"
    }, !0)
  }, function(t, e, i) {
    var n = i(16),
        s = i(1)("toStringTag"),
        o = "Arguments" == n(function() {
            return arguments
        }());
    t.exports = function(t) {
        var e, i, r;
        return void 0 === t ? "Undefined" : null === t ? "Null" : "string" == typeof(i = function(t, e) {
            try {
                return t[e]
            } catch (t) {}
        }(e = Object(t), s)) ? i : o ? n(e) : "Object" == (r = n(e)) && "function" == typeof e.callee ? "Arguments" : r
    }
  }, function(t, e, i) {
    var n = i(25),
        s = i(17);
    i(107)("keys", function() {
        return function(t) {
            return s(n(t))
        }
    })
  }, function(t, e, i) {
    var n = i(2),
        s = i(15),
        o = i(7);
    t.exports = function(t, e) {
        var i = (s.Object || {})[t] || Object[t],
            r = {};
        r[t] = e(i), n(n.S + n.F * o(function() {
            i(1)
        }), "Object", r)
    }
  }, function(t, e, i) {
    var n = i(2);
    n(n.S, "Object", {
        create: i(26)
    })
  }, function(t, e, i) {
    "use strict";
    var n = i(2),
        s = i(53)(!1),
        o = [].indexOf,
        r = !!o && 1 / [1].indexOf(1, -0) < 0;
    n(n.P + n.F * (r || !i(18)(o)), "Array", {
        indexOf: function(t) {
            return r ? o.apply(this, arguments) || 0 : s(this, t, arguments[1])
        }
    })
  }, function(t, e, i) {
    var n = i(4),
        s = i(55),
        o = i(5).f,
        r = i(27).f,
        a = i(57),
        l = i(111),
        h = n.RegExp,
        c = h,
        d = h.prototype,
        u = /a/g,
        p = /a/g,
        f = new h(u) !== u;
    if (i(6) && (!f || i(7)(function() {
            return p[i(1)("match")] = !1, h(u) != u || h(p) == p || "/a/i" != h(u, "i")
        }))) {
        h = function(t, e) {
            var i = this instanceof h,
                n = a(t),
                o = void 0 === e;
            return !i && n && t.constructor === h && o ? t : s(f ? new c(n && !o ? t.source : t, e) : c((n = t instanceof h) ? t.source : t, n && o ? l.call(t) : e), i ? this : d, h)
        };
        for (var m = function(t) {
                t in h || o(h, t, {
                    configurable: !0,
                    get: function() {
                        return c[t]
                    },
                    set: function(e) {
                        c[t] = e
                    }
                })
            }, g = r(c), v = 0; g.length > v;) m(g[v++]);
        d.constructor = h, h.prototype = d, i(10)(n, "RegExp", h)
    }
    i(112)("RegExp")
  }, function(t, e, i) {
    "use strict";
    var n = i(13);
    t.exports = function() {
        var t = n(this),
            e = "";
        return t.global && (e += "g"), t.ignoreCase && (e += "i"), t.multiline && (e += "m"), t.unicode && (e += "u"), t.sticky && (e += "y"), e
    }
  }, function(t, e, i) {
    "use strict";
    var n = i(4),
        s = i(5),
        o = i(6),
        r = i(1)("species");
    t.exports = function(t) {
        var e = n[t];
        o && e && !e[r] && s.f(e, r, {
            configurable: !0,
            get: function() {
                return this
            }
        })
    }
  }, function(t, e, i) {
    var n = i(2);
    n(n.S, "Date", {
        now: function() {
            return (new Date).getTime()
        }
    })
  }, function(t, e, i) {
    "use strict";
    var n = i(2),
        s = i(33)(0),
        o = i(18)([].forEach, !0);
    n(n.P + n.F * !o, "Array", {
        forEach: function(t) {
            return s(this, t, arguments[1])
        }
    })
  }, function(t, e, i) {
    var n = i(2);
    n(n.P, "Function", {
        bind: i(116)
    })
  }, function(t, e, i) {
    "use strict";
    var n = i(32),
        s = i(8),
        o = i(117),
        r = [].slice,
        a = {};
    t.exports = Function.bind || function(t) {
        var e = n(this),
            i = r.call(arguments, 1),
            l = function() {
                var n = i.concat(r.call(arguments));
                return this instanceof l ? function(t, e, i) {
                    if (!(e in a)) {
                        for (var n = [], s = 0; s < e; s++) n[s] = "a[" + s + "]";
                        a[e] = Function("F,a", "return new F(" + n.join(",") + ")")
                    }
                    return a[e](t, i)
                }(e, n.length, n) : o(e, n, t)
            };
        return s(e.prototype) && (l.prototype = e.prototype), l
    }
  }, function(t, e) {
    t.exports = function(t, e, i) {
        var n = void 0 === i;
        switch (e.length) {
            case 0:
                return n ? t() : t.call(i);
            case 1:
                return n ? t(e[0]) : t.call(i, e[0]);
            case 2:
                return n ? t(e[0], e[1]) : t.call(i, e[0], e[1]);
            case 3:
                return n ? t(e[0], e[1], e[2]) : t.call(i, e[0], e[1], e[2]);
            case 4:
                return n ? t(e[0], e[1], e[2], e[3]) : t.call(i, e[0], e[1], e[2], e[3])
        }
        return t.apply(i, e)
    }
  }, function(t, e, i) {
    var n, s;
    ! function(o, r) {
        n = [i(3)], void 0 === (s = function(t) {
            return function(t, e) {
                "use strict";
                var i = Array.prototype.slice,
                    n = t.console,
                    s = void 0 === n ? function() {} : function(t) {
                        n.error(t)
                    };
  
                function o(n, o, a) {
                    (a = a || e || t.jQuery) && (o.prototype.option || (o.prototype.option = function(t) {
                        a.isPlainObject(t) && (this.options = a.extend(!0, this.options, t))
                    }), a.fn[n] = function(t) {
                        if ("string" == typeof t) {
                            var e = i.call(arguments, 1);
                            return function(t, e, i) {
                                var o, r = "$()." + n + '("' + e + '")';
                                return t.each(function(t, l) {
                                    var h = a.data(l, n);
                                    if (h) {
                                        var c = h[e];
                                        if (c && "_" != e.charAt(0)) {
                                            var d = c.apply(h, i);
                                            o = void 0 === o ? d : o
                                        } else s(r + " is not a valid method")
                                    } else s(n + " not initialized. Cannot call methods, i.e. " + r)
                                }), void 0 !== o ? o : t
                            }(this, t, e)
                        }
                        return function(t, e) {
                            t.each(function(t, i) {
                                var s = a.data(i, n);
                                s ? (s.option(e), s._init()) : (s = new o(i, e), a.data(i, n, s))
                            })
                        }(this, t), this
                    }, r(a))
                }
  
                function r(t) {
                    !t || t && t.bridget || (t.bridget = o)
                }
                return r(e || t.jQuery), o
            }(o, t)
        }.apply(e, n)) || (t.exports = s)
    }(window)
  }, function(t, e, i) {
    var n, s;
    /*!
     * Isotope v3.0.6
     *
     * Licensed GPLv3 for open source use
     * or Isotope Commercial License for commercial use
     *
     * https://isotope.metafizzy.co
     * Copyright 2010-2018 Metafizzy
     */
    /*!
     * Isotope v3.0.6
     *
     * Licensed GPLv3 for open source use
     * or Isotope Commercial License for commercial use
     *
     * https://isotope.metafizzy.co
     * Copyright 2010-2018 Metafizzy
     */
    ! function(o, r) {
        n = [i(28), i(19), i(60), i(59), i(125), i(29), i(122), i(124), i(121)], void 0 === (s = function(t, e, i, n, s, r) {
            return function(t, e, i, n, s, o, r) {
                "use strict";
                var a = t.jQuery,
                    l = String.prototype.trim ? function(t) {
                        return t.trim()
                    } : function(t) {
                        return t.replace(/^\s+|\s+$/g, "")
                    },
                    h = e.create("isotope", {
                        layoutMode: "masonry",
                        isJQueryFiltering: !0,
                        sortAscending: !0
                    });
                h.Item = o, h.LayoutMode = r;
                var c = h.prototype;
                c._create = function() {
                    for (var t in this.itemGUID = 0, this._sorters = {}, this._getSorters(), e.prototype._create.call(this), this.modes = {}, this.filteredItems = this.items, this.sortHistory = ["original-order"], r.modes) this._initLayoutMode(t)
                }, c.reloadItems = function() {
                    this.itemGUID = 0, e.prototype.reloadItems.call(this)
                }, c._itemize = function() {
                    for (var t = e.prototype._itemize.apply(this, arguments), i = 0; i < t.length; i++) {
                        var n = t[i];
                        n.id = this.itemGUID++
                    }
                    return this._updateItemsSortData(t), t
                }, c._initLayoutMode = function(t) {
                    var e = r.modes[t],
                        i = this.options[t] || {};
                    this.options[t] = e.options ? s.extend(e.options, i) : i, this.modes[t] = new e(this)
                }, c.layout = function() {
                    this._isLayoutInited || !this._getOption("initLayout") ? this._layout() : this.arrange()
                }, c._layout = function() {
                    var t = this._getIsInstant();
                    this._resetLayout(), this._manageStamps(), this.layoutItems(this.filteredItems, t), this._isLayoutInited = !0
                }, c.arrange = function(t) {
                    this.option(t), this._getIsInstant();
                    var e = this._filter(this.items);
                    this.filteredItems = e.matches, this._bindArrangeComplete(), this._isInstant ? this._noTransition(this._hideReveal, [e]) : this._hideReveal(e), this._sort(), this._layout()
                }, c._init = c.arrange, c._hideReveal = function(t) {
                    this.reveal(t.needReveal), this.hide(t.needHide)
                }, c._getIsInstant = function() {
                    var t = this._getOption("layoutInstant"),
                        e = void 0 !== t ? t : !this._isLayoutInited;
                    return this._isInstant = e, e
                }, c._bindArrangeComplete = function() {
                    var t, e, i, n = this;
  
                    function s() {
                        t && e && i && n.dispatchEvent("arrangeComplete", null, [n.filteredItems])
                    }
                    this.once("layoutComplete", function() {
                        t = !0, s()
                    }), this.once("hideComplete", function() {
                        e = !0, s()
                    }), this.once("revealComplete", function() {
                        i = !0, s()
                    })
                }, c._filter = function(t) {
                    var e = this.options.filter;
                    e = e || "*";
                    for (var i = [], n = [], s = [], o = this._getFilterTest(e), r = 0; r < t.length; r++) {
                        var a = t[r];
                        if (!a.isIgnored) {
                            var l = o(a);
                            l && i.push(a), l && a.isHidden ? n.push(a) : l || a.isHidden || s.push(a)
                        }
                    }
                    return {
                        matches: i,
                        needReveal: n,
                        needHide: s
                    }
                }, c._getFilterTest = function(t) {
                    return a && this.options.isJQueryFiltering ? function(e) {
                        return a(e.element).is(t)
                    } : "function" == typeof t ? function(e) {
                        return t(e.element)
                    } : function(e) {
                        return n(e.element, t)
                    }
                }, c.updateSortData = function(t) {
                    var e;
                    t ? (t = s.makeArray(t), e = this.getItems(t)) : e = this.items, this._getSorters(), this._updateItemsSortData(e)
                }, c._getSorters = function() {
                    var t = this.options.getSortData;
                    for (var e in t) {
                        var i = t[e];
                        this._sorters[e] = d(i)
                    }
                }, c._updateItemsSortData = function(t) {
                    for (var e = t && t.length, i = 0; e && i < e; i++) {
                        var n = t[i];
                        n.updateSortData()
                    }
                };
                var d = function() {
                    return function(t) {
                        if ("string" != typeof t) return t;
                        var e = l(t).split(" "),
                            i = e[0],
                            n = i.match(/^\[(.+)\]$/),
                            s = function(t, e) {
                                if (t) return function(e) {
                                    return e.getAttribute(t)
                                };
                                return function(t) {
                                    var i = t.querySelector(e);
                                    return i && i.textContent
                                }
                            }(n && n[1], i),
                            o = h.sortDataParsers[e[1]];
                        return t = o ? function(t) {
                            return t && o(s(t))
                        } : function(t) {
                            return t && s(t)
                        }
                    }
                }();
                h.sortDataParsers = {
                    parseInt: function(t) {
                        return parseInt(t, 10)
                    },
                    parseFloat: function(t) {
                        return parseFloat(t)
                    }
                }, c._sort = function() {
                    if (this.options.sortBy) {
                        var t = s.makeArray(this.options.sortBy);
                        this._getIsSameSortBy(t) || (this.sortHistory = t.concat(this.sortHistory));
                        var e = function(t, e) {
                            return function(i, n) {
                                for (var s = 0; s < t.length; s++) {
                                    var o = t[s],
                                        r = i.sortData[o],
                                        a = n.sortData[o];
                                    if (r > a || r < a) {
                                        var l = void 0 !== e[o] ? e[o] : e,
                                            h = l ? 1 : -1;
                                        return (r > a ? 1 : -1) * h
                                    }
                                }
                                return 0
                            }
                        }(this.sortHistory, this.options.sortAscending);
                        this.filteredItems.sort(e)
                    }
                }, c._getIsSameSortBy = function(t) {
                    for (var e = 0; e < t.length; e++)
                        if (t[e] != this.sortHistory[e]) return !1;
                    return !0
                }, c._mode = function() {
                    var t = this.options.layoutMode,
                        e = this.modes[t];
                    if (!e) throw new Error("No layout mode: " + t);
                    return e.options = this.options[t], e
                }, c._resetLayout = function() {
                    e.prototype._resetLayout.call(this), this._mode()._resetLayout()
                }, c._getItemLayoutPosition = function(t) {
                    return this._mode()._getItemLayoutPosition(t)
                }, c._manageStamp = function(t) {
                    this._mode()._manageStamp(t)
                }, c._getContainerSize = function() {
                    return this._mode()._getContainerSize()
                }, c.needsResizeLayout = function() {
                    return this._mode().needsResizeLayout()
                }, c.appended = function(t) {
                    var e = this.addItems(t);
                    if (e.length) {
                        var i = this._filterRevealAdded(e);
                        this.filteredItems = this.filteredItems.concat(i)
                    }
                }, c.prepended = function(t) {
                    var e = this._itemize(t);
                    if (e.length) {
                        this._resetLayout(), this._manageStamps();
                        var i = this._filterRevealAdded(e);
                        this.layoutItems(this.filteredItems), this.filteredItems = i.concat(this.filteredItems), this.items = e.concat(this.items)
                    }
                }, c._filterRevealAdded = function(t) {
                    var e = this._filter(t);
                    return this.hide(e.needHide), this.reveal(e.matches), this.layoutItems(e.matches, !0), e.matches
                }, c.insert = function(t) {
                    var e = this.addItems(t);
                    if (e.length) {
                        var i, n, s = e.length;
                        for (i = 0; i < s; i++) n = e[i], this.element.appendChild(n.element);
                        var o = this._filter(e).matches;
                        for (i = 0; i < s; i++) e[i].isLayoutInstant = !0;
                        for (this.arrange(), i = 0; i < s; i++) delete e[i].isLayoutInstant;
                        this.reveal(o)
                    }
                };
                var u = c.remove;
                return c.remove = function(t) {
                    t = s.makeArray(t);
                    var e = this.getItems(t);
                    u.call(this, t);
                    for (var i = e && e.length, n = 0; i && n < i; n++) {
                        var o = e[n];
                        s.removeFrom(this.filteredItems, o)
                    }
                }, c.shuffle = function() {
                    for (var t = 0; t < this.items.length; t++) this.items[t].sortData.random = Math.random();
                    this.options.sortBy = "random", this._sort(), this._layout()
                }, c._noTransition = function(t, e) {
                    var i = this.options.transitionDuration;
                    this.options.transitionDuration = 0;
                    var n = t.apply(this, e);
                    return this.options.transitionDuration = i, n
                }, c.getFilteredItemElements = function() {
                    return this.filteredItems.map(function(t) {
                        return t.element
                    })
                }, h
            }(o, t, 0, i, n, s, r)
        }.apply(e, n)) || (t.exports = s)
    }(window)
  }, function(t, e, i) {
    var n, s, o;
    window, s = [i(42), i(19)], void 0 === (o = "function" == typeof(n = function(t, e) {
        "use strict";
        var i = document.documentElement.style,
            n = "string" == typeof i.transition ? "transition" : "WebkitTransition",
            s = "string" == typeof i.transform ? "transform" : "WebkitTransform",
            o = {
                WebkitTransition: "webkitTransitionEnd",
                transition: "transitionend"
            } [n],
            r = {
                transform: s,
                transition: n,
                transitionDuration: n + "Duration",
                transitionProperty: n + "Property",
                transitionDelay: n + "Delay"
            };
  
        function a(t, e) {
            t && (this.element = t, this.layout = e, this.position = {
                x: 0,
                y: 0
            }, this._create())
        }
        var l = a.prototype = Object.create(t.prototype);
        l.constructor = a, l._create = function() {
            this._transn = {
                ingProperties: {},
                clean: {},
                onEnd: {}
            }, this.css({
                position: "absolute"
            })
        }, l.handleEvent = function(t) {
            var e = "on" + t.type;
            this[e] && this[e](t)
        }, l.getSize = function() {
            this.size = e(this.element)
        }, l.css = function(t) {
            var e = this.element.style;
            for (var i in t) {
                var n = r[i] || i;
                e[n] = t[i]
            }
        }, l.getPosition = function() {
            var t = getComputedStyle(this.element),
                e = this.layout._getOption("originLeft"),
                i = this.layout._getOption("originTop"),
                n = t[e ? "left" : "right"],
                s = t[i ? "top" : "bottom"],
                o = parseFloat(n),
                r = parseFloat(s),
                a = this.layout.size; - 1 != n.indexOf("%") && (o = o / 100 * a.width), -1 != s.indexOf("%") && (r = r / 100 * a.height), o = isNaN(o) ? 0 : o, r = isNaN(r) ? 0 : r, o -= e ? a.paddingLeft : a.paddingRight, r -= i ? a.paddingTop : a.paddingBottom, this.position.x = o, this.position.y = r
        }, l.layoutPosition = function() {
            var t = this.layout.size,
                e = {},
                i = this.layout._getOption("originLeft"),
                n = this.layout._getOption("originTop"),
                s = i ? "paddingLeft" : "paddingRight",
                o = i ? "left" : "right",
                r = i ? "right" : "left",
                a = this.position.x + t[s];
            e[o] = this.getXValue(a), e[r] = "";
            var l = n ? "paddingTop" : "paddingBottom",
                h = n ? "top" : "bottom",
                c = n ? "bottom" : "top",
                d = this.position.y + t[l];
            e[h] = this.getYValue(d), e[c] = "", this.css(e), this.emitEvent("layout", [this])
        }, l.getXValue = function(t) {
            var e = this.layout._getOption("horizontal");
            return this.layout.options.percentPosition && !e ? t / this.layout.size.width * 100 + "%" : t + "px"
        }, l.getYValue = function(t) {
            var e = this.layout._getOption("horizontal");
            return this.layout.options.percentPosition && e ? t / this.layout.size.height * 100 + "%" : t + "px"
        }, l._transitionTo = function(t, e) {
            this.getPosition();
            var i = this.position.x,
                n = this.position.y,
                s = t == this.position.x && e == this.position.y;
            if (this.setPosition(t, e), !s || this.isTransitioning) {
                var o = t - i,
                    r = e - n,
                    a = {};
                a.transform = this.getTranslate(o, r), this.transition({
                    to: a,
                    onTransitionEnd: {
                        transform: this.layoutPosition
                    },
                    isCleaning: !0
                })
            } else this.layoutPosition()
        }, l.getTranslate = function(t, e) {
            var i = this.layout._getOption("originLeft"),
                n = this.layout._getOption("originTop");
            return "translate3d(" + (t = i ? t : -t) + "px, " + (e = n ? e : -e) + "px, 0)"
        }, l.goTo = function(t, e) {
            this.setPosition(t, e), this.layoutPosition()
        }, l.moveTo = l._transitionTo, l.setPosition = function(t, e) {
            this.position.x = parseFloat(t), this.position.y = parseFloat(e)
        }, l._nonTransition = function(t) {
            for (var e in this.css(t.to), t.isCleaning && this._removeStyles(t.to), t.onTransitionEnd) t.onTransitionEnd[e].call(this)
        }, l.transition = function(t) {
            if (parseFloat(this.layout.options.transitionDuration)) {
                var e = this._transn;
                for (var i in t.onTransitionEnd) e.onEnd[i] = t.onTransitionEnd[i];
                for (i in t.to) e.ingProperties[i] = !0, t.isCleaning && (e.clean[i] = !0);
                t.from && (this.css(t.from), this.element.offsetHeight), this.enableTransition(t.to), this.css(t.to), this.isTransitioning = !0
            } else this._nonTransition(t)
        };
        var h = "opacity," + function(t) {
            return t.replace(/([A-Z])/g, function(t) {
                return "-" + t.toLowerCase()
            })
        }(s);
        l.enableTransition = function() {
            if (!this.isTransitioning) {
                var t = this.layout.options.transitionDuration;
                t = "number" == typeof t ? t + "ms" : t, this.css({
                    transitionProperty: h,
                    transitionDuration: t,
                    transitionDelay: this.staggerDelay || 0
                }), this.element.addEventListener(o, this, !1)
            }
        }, l.onwebkitTransitionEnd = function(t) {
            this.ontransitionend(t)
        }, l.onotransitionend = function(t) {
            this.ontransitionend(t)
        };
        var c = {
            "-webkit-transform": "transform"
        };
        l.ontransitionend = function(t) {
            if (t.target === this.element) {
                var e = this._transn,
                    i = c[t.propertyName] || t.propertyName;
                if (delete e.ingProperties[i], function(t) {
                        for (var e in t) return !1;
                        return !0
                    }(e.ingProperties) && this.disableTransition(), i in e.clean && (this.element.style[t.propertyName] = "", delete e.clean[i]), i in e.onEnd) {
                    var n = e.onEnd[i];
                    n.call(this), delete e.onEnd[i]
                }
                this.emitEvent("transitionEnd", [this])
            }
        }, l.disableTransition = function() {
            this.removeTransitionStyles(), this.element.removeEventListener(o, this, !1), this.isTransitioning = !1
        }, l._removeStyles = function(t) {
            var e = {};
            for (var i in t) e[i] = "";
            this.css(e)
        };
        var d = {
            transitionProperty: "",
            transitionDuration: "",
            transitionDelay: ""
        };
        return l.removeTransitionStyles = function() {
            this.css(d)
        }, l.stagger = function(t) {
            t = isNaN(t) ? 0 : t, this.staggerDelay = t + "ms"
        }, l.removeElem = function() {
            this.element.parentNode.removeChild(this.element), this.css({
                display: ""
            }), this.emitEvent("remove", [this])
        }, l.remove = function() {
            n && parseFloat(this.layout.options.transitionDuration) ? (this.once("transitionEnd", function() {
                this.removeElem()
            }), this.hide()) : this.removeElem()
        }, l.reveal = function() {
            delete this.isHidden, this.css({
                display: ""
            });
            var t = this.layout.options,
                e = {};
            e[this.getHideRevealTransitionEndProperty("visibleStyle")] = this.onRevealTransitionEnd, this.transition({
                from: t.hiddenStyle,
                to: t.visibleStyle,
                isCleaning: !0,
                onTransitionEnd: e
            })
        }, l.onRevealTransitionEnd = function() {
            this.isHidden || this.emitEvent("reveal")
        }, l.getHideRevealTransitionEndProperty = function(t) {
            var e = this.layout.options[t];
            if (e.opacity) return "opacity";
            for (var i in e) return i
        }, l.hide = function() {
            this.isHidden = !0, this.css({
                display: ""
            });
            var t = this.layout.options,
                e = {};
            e[this.getHideRevealTransitionEndProperty("hiddenStyle")] = this.onHideTransitionEnd, this.transition({
                from: t.visibleStyle,
                to: t.hiddenStyle,
                isCleaning: !0,
                onTransitionEnd: e
            })
        }, l.onHideTransitionEnd = function() {
            this.isHidden && (this.css({
                display: "none"
            }), this.emitEvent("hide"))
        }, l.destroy = function() {
            this.css({
                position: "",
                left: "",
                right: "",
                top: "",
                bottom: "",
                transition: "",
                transform: ""
            })
        }, a
    }) ? n.apply(e, s) : n) || (t.exports = o)
  }, function(t, e, i) {
    var n, s, o;
    window, s = [i(29)], void 0 === (o = "function" == typeof(n = function(t) {
        "use strict";
        var e = t.create("vertical", {
                horizontalAlignment: 0
            }),
            i = e.prototype;
        return i._resetLayout = function() {
            this.y = 0
        }, i._getItemLayoutPosition = function(t) {
            t.getSize();
            var e = (this.isotope.size.innerWidth - t.size.outerWidth) * this.options.horizontalAlignment,
                i = this.y;
            return this.y += t.size.outerHeight, {
                x: e,
                y: i
            }
        }, i._getContainerSize = function() {
            return {
                height: this.y
            }
        }, e
    }) ? n.apply(e, s) : n) || (t.exports = o)
  }, function(t, e, i) {
    var n, s, o;
    /*!
     * Masonry layout mode
     * sub-classes Masonry
     * https://masonry.desandro.com
     */
    window, s = [i(29), i(123)], void 0 === (o = "function" == typeof(n = function(t, e) {
        "use strict";
        var i = t.create("masonry"),
            n = i.prototype,
            s = {
                _getElementOffset: !0,
                layout: !0,
                _getMeasurement: !0
            };
        for (var o in e.prototype) s[o] || (n[o] = e.prototype[o]);
        var r = n.measureColumns;
        n.measureColumns = function() {
            this.items = this.isotope.filteredItems, r.call(this)
        };
        var a = n._getOption;
        return n._getOption = function(t) {
            return "fitWidth" == t ? void 0 !== this.options.isFitWidth ? this.options.isFitWidth : this.options.fitWidth : a.apply(this.isotope, arguments)
        }, i
    }) ? n.apply(e, s) : n) || (t.exports = o)
  }, function(t, e, i) {
    var n, s, o;
    /*!
     * Masonry v4.2.2
     * Cascading grid layout library
     * https://masonry.desandro.com
     * MIT License
     * by David DeSandro
     */
    window, s = [i(28), i(19)], void 0 === (o = "function" == typeof(n = function(t, e) {
        "use strict";
        var i = t.create("masonry");
        i.compatOptions.fitWidth = "isFitWidth";
        var n = i.prototype;
        return n._resetLayout = function() {
            this.getSize(), this._getMeasurement("columnWidth", "outerWidth"), this._getMeasurement("gutter", "outerWidth"), this.measureColumns(), this.colYs = [];
            for (var t = 0; t < this.cols; t++) this.colYs.push(0);
            this.maxY = 0, this.horizontalColIndex = 0
        }, n.measureColumns = function() {
            if (this.getContainerWidth(), !this.columnWidth) {
                var t = this.items[0],
                    i = t && t.element;
                this.columnWidth = i && e(i).outerWidth || this.containerWidth
            }
            var n = this.columnWidth += this.gutter,
                s = this.containerWidth + this.gutter,
                o = s / n,
                r = n - s % n;
            o = Math[r && r < 1 ? "round" : "floor"](o), this.cols = Math.max(o, 1)
        }, n.getContainerWidth = function() {
            var t = this._getOption("fitWidth") ? this.element.parentNode : this.element,
                i = e(t);
            this.containerWidth = i && i.innerWidth
        }, n._getItemLayoutPosition = function(t) {
            t.getSize();
            var e = t.size.outerWidth % this.columnWidth,
                i = Math[e && e < 1 ? "round" : "ceil"](t.size.outerWidth / this.columnWidth);
            i = Math.min(i, this.cols);
            for (var n = this[this.options.horizontalOrder ? "_getHorizontalColPosition" : "_getTopColPosition"](i, t), s = {
                    x: this.columnWidth * n.col,
                    y: n.y
                }, o = n.y + t.size.outerHeight, r = i + n.col, a = n.col; a < r; a++) this.colYs[a] = o;
            return s
        }, n._getTopColPosition = function(t) {
            var e = this._getTopColGroup(t),
                i = Math.min.apply(Math, e);
            return {
                col: e.indexOf(i),
                y: i
            }
        }, n._getTopColGroup = function(t) {
            if (t < 2) return this.colYs;
            for (var e = [], i = this.cols + 1 - t, n = 0; n < i; n++) e[n] = this._getColGroupY(n, t);
            return e
        }, n._getColGroupY = function(t, e) {
            if (e < 2) return this.colYs[t];
            var i = this.colYs.slice(t, t + e);
            return Math.max.apply(Math, i)
        }, n._getHorizontalColPosition = function(t, e) {
            var i = this.horizontalColIndex % this.cols;
            i = t > 1 && i + t > this.cols ? 0 : i;
            var n = e.size.outerWidth && e.size.outerHeight;
            return this.horizontalColIndex = n ? i + t : this.horizontalColIndex, {
                col: i,
                y: this._getColGroupY(i, t)
            }
        }, n._manageStamp = function(t) {
            var i = e(t),
                n = this._getElementOffset(t),
                s = this._getOption("originLeft") ? n.left : n.right,
                o = s + i.outerWidth,
                r = Math.floor(s / this.columnWidth);
            r = Math.max(0, r);
            var a = Math.floor(o / this.columnWidth);
            a -= o % this.columnWidth ? 0 : 1, a = Math.min(this.cols - 1, a);
            for (var l = (this._getOption("originTop") ? n.top : n.bottom) + i.outerHeight, h = r; h <= a; h++) this.colYs[h] = Math.max(l, this.colYs[h])
        }, n._getContainerSize = function() {
            this.maxY = Math.max.apply(Math, this.colYs);
            var t = {
                height: this.maxY
            };
            return this._getOption("fitWidth") && (t.width = this._getContainerFitWidth()), t
        }, n._getContainerFitWidth = function() {
            for (var t = 0, e = this.cols; --e && 0 === this.colYs[e];) t++;
            return (this.cols - t) * this.columnWidth - this.gutter
        }, n.needsResizeLayout = function() {
            var t = this.containerWidth;
            return this.getContainerWidth(), t != this.containerWidth
        }, i
    }) ? n.apply(e, s) : n) || (t.exports = o)
  }, function(t, e, i) {
    var n, s, o;
    window, s = [i(29)], void 0 === (o = "function" == typeof(n = function(t) {
        "use strict";
        var e = t.create("fitRows"),
            i = e.prototype;
        return i._resetLayout = function() {
            this.x = 0, this.y = 0, this.maxY = 0, this._getMeasurement("gutter", "outerWidth")
        }, i._getItemLayoutPosition = function(t) {
            t.getSize();
            var e = t.size.outerWidth + this.gutter,
                i = this.isotope.size.innerWidth + this.gutter;
            0 !== this.x && e + this.x > i && (this.x = 0, this.y = this.maxY);
            var n = {
                x: this.x,
                y: this.y
            };
            return this.maxY = Math.max(this.maxY, this.y + t.size.outerHeight), this.x += e, n
        }, i._getContainerSize = function() {
            return {
                height: this.maxY
            }
        }, e
    }) ? n.apply(e, s) : n) || (t.exports = o)
  }, function(t, e, i) {
    var n, s, o;
    window, s = [i(28)], void 0 === (o = "function" == typeof(n = function(t) {
        "use strict";
  
        function e() {
            t.Item.apply(this, arguments)
        }
        var i = e.prototype = Object.create(t.Item.prototype),
            n = i._create;
        i._create = function() {
            this.id = this.layout.itemGUID++, n.call(this), this.sortData = {}
        }, i.updateSortData = function() {
            if (!this.isIgnored) {
                this.sortData.id = this.id, this.sortData["original-order"] = this.id, this.sortData.random = Math.random();
                var t = this.layout.options.getSortData,
                    e = this.layout._sorters;
                for (var i in t) {
                    var n = e[i];
                    this.sortData[i] = n(this.element, this)
                }
            }
        };
        var s = i.destroy;
        return i.destroy = function() {
            s.apply(this, arguments), this.css({
                display: ""
            })
        }, e
    }) ? n.apply(e, s) : n) || (t.exports = o)
  }, function(t, e, i) {
    var n, s;
    /*!
     * imagesLoaded v4.1.4
     * JavaScript is all like "You images are done yet or what?"
     * MIT License
     */
    /*!
     * imagesLoaded v4.1.4
     * JavaScript is all like "You images are done yet or what?"
     * MIT License
     */
    ! function(o, r) {
        "use strict";
        n = [i(42)], void 0 === (s = function(t) {
            return function(t, e) {
                var i = t.jQuery,
                    n = t.console;
  
                function s(t, e) {
                    for (var i in e) t[i] = e[i];
                    return t
                }
                var o = Array.prototype.slice;
  
                function r(t, e, a) {
                    if (!(this instanceof r)) return new r(t, e, a);
                    var l = t;
                    "string" == typeof t && (l = document.querySelectorAll(t)), l ? (this.elements = function(t) {
                        if (Array.isArray(t)) return t;
                        if ("object" == typeof t && "number" == typeof t.length) return o.call(t);
                        return [t]
                    }(l), this.options = s({}, this.options), "function" == typeof e ? a = e : s(this.options, e), a && this.on("always", a), this.getImages(), i && (this.jqDeferred = new i.Deferred), setTimeout(this.check.bind(this))) : n.error("Bad element for imagesLoaded " + (l || t))
                }
                r.prototype = Object.create(e.prototype), r.prototype.options = {}, r.prototype.getImages = function() {
                    this.images = [], this.elements.forEach(this.addElementImages, this)
                }, r.prototype.addElementImages = function(t) {
                    "IMG" == t.nodeName && this.addImage(t), !0 === this.options.background && this.addElementBackgroundImages(t);
                    var e = t.nodeType;
                    if (e && a[e]) {
                        for (var i = t.querySelectorAll("img"), n = 0; n < i.length; n++) {
                            var s = i[n];
                            this.addImage(s)
                        }
                        if ("string" == typeof this.options.background) {
                            var o = t.querySelectorAll(this.options.background);
                            for (n = 0; n < o.length; n++) {
                                var r = o[n];
                                this.addElementBackgroundImages(r)
                            }
                        }
                    }
                };
                var a = {
                    1: !0,
                    9: !0,
                    11: !0
                };
  
                function l(t) {
                    this.img = t
                }
  
                function h(t, e) {
                    this.url = t, this.element = e, this.img = new Image
                }
                return r.prototype.addElementBackgroundImages = function(t) {
                    var e = getComputedStyle(t);
                    if (e)
                        for (var i = /url\((['"])?(.*?)\1\)/gi, n = i.exec(e.backgroundImage); null !== n;) {
                            var s = n && n[2];
                            s && this.addBackground(s, t), n = i.exec(e.backgroundImage)
                        }
                }, r.prototype.addImage = function(t) {
                    var e = new l(t);
                    this.images.push(e)
                }, r.prototype.addBackground = function(t, e) {
                    var i = new h(t, e);
                    this.images.push(i)
                }, r.prototype.check = function() {
                    var t = this;
  
                    function e(e, i, n) {
                        setTimeout(function() {
                            t.progress(e, i, n)
                        })
                    }
                    this.progressedCount = 0, this.hasAnyBroken = !1, this.images.length ? this.images.forEach(function(t) {
                        t.once("progress", e), t.check()
                    }) : this.complete()
                }, r.prototype.progress = function(t, e, i) {
                    this.progressedCount++, this.hasAnyBroken = this.hasAnyBroken || !t.isLoaded, this.emitEvent("progress", [this, t, e]), this.jqDeferred && this.jqDeferred.notify && this.jqDeferred.notify(this, t), this.progressedCount == this.images.length && this.complete(), this.options.debug && n && n.log("progress: " + i, t, e)
                }, r.prototype.complete = function() {
                    var t = this.hasAnyBroken ? "fail" : "done";
                    if (this.isComplete = !0, this.emitEvent(t, [this]), this.emitEvent("always", [this]), this.jqDeferred) {
                        var e = this.hasAnyBroken ? "reject" : "resolve";
                        this.jqDeferred[e](this)
                    }
                }, l.prototype = Object.create(e.prototype), l.prototype.check = function() {
                    this.getIsImageComplete() ? this.confirm(0 !== this.img.naturalWidth, "naturalWidth") : (this.proxyImage = new Image, this.proxyImage.addEventListener("load", this), this.proxyImage.addEventListener("error", this), this.img.addEventListener("load", this), this.img.addEventListener("error", this), this.proxyImage.src = this.img.src)
                }, l.prototype.getIsImageComplete = function() {
                    return this.img.complete && this.img.naturalWidth
                }, l.prototype.confirm = function(t, e) {
                    this.isLoaded = t, this.emitEvent("progress", [this, this.img, e])
                }, l.prototype.handleEvent = function(t) {
                    var e = "on" + t.type;
                    this[e] && this[e](t)
                }, l.prototype.onload = function() {
                    this.confirm(!0, "onload"), this.unbindEvents()
                }, l.prototype.onerror = function() {
                    this.confirm(!1, "onerror"), this.unbindEvents()
                }, l.prototype.unbindEvents = function() {
                    this.proxyImage.removeEventListener("load", this), this.proxyImage.removeEventListener("error", this), this.img.removeEventListener("load", this), this.img.removeEventListener("error", this)
                }, h.prototype = Object.create(l.prototype), h.prototype.check = function() {
                    this.img.addEventListener("load", this), this.img.addEventListener("error", this), this.img.src = this.url, this.getIsImageComplete() && (this.confirm(0 !== this.img.naturalWidth, "naturalWidth"), this.unbindEvents())
                }, h.prototype.unbindEvents = function() {
                    this.img.removeEventListener("load", this), this.img.removeEventListener("error", this)
                }, h.prototype.confirm = function(t, e) {
                    this.isLoaded = t, this.emitEvent("progress", [this, this.element, e])
                }, r.makeJQueryPlugin = function(e) {
                    (e = e || t.jQuery) && ((i = e).fn.imagesLoaded = function(t, e) {
                        return new r(this, t, e).jqDeferred.promise(i(this))
                    })
                }, r.makeJQueryPlugin(), r
            }(o, t)
        }.apply(e, n)) || (t.exports = s)
    }("undefined" != typeof window ? window : this)
  }]);